import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import TextField from '@material-ui/core/TextField';
import { notification } from 'antd';

import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import jszip from 'jszip';
import togeojson from '@mapbox/togeojson';

import shpjs from 'shpjs';
import saveAs from 'file-saver';
import geo from '../../components/util/geo';
import downloadPolygons from '../../components/geo/downloadPolygons';

import Config from '../../constants/appConfig';
import MaterialIcon from '../../components/MaterialIcon';
import SvgIcon from '@material-ui/core/SvgIcon';
import Img_mark from './../../components/image/img';

import L from 'leaflet';
import 'leaflet-draw';

import MenuList from '@material-ui/core/Menu';
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import SPW from "string-pixel-width";

import tools from '../../components/util/tools';
import toolsPlan from './tools';
import { planningPolygonRefuelCount } from './planningRefuels';
import toolsCali from './../calibration/tools';

import { useParams } from "react-router";

import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogTitle from "@material-ui/core/DialogTitle";
import Tooltip from '@material-ui/core/Tooltip';
import Checkbox from '@material-ui/core/Checkbox';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import InputAdornment from '@material-ui/core/InputAdornment';
import Radio from '@material-ui/core/Radio';
import NativeSelect from '@material-ui/core/NativeSelect';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormLabel from '@material-ui/core/FormLabel';

import Backd from '../../components/Backdrop';
import ListFilter from '../../components/ListFilter/filterArea';
import Tab from '../../components/Tab/local';
import Slider from '../../components/Slider/slider';
import CircularProgress from '@material-ui/core/CircularProgress';

import DescriptionIcon from '@material-ui/icons/Description';
import SaveIcon from '@material-ui/icons/Save';
import CloseIcon from '@material-ui/icons/Close';
import SearchIcon from '@material-ui/icons/Search';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import ArrowLeftIcon from '@material-ui/icons/ArrowLeft';
import DeleteIcon from '@material-ui/icons/Delete';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import NavigationIcon from '@material-ui/icons/Navigation';
import RoomIcon from '@material-ui/icons/Room';

import pinWaypoint from '../../assets/images/marker/waypoint/pin.png';
import HangarIcon from '../../assets/images/marker/waypoint/hangar.png';
import RosaDosVentos from '../../assets/images/rosaDosVentos.png';
import img from './../point/img';
import deltaTChart from '../../assets/images/deltaTChart.png'
import Replay3D from './replay_3d/Replay3D';

import './style.css';

import * as turf from '@turf/turf';
import { getValueColor } from '../../components/geo/geometry';
import iconA from '../../assets/images/marker/a.svg';
import iconB from '../../assets/images/marker/b.svg';

import Units from '../../components/util/units';
const styles = theme => ({
    noMaxWidth: {
        maxWidth: 'none',
    },
});
class oPolygon {
    constructor(props) {
        //this.selected = null;
        this.id_property = null;
        this.area = 0;
        this.lines = [];
        this.ABs = [];
        this.selected_AB = 0;
        this.selected_AB_back = 0;
        this.selected_line = null;
        this.speed_apl = 0;
        this.best = null;
        this.yaw = null;
        this.yaw_value = null;
        this.ab = null;
        this.layer = null;
        this.id = '';
        this.guid = '';
        this.guid_p = null;
        this.planningVersion = 2;
        this.name = '';
        this.points = '';
        this.type = 'N';
        this.estrategia = '';
        this.estrategia_manual = false;
        this.aTlPul = 0;
        this.comTl = 0;
        this.flxMedApl = 0;
        this.difficult = 0;
        this.out = [];
        this.best_Out = 0;
        this.selected_Out = 0;
        this.faixa = Units.convertLengthTo(props.res.LINGUA === 'en-US' ? 70 : 20, Units.getLegacyUnitConfig(props.res.LINGUA).length_unit, Units.getLengthUnit(props.res));
        this.space = 0;
        this.fluxo = Units.convertFlowTo(props.res.LINGUA === 'en-US' ? 3 : 10, Units.getLegacyUnitConfig(props.res.LINGUA).volume_unit, Units.getLegacyUnitConfig(props.res.LINGUA).area_unit, Units.getVolumeUnit(props.res, 'L'), Units.getAreaUnit(props.res));
        this.nPulverizador = 40;
        this.grupo = false;
        this.config = false;
        this.equip_label = '';
        this.equip = null;
        this.carga_inicial = 0;
        this.carga_final = 0;
        this.detalhes = {
            //            typeApp: 'Líquido',
            selectedService: '',
            typeService: {
                insecticide: false,
                herbicide: false,
                fungicide: false,
                seeding: false,
                fertilizing: false,
                maturator: false,
                others: false,
            },
            otherService: '',
            areaRisk: {
                app: false,
                abelhas: false,
                others: false,
            },
            areaRiskOthers: '',
            equipment: '',
            useEquipmentReport: false,
            useCultureReport: false,
            useProductReport: false,
            useInfoReport: false,
            agriculturelCulture: '',
            target: '',
            cultureVariety: '',
            cultureQuantityApplications: '',
            cultureCycle: '',
            cultureHeight: '',
            culturePopulationDensity: '',
            culturePlantingTime: '',
            culturePestSurvey: '',
            dosage: '',
            tailVolume: '',
            mixingRecommendation: '',
            tempMin: '',
            tempMax: '',
            humidityMin: '',
            humidityMax: '',
            windSpeed: '',
            windDirection: '',
            application_period: '',
            deltaT: '',
            selectedProducts: [],
            selectedProductsSolids: [],
            dosageDetails: {},
            equipmentName: '',
            equipmentID: '',
            name: '',
            manufacturerEquipment: '',
            equipmentType: '',
            electrostatic: '',
            jetType: '',
            sprayTip: '',
            deflectionAngle: '',
            quantityNozzle: '',
            screen: '',
            flowRegulator: '',
            angleBlades: '',
            quantityAtomizer: '',
            minimumSpeed: '',
            averageSpeed: '',
            maximumSpeed: '',
            applicationRange: '',
            applicationFee: '',
            sprayClassification: '',
            minimumCoveredArea: '',
            averageCoveredArea: '',
            maximumCoveredArea: '',
            minimumTotalVolume: '',
            averageTotalVolume: '',
            maximumTotalVolume: '',
            minimumEquipmentVolume: '',
            averageEquipmentVolume: '',
            maximumEquipmentVolume: '',
            minimumPressure: '',
            averagePressure: '',
            maximumPressure: '',
            leftWing: '',
            leftCenter: '',
            rightCenter: '',
            rightWing: '',
            leftWingDistanceinputFields: '',
            leftCenterDistanceinputFields: '',
            rightCenterDistanceinputFields: '',
            rightWingDistanceinputFields: '',
        };
    }
}
class marks {
    constructor() {
        this.id = '';
        this.guid = '';
        this.name = '';
        this.icon = '';
        this.alt = '';
        this.lat = '';
        this.lng = '';
        this.r = '';
        this.type = '';
    }
}
const CssTextField = withStyles({
    root: {
        '& label': {
            fontWeight: 'bold',
            fontSize: '16px'

        },
    },
})(TextField);

class Edit extends React.Component {
    getDateTime = (date) => {
        if (!date) date = new Date();
        let ret = date.getFullYear() + '-';
        ret += (date.getMonth() + 1).toString().padStart(2, '0') + '-';
        ret += date.getDate().toString().padStart(2, '0') + 'T';
        ret += date.getHours().toString().padStart(2, '0') + ':' + date.getMinutes().toString().padStart(2, '0');
        return ret;
    }

    dName = 'VOO ' + tools.dateFormat(new Date(), this.props.res.LINGUA);
    state = {//verificar se deve manter valor no keepData
        id: -1,
        language: this.props.res.LINGUA,
        unit_config: Units.getUnitConfig(this.props.res),
        guid: null,
        download_id: -1,
        polygons: [],
        origemPolygons: [],
        clients: [],
        pilots: [],
        planes: [],
        markers: [],
        sel_poly: null,

        save: true,

        create: false,
        edit: false,
        delete: false,
        clear: false,
        config: false,
        angle: false,
        stack: false,
        estra: false,
        uEstimative: false,//glow 
        dEstimative: false,//disable 
        goto: false,
        progress: false,
        showImport: false,
        calibracao: false,

        openAreaList: false,
        areaFilterSelection: [],
        areaFilterSelectionBackup: [],
        areaFilterSelectionStart: [],

        itensImport: [],

        tab: '2',

        lat: {
            value: '',
            error: false,
            input: ''
        },
        lng: {
            value: '',
            error: false,
            input: ''
        },

        aplicacao: 'L',
        faixa: Units.convertLengthTo(this.props.res.LINGUA === 'en-US' ? 70 : 20, Units.getLegacyUnitConfig(this.props.res.LINGUA).length_unit, Units.getLengthUnit(this.props.res)),
        space: 0,
        planningVersion: 2,
        fluxo: Units.convertFlowTo(this.props.res.LINGUA === 'en-US' ? 3 : 10, Units.getLegacyUnitConfig(this.props.res.LINGUA).volume_unit, Units.getLegacyUnitConfig(this.props.res.LINGUA).area_unit, Units.getVolumeUnit(this.props.res, 'L'), Units.getAreaUnit(this.props.res)),
        altura: Units.convertLengthTo(this.props.res.LINGUA === 'en-US' ? 7 : 2, Units.getLegacyUnitConfig(this.props.res.LINGUA).length_unit, Units.getLengthUnit(this.props.res)),
        carga: Units.convertVolumeTo(this.props.res.LINGUA === 'en-US' ? 160 : 600, Units.getLegacyUnitConfig(this.props.res.LINGUA).volume_unit, Units.getVolumeUnit(this.props.res, 'L')),
        angulo: 0,
        estrategia: '',

        groupPolygons: 'All',
        tempPoly: null,

        title_est: this.dName,
        description_est: '',
        client_est: '',
        pilot_est: '',
        plane_est: '',
        plane_est_id: null,
        equip: '',

        serviceOrderID: '',

        dateTimeTrabalho: '',
        timetable: [],

        time: {
            tApl: 0,
            tVoo: 0,
            tTotal: 0,
            tLoop: 0,
            tTras: 0,
            aTlPul: 0,
            comTl: 0,
            flxMedApl: 0,
        },

        cVoo: 0,
        cImp: 0,
        cLucro: 0,
        vLucro_old: 0,

        cLucroHora: 0,

        vVoo: 0,
        vVooHA: 0,
        vImp: 0,
        vLucro: 0,

        horas_dia: 8,
        horas_base: false,
        aproveitamento: false,
        cost: 0,
        speed: Units.convertSpeedTo(this.props.res.LINGUA === 'en-US' ? 180 : 110, Units.getLegacyUnitConfig(this.props.res.LINGUA).speed_unit, Units.getSpeedUnit(this.props.res)),//mph / kph 
        speed_travel: Units.convertSpeedTo(this.props.res.LINGUA === 'en-US' ? 180 : 110, Units.getLegacyUnitConfig(this.props.res.LINGUA).speed_unit, Units.getSpeedUnit(this.props.res)),//mph / kph
        speed_loop: Units.convertSpeedTo(this.props.res.LINGUA === 'en-US' ? 180 : 110, Units.getLegacyUnitConfig(this.props.res.LINGUA).speed_unit, Units.getSpeedUnit(this.props.res)),//mph / kph
        speed_apl: Units.convertSpeedTo(this.props.res.LINGUA === 'en-US' ? 180 : 110, Units.getLegacyUnitConfig(this.props.res.LINGUA).speed_unit, Units.getSpeedUnit(this.props.res)),//mph / kph
        size_loop: Units.convertLengthTo(this.props.res.LINGUA === 'en-US' ? 1300 : 400, Units.getLegacyUnitConfig(this.props.res.LINGUA).length_unit, Units.getLengthUnit(this.props.res)),//pes / metros
        size_h_loop: Units.convertLengthTo(this.props.res.LINGUA === 'en-US' ? 1900 : 600, Units.getLegacyUnitConfig(this.props.res.LINGUA).length_unit, Units.getLengthUnit(this.props.res)),//pes / metros
        r_time: 5,//minutos
        dificuldade: 1,
        sel_faixa: 0,

        nPulverizador: 0,
        dsc: 99,
        tbico: 99,
        fabricante: 99,
        list_local: [],
        list_data1: [],
        equip_plan: false,
        equip_orc: false,

        base: false,
        setBase: false,
        fuel: false,

        home: Config.place,
        play: false,
        edit_speed: false,
        edit_add: false,
        add_list: [],

        itens_faixa: [],

        label_text: '',
        openType: 'new',

        equipmentData: [],
        equipmentCalibrationData: [],
        equipmentConfigurationData: [],
        equipment: '',
        equipmentId: '',

        openDialogDetail: false,
        openCloneDialog: false,
        openedDialogDetail: 0,
        list_all_prod: [],
        filteredProducts: [],
        filter: '',
        productList: false,
        selectedTab: 0,
        currentPage: 1,
        itemsPerPage: 10,
        cultureData: [],
        calibrationData: [],
        configurationData: [],
        selectedPlane: '',
        showPlanningReplay3D: false,
        planningReplay3DData: null,

        isCalculating: false,
        treatmentDetails: false,
        areaData: [],
        saveData: false,

        polyCreate: false,
        polyEdit: false,
        polyDelete: false,
        polyLabelText: '',
        polyTab: '0',
        nameP: '',
        valid_nameP: false,
        polyNameEditing: false,
        disable: false,
        split: false,
        create_circle: false,
        ruler_a: false,

        sel_polygons: [],
        merge: false,
        gap_size: 10,
        type: '',
        past_merge: false,
        mergeNameEditing: false,
        mergeNames: [],
        mergeDeleteIds: [],
        startPolygons: [],

        selector: false,
        selectorMode: 'poly',
        sPoly: true,
        anchorMN: null,
        typeTool: 'select',

        openSendPlaneDialog: false,
        sendPlaneGuid: null,
        sendPlaneId: null,
        sendPlaneIds: [],
        sendingPlaneNow: false,
        dataPlanejamento: [],
        autoPlanningConfig: { checkAutoPlan: false, checkAutoSend: false },

        coordMode: 'dms',

        plane_est: '',
        plane_est_id: null,
        plane_est_ids: [],
        plane_est_id_company: null,
        plane_est_id_companies: [],
        pilot_est: '',
        pilot_est_id: null,
        pilot_est_ids: [],
        pilot_est_id_company: null,
        pilot_est_id_companies: [],
    };
    //slider de dificuldade
    dificult = {
        1: 1.00,
        2: 1.10,
        3: 1.20,
        4: 1.30,
        5: 1.40,
        6: 1.50,
        7: 1.60,
    };
    areaTotal = 0;
    download = false;
    area = 0;
    ruler_p = { type: 'r', first: { lat: null, lng: null }, second: { lat: null, lng: null } };
    strategy = [
        { id: 0, value: "BACKTOBACK", text: 'Back to Back', time: 0 },
        { id: 1, value: "SKIPBACKTOBACK", text: 'Skip Back to Back', time: 0 },
        { id: 2, value: "RACETRACK", text: 'Racetrack', time: 0 },
        { id: 3, value: "QUICKRACETRACK", text: 'Quick Racetrack', time: 0 },
        { id: 4, value: "REVERSERACETRACK", text: 'Reverse Racetrack', time: 0 },
        { id: 5, value: "EXPAND", text: 'Expand', time: 0 },
        { id: 6, value: "SQUEEZE", text: 'Squeeze', time: 0 },
        //{ id: 7, value: "PIVOTRACETRACK", text: 'Pivot Racetrack', time: 0 },
    ];
    tabItens = [
        {
            label: this.props.res.INFORMACAO,
            value: '2',
            step: 1,
            description: this.props.res.PLANEJAMENTO_ETAPA_INFO
        },
        {
            label: this.props.res.AREAS + '/' + this.props.res.CALIBRACAO,
            value: '0',
            step: 2,
            description: this.props.res.PLANEJAMENTO_ETAPA_AREAS
        },
        {
            label: this.props.res.PLANEJAMENTO,
            value: '1',
            step: 3,
            description: this.props.res.PLANEJAMENTO_ETAPA_ROTAS
        },
        {
            label: this.props.res.FINANCEIRO,
            value: '3',
            step: 4,
            description: this.props.res.PLANEJAMENTO_ETAPA_FINANCEIRO
        },
    ]

    base = {
        guid: tools.newGuid(),
        lat: '',
        lng: ''
    };
    fuel = [];
    hangars = [];
    hangarsLoaded = false;
    hangarsPromise = null;
    planningReplay3DSelectedPlaneDetail = null;

    type_rel = 'total';

    savedPlanning = false;

    travel_time = 0;
    time = {
        tApl: 0,
        tVoo: 0,
        tTotal: 0,
        tLoop: 0,
        tTras: 0,
        aTlPul: 0,
        comTl: 0,
        flxMedApl: 0,
    };

    dsc_label = ['MUITO FINA', 'FINA', 'MÉDIA', 'GROSSA', 'MUITO GROSSA', 'EXTREMAMENTE GROSSA', 'ULT. GROSSA'];
    bico_label = ['JATO PLANO', 'JATO CÔNICO', 'ATOMIZADOR', 'ELETROSTÁTICO'];
    fabricante_label = ['TRAVICAR', 'TEEJET', 'CP', 'OUTROS'];

    markClick = false;
    featureGroupP = null;
    featureGroupPM = null;
    featureGroupM = null;
    featureGroupE = null;
    strategyDirectionArrowLayer = null;
    featureGroupTest = null;
    drawControl = null;
    drawCreateToolbar = null;
    drawEditToolbar = null;
    drawDeleteToolbar = null;
    r = null;
    i = 0;
    polyindex = 0;
    text_polygon = 'new poly ';
    polyClick = false;
    sel_save = [];
    waypointMarker = null;
    waypointIcon = null;
    mapIsDragging = false;

    icons = null;
    img_base = { 'F': 24, 'T': 11 };
    // F: disabilitado; T: abilitado; Y: utilizado
    img_fuel = { 'F': 0, 'T': 1, 'Y': 23 };

    color_default = '#0a7eb4ff';
    color_selected = '#ffffff';
    color_x = '#ff002b';
    color_edit = '#3388ff';
    color_line = '#ee5151ff';//'#ff002b';
    color_line_selected = '#5f00ff';
    color_t = '#EAB711';
    color_r = '#8e44ad';

    planningPanes = {
        N: 'planningPolygonNPane',
        T: 'planningPolygonTPane',
        F: 'planningPolygonFPane',
        X: 'planningPolygonXPane',
        R: 'planningPolygonRPane',
        lines: 'planningApplicationLinesPane',
        AB: 'planningABPane',
        directionArrows: 'planningStrategyDirectionArrowPane'
    };

    getPolygonFlowValue = (polygon) => {
        if (!polygon) return NaN;

        const values = [polygon.fluxo, polygon.average_value, polygon.flow_rate];
        for (let i = 0; i < values.length; i++) {
            if (values[i] !== null && values[i] !== '' && typeof values[i] !== 'undefined') {
                const value = Number(values[i]);
                if (Number.isFinite(value)) return value;
            }
        }

        return NaN;
    };

    getFlowPolygonColor = (polygon, polygons) => {
        const source = Array.isArray(polygons) ? polygons : (this.state.polygons || []);
        const values = source
            .filter(item => item && item.type === 'F')
            .map(this.getPolygonFlowValue)
            .filter(Number.isFinite);
        const currentValue = this.getPolygonFlowValue(polygon);

        if (Number.isFinite(currentValue) && values.indexOf(currentValue) < 0) values.push(currentValue);

        return getValueColor(currentValue, Math.min(...values), Math.max(...values));
    };

    getPolygonBaseColor = (polygon, polygons) => {
        if (polygon.type === 'R') return this.color_r;
        if (polygon.type === 'X' || polygon.type === 'XL' || polygon.x) return this.color_x;
        if (polygon.type === 'T') return this.color_t;
        if (polygon.type === 'F') return this.getFlowPolygonColor(polygon, polygons);
        return this.color_default;
    };

    getPlanningPolygonPane = (type) => {
        if (type === 'R') return this.planningPanes.R;
        if (type === 'X') return this.planningPanes.X;
        if (type === 'T') return this.planningPanes.T;
        if (type === 'F') return this.planningPanes.F;
        return this.planningPanes.N;
    };

    getPlanningPolygonLevel = (polygon) => {
        if (polygon && polygon.type === 'R') return 4;
        if (polygon && polygon.type === 'X') return 3;
        if (polygon && polygon.type === 'F') return 2;
        if (polygon && polygon.type === 'T') return 1;
        return 0;
    };

    getPolygonsAtLatLng = (latlng) => {
        if (!latlng || !this.mymap || !this.mymap._layers || !this.featureGroupP) return [];

        const point = turf.point([latlng.lng, latlng.lat]);
        const polygons = Array.isArray(this.state.polygons) ? this.state.polygons : [];
        const matches = [];

        polygons.forEach((polygon, index) => {
            if (!polygon || !polygon.guid) return;

            const layer = this.mymap._layers[polygon.guid];
            if (!layer || !this.featureGroupP.hasLayer(layer)) return;

            let contains = false;
            try {
                const feature = typeof layer.toGeoJSON === 'function' ? layer.toGeoJSON() : null;
                const geometryType = feature && feature.geometry ? feature.geometry.type : '';

                if (geometryType === 'Polygon' || geometryType === 'MultiPolygon') {
                    contains = turf.booleanPointInPolygon(point, feature, { ignoreBoundary: false });
                } else if (typeof layer.getLatLng === 'function' && typeof layer.getRadius === 'function') {
                    contains = layer.getLatLng().distanceTo(latlng) <= layer.getRadius();
                }
            } catch (_) {
                contains = false;
            }

            if (!contains && typeof layer._containsPoint === 'function') {
                try {
                    contains = layer._containsPoint(this.mymap.latLngToLayerPoint(latlng));
                } catch (_) { }
            }

            if (contains) {
                let visualIndex = index;
                const path = layer._path;
                if (path && path.parentNode && path.parentNode.children) {
                    const pathIndex = Array.prototype.indexOf.call(path.parentNode.children, path);
                    if (pathIndex >= 0) visualIndex = pathIndex;
                }
                matches.push({ polygon, layer, index, visualIndex });
            }
        });

        matches.sort((a, b) => {
            const levelDifference = this.getPlanningPolygonLevel(b.polygon) - this.getPlanningPolygonLevel(a.polygon);
            return levelDifference !== 0 ? levelDifference : b.visualIndex - a.visualIndex;
        });

        return matches;
    };

    handlePolygonPointSelection = (event, fallbackPolygon) => {
        const latlng = event && event.latlng ? event.latlng : null;
        let matches = this.getPolygonsAtLatLng(latlng);

        if (matches.length === 0 && fallbackPolygon) {
            const layer = this.mymap && this.mymap._layers
                ? this.mymap._layers[fallbackPolygon.guid]
                : null;
            if (layer) matches = [{ polygon: fallbackPolygon, layer }];
        }

        if (matches.length === 0) {
            this.handleClickP();
            return;
        }

        const selectedGuid = this.state.sel_poly && this.state.sel_poly.guid;
        const selectedIndex = matches.findIndex(item => item.polygon.guid === selectedGuid);
        const nextIndex = selectedIndex >= 0 ? (selectedIndex + 1) % matches.length : 0;
        const next = matches[nextIndex];

        this.handleClickP(next.layer, next.polygon);
    };

    setPolygonBaseStyle = (layer, polygon, polygons) => {
        if (!layer || typeof layer.setStyle !== 'function') return;
        const color = this.getPolygonBaseColor(polygon, polygons);
        layer.setStyle({ color, fillColor: color });
    };

    refreshFlowPolygonColors = (polygons) => {
        const source = Array.isArray(polygons) ? polygons : (this.state.polygons || []);
        if (!this.mymap || !this.mymap._layers) return;

        source.forEach(polygon => {
            if (!polygon || polygon.type !== 'F') return;
            this.setPolygonBaseStyle(this.mymap._layers[polygon.guid], polygon, source);
        });
    };

    popup_marker = (marker, type) => {
        let temp_lat = document.getElementById("markerLat");
        if (temp_lat) temp_lat.remove();
        let temp_lng = document.getElementById("markerLng");
        if (temp_lng) temp_lng.remove();
        let temp_remove = document.getElementById("markRemove");
        if (temp_remove) temp_remove.remove();
        let temp_move = document.getElementById("markMove");
        if (temp_move) temp_move.remove();

        let htmlPopUp = '<span style="width: 1.7rem; display: inline-block; margin-left: -5px;">LAT:</span>' +
            '<input type="number" id="markerLat" class="popUpInput" value="' + marker._latlng.lat.toFixed(7) + '" /><br />' +
            '<span style="width: 1.7rem; display: inline-block; margin-left: -5px;">LNG:</span>' +
            '<input type="number" id="markerLng" value="' + marker._latlng.lng.toFixed(7) + '" class="popUpInput" maxlength="10" /><br />' +
            '<button id="markRemove" ';
        /*if (type === 'base')
            htmlPopUp += 'disabled style="border: 0 !important;transform: scale(.8);min-width:30px;margin-left: 7.5px;" class="MuiButtonBase-root MuiButton-root MuiButton-text buttonS buttonMenu Mui-disabled Mui-disabled" ';
        else*/
        htmlPopUp += 'style="transform: scale(.8);min-width:30px;margin-left: 7.5px;" class="MuiButtonBase-root MuiButton-root MuiButton-text popUpButton MuiButton-textSizeSmall MuiButton-sizeSmall" ';
        htmlPopUp += ' tabindex="0" type="button">' +
            '<span class="MuiButton-label"><i class="material-icons iconMap">delete</i></span>' +
            '</button>' +
            '<button id="markMove" style="min-width:33.6px;" class="MuiButtonBase-root MuiButton-root MuiButton-text popUpButton MuiButton-textSizeSmall MuiButton-sizeSmall" tabindex="0" type="button">' +
            '<span class="MuiButton-label">' + this.props.res.IR + '</span>' +
            '</button>'

        marker.setPopupContent(htmlPopUp);
        if (!document.getElementById('markMove')) {
            return;
        }

        document.getElementById('markMove').onclick = (e) => { this.alterMarker(marker, type, 'Move') };
        document.getElementById('markRemove').onclick = (e) => { this.alterMarker(marker, type, 'Remove') };
        document.getElementById('markerLat').addEventListener("keyup", (event) => {
            if (event.keyCode === 13) {
                event.preventDefault();
                this.alterMarker(marker, type, 'Move')
            }
        });
        document.getElementById('markerLng').addEventListener("keyup", (event) => {
            if (event.keyCode === 13) {
                event.preventDefault();
                this.alterMarker(marker, type, 'Move')
            }
        });
    };

    convertEstimateToCurrentUnits = (estimate) => {
        if (!estimate) return estimate;

        const source = estimate.unit_config || Units.getLegacyUnitConfig(estimate.language);
        const target = Units.getUnitConfig(this.props.res);
        const sourceVolume = estimate.aplicacao === 'S' ? 'kg' : (source.volume_unit === 'kg' ? 'L' : source.volume_unit);
        const targetVolume = estimate.aplicacao === 'S' ? 'kg' : Units.getVolumeUnit(this.props.res, sourceVolume);

        ['speed', 'speed_travel', 'speed_loop', 'speed_apl'].forEach(key => {
            if (estimate[key] !== undefined && estimate[key] !== null && estimate[key] !== '') {
                estimate[key] = Units.convertSpeedTo(estimate[key], source.speed_unit, target.speed_unit);
            }
        });

        ['size_loop', 'size_h_loop', 'faixa', 'space', 'altura'].forEach(key => {
            if (estimate[key] !== undefined && estimate[key] !== null && estimate[key] !== '') {
                estimate[key] = Units.convertLengthTo(estimate[key], source.length_unit, target.length_unit);
            }
        });

        const migrateLegacySpace = (spaceValue, widthValue) => {
            const widthMeters = Units.toCanonicalLength(widthValue, this.props.res);
            const oldDistanceMeters = spaceValue === undefined || spaceValue === null || spaceValue === ''
                ? widthMeters / 2
                : Units.toCanonicalLength(spaceValue, this.props.res);
            const limit = Math.max(0, widthMeters / 2);
            const offsetMeters = Math.max(-limit, Math.min(limit, oldDistanceMeters - widthMeters / 2));
            return Units.convertLengthTo(offsetMeters, 'm', target.length_unit);
        };

        if (estimate.planningVersion !== 2) {
            estimate.space = migrateLegacySpace(estimate.space, estimate.faixa || this.state.faixa);
            estimate.planningVersion = 2;
        }

        if (estimate.fluxo !== undefined && estimate.fluxo !== null && estimate.fluxo !== '') {
            estimate.fluxo = Units.convertFlowTo(estimate.fluxo, sourceVolume, source.area_unit, targetVolume, target.area_unit);
        }
        if (estimate.carga !== undefined && estimate.carga !== null && estimate.carga !== '') {
            estimate.carga = Units.convertVolumeTo(estimate.carga, sourceVolume, targetVolume);
        }

        if (estimate.polygons) {
            estimate.polygons.forEach(poly => {
                if (poly.faixa !== undefined && poly.faixa !== null && poly.faixa !== '') {
                    poly.faixa = Units.convertLengthTo(poly.faixa, source.length_unit, target.length_unit);
                } else {
                    poly.faixa = estimate.faixa || this.state.faixa;
                }
                if (poly.space !== undefined && poly.space !== null && poly.space !== '') {
                    poly.space = Units.convertLengthTo(poly.space, source.length_unit, target.length_unit);
                }
                if (poly.planningVersion !== 2) {
                    poly.space = migrateLegacySpace(poly.space, poly.faixa);
                    poly.planningVersion = 2;
                }
                if (poly.fluxo !== undefined && poly.fluxo !== null && poly.fluxo !== '') {
                    const polySourceVolume = poly.aplicacao === 'S' || estimate.aplicacao === 'S' ? 'kg' : source.volume_unit;
                    const polyTargetVolume = polySourceVolume === 'kg' ? 'kg' : Units.getVolumeUnit(this.props.res, polySourceVolume);
                    poly.fluxo = Units.convertFlowTo(poly.fluxo, polySourceVolume, source.area_unit, polyTargetVolume, target.area_unit);
                }
            });
        }

        estimate.language = this.props.res.LINGUA;
        estimate.unit_config = target;
        return estimate;
    };

    componentDidMount() {
        let d_ff_last = localStorage.getItem('d-ff-last');
        if (d_ff_last) {
            let ff_last = JSON.parse(d_ff_last);
            this.setState({ faixa: ff_last.faixa, fluxo: ff_last.fluxo }, () => {
                this.update();
            });
        } else {
            this.update();
        }
        this.getAuto('client', 'clients');
        this.readPlanes();
        this.readPilots();
        this.getProd().then(() => {
            this.setState({ filteredProducts: this.state.list_all_prod });
        });
        this.loadCultures();
        this.list_hangars();
        this.updateListPlanning();
        const hasLoadParams = Boolean(this.props.type || this.props.guid || window.location.search);
        const hasEstimateFromAreas = Boolean(localStorage.getItem('f-estimate'));
        if (!hasLoadParams && !hasEstimateFromAreas) {
            this.getLastPlanningDetail();
        }
    };

    componentDidUpdate(prevProps, prevState) {
        const previousSelectionGuid = prevState.sel_poly ? prevState.sel_poly.guid : null;
        const currentSelectionGuid = this.state.sel_poly ? this.state.sel_poly.guid : null;

        if ((prevState.play && !this.state.play) || (prevState.sel_poly && !this.state.sel_poly)) {
            this.clearStrategyDirectionArrows();
        } else if (previousSelectionGuid !== currentSelectionGuid && this.state.sel_poly && !this.state.play) {
            this.drawSelectedStrategyDirection(this.state.sel_poly);
        }
    }

    componentWillUnmount() {
        // fix Warning: Can't perform a React state update on an unmounted component
        this.setState = (state, callback) => {
            return;
        };
    };

    addDay = (date, days) => {
        let temp_date = new Date(date);
        temp_date.setDate(date.getDate() + days);
        return temp_date;
    };
    diffDay = (from1, to1) => {
        //return Math.floor((to1 - from1) / (1000 * 60 * 60 * 24));
        return Math.floor((to1 - from1) / 86400000);
    };

    updateTimetable = (time_total) => {
        if (!time_total && time_total === 0) {
            return;
        }

        const date = new Date(this.state.dateTimeTrabalho);
        const horas_dia = isNaN(this.state.horas_dia) ? 8 : Number(this.state.horas_dia);
        const timetable = this.state.timetable;
        let rest = time_total / 3600;
        let arr = [];
        let past_time = 0;
        let last = [];

        if (timetable.length > 0) {
            //check quantidade de horas
            for (let i = 0; i < timetable.length; i++) {
                const element = timetable[i];
                const lastItem = last.length === 0 ? null : last[last.length - 1];
                //past_time += (element.end - element.start) / (1000 * 60 * 60);
                if (typeof element.start) {
                    element.start = new Date(element.start);
                } else if (typeof element.end) {
                    element.end = new Date(element.end);
                }
                let segTime = (element.end - element.start) / 3600000;
                past_time += segTime;
                if (lastItem && element.start.getFullYear() === lastItem.date.getFullYear() &&
                    element.start.getMonth() === lastItem.date.getMonth() &&
                    element.start.getDate() === lastItem.date.getDate()) {
                    lastItem.time += segTime;
                } else {
                    last.push({
                        date: new Date(element.start.getFullYear(), element.start.getMonth(), element.start.getDate(), 8),
                        time: segTime
                    })
                }
            }

            if (past_time < rest) {
                rest -= rest - past_time;
                arr = timetable;
                let seg = last[last.length - 1];
                while (rest > 0) {
                    if ((seg.time / horas_dia < .9) || ((rest - (horas_dia - seg.time)) / horas_dia < .1)) {
                        let lastSeg = arr[arr.length - 1];
                        lastSeg.end = new Date(lastSeg.end + (rest * 3600000));
                        rest = 0;
                    } else {
                        let start = this.addDay(seg.date, 1);
                        let qtd = rest / horas_dia;
                        let mult = qtd >= 1 ? 1 : qtd;
                        let end = new Date(start.getTime() + mult * horas_dia * 3600000);
                        rest -= mult * horas_dia;
                        arr.push({
                            start: start,
                            end: end
                        });

                        start = this.addDay(start, 1);
                    }
                }

            } else {
                /*rest -= past_time - rest;
                while (rest > 0) {

                }*/
            }
        } else {
            let start = date;
            while (rest > 0) {
                let qtd = rest / horas_dia;
                let mult = qtd >= 1 ? 1 : qtd;
                let end = new Date(start.getTime() + mult * horas_dia * 3600000);
                rest -= mult * horas_dia;
                arr.push({
                    start: start,
                    end: end
                });

                start = this.addDay(start, 1);
            }
        }
        this.setState({ timetable: arr });
    };

    update = () => {
        let local_ini = Config.place;

        navigator.geolocation.getCurrentPosition((position) => {
            if (this.state.polygons.length <= 0 && !(this.base.lat && this.base.lng)) {

                let lat = this.round_coord(position.coords.latitude);
                let lng = this.round_coord(position.coords.longitude);
                this.validate('lat', geo.toDMS(lat, 'latitude', 4));
                this.validate('lng', geo.toDMS(lng, 'longitude', 4));

                this.mymap.setView([this.round_coord(position.coords.latitude), this.round_coord(position.coords.longitude)]);
                this.setState({ home: [this.round_coord(position.coords.latitude), this.round_coord(position.coords.longitude)] });
            }
        });
        if (this.base.lat && this.base.lng) {
            local_ini = [this.base.lat, this.base.lng];
        }

        this.icon = Img_mark;

        this.mymap = L.map('mapid', { zoomControl: false, attributionControl: false, maxZoom: 20 }).setView(local_ini, 14);
        let tileConfig = Object.assign({}, Config.tile_google_config, { maxZoom: 20 });
        L.tileLayer(Config.tile_google, tileConfig).addTo(this.mymap);


        if (this.mymap.doubleClickZoom) {
            this.mymap.doubleClickZoom.disable();
        }

        [
            { name: this.planningPanes.N, zIndex: 410 },
            { name: this.planningPanes.T, zIndex: 420 },
            { name: this.planningPanes.F, zIndex: 430 },
            { name: this.planningPanes.X, zIndex: 432 },
            { name: this.planningPanes.R, zIndex: 434 },
            { name: this.planningPanes.lines, zIndex: 440 },
            { name: this.planningPanes.AB, zIndex: 450 },
            { name: this.planningPanes.directionArrows, zIndex: 455 }
        ].forEach(item => {
            this.mymap.createPane(item.name);
            const pane = this.mymap.getPane(item.name);
            if (pane && pane.style) pane.style.zIndex = item.zIndex;
        });

        const directionArrowPane = this.mymap.getPane(this.planningPanes.directionArrows);
        if (directionArrowPane && directionArrowPane.style) directionArrowPane.style.pointerEvents = 'none';

        this.mymap.createPane('overlapPane');
        const op = this.mymap.getPane('overlapPane');
        if (op && op.style) {
            op.style.zIndex = 350;
            op.style.pointerEvents = 'none';
        }

        L.control.scale({ imperial: false }).addTo(this.mymap);

        this.featureGroupP = L.featureGroup().addTo(this.mymap);
        this.featureGroupPM = L.featureGroup().addTo(this.mymap);
        this.featureGroupM = L.featureGroup().addTo(this.mymap);
        this.featureGroupE = L.featureGroup().addTo(this.mymap);

        this.featureGroupTest = L.featureGroup().addTo(this.mymap);

        this.overlapGroup = L.featureGroup().addTo(this.mymap);

        this.drawControl = new L.Control.Draw({
            draw: {
                polyline: false,
                polygon: false,
                circle: false,
                rectangle: false,
                marker: false,
                circlemarker: false
            },
            edit: false
        }).addTo(this.mymap);

        this.mymap.on('draw:created', (e) => {
            const layer = e.layer;

            if (this.state.selector) {
                this.completeSelectorEstimate(layer);
                return;
            }

            const hasIcon = layer &&
                layer.options &&
                layer.options.icon &&
                layer.options.icon.options;

            const baseIconImg =
                this.icon &&
                this.img_base &&
                this.icon[this.img_base['T']] &&
                this.icon[this.img_base['T']].img;

            const fuelIconImg =
                this.icon &&
                this.img_fuel &&
                this.icon[this.img_fuel['Y']] &&
                this.icon[this.img_fuel['Y']].img;

            if (
                hasIcon &&
                baseIconImg &&
                baseIconImg === layer.options.icon.options.iconUrl
            ) {
                let temp_guid = this.base.guid;

                let layerBase = this.mymap._layers[this.base.guid];
                this.removeLayer(this.featureGroupM, layerBase);

                this.base.lat = layer._latlng.lat;
                this.base.lng = layer._latlng.lng;
                this.base.guid = tools.newGuid();
                this.keepData('base', this.base);

                layer._leaflet_id = this.base.guid;
                layer.bindPopup('');
                layer.on("click", () => { this.popup_marker(layer, 'base'); });

                this.setState({ uEstimative: true, setBase: true });

                this.featureGroupM.addLayer(layer);

                let temp_marker = this.state.markers.filter(item => (item.guid === temp_guid));
                if (temp_marker.length > 0) {
                    this.drawMarker(temp_marker[0]);
                }

            } else if (
                hasIcon &&
                fuelIconImg &&
                fuelIconImg === layer.options.icon.options.iconUrl
            ) {
                layer._leaflet_id = tools.newGuid();
                layer.bindPopup('');
                layer.on("click", () => { this.popup_marker(layer, 'fuel'); });
                this.setState({ uEstimative: true });
                this.featureGroupM.addLayer(layer);
                this.fuel.push({
                    guid: layer._leaflet_id,
                    lat: layer._latlng.lat,
                    lng: layer._latlng.lng,
                    status: 'Y'
                });
                this.keepData('fuel', this.fuel);

            } else if (this.state.polyCreate || this.state.create_circle) {

                const guid = tools.newGuid();

                const defaultName = (this.state.nameP && this.state.nameP.toString().trim())
                    ? this.state.nameP.toString().trim()
                    : this.nextIndex(this.state.polygons);

                layer.on("click", (event) => {
                    const poly = this.state.polygons.find(p => p.guid === guid);
                    this.handlePolygonPointSelection(event, poly);
                });

                layer._leaflet_id = guid;
                layer.options.pane = this.planningPanes.N;
                layer.setStyle({ color: this.color_default });

                let tempPoly = new oPolygon(this.props);
                tempPoly.guid = guid;
                tempPoly.name = defaultName;
                tempPoly.type = 'N';
                tempPoly.faixa = this.state.faixa;
                tempPoly.fluxo = this.state.fluxo;

                let latlng = [];

                if (layer._mRadius) {
                    tempPoly.radius = layer._mRadius;
                    tempPoly.point = [layer._latlng.lat, layer._latlng.lng];
                    latlng = geo.cicleToPolygon(
                        [layer._latlng.lng, layer._latlng.lat],
                        layer._mRadius
                    );
                } else {
                    if (layer._latlngs && layer._latlngs[0]) {
                        for (let c = 0; c < layer._latlngs[0].length; c++) {
                            const element = layer._latlngs[0][c];
                            latlng = latlng.concat([[element.lat, element.lng]]);
                        }
                    }
                }

                if (layer._mRadius) {
                    tempPoly.area = layer._mRadius * layer._mRadius * Math.PI;
                } else if (L.GeometryUtil && L.GeometryUtil.geodesicArea) {
                    tempPoly.area = L.GeometryUtil.geodesicArea(layer.getLatLngs()[0]);
                } else {
                    tempPoly.area = 0;
                }

                tempPoly.points = JSON.stringify(latlng);

                if (this.state.id_client) tempPoly.id_client = this.state.id_client;
                if (this.state.id_property) tempPoly.id_property = this.state.id_property;
                if (this.state.id_region) tempPoly.id_region = this.state.id_region;

                const newPolygons = this.state.polygons.concat(tempPoly);

                this.featureGroupP.addLayer(layer);

                layer.bindTooltip(defaultName, {
                    permanent: true,
                    direction: "center",
                    className: 'tool-tip-L tool-tip-size16-L'
                }).openTooltip();

                const polygonsForSelection = newPolygons;
                let baseSelection = [];
                const existingSel = this.state.areaFilterSelection;

                if (existingSel && existingSel.length > 0) {
                    baseSelection = existingSel.slice();
                } else {
                    if (this.mymap && this.mymap._layers) {
                        for (let i = 0; i < polygonsForSelection.length; i++) {
                            const p = polygonsForSelection[i];
                            if (p && p.guid && this.mymap._layers[p.guid]) {
                                baseSelection.push(p.guid);
                            }
                        }
                    }
                }

                if (baseSelection.indexOf(guid) < 0) {
                    baseSelection.push(guid);
                }

                let newSelPolygons = this.state.sel_polygons || [];
                let newSelPoly = this.state.sel_poly || null;

                if (baseSelection.length === 1) {
                    newSelPolygons = [baseSelection[0]];
                    if (guid === baseSelection[0]) {
                        newSelPoly = tempPoly;
                    } else {
                        newSelPoly = newPolygons.find(function (p) {
                            return p && p.guid === baseSelection[0];
                        }) || null;
                    }
                } else if (baseSelection.length > 1) {
                    if (!(newSelPoly && baseSelection.indexOf(newSelPoly.guid) >= 0)) {
                        newSelPoly = tempPoly;
                    }
                    if (newSelPolygons.indexOf(guid) < 0) {
                        newSelPolygons = newSelPolygons.concat(guid);
                    }
                }

                this.setState(
                    {
                        polygons: newPolygons,
                        areaFilterSelection: baseSelection,
                        sel_polygons: newSelPolygons,
                        sel_poly: newSelPoly,
                        polyCreate: false,
                        create_circle: false,
                        polyNameEditing: false
                    },
                    () => {
                        this.applyAreaFilter();
                    }
                );

            } else {
                return;
            }

            this.setState({ base: false, fuel: false });
            this.resetRef();
            this.resetDownloadJob();
            // Each time a feaute is created, it's added to the over arching feature group

            this.recalculateOverlaps();

            this.markClick = false;
        });

        this.mymap.on('draw:canceled', () => {
            this.cancelCreate();
            this.regua(false);
            //this.markClick = false;
        });

        this.mymap.on('draw:deleted', (e) => {
            let tempPolygons = this.state.polygons;
            let layers = e.layers;
            if (layers) {
                layers.eachLayer((feature) => {
                    for (let j = 0; j < tempPolygons.length; j++) {
                        const element = tempPolygons[j];
                        if (element.guid === feature._leaflet_id) {
                            tempPolygons.splice(tempPolygons.indexOf(element), 1);
                            if (element.lines.length > 0) {
                                this.removeLayer(this.featureGroupE, element.layer);
                                this.removeLayer(this.featureGroupE, (element.layer).replace("_lines", "_abL"));
                                this.removeLayer(this.featureGroupE, (element.layer).replace("_lines", "_abFG"));
                                this.removeLayer(this.featureGroupE, (element.layer).replace("_lines", "_abFR"));
                            }
                            break;
                        }
                    }
                    for (let j = 0; j < this.fuel.length; j++) {
                        const element = this.fuel[j];
                        if (element.guid === feature._leaflet_id) {
                            this.fuel.splice(this.fuel.indexOf(element), 1);
                            this.setState({ uEstimative: this.state.dEstimative ? true : false });
                            this.keepData('fuel', this.fuel);
                            break;
                        }
                    }
                });
                this.resetDownloadJob();
                this.recalculateOverlaps();
            }
        });

        this.mymap.on('dragstart', () => {
            this.mapIsDragging = true;
        });

        this.mymap.on('dragend', () => {
            setTimeout(() => {
                this.mapIsDragging = false;
            }, 0);
        });

        this.mymap.on('movestart', () => {
            this.mapIsDragging = true;
        });

        this.mymap.on('moveend', () => {
            setTimeout(() => {
                this.mapIsDragging = false;
            }, 0);
        });

        this.mymap.on('click', () => {
            if (this.state.selector) return;

            if (this.ignoreNextMapClick) {
                this.ignoreNextMapClick = false;
                return;
            }

            if (!this.state.angle && !this.state.ruler_a) {
                this.handleClickP();
            }

            if (this.closeWaypointPopup) {
                this.closeWaypointPopup();
            }
        });

        this.mymap.on('dblclick', (e) => {
            if (!e || !e.latlng) return;
            if (this.mapIsDragging) return;

            if (this.state &&
                (this.state.selector || this.state.polyCreate || this.state.create_circle || this.state.ruler_a)) {
                return;
            }

            if (!this.waypointMarker) {
                this.createWaypointMarker(e.latlng);
            } else {
                this.moveWaypointMarker(e.latlng);
            }
        });

        this.mymap.on('mouseup', e => {
            if (this.state.ruler_a && !this.mymap.dragging._enabled) {
                this.mymap.dragging.enable();
                if (this.ruler_p.second.lat === null) {
                    this.drawCreateToolbar.addVertex(e.latlng);
                }
            }
        });

        this.mymap.on('moveend', (e) => {
            let centerLat = this.mymap.getCenter().lat;
            let centerLng = this.mymap.getCenter().lng;

            let lat = { error: false, input: this.formatCoordText(centerLat, 'latitude'), value: centerLat };
            let lng = { error: false, input: this.formatCoordText(centerLng, 'longitude'), value: centerLng };

            this.setState({ lat: lat, lng: lng });
            this.checkMarkers();
        });

        this.mymap.on('zoomend', () => {
            if (this.mymap.getZoom() < 12) {
                tools.cssShow('editable', false);
            } else {
                tools.cssShow('editable', true);
            }
            this.checkMarkers();
        });

        this.mymap.on('draw:drawvertex', (e) => {
            if (this.drawCreateToolbar.type === 'polyline') {
                let layerIds = Object.keys(e.layers._layers);
                if (layerIds.length > 1) {
                    let v2 = e.layers._layers[layerIds[1]];
                    this.ruler_p.second.lat = v2._latlng.lat;
                    this.ruler_p.second.lng = v2._latlng.lng;
                    requestAnimationFrame(() => this.completeRuler());
                } else if (layerIds.length === 1) {
                    let v1 = e.layers._layers[layerIds[0]];
                    this.ruler_p.first.lat = v1._latlng.lat;
                    this.ruler_p.first.lng = v1._latlng.lng;
                }
            }
        });

        this.drawEditToolbar = new L["EditToolbar"].Edit(this.mymap, {
            featureGroup: this.featureGroupM,
        });

        this.drawDeleteToolbar = new L["EditToolbar"].Delete(this.mymap, {
            featureGroup: this.featureGroupP
        });

        L.drawLocal.draw.handlers.polyline.tooltip.start = '';
        L.drawLocal.draw.handlers.polyline.tooltip.cont = '';
        L.drawLocal.draw.handlers.polyline.tooltip.end = '';

        let newDate = new Date();
        newDate = new Date(newDate.getFullYear(), newDate.getMonth(), newDate.getDate() + 1, 8);
        this.setState({ dateTimeTrabalho: this.getDateTime(newDate) });

        this.list_markers(() => {
            if (this.props.guid) {
                this.loadJob(this.props.guid);
            } else if (this.props.type !== 'new') {
                this.keepData();
                let f_estimate = localStorage.getItem('f-estimate');
                if (f_estimate) {
                    let estimate = JSON.parse(f_estimate);
                    let polys = [];

                    if (estimate.polygons && estimate.polygons.length > 0) {
                        for (let i = 0; i < estimate.polygons.length; i++) {
                            let poly = new oPolygon(this.props);
                            poly.guid = estimate.polygons[i].guid;
                            poly.name = estimate.polygons[i].name;
                            poly.points = estimate.polygons[i].points;
                            poly.type = estimate.polygons[i].type;
                            poly.ab = estimate.polygons[i].ab;
                            poly.id_client = estimate.polygons[i].id_client ? estimate.polygons[i].id_client : null;
                            poly.id_property = estimate.polygons[i].id_property ? estimate.polygons[i].id_property : null;
                            poly.faixa = this.state.faixa;
                            poly.fluxo = this.state.fluxo;
                            polys.push(poly);
                        }
                    }

                    estimate.polygons = polys;

                    for (let i = 0; i < polys.length; i++) {
                        this.drawPolygon(polys[i], polys);
                    }

                    let prefilledClientId = null;
                    let prefilledClientName = '';
                    if (estimate.client) {
                        prefilledClientId = estimate.client.id ? estimate.client.id : null;
                        prefilledClientName = estimate.client.name ? estimate.client.name : '';
                    }
                    if (!prefilledClientId && estimate.id_client) {
                        prefilledClientId = estimate.id_client;
                    }
                    if (!prefilledClientName && estimate.client_est) {
                        prefilledClientName = estimate.client_est;
                    }

                    this.prefilledClientId = prefilledClientId;
                    this.prefilledClientName = prefilledClientName;

                    this.setState({ polygons: polys, client_est: prefilledClientName ? prefilledClientName : this.state.client_est }, () => {
                        this.loadData(estimate);

                        if (this.featureGroupP && this.featureGroupP.getBounds && this.featureGroupP.getBounds().isValid()) {
                            this.mymap.fitBounds(this.featureGroupP.getBounds());
                        }

                        localStorage.removeItem('f-estimate');
                        localStorage.removeItem('d-estimate');
                        this.keepData();
                        this.startAreaAbPlanning();
                    });
                } else {
                    const { res } = this.props;
                    let d_estimate = localStorage.getItem('d-estimate');
                    if (d_estimate) {
                        let estimate = JSON.parse(d_estimate);
                        estimate = this.convertEstimateToCurrentUnits(estimate);
                        this.setState({//TODO:check if need translate
                            faixa: estimate.faixa ? estimate.faixa : this.state.faixa,
                            space: estimate.space === undefined || estimate.space === null ? 0 : estimate.space,
                            fluxo: estimate.fluxo ? estimate.fluxo : this.state.fluxo,
                            altura: estimate.altura ? estimate.altura : this.state.altura,
                            carga: estimate.carga ? estimate.carga : this.state.carga,
                            angulo: estimate.angulo ? estimate.angulo : this.state.angulo,
                            estrategia: estimate.estrategia ? estimate.estrategia : this.state.estrategia,
                            dificuldade: estimate.dificuldade ? estimate.dificuldade : this.state.dificuldade,

                            cost: estimate.cost ? estimate.cost : this.state.cost,
                            speed: estimate.speed_apl ? estimate.speed_apl : this.state.speed_apl,
                            speed_travel: estimate.speed_travel ? estimate.speed_travel : this.state.speed_travel,
                            speed_loop: estimate.speed_loop ? estimate.speed_loop : this.state.speed_loop,
                            speed_apl: estimate.speed_apl ? estimate.speed_apl : this.state.speed_apl,
                            size_loop: estimate.size_loop ? estimate.size_loop : this.state.size_loop,
                            size_h_loop: estimate.size_h_loop ? estimate.size_h_loop : this.state.size_h_loop,
                            r_time: estimate.r_time ? estimate.r_time : this.state.r_time,
                            add_list: estimate.add_list ? this.state.add_list : [],

                            cLucro: estimate.cLucro && !isNaN(estimate.cLucro) ? estimate.cLucro : this.state.cLucro,
                            vLucro_old: estimate.vLucro_old ? estimate.vLucro_old : this.state.vLucro_old,
                            cImp: estimate.cImp ? estimate.cImp : this.state.cImp,
                            //lat_base: estimate.lat_base ? estimate.lat_base : '',
                            //lng_base: estimate.lng_base ? estimate.lng_base : '',

                            //reset on new
                            title_est: estimate.title_est ? this.state.title_est : this.dName,
                            plane_est: estimate.plane_est ? estimate.plane_est : this.state.plane_est,
                            client_est: estimate.client_est ? estimate.client_est : this.state.client_est,
                            pilot_est: estimate.pilot_est ? estimate.pilot_est : this.state.pilot_est,
                            polygons: estimate.polygons ? estimate.polygons : [],
                            horas_dia: estimate.horas_dia ? estimate.horas_dia : this.state.horas_dia,

                            horas_base: estimate.horas_base ? estimate.horas_base : false,
                            aproveitamento: estimate.aproveitamento ? estimate.aproveitamento : false,
                        });
                        this.loadData(estimate);

                        if (estimate.plane_est) {
                            this.listEquipment(estimate.plane_est);
                        }
                    }
                }
            }
        });
    };

    loadData = (estimate) => {
        if (!this.base.lat) this.base.lat = estimate.lat_base ? estimate.lat_base : '';
        if (!this.base.lng) this.base.lng = estimate.lng_base ? estimate.lng_base : '';

        this.areaTotal = estimate.area ? estimate.area : 0;
        this.time = estimate.time ? estimate.time : this.time;
        if (estimate.base) {
            let layer = this.mymap._layers[estimate.base.guid];
            this.removeLayer(this.featureGroupPM, layer);

            if (!estimate.base.type) {
                estimate.base.type = 'H';
            }

            this.create_update_base(estimate.base);
        }
        if (estimate.fuel) {
            for (let index = 0; index < estimate.fuel.length; index++) {
                const element = estimate.fuel[index];
                let item = this.fuel.filter(item => item.guid === element.guid);
                if (!element.status) {
                    element.status = 'Y';
                }
                if (item.length > 0) {
                    item = item[0];
                } else {
                    item = {};
                    this.fuel.push(item);
                }
                item.status = element.status;
                item.lat = element.lat;
                item.lng = element.lng;
                item.guid = element.guid ? element.guid : tools.newGuid();
                item.type = element.type;

                let layer = this.mymap._layers[item.guid];
                this.removeLayer(this.featureGroupPM, layer);

                this.create_update_fuel(item);
            }
        }
        if (estimate.polygons && estimate.polygons.length > 0) {
            for (let i = 0; i < estimate.polygons.length; i++) {
                if (!estimate.polygons[i].fluxo) {
                    estimate.polygons[i].fluxo = this.state.fluxo;
                }
                if (!estimate.polygons[i].faixa) {
                    estimate.polygons[i].faixa = this.state.faixa;
                }
                this.setState({ polygons: estimate.polygons ? estimate.polygons : [] });
                this.drawPolygon(estimate.polygons[i], estimate.polygons);
                if (estimate.polygons[i].lines && estimate.polygons[i].lines.length > 0) {
                    const layer = this.mymap._layers[estimate.polygons[i].guid];
                    this.migratePlanningGeometry(estimate.polygons[i], layer);
                    this.intersectLine(estimate.polygons[i], layer);
                    this.setState({ dEstimative: true, uEstimative: false });
                }
                /*if (estimate.polygons[i].out && estimate.polygons[i].out.length > 0) {
                    this.travel_time = estimate.polygons[0].out[estimate.polygons[0].selected_Out].trasTime;
                }*/
            }
            this.travel_time = estimate.travel_time;
            setTimeout(() => {
                this.calcEstimativa();
                this.handleClickP();
            }, 200);
            this.mymap.fitBounds(this.featureGroupP.getBounds());
        }
    };

    loadJob = (guid) => {
        if (guid) {
            this.setState({ progress: true });
            let apiUrl = Config.server + '/job_load/' + guid;
            let method = 'GET';

            let options = {
                method: method,
                headers: {
                    'Authorization': localStorage.getItem('access-token-jwt')
                }
            };

            fetch(apiUrl, options)
                .then((res) => {
                    if (res.status !== 200) throw res;
                    else return res.json();
                }).then(
                    (result) => {
                        this.setState({ progress: false });
                        if (result) {

                            const mapServiceTypeFromServiceOrder = (serviceType) => {
                                if (!serviceType) return '';

                                const serviceTypeValue = String(serviceType).trim();
                                const validServices = {
                                    AplicacaoAgrotoxico: true,
                                    AplicacaoBioinsumo: true,
                                    AplicacaoFertilizante: true,
                                    Semeadura: true,
                                    Maturador: true,
                                    AplicacaoAdjuvante: true
                                };

                                return validServices[serviceTypeValue] ? serviceTypeValue : '';
                            };

                            const mapAgroClass = (agroClassValue) => {
                                const ret = {
                                    insecticide: false,
                                    herbicide: false,
                                    fungicide: false,
                                    seeding: false,
                                    fertilizing: false,
                                    maturator: false,
                                    others: false,
                                    otherText: ''
                                };
                                if (!agroClassValue) return ret;

                                let obj = null;

                                if (typeof agroClassValue === 'string') {
                                    try { obj = JSON.parse(agroClassValue); } catch (_) { obj = null; }
                                } else if (typeof agroClassValue === 'object') {
                                    obj = agroClassValue;
                                }

                                if (!obj) return ret;

                                ret.insecticide = obj.insecticide === true;
                                ret.herbicide = obj.herbicide === true;
                                ret.fungicide = obj.fungicide === true;
                                ret.seeding = obj.seeding === true;
                                ret.fertilizing = obj.fertilizing === true;
                                ret.maturator = obj.maturator === true;
                                ret.others = obj.others === true;
                                ret.otherText = obj.otherText || obj.otherService || '';

                                return ret;
                            };

                            const parseRiskArea = (riskAreaValue) => {
                                if (!riskAreaValue) return null;

                                let raw = riskAreaValue;
                                if (typeof raw === 'string') {
                                    raw = raw.trim();
                                    if (!raw) return null;
                                    try { return JSON.parse(raw); } catch (_) { return null; }
                                }
                                if (typeof raw === 'object') return raw;
                                return null;
                            };

                            const allProducts = Array.isArray(this.state.list_all_prod) ? this.state.list_all_prod : [];
                            let serviceOrderFaixa = null;
                            let serviceOrderFluxo = null;
                            let correctServiceOrderID = null;

                            let serviceOrderPlaneName = '';
                            let serviceOrderPilotName = '';
                            let serviceOrderClientName = '';
                            let serviceOrderAplicacao = this.state.aplicacao;
                            let serviceOrderPrefillState = null;
                            let jobDataPrefillState = null;


                            if (result.job &&
                                result.job.serviceOrder &&
                                result.job.serviceOrder.jobs &&
                                result.job.serviceOrder.jobs.length) {

                                correctServiceOrderID = result.job.serviceOrder.id;

                                var jobsSO = result.job.serviceOrder.jobs;
                                var mergedAreas = [];

                                for (var iJob = 0; iJob < jobsSO.length; iJob++) {
                                    var jItem = jobsSO[iJob];
                                    if (jItem && jItem.areas && jItem.areas.length) {

                                        for (var a = 0; a < jItem.areas.length; a++) {
                                            var areaOrig = jItem.areas[a];
                                            var areaCopy = Object.assign({}, areaOrig);

                                            areaCopy._service_type = jItem.service_type || jItem.serviceType || jItem.typeService || '';
                                            areaCopy._agro_class = jItem.agro_class || jItem.agroClass || '';
                                            areaCopy._crop = jItem.crop || '';
                                            areaCopy._risk_area = jItem.risk_area || '';
                                            areaCopy._products = Array.isArray(jItem.products) ? jItem.products : [];

                                            mergedAreas.push(areaCopy);
                                        }
                                    }
                                }

                                result.job.serviceOrder.areas = mergedAreas;

                                let planeName = this.state.plane_est;
                                let clientName = this.state.client_est;
                                let pilotName = this.state.pilot_est;
                                let aplicacaoTipo = this.state.aplicacao;

                                const jobsSO2 = result.job.serviceOrder.jobs;
                                for (let i = 0; i < jobsSO2.length; i++) {
                                    const jItem2 = jobsSO2[i];
                                    const jobData = result.job && result.job.data ? result.job.data : {};

                                    const planeFromSO = jItem2.plane ? jItem2.plane : (jobData.aircraftprefix ? jobData.aircraftprefix : '');
                                    const pilotFromSO = jItem2.pilot ? jItem2.pilot : (jobData.pilotname ? jobData.pilotname : '');
                                    const clientFromSO = result.job.serviceOrder.client ? result.job.serviceOrder.client : (jobData.customername ? jobData.customername : '');

                                    if (!serviceOrderPlaneName && planeFromSO) {
                                        serviceOrderPlaneName = planeFromSO;
                                    }

                                    if (!serviceOrderPilotName && pilotFromSO) {
                                        serviceOrderPilotName = pilotFromSO;
                                    }

                                    if (!serviceOrderClientName && clientFromSO) {
                                        serviceOrderClientName = clientFromSO;
                                    }

                                    if (jItem2.application_type) {
                                        serviceOrderAplicacao = jItem2.application_type === 'liquid' ? 'L' : 'S';
                                    }

                                    if (!result.state) {
                                        planeName = planeFromSO ? planeFromSO : planeName;
                                        clientName = clientFromSO ? clientFromSO : clientName;
                                        pilotName = pilotFromSO ? pilotFromSO : pilotName;
                                        aplicacaoTipo = serviceOrderAplicacao;
                                    }

                                    if (
                                        serviceOrderFaixa === null &&
                                        jItem2.strip_width !== undefined &&
                                        jItem2.strip_width !== null &&
                                        !isNaN(Number(jItem2.strip_width)) &&
                                        Number(jItem2.strip_width) > 0
                                    ) {
                                        serviceOrderFaixa = Number(jItem2.strip_width);
                                    }

                                    if (
                                        serviceOrderFluxo === null &&
                                        jItem2.application_flow !== undefined &&
                                        jItem2.application_flow !== null &&
                                        !isNaN(Number(jItem2.application_flow)) &&
                                        Number(jItem2.application_flow) > 0
                                    ) {
                                        serviceOrderFluxo = Number(jItem2.application_flow);
                                    }
                                }


                                if (!result.state) {
                                    const planeNames = planeName ? String(planeName).split(',').map(item => item.trim()).filter(Boolean) : [];
                                    const pilotNames = pilotName ? String(pilotName).split(',').map(item => item.trim()).filter(Boolean) : [];
                                    const planeData = this.state.planes.filter(data => planeNames.indexOf(String(data.name || '').trim()) >= 0 || planeNames.indexOf(String(data.original_name || '').trim()) >= 0);
                                    const pilotData = this.state.pilots.filter(data => pilotNames.indexOf(String(data.name || '').trim()) >= 0 || pilotNames.indexOf(String(data.original_name || '').trim()) >= 0);

                                    const jobPlaneId = result.job && result.job.id_plane ? Number(result.job.id_plane) : null;
                                    const planeIds = planeData.length ? planeData.map(item => item.id) : (jobPlaneId ? [jobPlaneId] : []);

                                    serviceOrderPrefillState = {
                                        serviceOrderID: result.job.serviceOrder.id,
                                        plane_est: planeData.length ? planeData.map(item => item.name).join(', ') : planeName,
                                        plane_est_id: planeIds.length ? planeIds[0] : null,
                                        plane_est_ids: planeIds,
                                        plane_est_id_company: planeData[0] ? planeData[0].id_company : null,
                                        plane_est_id_companies: planeData.map(item => item.id_company),
                                        client_est: clientName,
                                        pilot_est: pilotData.length ? pilotData.map(item => item.name).join(', ') : pilotName,
                                        pilot_est_id: pilotData[0] ? pilotData[0].id : null,
                                        pilot_est_ids: pilotData.map(item => item.id),
                                        pilot_est_id_company: pilotData[0] ? pilotData[0].id_company : null,
                                        pilot_est_id_companies: pilotData.map(item => item.id_company),
                                        aplicacao: aplicacaoTipo
                                    };

                                    if (serviceOrderFaixa !== null) {
                                        serviceOrderPrefillState.faixa = serviceOrderFaixa;
                                    }

                                    if (serviceOrderFluxo !== null) {
                                        serviceOrderPrefillState.fluxo = serviceOrderFluxo;
                                    }

                                }
                            }

                            if (!result.state && result.job && result.job.data) {
                                const jobData = result.job.data;
                                const planeName = jobData.aircraftprefix ? jobData.aircraftprefix : '';
                                const clientName = jobData.customername ? jobData.customername : '';
                                const pilotName = jobData.pilotname ? jobData.pilotname : '';
                                const jobPlaneId = result.job.id_plane ? Number(result.job.id_plane) : null;

                                const planeNames = planeName ? String(planeName).split(',').map(item => item.trim()).filter(Boolean) : [];
                                const pilotNames = pilotName ? String(pilotName).split(',').map(item => item.trim()).filter(Boolean) : [];
                                const planeData = this.state.planes.filter(data => planeNames.indexOf(String(data.name || '').trim()) >= 0 || planeNames.indexOf(String(data.original_name || '').trim()) >= 0);
                                const pilotData = this.state.pilots.filter(data => pilotNames.indexOf(String(data.name || '').trim()) >= 0 || pilotNames.indexOf(String(data.original_name || '').trim()) >= 0);
                                const planeIds = planeData.length ? planeData.map(item => item.id) : (jobPlaneId ? [jobPlaneId] : []);

                                jobDataPrefillState = {};

                                if (clientName) {
                                    jobDataPrefillState.client_est = clientName;
                                }

                                if (planeName) {
                                    jobDataPrefillState.plane_est = planeData.length ? planeData.map(item => item.name).join(', ') : planeName;
                                    jobDataPrefillState.plane_est_id = planeIds.length ? planeIds[0] : null;
                                    jobDataPrefillState.plane_est_ids = planeIds;
                                    jobDataPrefillState.plane_est_id_company = planeData[0] ? planeData[0].id_company : null;
                                    jobDataPrefillState.plane_est_id_companies = planeData.map(item => item.id_company);
                                }

                                if (pilotName) {
                                    jobDataPrefillState.pilot_est = pilotData.length ? pilotData.map(item => item.name).join(', ') : pilotName;
                                    jobDataPrefillState.pilot_est_id = pilotData[0] ? pilotData[0].id : null;
                                    jobDataPrefillState.pilot_est_ids = pilotData.map(item => item.id);
                                    jobDataPrefillState.pilot_est_id_company = pilotData[0] ? pilotData[0].id_company : null;
                                    jobDataPrefillState.pilot_est_id_companies = pilotData.map(item => item.id_company);
                                }

                                if (jobData.title) {
                                    jobDataPrefillState.title_est = jobData.title;
                                }

                                if (result.job.id) {
                                    jobDataPrefillState.id = result.job.id;
                                }

                                if (Object.keys(jobDataPrefillState).length > 0) {
                                }
                            }

                            if (result.state) {
                                this.savedPlanning = true;
                                const { res } = this.props;
                                if (result.state.aproveitamento && Array.isArray(result.state.polygons)) {
                                    result.state.polygons.forEach((polygon) => {
                                        const selectedOut = polygon.out && polygon.out[polygon.selected_Out];
                                        if (selectedOut && selectedOut.qtdFuel != null) {
                                            polygon.flxMedApl = planningPolygonRefuelCount(polygon, selectedOut, true);
                                        }
                                    });
                                }
                                result.polygons = result.state.polygons;
                                this.loadData(result);

                                if (result.state.base && result.state.base.lat !== undefined && result.state.base.lng !== undefined) {
                                    const latBase = Number(result.state.base.lat);
                                    const lngBase = Number(result.state.base.lng);

                                    if (!isNaN(latBase) && !isNaN(lngBase)) {
                                        let itemBase = {
                                            lat: latBase,
                                            lng: lngBase,
                                            guid: result.state.base.guid ? result.state.base.guid : tools.newGuid(),
                                            type: result.state.base.type ? result.state.base.type : 'H'
                                        };
                                        this.create_update_base(itemBase);
                                        this.setState({ setBase: true });
                                    }
                                }

                                result.state = this.convertEstimateToCurrentUnits(result.state);
                                let nextState = Object.assign({}, result.state);


                                if (nextState.base !== undefined) delete nextState.base;
                                if (nextState.fuel !== undefined) delete nextState.fuel;

                                if (nextState.base_point !== undefined) delete nextState.base_point;
                                if (nextState.fuel_points !== undefined) delete nextState.fuel_points;

                                nextState.base = false;
                                nextState.fuel = false;

                                if (correctServiceOrderID) {
                                    nextState.serviceOrderID = correctServiceOrderID;
                                }

                                const jobData = result.job && result.job.data ? result.job.data : {};

                                const fallbackPlaneName = serviceOrderPlaneName
                                    ? serviceOrderPlaneName
                                    : (jobData.aircraftprefix ? jobData.aircraftprefix : '');

                                const fallbackPilotName = serviceOrderPilotName
                                    ? serviceOrderPilotName
                                    : (jobData.pilotname ? jobData.pilotname : '');

                                const fallbackClientName = serviceOrderClientName
                                    ? serviceOrderClientName
                                    : (jobData.customername ? jobData.customername : '');


                                if ((!nextState.plane_est || String(nextState.plane_est).trim() === '') && fallbackPlaneName) {
                                    const planeNames = String(fallbackPlaneName).split(',').map(item => item.trim()).filter(Boolean);
                                    const planeData = this.state.planes.filter(data =>
                                        planeNames.indexOf(String(data.name || '').trim()) >= 0 ||
                                        planeNames.indexOf(String(data.original_name || '').trim()) >= 0
                                    );

                                    const jobPlaneId = result.job && result.job.id_plane ? Number(result.job.id_plane) : null;
                                    const planeIds = planeData.length ? planeData.map(item => item.id) : (jobPlaneId ? [jobPlaneId] : []);

                                    nextState.plane_est = planeData.length ? planeData.map(item => item.name).join(', ') : fallbackPlaneName;
                                    nextState.plane_est_id = planeIds.length ? planeIds[0] : null;
                                    nextState.plane_est_ids = planeIds;
                                    nextState.plane_est_id_company = planeData[0] ? planeData[0].id_company : null;
                                    nextState.plane_est_id_companies = planeData.map(item => item.id_company);
                                }

                                if ((!nextState.pilot_est || String(nextState.pilot_est).trim() === '') && fallbackPilotName) {
                                    const pilotNames = String(fallbackPilotName).split(',').map(item => item.trim()).filter(Boolean);
                                    const pilotData = this.state.pilots.filter(data =>
                                        pilotNames.indexOf(String(data.name || '').trim()) >= 0 ||
                                        pilotNames.indexOf(String(data.original_name || '').trim()) >= 0
                                    );

                                    nextState.pilot_est = pilotData.length ? pilotData.map(item => item.name).join(', ') : fallbackPilotName;
                                    nextState.pilot_est_id = pilotData[0] ? pilotData[0].id : null;
                                    nextState.pilot_est_ids = pilotData.map(item => item.id);
                                    nextState.pilot_est_id_company = pilotData[0] ? pilotData[0].id_company : null;
                                    nextState.pilot_est_id_companies = pilotData.map(item => item.id_company);
                                }

                                if ((!nextState.client_est || String(nextState.client_est).trim() === '') && fallbackClientName) {
                                    nextState.client_est = fallbackClientName;
                                }

                                if (serviceOrderAplicacao) {
                                    nextState.aplicacao = serviceOrderAplicacao;
                                }

                                if (serviceOrderFaixa !== null && (!nextState.faixa || Number(nextState.faixa) <= 0)) {
                                    nextState.faixa = serviceOrderFaixa;
                                }

                                if (serviceOrderFluxo !== null && (!nextState.fluxo || Number(nextState.fluxo) <= 0)) {
                                    nextState.fluxo = serviceOrderFluxo;
                                }


                                this.markClick = false;

                                this.setState(nextState, () => {

                                    if (this.state.plane_est_id || this.state.plane_est) {
                                        this.applySelectedPlaneParameters();
                                    }
                                });
                            } else if (result.job) {
                                const { res } = this.props;
                                const prefillState = Object.assign({}, jobDataPrefillState || {}, serviceOrderPrefillState || {});

                                if (Object.keys(prefillState).length > 0) {
                                    this.setState(prefillState, () => {
                                        if (this.state.plane_est_id || this.state.plane_est) {
                                            this.applySelectedPlaneParameters();
                                        }
                                    });
                                }

                                let cLucro = this.state.cLucro;
                                let cImp = this.state.cImp;

                                const serviceAreas = (result.job.serviceOrder && result.job.serviceOrder.areas)
                                    ? result.job.serviceOrder.areas
                                    : null;

                                let polygons = this.state.polygons || [];
                                let baseCreatedFromPoint = false;
                                let createdFromServiceOrder = false;

                                if (serviceAreas && (!result.job.polys || !result.job.polys.length)) {

                                    for (let i = 0; i < serviceAreas.length; i++) {
                                        const area = serviceAreas[i];
                                        let rawPoints = [];

                                        try {
                                            rawPoints = area.points_place ? JSON.parse(area.points_place) : [];
                                        } catch (e) {
                                            rawPoints = [];
                                        }

                                        if (!rawPoints || !rawPoints.length) {
                                            continue;
                                        }

                                        const areaType = (area.type || '').toLowerCase();

                                        if (areaType === 'point' && !baseCreatedFromPoint) {
                                            const p0 = rawPoints[0];
                                            if (p0 && p0.length >= 2) {
                                                const latBase = Number(p0[0]);
                                                const lngBase = Number(p0[1]);

                                                if (!isNaN(latBase) && !isNaN(lngBase)) {
                                                    const itemBase = {
                                                        lat: latBase,
                                                        lng: lngBase,
                                                        guid: tools.newGuid(),
                                                        type: 'H'
                                                    };
                                                    this.create_update_base(itemBase);
                                                    baseCreatedFromPoint = true;
                                                    this.setState({ setBase: true });
                                                }
                                            }
                                            continue;
                                        }

                                        let coordsGeo = [];
                                        for (let j = 0; j < rawPoints.length; j++) {
                                            const p = rawPoints[j];
                                            if (!p || p.length < 2) continue;

                                            const lat = Number(p[0]);
                                            const lng = Number(p[1]);

                                            if (isNaN(lat) || isNaN(lng)) {
                                                continue;
                                            }

                                            coordsGeo.push([lng, lat]);
                                        }

                                        if (!coordsGeo.length) {
                                            continue;
                                        }

                                        const serviceTypeFromSO = area._service_type;
                                        const selectedService = mapServiceTypeFromServiceOrder(serviceTypeFromSO);

                                        const agroClassRaw = area._agro_class;
                                        const agroMapped = mapAgroClass(agroClassRaw);

                                        const cropFromSO = area._crop;

                                        const riskObj = parseRiskArea(area._risk_area);

                                        const faixaFromServiceOrder = (serviceOrderFaixa !== null) ? serviceOrderFaixa : this.state.faixa;
                                        const fluxoFromServiceOrder = (serviceOrderFluxo !== null) ? serviceOrderFluxo : this.state.fluxo;
                                        const spaceFromServiceOrder = 0;
                                        const areaPolygonType = area.poly_type || area.polyType || area.type;

                                        polygons = this.loadPolyFile({
                                            faixa: faixaFromServiceOrder,
                                            space: spaceFromServiceOrder,
                                            guid: tools.newGuid(),
                                            name: area.name || (this.props.res && this.props.res.AREA),
                                            type: ['N', 'T', 'F', 'X'].includes(areaPolygonType) ? areaPolygonType : 'N',
                                            fluxo: areaPolygonType === 'F' && area.average_value !== null && typeof area.average_value !== 'undefined'
                                                ? area.average_value
                                                : fluxoFromServiceOrder
                                        }, coordsGeo, polygons);

                                        const newPolygon = polygons[polygons.length - 1];
                                        if (newPolygon) {
                                            if (!newPolygon.detalhes) newPolygon.detalhes = {};

                                            if (!newPolygon.detalhes.selectedService && selectedService) {
                                                newPolygon.detalhes.selectedService = selectedService;
                                            }
                                            if (!newPolygon.detalhes.typeService) newPolygon.detalhes.typeService = {};
                                            if (agroMapped.insecticide) newPolygon.detalhes.typeService.insecticide = true;
                                            if (agroMapped.herbicide) newPolygon.detalhes.typeService.herbicide = true;
                                            if (agroMapped.fungicide) newPolygon.detalhes.typeService.fungicide = true;
                                            if (agroMapped.seeding) newPolygon.detalhes.typeService.seeding = true;
                                            if (agroMapped.fertilizing) newPolygon.detalhes.typeService.fertilizing = true;
                                            if (agroMapped.maturator) newPolygon.detalhes.typeService.maturator = true;
                                            if (agroMapped.others) newPolygon.detalhes.typeService.others = true;
                                            if (agroMapped.otherText && !newPolygon.detalhes.otherService) {
                                                newPolygon.detalhes.otherService = agroMapped.otherText;
                                            }
                                            if (cropFromSO && !newPolygon.detalhes.agriculturelCulture) {
                                                newPolygon.detalhes.agriculturelCulture = cropFromSO;
                                            }
                                            if (riskObj) {
                                                if (!newPolygon.detalhes.areaRisk) newPolygon.detalhes.areaRisk = {};
                                                newPolygon.detalhes.areaRisk.app = !!riskObj.app;
                                                newPolygon.detalhes.areaRisk.abelhas = !!(riskObj.bee || riskObj.abelhas || riskObj.abelha);
                                                newPolygon.detalhes.areaRisk.others = !!riskObj.others;
                                                if (riskObj.otherText && !newPolygon.detalhes.areaRiskOthers) {
                                                    newPolygon.detalhes.areaRiskOthers = riskObj.otherText;
                                                }
                                            }
                                            if (area._products && area._products.length && allProducts.length) {
                                                if (!newPolygon.detalhes.selectedProducts) newPolygon.detalhes.selectedProducts = [];
                                                if (!newPolygon.detalhes.dosageDetails) newPolygon.detalhes.dosageDetails = {};

                                                var selectedProducts = newPolygon.detalhes.selectedProducts;
                                                var dosageDetails = newPolygon.detalhes.dosageDetails;

                                                for (var ip = 0; ip < area._products.length; ip++) {
                                                    var prodSO = area._products[ip];

                                                    var soIdProd = prodSO.id_product || prodSO.idProduct || null;
                                                    var soIdProdCustom = prodSO.id_product_custom || prodSO.idProductCustom || null;
                                                    var soName = prodSO.name || prodSO.product_name || prodSO.productName || '';

                                                    var baseProd = null;

                                                    for (var lp = 0; lp < allProducts.length; lp++) {
                                                        var pAll = allProducts[lp];
                                                        var pId = pAll.id != null ? Number(pAll.id) : null;
                                                        var pIdProd = pAll.id_product != null ? Number(pAll.id_product) : null;
                                                        var pIdProdCustom = pAll.id_product_custom != null ? Number(pAll.id_product_custom) : null;
                                                        var pName = pAll.name || '';

                                                        if (soIdProd != null && (pId === Number(soIdProd) || pIdProd === Number(soIdProd))) {
                                                            baseProd = pAll;
                                                            break;
                                                        }
                                                        if (soIdProdCustom != null && (pId === Number(soIdProdCustom) || pIdProdCustom === Number(soIdProdCustom))) {
                                                            baseProd = pAll;
                                                            break;
                                                        }
                                                        if (!baseProd && soName && pName && String(soName).toLowerCase() === String(pName).toLowerCase()) {
                                                            baseProd = pAll;
                                                        }
                                                    }

                                                    if (!baseProd) {
                                                        baseProd = {
                                                            id: soIdProdCustom || soIdProd || prodSO.id || null,
                                                            name: soName,
                                                            source: soIdProdCustom ? 'custom' : 'system'
                                                        };
                                                    }

                                                    var jaSelecionado = false;
                                                    for (var sp = 0; sp < selectedProducts.length; sp++) {
                                                        var sel = selectedProducts[sp];
                                                        if (sel && sel.id === baseProd.id && sel.name === baseProd.name) {
                                                            jaSelecionado = true;
                                                            break;
                                                        }
                                                    }
                                                    if (!jaSelecionado) {
                                                        selectedProducts.push(baseProd);
                                                    }

                                                    var keyName = baseProd.name || soName;
                                                    if (keyName) {
                                                        if (!dosageDetails[keyName]) {
                                                            dosageDetails[keyName] = {};
                                                        }
                                                        var dVal = 0;
                                                        if (prodSO.dosage != null && !isNaN(prodSO.dosage)) {
                                                            dVal = Number(prodSO.dosage);
                                                        }
                                                        dosageDetails[keyName].dosage = dVal;
                                                    }
                                                }
                                            }
                                        }

                                        createdFromServiceOrder = true;
                                    }

                                    if (polygons.length > 0) {
                                        this.setState({
                                            polygons: polygons,
                                            type: 'L',
                                            dEstimative: true,
                                            uEstimative: true,
                                            sel_poly: null
                                        });
                                        this.keepData('polygons', polygons);

                                        setTimeout(() => {
                                            if (this.featureGroupP &&
                                                this.featureGroupP.getBounds &&
                                                this.featureGroupP.getBounds().isValid &&
                                                this.featureGroupP.getBounds().isValid()) {
                                                this.mymap.fitBounds(this.featureGroupP.getBounds());
                                            }
                                        }, 200);
                                    }

                                    if (createdFromServiceOrder && this.state.setBase) {
                                        this.executePlanning();
                                    }
                                }

                                if (result.job.geral) {
                                    if (!isNaN(result.job.geral.rows[11]) && Number(result.job.geral.rows[11]) > 0
                                        && !isNaN(result.job.geral.rows[8] && Number(result.job.geral.rows[9]) > 0)) {
                                        cLucro = Math.round(10000 * result.job.geral.rows[8] / result.job.geral.rows[11]) / 100;
                                    }
                                    if (!isNaN(result.job.geral.rows[11]) && Number(result.job.geral.rows[11]) > 0
                                        && !isNaN(result.job.geral.rows[9] && Number(result.job.geral.rows[9]) > 0)) {
                                        cImp = Math.round(10000 * result.job.geral.rows[9] / result.job.geral.rows[11]) / 100;
                                    }
                                    let job = {
                                        client_est: result.job.geral.rows[20] ? result.job.geral.rows[20] :
                                            prefillState.client_est ? prefillState.client_est :
                                                result.job.data.customername ? result.job.data.customername : this.state.client_est,
                                        plane_est: result.job.geral.rows[21] ? result.job.geral.rows[21] :
                                            prefillState.plane_est ? prefillState.plane_est :
                                                result.job.data.aircraftprefix ? result.job.data.aircraftprefix : this.state.plane_est,
                                        altura: result.job.geral.rows[22] ? Units.convertLength(result.job.geral.rows[22], 'm', res) :
                                            result.job.data.targetheight ? Units.convertLength(result.job.data.targetheight, 'm', res) : this.state.altura,
                                        pilot_est: result.job.geral.rows[23] ? result.job.geral.rows[23] :
                                            prefillState.pilot_est ? prefillState.pilot_est :
                                                result.job.data.pilotname ? result.job.data.pilotname : this.state.pilot_est,
                                        openType: this.props.type === 'edit' ? 'edit' : 'copy',
                                        cost: result.job.geral.rows[0] ? result.job.geral.rows[0] : this.state.cost,
                                        speed_travel: result.job.geral.rows[1] ?
                                            (Units.convertSpeed(result.job.geral.rows[1], 'km/h', res)) : this.state.speed_travel,
                                        speed: result.job.geral.rows[2] ?
                                            (Units.convertSpeed(result.job.geral.rows[2], 'km/h', res)) : this.state.speed,
                                        speed_apl: result.job.geral.rows[2] ?
                                            (Units.convertSpeed(result.job.geral.rows[2], 'km/h', res)) : this.state.speed_apl,
                                        speed_loop: result.job.geral.rows[3] ?
                                            (Units.convertSpeed(result.job.geral.rows[3], 'km/h', res)) : this.state.speed_loop,
                                        size_loop: result.job.geral.rows[4] ?
                                            (Units.convertLength(result.job.geral.rows[4], 'm', res)) : this.state.size_loop,
                                        r_time: result.job.geral.rows[5] ?
                                            result.job.geral.rows[5] : this.state.r_time,
                                        carga: result.job.geral.rows[7] ?
                                            (Units.convertVolume(result.job.geral.rows[7], 'L', res)) : this.state.carga,
                                        horas_dia: result.job.geral.rows[10] ?
                                            result.job.geral.rows[10] : this.state.horas_dia,
                                        dificuldade: result.job.geral.rows[14] ?
                                            (result.job.geral.rows[14] === 'true' ? true : false) : this.state.dificuldade,
                                        size_h_loop: result.job.geral.rows[15] ?
                                            (Units.convertLength(result.job.geral.rows[15], 'm', res)) : this.state.size_h_loop,
                                        horas_base: result.job.geral.rows[16] ?
                                            result.job.geral.rows[16] === 'true' ? true : false : this.state.horas_base,
                                        aproveitamento: result.job.geral.rows[18] ?
                                            (result.job.geral.rows[18] === 'true' ? true : false) : this.state.aproveitamento,
                                        title_est: result.job.data.title ?
                                            result.job.data.title : this.state.title_est,
                                        cLucro: isNaN(cLucro) ? 0 : cLucro,
                                        cImp: cImp,
                                    };
                                    if (result.job.id) {
                                        job.id = result.job.id;
                                        job.guid = result.job.guid_link;
                                    }

                                    if (!result.job.geral.rows[21] && prefillState.plane_est) {
                                        job.plane_est_id = prefillState.plane_est_id;
                                        job.plane_est_ids = prefillState.plane_est_ids || [];
                                        job.plane_est_id_company = prefillState.plane_est_id_company;
                                        job.plane_est_id_companies = prefillState.plane_est_id_companies || [];
                                    }

                                    if (!result.job.geral.rows[23] && prefillState.pilot_est) {
                                        job.pilot_est_id = prefillState.pilot_est_id;
                                        job.pilot_est_ids = prefillState.pilot_est_ids || [];
                                        job.pilot_est_id_company = prefillState.pilot_est_id_company;
                                        job.pilot_est_id_companies = prefillState.pilot_est_id_companies || [];
                                    }

                                    if (prefillState.serviceOrderID) job.serviceOrderID = prefillState.serviceOrderID;
                                    if (prefillState.aplicacao) job.aplicacao = prefillState.aplicacao;
                                    if (prefillState.faixa !== undefined) job.faixa = prefillState.faixa;
                                    if (prefillState.fluxo !== undefined) job.fluxo = prefillState.fluxo;

                                    this.setState(job, () => {
                                        if (this.state.plane_est_id || this.state.plane_est) {
                                            this.applySelectedPlaneParameters();
                                        }
                                    });

                                    if (result.job.geral.rows[12]) {
                                        let base = JSON.parse(result.job.geral.rows[12]);
                                        let itemBase = {
                                            lat: base[0],
                                            lng: base[1],
                                            guid: tools.newGuid(),
                                            type: 'H'
                                        };
                                        this.create_update_base(itemBase);
                                        this.setState({ setBase: true });
                                    }

                                    let fuel = result.job.geral.rows[13] ? JSON.parse(result.job.geral.rows[13]) : [];
                                    for (let index = 0; index < fuel.length; index++) {
                                        const element = fuel[index];
                                        let itemFuel = {
                                            status: 'T',
                                            lat: element.lat,
                                            lng: element.lng,
                                            guid: element.guid ? element.guid : tools.newGuid(),
                                            type: 'P'
                                        };
                                        this.create_update_fuel(itemFuel);
                                    }
                                }

                                if (result.job.polys && result.job.polys.length > 0) {
                                    let polygons2 = this.state.polygons;
                                    for (let i = 0; i < result.job.polys.length; i++) {
                                        let fluxo = this.state.fluxo;
                                        let faixa = this.state.faixa;
                                        let space = 0;

                                        if (result.job.polys[i].info.fluxo) {
                                            fluxo = tools.round(Units.convertFlow(result.job.polys[i].info.fluxo, 'L', 'ha', res), 2);
                                        }
                                        if (result.job.polys[i].info.faixa) {
                                            faixa = tools.round(Units.convertLength(result.job.polys[i].info.faixa, 'm', res), 2);
                                        }
                                        const widthMeters = Units.toCanonicalLength(faixa, res);
                                        const info = result.job.polys[i].info || {};
                                        const savedSpaceMeters = info.space === undefined || info.space === null || info.space === ''
                                            ? widthMeters / 2
                                            : Number(info.space);
                                        const offsetMeters = info.planningVersion === 2
                                            ? (Number.isFinite(savedSpaceMeters) ? savedSpaceMeters : 0)
                                            : savedSpaceMeters - widthMeters / 2;
                                        const maxOffsetMeters = Math.max(0, widthMeters / 2);
                                        space = tools.round(Units.convertLengthTo(
                                            Math.max(-maxOffsetMeters, Math.min(maxOffsetMeters, offsetMeters)),
                                            'm',
                                            Units.getLengthUnit(res)
                                        ), 2);

                                        polygons2 = this.loadPolyFile({
                                            fluxo: fluxo,
                                            faixa: faixa,
                                            space: space,
                                            planningVersion: 2,
                                            guid: result.job.polys[i].info.guid,
                                            name: result.job.polys[i].info.name,
                                            type: result.job.polys[i].info.type ? result.job.polys[i].info.type : 'N'
                                        }, JSON.parse(result.job.polys[i].info.poly)[0].geometry.coordinates[0], polygons2);
                                        if (result.job.polys[i].lines) {
                                            let polygon = polygons2[polygons2.length - 1];
                                            let str = result.job.polys[i].lines;

                                            polygon.lines = polygon.lines.concat(str.itens[0]);
                                            polygon.yaw = polygon.lines[polygon.lines.length - 1].yaw;
                                            polygon.yaw_value = result.job.polys[i].info.yaw;
                                            polygon.selected_line = polygon.lines.length - 1;

                                            polygon.selected_AB = result.job.polys[i].info.selected_AB;
                                            polygon.selected_AB_back = result.job.polys[i].info.selected_AB_back;

                                            polygon.estrategia = result.job.polys[i].info.estrategia;
                                            if (result.job.polys[i].estimate) {
                                                for (let k = 0; k < this.strategy.length; k++) {
                                                    const item = this.strategy[k];
                                                    if (item.value === polygon.estrategia) {
                                                        polygon.selected_Out = item.id;
                                                        let out = result.job.polys[i].estimate.out[0];
                                                        let flxMedApl = out.qtdFuel; // TODO: FIX: reaproveitamento?
                                                        let appTime = out.appTime;
                                                        let loopTime = out.loopTime;
                                                        let fuelTime = out.fuelTime;
                                                        let travelTime = out.travelTime;
                                                        let tVoo = appTime + loopTime + fuelTime;
                                                        let cVoo = tVoo +
                                                            (flxMedApl * (Number(this.state.r_time) * 60)) /
                                                            60 / 60 * this.state.cost;

                                                        polygon.out.push({
                                                            appTime: appTime,
                                                            cLucro: isNaN(this.state.cLucro) ? 0 : this.state.cLucro,
                                                            cVoo: cVoo,
                                                            center: out.center,
                                                            endPath: out.endPath,
                                                            first_line: null,
                                                            fuelPoint: out.fuelPoint,
                                                            fuelTime: fuelTime,
                                                            loopTime: loopTime,
                                                            path: out.path,
                                                            qtdFuel: out.qtdFuel,
                                                            startPath: out.startPath,
                                                            tVoo: tVoo,
                                                            trasTime: travelTime
                                                        });
                                                    } else {
                                                        polygon.out.push(null);
                                                    }
                                                }
                                            }
                                            polygon.area = str.area;
                                            if (!polygon.guid_p) {
                                                polygon.guid_p = tools.newGuid();
                                            }
                                            const layer = this.mymap._layers[polygon.guid];
                                            this.intersectLine(polygon, layer);
                                        }
                                    }
                                    this.setState({ type: 'L', dEstimative: true, uEstimative: true, sel_poly: null, polygons: polygons2 });
                                    this.keepData('polygons', polygons2);

                                    setTimeout(() => {
                                        this.calcEstimativa();
                                        this.handleClickP();
                                    }, 200);
                                    this.mymap.fitBounds(this.featureGroupP.getBounds());
                                }
                                if (result.job.data && result.job.data.title) {
                                    let state = {
                                        title_est: result.job.data.title,
                                        id: result.job.id
                                    };
                                    if (serviceOrderAplicacao) state.aplicacao = serviceOrderAplicacao;
                                    this.setState(state);
                                }

                                if (result.data) {
                                    this.setState({
                                        time: {
                                            tTotal: result.data.tTotal,
                                            tVoo: result.data.tVoo,
                                            tLoop: result.data.loop ? result.data.loop.tLoop : 0,
                                            tTras: result.data.travel ? result.data.travel.tTravel : 0,
                                            tApl: result.data.apl ? result.data.apl.tApl : 0,
                                            flxMedApl: result.data.fuel ? result.data.fuel.qtdFuel : 0,
                                            comTl: result.data.comTl,
                                            aTlPul: result.data.aTlPul,
                                            cVoo: !result.job.geral ? 0 : result.data.tVoo +
                                                ((result.data.fuel ? result.data.fuel.qtdFuel : 0) * (Number(this.state.r_time) * 60)) /
                                                60 / 60 * (result.job.geral.rows[0] ? result.job.geral.rows[0] : this.state.cost),
                                        }
                                    });
                                }
                            }
                            else {
                                if (result.id) {
                                    this.setState({ id: result.id });
                                }
                            }
                        } else {
                            notification.open({
                                message: this.props.res.ERRO,
                                description: this.props.res.ERRO_MSG,
                                icon: <MaterialIcon icon="error" className="text-danger" />
                            });
                        }
                    },
                    (error) => {
                        this.setState({ progress: false });
                        if (error.status === 405) {
                            notification.open({
                                message: this.props.res.PERMISSAO,
                                description: this.props.res.PERMISSAO_MSG,
                                icon: <MaterialIcon icon="error" className="text-danger" />
                            });
                        } else if (error.status === 401 || error.status === 403) {
                            console.log(error);
                            this.props.link('/login');
                        } else if (error.status === 400) {
                            error.json()
                                .then((errCode) => {
                                    notification.open({
                                        message: errCode && errCode.code && this.props.res[errCode.code]
                                            ? this.props.res[errCode.code]
                                            : this.props.res.ERRO,
                                        description: errCode && errCode.code && this.props.res[errCode.code]
                                            ? undefined
                                            : this.props.res.ERRO_MSG,
                                        icon: <MaterialIcon icon="error" className="text-danger" />
                                    });
                                })
                                .catch(() => {
                                    notification.open({
                                        message: this.props.res.ERRO,
                                        description: this.props.res.ERRO_MSG,
                                        icon: <MaterialIcon icon="error" className="text-danger" />
                                    });
                                });
                        } else {
                            console.log(error);
                            notification.open({
                                message: this.props.res.ERRO,
                                description: this.props.res.ERRO_MSG,
                                icon: <MaterialIcon icon="error" className="text-danger" />
                            });
                        }
                    }
                );
        }
    };

    create_update_fuel = (item) => {
        let layer = this.mymap._layers[item.guid];
        this.removeLayer(this.featureGroupM, layer);

        let dIcon = L.icon({
            iconUrl: item.type ? HangarIcon : this.icon[this.img_fuel[item.status]].img,
            iconSize: item.type ? [34, 34] : undefined,
            iconAnchor: item.type ? [17, 34] : [13, 33],
            popupAnchor: item.type ? [3, -30] : [3, -35]
        });
        let pos = [item.lat, item.lng];
        let mark = L.marker(pos, { icon: dIcon });
        mark._leaflet_id = item.guid;
        mark.bindPopup('');
        mark.on("click", () => { this.popup_marker(mark, 'fuel'); });
        this.featureGroupM.addLayer(mark);
    };

    create_update_base = (item) => {
        let layer = this.mymap._layers[this.base.guid];
        this.removeLayer(this.featureGroupPM, layer);

        let dIcon = L.icon({
            iconUrl: item.type ? HangarIcon : this.icon[this.img_base['T']].img,
            iconSize: item.type ? [34, 34] : undefined,
            iconAnchor: item.type ? [17, 34] : [13, 33],
            popupAnchor: item.type ? [3, -30] : [3, -35]
        });
        let pos = [item.lat, item.lng];
        let mark = L.marker(pos, { icon: dIcon });
        mark._leaflet_id = item.guid;
        mark.bindPopup('');
        mark.on("click", () => { this.popup_marker(mark, 'base'); });
        this.featureGroupM.addLayer(mark);

        this.base.lat = item.lat;
        this.base.lng = item.lng;
        this.base.guid = item.guid ? item.guid : tools.newGuid();
        this.base.type = item && item.type ? item.type : this.base.type;

        this.setState({ setBase: true });
    };

    list_markers = (callback) => {
        this.featureGroupPM.clearLayers();
        const apiUrl = Config.server + '/point/0';
        const options = {
            method: 'GET',
            headers: {
                'Authorization': localStorage.getItem('access-token-jwt')
            }
        }

        fetch(apiUrl, options)
            .then((res) => {
                if (res.status !== 200) throw res;
                else return res.json();
            })
            .then(
                (result) => {
                    if (result.length > 0) {
                        let m = [];
                        const only1 = result.filter(a => a.type === 'H').length === 1;
                        for (let i = 0; i < result.length; i++) {
                            const element = result[i];
                            /*if (element.type === 'P') {
                                let itemFuel = {
                                    guid: element.guid,
                                    lat: element.lat,
                                    lng: element.lng,
                                    status: 'F'
                                }
                                this.fuel.push(itemFuel);
                                this.create_update_fuel(itemFuel);
                            } else if (element.type === 'H') {
                                let itemBase = {
                                    guid: element.guid,
                                    lat: element.lat,
                                    lng: element.lng,
                                }
                                this.base = itemBase;
                                this.create_update_base(itemBase);
                            } else {*/
                            let tempMark = new marks();
                            tempMark.id = element.id;
                            tempMark.guid = element.guid;
                            tempMark.name = element.name;
                            tempMark.lat = element.lat;
                            tempMark.lng = element.lng;
                            tempMark.alt = element.height;
                            tempMark.r = element.radios;
                            tempMark.desc = element.icon;
                            tempMark.type = element.type;

                            for (let j = 0; j < img.length; j++) {
                                if (img[j].desc.includes(element.icon)) {
                                    tempMark.img = img[j].img;
                                    break;
                                }
                            }
                            if (tempMark.type === 'P' || tempMark.type === 'H' || tempMark.img) {
                                m.push(tempMark)
                                this.drawMarker(tempMark, only1 && tempMark.type === 'H' ? true : false);
                            }
                            /*}*/
                        }
                        this.setState({ markers: m });
                        //this.mymap.fitBounds(this.featureGroupPM.getBounds());
                    }
                    if (callback) callback();
                },
                (error) => {
                    if (error.status === 405) {
                        notification.open({
                            message: this.props.res.PERMISSAO,
                            description: this.props.res.PERMISSAO_MSG,
                            icon: <MaterialIcon icon="error" className="text-danger" />
                        });
                    } else if (error.status === 401 || error.status === 403) {
                        console.log(error);
                        this.props.link('/login');
                    }
                    else {
                        console.log(error);
                        notification.open({
                            message: this.props.res.ERRO,
                            description: this.props.res.ERRO_MSG,
                            icon: <MaterialIcon icon="error" className="text-danger" />
                        });
                    }
                }
            );
    };

    drawMarker = (marker, active) => {
        let dIcon = L.icon({
            iconUrl: marker.type === 'P' ? this.icon[this.img_fuel['F']].img :
                marker.type === 'H' ? this.icon[this.img_base['F']].img : marker.img,
            iconAnchor: marker.type === 'O' ? [25, 30] : [13, 33],
            popupAnchor: [0, -25]
        });
        let newLatLng = new L.LatLng(marker.lat, marker.lng);
        let myLayer = L.marker(newLatLng, { icon: dIcon });
        myLayer._leaflet_id = marker.guid;
        myLayer.bindPopup(marker.name);

        myLayer.on("mouseover", () => {
            myLayer.openPopup();
        });

        myLayer.on("mouseout", () => {
            myLayer.closePopup();
        });

        myLayer.addTo(this.featureGroupPM);

        if (marker.r > 0) {
            let myStyle = {
                "color": 'red',
                "weight": 4,
                "opacity": 0.5,
                "radius": marker.r
            };
            myLayer = L.circle(newLatLng, myStyle);
            myLayer._leaflet_id = marker.guid + 'r';
            myLayer.addTo(this.featureGroupPM);
        }
        if (marker.type === 'P' || marker.type === 'H') {
            if (active) {
                this.toggleBaseFuel(myLayer, marker);
            }
            myLayer.on("click", () => { this.toggleBaseFuel(myLayer, marker) });
        }
    };

    toggleBaseFuel = (layer, marker) => {
        this.removeLayer(this.featureGroupPM, layer);
        let type = 'fuel';
        let img = this.icon[this.img_fuel['Y']].img;
        if (marker.type === 'H') {
            img = this.icon[this.img_base['T']].img;
            type = 'base';

            let layer = this.mymap._layers[this.base.guid];
            this.removeLayer(this.featureGroupM, layer);

            let temp_marker = layer ? this.state.markers.filter(item => (item.guid === layer._leaflet_id)) : [];
            if (temp_marker.length > 0) {
                this.drawMarker(temp_marker[0]);
            }

            this.base.lat = marker.lat;
            this.base.lng = marker.lng;
            this.base.guid = marker.guid;
            this.keepData('base', this.base);
            this.setState({ setBase: true });
        }

        const dIcon = L.icon({
            iconUrl: img,
            iconAnchor: marker.type === 'O' ? [25, 30] : [13, 33],
            popupAnchor: [0, -25]
        });
        const newLatLng = new L.LatLng(marker.lat, marker.lng);
        let temp_layer = L.marker(newLatLng, { icon: dIcon });
        temp_layer.bindPopup('');
        temp_layer.on("click", () => { this.popup_marker(temp_layer, type); });
        temp_layer._leaflet_id = marker.guid;
        this.featureGroupM.addLayer(temp_layer);
        newLatLng._leaflet_id = marker.guid;
        if (marker.type === 'P') {
            const newMarker = {
                guid: marker.guid,
                lat: marker.lat,
                lng: marker.lng,
                status: 'Y',
                type: 'waypoint'
            };

            this.adduel(newMarker);
        }
        this.setState({ uEstimative: true });
    };

    adduel = (marker) => {
        (this.fuel).forEach(f => {
            if (f.guid === marker.guid) {
                return;
            }
        });

        this.fuel.push(marker);
        this.keepData('fuel', this.fuel);
    };

    removeFuel = (marker) => {
        const tempFuel = [];

        (this.fuel).forEach(f => {
            if (f.guid !== marker.guid) {
                tempFuel.push(marker);
            }
        });

        this.fuel = tempFuel;
        this.keepData('fuel', this.fuel);
    };

    checkMarkers = () => {
        /*let mapBounds = this.mymap.getBounds();
        for (let i = this.state.markers.length - 1; i >= 0; i--) {
            let m = this.mymap._layers[this.state.markers[i].guid];
            if (this.mymap.getZoom() > 11) {
                if (!m) {
                    this.drawMarker(this.state.markers[i]);
                } else {
                    let shouldBeVisible = mapBounds.contains(m.getLatLng());
                    if (m._icon && !shouldBeVisible) {
                        this.featureGroupPM.removeLayer(m);
                        let mr = this.mymap._layers[this.state.markers[i].guid + 'r'];
                        if (mr)
                            this.featureGroupP.removeLayer(mr);
                    }
                }
            } else if (m) {
                this.featureGroupPM.removeLayer(m);
                let mr = this.mymap._layers[this.state.markers[i].guid + 'r'];
                if (mr)
                    this.featureGroupP.removeLayer(mr);
            }
        }*/
    };

    alterMarker = (marker, type, action) => {
        if (type === 'base') {
            this.removeLayer(this.featureGroupM, marker);
            this.base = {
                guid: tools.newGuid(),
                lat: '',
                lng: ''
            };
            if (action !== 'Remove') {
                let lat = document.getElementById('markerLat').value;
                let lng = document.getElementById('markerLng').value;
                let itemBase = {
                    lat: lat,
                    lng: lng,
                    guid: this.base.guid
                }
                this.create_update_base(itemBase);

                this.base.lat = lat;
                this.base.lng = lng;
                this.keepData('base', this.base);
            } else {
                let temp_marker = this.state.markers.filter(item => (item.guid === marker._leaflet_id));
                if (temp_marker.length > 0) {
                    this.drawMarker(temp_marker[0]);
                }
                this.setState({ setBase: false });
            }
        } else {
            this.setState({ uEstimative: this.state.dEstimative ? true : false });
            for (let j = 0; j < this.fuel.length; j++) {
                const element = this.fuel[j];
                if (element.guid === marker._leaflet_id) {
                    this.removeLayer(this.featureGroupM, marker);
                    if (action === 'Remove' && element.type === 'waypoint') {
                        let temp_marker = this.state.markers.filter(item => (element.guid === item.guid));
                        temp_marker.length > 0 && this.drawMarker(temp_marker[0]);
                    }

                    if (action !== 'Remove') {
                        element.lat = document.getElementById('markerLat').value;
                        element.lng = document.getElementById('markerLng').value;
                        this.create_update_fuel(element);
                    } else {
                        this.fuel.splice(this.fuel.indexOf(element), 1);
                    }
                    this.keepData('fuel', this.fuel);

                    break;
                }
            }
        }
    };

    formatRegua = (valor) => {
        let text = '';
        if (Units.getLengthUnit(this.props.res) === 'ft') {
            if (tools.m_to_ft(valor) < 5280) {
                text = Math.round(tools.m_to_ft(valor)) + ' ft';
            } else {
                text = tools.round(tools.m_to_ft(valor) / 5280, 2) + ' mi';
            }
        } else {
            if (valor < 1000) {
                text = Math.round(valor) + ' m';
            } else {
                text = Math.round(valor / 10) / 100 + ' km';
            }
        }

        return text;
    };

    keepData = (item, value) => {
        const base = {
            version: null,
            aplicacao: null,
            faixa: null,
            fluxo: null,
            altura: null,
            carga: null,
            angulo: null,
            estrategia: null,
            dificuldade: null,
            cost: null,
            speed: null,
            speed_travel: null,
            speed_loop: null,
            speed_apl: null,
            size_loop: null,
            size_h_loop: null,
            r_time: null,
            add_list: null,
            cLucro: 0,
            vLucro_old: 0,
            cImp: 0,
            title_est: null,
            plane_est: null,
            client_est: null,
            pilot_est: null,
            polygons: null,
            lat_base: null,
            lng_base: null,
            travel_time: null,
            fuel: null,
        };

        // Os valores do rascunho ficam na unidade exibida e levam a configuração usada no momento.


        let d_estimate = localStorage.getItem('d-estimate');

        if (!d_estimate) {
            d_estimate = {};
        } else {
            d_estimate = JSON.parse(d_estimate);
        }
        if (!item) {
            for (let key in base) {
                // skip loop if the property is from prototype
                if (!base.hasOwnProperty(key)) continue;

                if ((key !== 'fuel' || key !== 'lat_base' || key !== 'lng_base') && !d_estimate[key]) {
                    d_estimate[key] = this.state[key];
                }
                if (key === 'fuel' && !d_estimate[key]) {
                    d_estimate[key] = this.fuel;
                } else if (key === 'lat_base' && !d_estimate[key]) {
                    d_estimate[key] = this.lat_base;
                } else if (key === 'lng_base' && !d_estimate[key]) {
                    d_estimate[key] = this.lng_base;
                }
            }
        } else if (item) {
            d_estimate[item] = value;
            if (item === 'speed') {
                d_estimate.speed_travel = value;
                d_estimate.speed_loop = value;
                d_estimate.speed_apl = value;
            }
        }

        d_estimate.language = this.props.res.LINGUA;
        d_estimate.unit_config = Units.getUnitConfig(this.props.res);

        let storage = JSON.stringify(d_estimate);
        if (storage.length < 3500000) {
            localStorage.setItem('d-estimate', storage);
        }
        return d_estimate;
    };

    criaMark = (item) => {
        if (!this.markClick) {
            let dIcon = L.icon({
                iconUrl: this.icon[item].img,
                iconAnchor: [13, 33],
                popupAnchor: [3, -35]
            });
            this.drawCreateToolbar = new L.Draw.Marker(this.mymap, { icon: dIcon });
            this.drawCreateToolbar.enable();
            if (item === 11) {
                this.setState({ base: true });
            } else if (item === 0) {
                this.setState({ fuel: true });
            }
            this.markClick = true;
        } else {
            this.cancelCreate();
        }
    };

    round_coord = (coord) => {
        return Math.round(coord * 10000000) / 10000000;
    };

    handleClickP = (layer, polygon) => {
        if (this.state.polyCreate) {
            return;
        }

        if (this.state.selector) {
            return;
        }

        if (this.ignoreNextPolygonClick) {
            this.ignoreNextPolygonClick = false;
            return;
        }

        const confirmarCheckDaArea = (poly) => {
            if (!poly || !poly.out || poly.out.length <= 0) {
                return;
            }

            let estrategiaAtual = poly.estrategia;
            if (!estrategiaAtual && poly.out[poly.selected_Out]) {
                estrategiaAtual = poly.out[poly.selected_Out].type;
            }

            if (!estrategiaAtual) {
                return;
            }

            const estrategiaItem = this.strategy.filter(item => {
                return item.value === estrategiaAtual;
            })[0];

            this.updateText(poly);
            poly.estrategia = estrategiaAtual;
            poly.estrategia_manual = true;
            poly.is_selected = true;

            if (estrategiaItem) {
                poly.selected_Out = estrategiaItem.id;
            }
        };

        if (!this.state.delete) {
            if (layer && polygon) {
                this.polyClick = true;
                for (let i = 0; i < this.state.polygons.length; i++) {
                    const pg = this.state.polygons[i];
                    const lyr = (this.mymap && this.mymap._layers) ? this.mymap._layers[pg.guid] : null;

                    if (!lyr || typeof lyr.setStyle !== 'function') {
                        continue;
                    }

                    this.setPolygonBaseStyle(lyr, pg, this.state.polygons);
                }

                if (this.state.sel_poly && polygon && this.state.sel_poly.guid === polygon.guid) {
                    let previousSelected = this.state.sel_poly;

                    confirmarCheckDaArea(previousSelected);

                    if (this.state.play && previousSelected && previousSelected.lines.length > 0) {
                        const lyrSel = (this.mymap && this.mymap._layers) ? this.mymap._layers[previousSelected.guid] : null;
                        if (lyrSel) {
                            this.showAB(previousSelected, lyrSel);
                        }
                    }
                    this.showLabel(false);
                    this.setState({ sel_poly: null, play: false }, () => {
                        const previousLayer = previousSelected && this.mymap && this.mymap._layers
                            ? this.mymap._layers[previousSelected.guid]
                            : null;

                        if (
                            previousSelected &&
                            previousLayer &&
                            previousSelected.lines &&
                            previousSelected.lines.length > 0
                        ) {
                            this.intersectLine(previousSelected, previousLayer);
                        }
                    });

                    setTimeout(() => {
                        this.exibirEstimativa();
                    }, 20);
                } else {//seleciona item
                    let previousSelected = this.state.sel_poly;

                    confirmarCheckDaArea(previousSelected);

                    if (this.state.play && previousSelected && previousSelected.lines.length > 0) {
                        const lyrSel = (this.mymap && this.mymap._layers) ? this.mymap._layers[previousSelected.guid] : null;
                        if (lyrSel) {
                            this.showAB(previousSelected, lyrSel);
                        }
                    }

                    layer.setStyle({ color: this.color_selected, weight: 5 });

                    this.showLabel(true, polygon);
                    this.setState({ sel_poly: polygon }, () => {
                        const currentLayer = (this.mymap && this.mymap._layers) ? this.mymap._layers[polygon.guid] : null;
                        const previousLayer = previousSelected && this.mymap && this.mymap._layers
                            ? this.mymap._layers[previousSelected.guid]
                            : null;

                        if (
                            previousSelected &&
                            previousSelected.guid !== polygon.guid &&
                            previousLayer &&
                            previousSelected.lines &&
                            previousSelected.lines.length > 0
                        ) {
                            this.intersectLine(previousSelected, previousLayer);
                        }

                        if (currentLayer && polygon && polygon.lines && polygon.lines.length > 0) {
                            this.intersectLine(polygon, currentLayer);
                        }

                        const selectedCandidate = polygon && polygon.lines && polygon.lines[polygon.selected_line];
                        if (!this.state.play && (!selectedCandidate || !Array.isArray(selectedCandidate.lines) || selectedCandidate.lines.length === 0)) {
                            this.drawSelectedStrategyDirection(polygon);
                        }

                        if (this.state.play && this.state.sel_poly && this.state.sel_poly.lines.length > 0) {
                            this.startLine(true);
                        }
                    });
                    setTimeout(() => {
                        if (polygon.type === 'X' || polygon.type === 'XL') {
                            this.setState({ type_poly: 'X', groupPolygons: 'all', line_poly: false });
                        } else if (polygon.type === 'T' || polygon.type === 'R') {
                            this.setState({ type_poly: polygon.type, groupPolygons: 'all', line_poly: false });
                        } else {
                            this.setState({ type_poly: 'N' });
                            if (polygon && polygon.lines && polygon.lines.length > 0) {
                                this.setState({ groupPolygons: polygon.guid, line_poly: polygon.lines.length > 0 });
                            } else {
                                this.setState({ groupPolygons: 'all', line_poly: false, play: false });
                            }
                        }
                        this.exibirEstimativa(polygon);
                    }, 20);
                }

            } else if (!this.polyClick) {
                let previousSelected = this.state.sel_poly;

                confirmarCheckDaArea(previousSelected);

                this.showLabel(false);

                if (this.state.polygons.length > 0) {
                    for (let i = 0; i < this.state.polygons.length; i++) {
                        const pg = this.state.polygons[i];
                        const lyr = (this.mymap && this.mymap._layers) ? this.mymap._layers[pg.guid] : null;

                        if (!lyr || typeof lyr.setStyle !== 'function') {
                            continue;
                        }

                        this.setPolygonBaseStyle(lyr, pg, this.state.polygons);
                    }
                    this.setState({ sel_poly: null, sel_polygons: [], sel_x: false, groupPolygons: 'all', line_poly: false, play: false }, () => {
                        const previousLayer = previousSelected && this.mymap && this.mymap._layers
                            ? this.mymap._layers[previousSelected.guid]
                            : null;

                        if (
                            previousSelected &&
                            previousLayer &&
                            previousSelected.lines &&
                            previousSelected.lines.length > 0
                        ) {
                            this.intersectLine(previousSelected, previousLayer);
                        }
                    });
                    setTimeout(() => {
                        this.calcEstimativa();
                    }, 20);
                }
            } else {
                this.polyClick = false;
            }
        }
    };

    showLabel = (show, polygon) => {
        const { res } = this.props;
        //let add_total = false;
        if (show) {
            let area_text = 0;
            let qtd_lines = 0;
            let angulo = 0;
            let areaS = (polygon && polygon.guid) ? polygon : null;
            if (areaS) {
                let area = 0;
                if (areaS.area) {
                    area = areaS.area;
                } else {
                    let layerP = (this.mymap && this.mymap._layers) ? this.mymap._layers[areaS.guid] : null;

                    if (layerP && typeof layerP.getLatLngs === 'function') {
                        const latlngs = layerP.getLatLngs();
                        const ring = (latlngs && latlngs[0]) ? latlngs[0] : null;
                        if (ring && ring.length) {
                            area = L.GeometryUtil.geodesicArea(ring);
                            areaS.area = area;
                            //add_total = true;
                        } else {
                            area = areaS.area || 0;
                        }
                    } else {
                        area = areaS.area || 0;
                    }
                }

                if (areaS.lines && areaS.lines.length > 0 && areaS.lines[areaS.selected_line]) {
                    qtd_lines += areaS.lines[areaS.selected_line].lines.length;
                    angulo = areaS.lines[areaS.selected_line].yaw;
                    if (areaS.selected_AB === 1) {
                        angulo = angulo < 180 ? angulo + 180 : angulo - 180;
                    }
                    angulo = angulo < 0 ? angulo + 360 : angulo > 360 ? angulo - 360 : angulo;
                }
                area_text += area;
            }
            if (area_text > 0) {
                this.area = area_text / 10000;
                let text = `${Units.formatValue(Units.convertArea(this.area, 'ha', res), res)} ${Units.getAreaUnit(res)}`;
                if (areaS && areaS.lines && areaS.lines.length > 0) {
                    text = `${text} ${qtd_lines} ${res.FAIXAS} ${tools.round(angulo, 2)}º`;
                    areaS.text = qtd_lines;
                }
                this.setState({ label_text: text, angulo: angulo });
            } else {
                this.setState({ label_text: '' });
            }
        } else {
            this.setState({ label_text: '' });
            this.area = this.areaTotal;
        }
    };

    //cria as possibilidades de linhas
    handleClickB = (type) => {
        if (this.state.sel_poly && this.state.sel_poly.type !== 'N') return;
        if (type === 'all') {
            this.preALLLines(0);
        } else if (this.state.sel_poly !== null) {
            if (this.state.line_poly) {
                this.handleClickPR(true);
            } else {
                this.preLines(null);
                this.resetRef();
            }
            this.resetDownloadJob();
        }
    };

    getAreaPlanningAb = (polygon) => {
        if (!polygon || polygon.type !== 'N' || !polygon.ab) return null;
        try {
            const points = typeof polygon.ab === 'string' ? JSON.parse(polygon.ab) : polygon.ab;
            if (!Array.isArray(points) || points.length !== 2 || !points.every(point =>
                Array.isArray(point) && point.length === 2 && point.every(value => typeof value === 'number' && Number.isFinite(value)) &&
                Math.abs(point[0]) <= 90 && Math.abs(point[1]) <= 180)) return null;
            return { a: { lat: points[0][0], lng: points[0][1] }, b: { lat: points[1][0], lng: points[1][1] } };
        } catch (error) { return null; }
    };

    startAreaAbPlanning = () => {
        if (this.state.polygons.some(polygon => this.getAreaPlanningAb(polygon))) this.preALLLines(0);
    };

    preALLLines = (i) => {
        let poly = this.state.polygons;
        if (i < poly.length) {
            if (poly[i].lines && poly[i].lines.length > 0) {
                this.preALLLines(++i);
            } else {
                this.setState({ sel_poly: poly[i] }, () => {
                    if (this.state.sel_poly.type !== 'N') {
                        this.preALLLines(++i);
                    } else {
                        this.preLines(null, i);
                        this.resetRef();
                    }
                    this.resetDownloadJob();
                });
            }
        }
    };

    preLines = (anl, index) => {
        if (this.state.sel_poly && this.state.sel_poly.type !== 'N') return;
        this.setState({ progress: true });
        let apiUrl = Config.server + '/strategy';
        let method = 'POST';

        const formData = new URLSearchParams();

        let polys = [];
        let guids = [];
        let polysX = [];
        let faixa = 20;
        let space = this.state.space;
        let ab = { a: this.ruler_p.first, b: this.ruler_p.second };
        let has_ab = this.ruler_p.type === 'ab' && this.ruler_p.first && this.ruler_p.second &&
            Number.isFinite(this.ruler_p.first.lat) && Number.isFinite(this.ruler_p.first.lng) &&
            Number.isFinite(this.ruler_p.second.lat) && Number.isFinite(this.ruler_p.second.lng);
        const polygons = this.state.polygons || [];

        let selectedGuid = null;

        const filterGuids = Array.isArray(this.state.areaFilterSelection)
            ? this.state.areaFilterSelection.filter(function (g) { return !!g; })
            : [];

        const isValidVisibleGuid = (guid) => {
            if (!guid) return false;

            const poly = polygons.find(function (p) {
                return p && p.guid === guid && p.type === 'N';
            });

            if (!poly) return false;

            const lyr = (this.mymap && this.mymap._layers) ? this.mymap._layers[guid] : null;
            return !!(lyr && typeof lyr.toGeoJSON === 'function');
        };

        if (filterGuids.length === 1 && isValidVisibleGuid(filterGuids[0])) {
            selectedGuid = filterGuids[0];
        }

        if (!selectedGuid && this.state.sel_poly && this.state.sel_poly.guid && isValidVisibleGuid(this.state.sel_poly.guid)) {
            selectedGuid = this.state.sel_poly.guid;
        }

        if (!selectedGuid &&
            Array.isArray(this.state.sel_polygons) &&
            this.state.sel_polygons.length === 1 &&
            isValidVisibleGuid(this.state.sel_polygons[0])) {

            selectedGuid = this.state.sel_polygons[0];
        }

        if (!selectedGuid && filterGuids.length > 1) {
            const visibleFilter = filterGuids.filter(isValidVisibleGuid);

            if (visibleFilter.length === 1) {
                selectedGuid = visibleFilter[0];
            } else if (visibleFilter.length === 0) {
                this.setState({ progress: false });
                return;
            }
        }

        if (!selectedGuid && filterGuids.length === 0) {
            for (let i = polygons.length - 1; i >= 0; i--) {
                const p = polygons[i];
                if (p && p.guid && p.type !== 'X' && p.type !== 'XL' && isValidVisibleGuid(p.guid)) {
                    selectedGuid = p.guid;
                    break;
                }
            }
        }

        if (!selectedGuid) {
            this.setState({ progress: false });

            if (filterGuids.length > 0 && !isNaN(index)) {
                this.preALLLines(++index);
                return;
            }

            notification.open({
                message: this.props.res.SELECIONE_AREA || 'Selecione uma área para calcular.',
                icon: <MaterialIcon icon="error" className="text-danger" />
            });
            return;
        }

        this.state.polygons.forEach(element => {
            if (!element) return;

            if (element.guid === selectedGuid) {
                if (element.type === 'X' || element.type === 'XL') {
                    const lyrX = (this.mymap && this.mymap._layers) ? this.mymap._layers[element.guid] : null;
                    if (lyrX && typeof lyrX.toGeoJSON === 'function') {
                        polysX.push(lyrX.toGeoJSON());
                    }
                } else {
                    faixa = element.faixa ? element.faixa : this.state.faixa;

                    if (element.planningVersion !== 2) {
                        const widthMeters = Units.toCanonicalLength(faixa, this.props.res);
                        const savedDistance = element.space === undefined || element.space === null || element.space === ''
                            ? widthMeters / 2
                            : Units.toCanonicalLength(element.space, this.props.res);
                        const offset = this.clampPlanningOffset(savedDistance - widthMeters / 2, widthMeters);
                        element.space = Units.convertLengthTo(offset, 'm', Units.getLengthUnit(this.props.res));
                        element.planningVersion = 2;
                    }

                    if (!this.state.angle) {
                        const s = element.space === undefined || element.space === null || element.space === ''
                            ? 0
                            : element.space;
                        space = s;
                        element.space = s;
                    } else {
                        element.space = space;
                    }

                    const lyr = (this.mymap && this.mymap._layers) ? this.mymap._layers[element.guid] : null;
                    if (lyr && typeof lyr.toGeoJSON === 'function') {
                        polys.push(lyr.toGeoJSON());
                        guids.push(element.guid);
                    }
                    const areaAb = this.getAreaPlanningAb(element);
                    if (anl === null && !has_ab && areaAb) {
                        ab = areaAb;
                        has_ab = true;
                        anl = (turf.bearing(turf.point([ab.a.lng, ab.a.lat]), turf.point([ab.b.lng, ab.b.lat])) + 360) % 360;
                    }
                    element.yaw_value = anl;
                    element.yaw = anl;

                    if (this.ruler_p.type === 'ab' && has_ab) {
                        element.ab = JSON.parse(JSON.stringify(this.ruler_p));
                    } else if (!has_ab && element.ABs && element.ABs.length === 2) {
                        ab = { a: { lat: element.ABs[0][1], lng: element.ABs[0][0] }, b: { lat: element.ABs[1][1], lng: element.ABs[1][0] } };
                        has_ab = true;
                    }
                }
            } else {
                if (element.type === 'X' || element.type === 'XL') {
                    const lyrX = (this.mymap && this.mymap._layers) ? this.mymap._layers[element.guid] : null;
                    if (lyrX && typeof lyrX.toGeoJSON === 'function') {
                        polysX.push(lyrX.toGeoJSON());
                    }
                }
            }
        });

        if (polys.length === 0 || guids.length === 0) {
            this.setState({ progress: false });
            notification.open({
                message: this.props.res.ERRO,
                description: this.props.res.ERRO_MSG,
                icon: <MaterialIcon icon="error" className="text-danger" />
            });
            return;
        }
        formData.append('poly', JSON.stringify(polys));
        formData.append('guids', JSON.stringify(guids));
        formData.append('faixa', Units.toCanonicalLength(faixa, this.props.res));
        const widthMeters = Units.toCanonicalLength(faixa, this.props.res);
        const halfWidthMeters = widthMeters / 2;
        const enteredSpace = Number(space) || 0;
        const displayLimit = Units.convertLengthTo(halfWidthMeters, 'm', Units.getLengthUnit(this.props.res));
        const acceptedSpace = Math.max(-displayLimit, Math.min(displayLimit, enteredSpace));
        let strategySpaceMeters = this.clampPlanningOffset(
            Units.toCanonicalLength(acceptedSpace, this.props.res),
            widthMeters
        );
        if (acceptedSpace !== 0 && Math.abs(Math.abs(acceptedSpace) - displayLimit) <= 1e-6) {
            strategySpaceMeters = Math.sign(acceptedSpace) * Math.max(0, halfWidthMeters - 0.4);
        }
        formData.append('space', strategySpaceMeters);
        if (anl !== null && anl !== undefined && Number.isFinite(Number(anl))) {
            formData.append('yaw', JSON.stringify(anl));
            if (has_ab) {
                formData.append('ab', JSON.stringify(ab));
            }
        }
        formData.append('interPoly', JSON.stringify(polysX));

        let options = {
            method: method,
            body: formData,
            headers: {
                'Authorization': localStorage.getItem('access-token-jwt')
            }
        };

        fetch(apiUrl, options)
            .then((res) => {
                if (res.status !== 200) throw res;
                else return res.json();
            })
            .then(
                (result) => {
                    this.setState({ progress: false });
                    if (result.msgErro) {
                        notification.open({
                            message: result.msgErro,
                            icon: <MaterialIcon icon="error" className="text-danger" />
                        });
                    } else if (result.itens.length === 0) {
                        notification.open({
                            message: 'no lines found',
                            icon: <MaterialIcon icon="error" className="text-danger" />
                        });
                    } else if (result.itens) {
                        if (this.state.ruler_a) {
                            this.regua(null, 'r');
                        }
                        let str = result;
                        let polygon = null;

                        polygon = this.state.polygons.filter(p => p.guid === selectedGuid)[0];

                        if (!polygon) {
                            notification.open({
                                message: this.props.res.ERRO,
                                description: this.props.res.ERRO_MSG,
                                icon: <MaterialIcon icon="error" className="text-danger" />
                            });
                            return;
                        }

                        const polygonLayer = (this.mymap && this.mymap._layers) ? this.mymap._layers[polygon.guid] : null;
                        const widthMeters = Units.toCanonicalLength(polygon.faixa || this.state.faixa, this.props.res);
                        const exclusions = this.getPlanningExclusions();
                        if (!polygonLayer || typeof polygonLayer.toGeoJSON !== 'function') {
                            this.setState({ progress: false });
                            return;
                        }
                        const originalBest = str.best;
                        let mappedBest = -1;
                        const generatedCandidates = [];
                        (str.itens || []).forEach((candidate, index) => {
                            const next = Object.assign({}, candidate, { planningGeometryVersion: 2, _planningABBack: 0 });
                            next.lines = toolsPlan.createPlanningLines(polygonLayer.toGeoJSON(), next.ABs, 0, widthMeters, exclusions);
                            next.ABs = Object.assign({}, next.ABs, toolsPlan.createPlanningCenterABs(next.lines, next.ABs.initialAB));
                            next.qtd = next.lines.length;
                            if (next.lines.length === 0) return;
                            if (index === originalBest) mappedBest = generatedCandidates.length;
                            generatedCandidates.push(next);
                        });
                        str.itens = generatedCandidates;
                        str.best = mappedBest >= 0 ? mappedBest : 0;
                        if (str.itens.length === 0) {
                            notification.open({
                                message: 'no lines found',
                                icon: <MaterialIcon icon="error" className="text-danger" />
                            });
                            return;
                        }
                        polygon.planningVersion = 2;

                        if (anl !== null) {
                            polygon.lines[99] = str.itens[0];
                            polygon.selected_line = polygon.lines.length - 1;
                            polygon.selected_AB = 0;
                            polygon.selected_AB_back = 0;
                            if (polygon.selected_Out === undefined || polygon.selected_Out === null) {
                                polygon.selected_Out = 0;
                            }
                        } else {
                            if (str.itens) {
                                polygon.lines = str.itens;
                                polygon.selected_line = str.best;
                                polygon.best = str.best;
                            }
                        }
                        polygon.area = result.area;
                        if (!polygon.guid_p) {
                            polygon.guid_p = tools.newGuid();
                        }
                        const layer = (this.mymap && this.mymap._layers) ? this.mymap._layers[polygon.guid] : null;

                        if (layer) {
                            this.intersectLine(polygon, layer);
                        }

                        this.setState(
                            {
                                type: 'L',
                                dEstimative: true,
                                uEstimative: true,
                                sel_poly: polygon
                            },
                            () => {
                                if (layer) {
                                    this.handleClickP(layer, polygon);
                                }
                                if (!isNaN(index)) {
                                    this.preALLLines(++index);
                                }
                            });
                        this.keepData('polygons', this.state.polygons);
                    } else {
                        notification.open({
                            message: this.props.res.ERRO,
                            description: this.props.res.ERRO_MSG,
                            icon: <MaterialIcon icon="error" className="text-danger" />
                        });
                    }
                },
                (error) => {
                    this.setState({ progress: false });
                    if (error.status === 405) {
                        notification.open({
                            message: this.props.res.PERMISSAO,
                            description: this.props.res.PERMISSAO_MSG,
                            icon: <MaterialIcon icon="error" className="text-danger" />
                        });
                    } else if (error.status === 401 || error.status === 403) {
                        console.log(error);
                        this.props.link('/login');
                    } else if (error.status === 400) {
                        error.json().then(
                            (errCode) => {
                                notification.open({
                                    message: this.props.res[errCode.code],
                                    icon: <MaterialIcon icon="error" className="text-danger" />
                                });
                            });
                    } else {
                        console.log(error);
                        notification.open({
                            message: this.props.res.ERRO,
                            description: this.props.res.ERRO_MSG,
                            icon: <MaterialIcon icon="error" className="text-danger" />
                        });
                    }
                }
            );
    };


    mountStrategy = () => {
        this.setState({ progress: true });
        let apiUrl = Config.server + '/strategy_complex';
        let method = 'POST';

        const formData = new URLSearchParams();

        const polygons = this.state.polygons.filter(p => p.type === 'N').map(p => ({
            guid: p.guid,
            faixa: Units.toCanonicalLength(p.faixa ? p.faixa : this.state.faixa, this.props.res),
            points: p.points,
            type: p.type,
        }));

        if (polygons.length === 0) {
            this.setState({ progress: false });
            notification.open({
                message: this.props.res.ERRO,
                description: this.props.res.ERRO_MSG,
                icon: <MaterialIcon icon="error" className="text-danger" />
            });
            return;
        }

        const polysX = this.state.polygons.filter(p => p.type === 'X').map(p => ({
            guid: p.guid,
            faixa: Units.toCanonicalLength(p.faixa ? p.faixa : this.state.faixa, this.props.res),
            fluxo: Units.toCanonicalFlow(p.fluxo ? p.fluxo : this.state.fluxo, this.props.res, this.state.aplicacao === 'S' ? 'kg' : 'L', 'ha'),
            points: p.points,
            type: p.type,
        }));

        const faixa = polygons[0].faixa ? polygons[0].faixa : Units.toCanonicalLength(this.state.faixa, this.props.res);

        formData.append('poly', JSON.stringify(polygons));
        formData.append('faixa', faixa);
        formData.append('interPoly', JSON.stringify(polysX));

        formData.append('fluxo', Units.toCanonicalFlow(this.state.fluxo, this.props.res, this.state.aplicacao === 'S' ? 'kg' : 'L', 'ha'));
        formData.append('carga', this.state.aplicacao === 'S' ? this.state.carga : Units.toCanonicalVolume(this.state.carga, this.props.res));
        formData.append('space', Units.toCanonicalLength(this.state.size_loop, this.props.res));
        formData.append('spaceH', Units.toCanonicalLength(this.state.size_h_loop, this.props.res));
        formData.append('speedB', Units.toCanonicalSpeed(this.state.speed_loop, this.props.res));
        formData.append('speedApp', Units.toCanonicalSpeed(this.state.speed_apl, this.props.res));
        formData.append('speedTra', Units.toCanonicalSpeed(this.state.speed_travel, this.props.res));
        formData.append('r_time', this.state.r_time);
        if (this.base.lng !== '' && this.fuel.length > 0) {
            formData.append('base', JSON.stringify([this.base.lng, this.base.lat]));
            formData.append('fuel', JSON.stringify(this.fuel));
        } else if (this.base.lng !== '') {
            formData.append('base', JSON.stringify([this.base.lng, this.base.lat]));
            formData.append('fuel', JSON.stringify([{ lng: this.base.lng, lat: this.base.lat }]));
        } else {
            this.setState({ progress: false });
            return;
        }
        let options = {
            method: method,
            body: formData,
            headers: {
                'Authorization': localStorage.getItem('access-token-jwt')
            }
        };
        fetch(apiUrl, options)
            .then((res) => {
                if (res.status !== 200) throw res;
                else return res.json();
            })
            .then(
                (result) => {
                    const inter = setInterval(() => {
                        const formRes = new URLSearchParams();
                        formRes.append('guid', result.guid);
                        options.body = formRes;
                        fetch(apiUrl, options)
                            .then((res) => {
                                if (res.status !== 200) throw res;
                                else return res.json();
                            })
                            .then(
                                (result) => {
                                    clearInterval(inter);
                                    this.setState({ progress: false });
                                    if (result.polygons) {

                                        const restrictedPolygons = this.state.polygons.filter(polygon => polygon.type === 'R');

                                        if (this.featureGroupE) this.featureGroupE.clearLayers();
                                        if (this.featureGroupP) this.featureGroupP.clearLayers();
                                        if (this.featureGroupPM) this.featureGroupPM.clearLayers();
                                        if (this.featureGroupM) this.featureGroupM.clearLayers();

                                        if (this.overlapGroup) {
                                            this.overlapGroup.clearLayers();
                                        }

                                        const polys = restrictedPolygons.slice();
                                        restrictedPolygons.forEach(polygon => this.drawPolygon(polygon, polys));
                                        for (let i = 0; i < result.polygons.length; i++) {
                                            const element = result.polygons[i];
                                            let poly = new oPolygon(this.props);
                                            poly.guid = element.guid;
                                            poly.name = element.name;
                                            poly.points = JSON.stringify(element.poly.geometry.coordinates[0].map((point) => [point[1], point[0]]));
                                            poly.type = element.type;
                                            poly.faixa = this.state.faixa;
                                            poly.fluxo = this.state.fluxo;
                                            polys.push(poly);
                                            this.drawPolygon(poly, polys);
                                            /*
                                            if (element.strategy.itens) {
                                                poly.lines = element.strategy.itens;
                                                poly.selected_line = element.strategy.best;
                                                poly.best = element.strategy.best;
                                            }
                
                                            //poly.area = result.strategy.area;
                                            if (!poly.guid_p) {
                                                poly.guid_p = tools.newGuid();
                                            }
                                            const layer = (this.mymap && this.mymap._layers) ? this.mymap._layers[poly.guid] : null;
                
                                            if (layer) {
                                                this.intersectLine(poly, layer);
                                            }
                
                
                                            this.updateEstimativa(result.estimate);*/
                                        }
                                        this.setState({ polygons: polys });
                                    }
                                },
                                (error) => {
                                }
                            );
                    }, 1000);
                },
                (error) => {
                    this.setState({ progress: false });
                    if (error.status === 405) {
                        notification.open({
                            message: this.props.res.PERMISSAO,
                            description: this.props.res.PERMISSAO_MSG,
                            icon: <MaterialIcon icon="error" className="text-danger" />
                        });
                    } else if (error.status === 401 || error.status === 403) {
                        console.log(error);
                        this.props.link('/login');
                    } else if (error.status === 400) {
                        error.json().then(
                            (errCode) => {
                                notification.open({
                                    message: this.props.res[errCode.code],
                                    icon: <MaterialIcon icon="error" className="text-danger" />
                                });
                            });
                    } else {
                        console.log(error);
                        notification.open({
                            message: this.props.res.ERRO,
                            description: this.props.res.ERRO_MSG,
                            icon: <MaterialIcon icon="error" className="text-danger" />
                        });
                    }
                }
            );
    };

    resetPolygon = name => (event) => {
        this.setState({
            [name]: event.target.value,
            dEstimative: false,
            uEstimative: false,
        });
        this.keepData(name, event.target.value);
        this.resetPolygonMap();
    };

    polyData = (name, guid, type) => (event) => {
        this.updatePolyData(name, guid, type, event.target.value);
        if (name === 'faixa' || name === 'fluxo' || name === 'nPulverizador') {
            this.calcCali();
            this.keepData(name, event.target.value);
            if (name === 'faixa') {
                this.setState({ space: 0 });
            }
            this.setState({ [name]: event.target.value });
        }
    };

    updatePolyData = (name, guid, type, value) => {
        if (guid === '') {
            guid = this.state.sel_poly.guid;
        }
        let polys = this.state.polygons
        let poly = null;
        if (guid === 'All') {
            for (let i = 0; i < polys.length; i++) {
                const poly = polys[i];
                poly[name] = value;
                if (name === 'faixa') {
                    poly.space = 0;
                    poly.planningVersion = 2;
                }
            }
            this.setState({ [name]: value });
            this.keepData(name, value);
        } else {
            poly = polys.filter(item => {
                return (item.guid === guid);
            });
            if (poly.length > 0) {
                poly = poly[0];
                poly[name] = value;
                if (name === 'faixa') {
                    poly.space = 0;
                    poly.planningVersion = 2;
                }
            }
        }
        this.keepData('polygons', polys);
        if (type === 'reset') {
            if (poly) {
                poly.is_selected = false;
            }
            this.setState({
                dEstimative: guid !== 'All',
                uEstimative: false,
                polygons: polys
            });
            this.resetPolygonMap(guid === 'All' ? false : [poly]);
        } else {
            this.setState({
                uEstimative: true,
                polygons: polys
            });
            this.resetRef();
        }
        if (name === 'fluxo') this.refreshFlowPolygonColors(polys);
        this.resetDownloadJob();
    };

    polyDataBlur = (name, guid) => {
        let polys = this.state.polygons
        let poly = polys.filter(item => {
            return (item.guid === guid);
        })[0];

        if (!isNaN(poly[name]) && Number(poly[name]) < 10 && name === 'faixa') {
            poly[name] = 10;
            this.keepData('polygons', polys);
            //this.resetPolygonMap();
            this.setState({
                polygons: polys
            });
        }
        if (name === 'faixa' || name === 'fluxo' || name === 'nPulverizador') {
            this.setState({
                [name]: poly[name]
            }, () => {
                if (name === 'faixa' || name === 'fluxo') {
                    localStorage.setItem('d-ff-last', JSON.stringify({ fluxo: this.state.fluxo, faixa: this.state.faixa }));
                }
            });
        }
    };

    resetPolygonMap = (polys) => {
        let allPolygons = polys ? polys : this.state.polygons;
        for (let i = 0; i < allPolygons.length; i++) {
            const polygon = allPolygons[i];
            if (polygon.lines && polygon.lines.length > 0) {
                polygon.out = [];
                polygon.lines = [];
                polygon.ABs = [];
                polygon.selected_AB = 0;
                polygon.selected_AB_back = 0;
                polygon.selected_Out = 0;
                polygon.selected_line = null;
                polygon.first_line = 0;
                polygon.speed_apl = 0;
                polygon.best = null;
                polygon.yaw = null;
                polygon.yaw_value = null;
                polygon.guid_p = null;
                polygon.aTlPul = 0;
                polygon.comTl = 0;
                polygon.flxMedApl = 0;
                polygon.tApl = 0;
                polygon.tVoo = 0;

                this.removeLayer(this.featureGroupE, this.mymap._layers[polygon.guid + "_lines"]);
                this.removeLayer(this.featureGroupE, this.mymap._layers[polygon.guid + "_abL"]);
                this.removeLayer(this.featureGroupE, this.mymap._layers[polygon.guid + "_abFG"]);
                this.removeLayer(this.featureGroupE, this.mymap._layers[polygon.guid + "_abFR"]);
            }
        };
        this.setState({
            polygons: this.state.polygons,
            uEstimative: false
        })
        this.resetRef();
        this.handleClickP();
    };

    drawLinePath = (path) => {
        this.removeLayer(this.featureGroupE, this.mymap._layers["pathLine"]);
        let myStyle = {
            "color": 'white',
            "weight": 2,
            "opacity": 1,
            pane: this.planningPanes.lines
        };

        let myLayer = L.geoJSON(path, { style: myStyle, pane: this.planningPanes.lines });
        myLayer._leaflet_id = 'pathLine';
        myLayer.addTo(this.featureGroupE);
    };

    //monta as linhas no mapa
    intersectLine = (polygon, fcPoly) => {
        if (!polygon) return;

        if (!fcPoly || typeof fcPoly.toGeoJSON !== 'function') {
            fcPoly = (this.mymap && this.mymap._layers) ? this.mymap._layers[polygon.guid] : null;
        }
        if (!fcPoly || typeof fcPoly.toGeoJSON !== 'function') return;
        this.migratePlanningGeometry(polygon, fcPoly);

        let lines = polygon.lines;
        if (!Array.isArray(lines) || lines.length === 0) return;

        let sel = polygon.selected_line;

        if (this.mymap && this.mymap._layers && polygon.layer && this.mymap._layers[polygon.layer]) {
            this.removeLayer(this.featureGroupE, this.mymap._layers[polygon.layer]);
        }

        let myStyle = {
            "color": this.state.sel_poly && this.state.sel_poly.guid === polygon.guid ? this.color_line_selected : this.color_line,
            "weight": 3,
            "opacity": .7,
            pane: this.planningPanes.lines
        };

        if (typeof fcPoly._leaflet_id === 'undefined') {
            return;
        }

        if (isNaN(sel) || !lines[sel]) return;
        const currentCandidate = lines[sel];
        this.ensurePlanningLines(polygon, currentCandidate, fcPoly);
        if (!Array.isArray(currentCandidate.lines) || currentCandidate.lines.length === 0) return;

        let name = fcPoly._leaflet_id + '_lines';
        polygon.layer = name;
        let currentZoom = this.mymap.getZoom();
        /*let size = 2;

        if (currentZoom > 14) {
            size = 4;
        }*/

        let mapLines = [];
        lines[sel].lines.forEach(item => {
            const validLines = this.getValidPlanningLines(item && item.linhas, fcPoly);
            validLines.forEach(line => {
                mapLines.push(line);
            });
        });

        let myLayer = L.geoJSON(mapLines, { style: myStyle, pane: this.planningPanes.lines });
        myLayer._leaflet_id = name;
        myLayer.on("click", (event) => { this.handlePolygonPointSelection(event, polygon); });
        //myLayer.setStyle({ weight: size });
        myLayer.addTo(this.featureGroupE);

        this.showAB(polygon, fcPoly);

        if (this.state.sel_poly && this.state.sel_poly.guid === polygon.guid && !this.state.play) {
            this.drawSelectedStrategyDirection(polygon);
        } else if (!this.state.sel_poly) {
            this.clearStrategyDirectionArrows();
        }
    };

    getValidPlanningLines = (lineGeoJson, fcPoly) => {
        if (!lineGeoJson || !fcPoly || typeof fcPoly.toGeoJSON !== 'function') {
            return [];
        }

        const polygonFeature = fcPoly.toGeoJSON();
        const validLines = [];
        let lineCoordinatesList = [];

        if (lineGeoJson.type === 'FeatureCollection' && Array.isArray(lineGeoJson.features)) {
            lineGeoJson.features.forEach(feature => {
                if (!feature.geometry) {
                    return;
                }

                if (feature.geometry.type === 'LineString') {
                    lineCoordinatesList.push(feature.geometry.coordinates);
                }

                if (feature.geometry.type === 'MultiLineString') {
                    lineCoordinatesList = lineCoordinatesList.concat(feature.geometry.coordinates);
                }
            });
        } else {
            const geometry = lineGeoJson.type === 'Feature' ? lineGeoJson.geometry : lineGeoJson;

            if (!geometry) {
                return [];
            }

            if (geometry.type === 'LineString') {
                lineCoordinatesList.push(geometry.coordinates);
            }

            if (geometry.type === 'MultiLineString') {
                lineCoordinatesList = lineCoordinatesList.concat(geometry.coordinates);
            }
        }

        lineCoordinatesList.forEach(coords => {
            if (!Array.isArray(coords) || coords.length < 2) {
                return;
            }

            try {
                const lineFeature = turf.lineString(coords);
                const lineLength = turf.length(lineFeature, { units: 'kilometers' });
                const middlePoint = turf.along(lineFeature, lineLength / 2, { units: 'kilometers' });

                if (turf.booleanPointInPolygon(middlePoint, polygonFeature, { ignoreBoundary: false })) {
                    validLines.push(lineFeature);
                }
            } catch (err) {
            }
        });

        return validLines;
    };

    getPlanningExclusions = () => {
        const exclusions = [];
        (this.state.polygons || []).forEach(polygon => {
            if (!polygon || (polygon.type !== 'X' && polygon.type !== 'XL')) return;
            const layer = this.mymap && this.mymap._layers ? this.mymap._layers[polygon.guid] : null;
            if (layer && typeof layer.toGeoJSON === 'function') exclusions.push(layer.toGeoJSON());
        });
        return exclusions;
    };

    clampPlanningOffset = (offsetMeters, widthMeters) => {
        const limit = Math.max(0, Number(widthMeters) / 2);
        return Math.max(-limit, Math.min(limit, Number(offsetMeters) || 0));
    };

    migratePlanningGeometry = (polygon, layer) => {
        if (!polygon || !layer || typeof layer.toGeoJSON !== 'function') return;
        const width = Units.toCanonicalLength(polygon.faixa || this.state.faixa, this.props.res);
        if (polygon.planningVersion !== 2) {
            const oldDistance = polygon.space === undefined || polygon.space === null || polygon.space === ''
                ? width / 2
                : Units.toCanonicalLength(polygon.space, this.props.res);
            const offset = this.clampPlanningOffset(oldDistance - width / 2, width);
            polygon.space = Units.convertLengthTo(offset, 'm', Units.getLengthUnit(this.props.res));
            polygon.planningVersion = 2;
        } else if (polygon.space === undefined || polygon.space === null || polygon.space === '') {
            polygon.space = 0;
        }

        const feature = layer.toGeoJSON();
        (polygon.lines || []).forEach(candidate => {
            if (!candidate) return;
            const abs = candidate.ABs || {};
            if (abs.initialAB && abs.mirroredAB) return;

            const referenceAB = (abs.startAB && abs.startAB.c) || (abs.endAB && abs.endAB.c);
            if (!referenceAB) return;
            const pair = toolsPlan.createPlanningABPair(
                feature,
                referenceAB,
                width,
                Units.toCanonicalLength(polygon.space, this.props.res)
            );
            if (pair) {
                candidate.ABs = pair;
                candidate.lines = null;
                candidate.planningGeometryVersion = 0;
                delete candidate._planningABBack;
            }
        });
    };

    getPlanningPattern = (polygon, candidate, type) => {
        const strategy = this.strategy && this.strategy[polygon.selected_Out];
        return toolsPlan.createPlanningPattern(
            candidate.lines,
            candidate.ABs,
            polygon.selected_AB_back,
            polygon.selected_AB,
            type || polygon.estrategia || (strategy && strategy.value) || 'BACKTOBACK',
            { size_loop: this.state.size_loop, size_line: polygon.faixa || this.state.faixa }
        );
    };

    ensurePlanningLines = (polygon, candidate, layer, force = false) => {
        if (!polygon || !candidate || !layer || typeof layer.toGeoJSON !== 'function') return;
        this.migratePlanningGeometry(polygon, layer);
        const strategy = this.strategy && this.strategy[polygon.selected_Out];
        const type = polygon.estrategia || (strategy && strategy.value) || 'BACKTOBACK';
        const back = polygon.selected_AB_back === 1 && !toolsPlan.isCentralPlanningStrategy(type) ? 1 : 0;
        if (force || candidate.planningGeometryVersion !== 2 || candidate._planningABBack !== back || !Array.isArray(candidate.lines)) {
            candidate.lines = toolsPlan.createPlanningLines(
                layer.toGeoJSON(),
                candidate.ABs,
                back,
                Units.toCanonicalLength(polygon.faixa || this.state.faixa, this.props.res),
                this.getPlanningExclusions()
            );
            candidate.qtd = candidate.lines.length;
            candidate.planningGeometryVersion = 2;
            candidate._planningABBack = back;
        }

        const pattern = this.getPlanningPattern(polygon, candidate);
        candidate.ABs = pattern.ABs;
        candidate.lines = pattern.lines;
        return pattern;
    };

    removeLayer = (map, layer) => {
        if (!map || !layer) {
            return;
        }

        try {
            if (map.hasLayer && !map.hasLayer(layer)) {
                return;
            }

            map.removeLayer(layer);
        } catch (_) { }
    };

    hideAB = (polygon) => {
        if (!polygon || !polygon.layer || !this.mymap || !this.mymap._layers) {
            return;
        }

        const baseId = polygon.layer;
        const abLId = baseId.replace("_lines", "_abL");
        const abFGId = baseId.replace("_lines", "_abFG");
        const abFRId = baseId.replace("_lines", "_abFR");

        const layerAbL = this.mymap._layers[abLId];
        const layerAbFG = this.mymap._layers[abFGId];
        const layerAbFR = this.mymap._layers[abFRId];

        if (layerAbL && this.featureGroupE) {
            this.removeLayer(this.featureGroupE, layerAbL);
        }
        if (layerAbFG && this.featureGroupE) {
            this.removeLayer(this.featureGroupE, layerAbFG);
        }
        if (layerAbFR && this.featureGroupE) {
            this.removeLayer(this.featureGroupE, layerAbFR);
        }
    };

    showAB = (polygon, fcPoly, hideGlowUpdate) => {

        this.ensurePlanningLines(polygon, polygon.lines && polygon.lines[polygon.selected_line], fcPoly);

        if (polygon.layer !== null) {
            this.removeLayer(this.featureGroupE, this.mymap._layers[(polygon.layer).replace("_lines", "_abL")]);
            this.removeLayer(this.featureGroupE, this.mymap._layers[(polygon.layer).replace("_lines", "_abFG")]);
            this.removeLayer(this.featureGroupE, this.mymap._layers[(polygon.layer).replace("_lines", "_abFR")]);
        }
        let polySelected = this.state.sel_poly && polygon && this.state.sel_poly.guid === polygon.guid;

        let myStyle = {
            color: polySelected ? '#0084ff' : '#f5c749',
            weight: 5,
            opacity: 1,
            pane: this.planningPanes.AB
        };

        polygon.ABs = this.selectedAB(polygon);
        let latlngs = polygon.ABs;

        if (!Array.isArray(latlngs) || latlngs.length < 2) return;

        let myLayer = L.polyline(this.geojsonToLeafletArray(latlngs), myStyle);
        myLayer._leaflet_id = fcPoly._leaflet_id + '_abL';
        myLayer.on("click", (event) => this.handlePolygonPointSelection(event, polygon));
        myLayer.addTo(this.featureGroupE);

        let dIcon = L.icon({
            iconUrl: iconA,
            iconSize: [40, 40],
            iconAnchor: [20, 35]
        });

        let newLatLng = new L.LatLng(latlngs[0][1], latlngs[0][0]);
        myLayer = L.marker(newLatLng, { icon: dIcon, pane: this.planningPanes.AB });

        myLayer._leaflet_id = fcPoly._leaflet_id + '_abFG';
        myLayer.on("click", (event) => this.handlePolygonPointSelection(event, polygon));
        myLayer.addTo(this.featureGroupE);

        dIcon = L.icon({
            iconUrl: iconB,
            iconSize: [40, 40],
            iconAnchor: [20, 35]
        });
        newLatLng = new L.LatLng(latlngs[1][1], latlngs[1][0]);
        myLayer = L.marker(newLatLng, { icon: dIcon, pane: this.planningPanes.AB });

        myLayer._leaflet_id = fcPoly._leaflet_id + '_abFR';
        myLayer.on("click", (event) => this.handlePolygonPointSelection(event, polygon));
        myLayer.addTo(this.featureGroupE);

        if (!hideGlowUpdate) {
            this.setState({ uEstimative: true });
        }
    };

    getAngleFromCoordinates = (lat1, lng1, lat2, lng2) => {
        const rad = Math.PI / 180;
        const dLon = (lng2 - lng1) * rad;
        const y = Math.sin(dLon) * Math.cos(lat2 * rad);
        const x = Math.cos(lat1 * rad) * Math.sin(lat2 * rad) - Math.sin(lat1 * rad) * Math.cos(lat2 * rad) * Math.cos(dLon);
        let brng = Math.atan2(y, x);
        brng = brng / rad;
        brng = (brng + 360) % 360;
        return brng;
    };

    getCardinalDirection = (angle) => {
        if (angle >= 348.75 || angle < 11.25) {
            return 'N';
        } else if (angle >= 11.25 && angle < 33.75) {
            return 'NNE';
        } else if (angle >= 33.75 && angle < 56.25) {
            return 'NE';
        } else if (angle >= 56.25 && angle < 78.75) {
            return 'ENE';
        } else if (angle >= 78.75 && angle < 101.25) {
            return 'L';
        } else if (angle >= 101.25 && angle < 123.75) {
            return 'ESE';
        } else if (angle >= 123.75 && angle < 146.25) {
            return 'SE';
        } else if (angle >= 146.25 && angle < 168.75) {
            return 'SSE';
        } else if (angle >= 168.75 && angle < 191.25) {
            return 'S';
        } else if (angle >= 191.25 && angle < 213.75) {
            return 'SSO';
        } else if (angle >= 213.75 && angle < 236.25) {
            return 'SO';
        } else if (angle >= 236.25 && angle < 258.75) {
            return 'OSO';
        } else if (angle >= 258.75 && angle < 281.25) {
            return 'O';
        } else if (angle >= 281.25 && angle < 303.75) {
            return 'ONO';
        } else if (angle >= 303.75 && angle < 326.25) {
            return 'NO';
        } else if (angle >= 326.25 && angle < 348.75) {
            return 'NNO';
        }
    };

    selectedAB = (itemPoly) => {
        let ret = [];
        if (!itemPoly || !Array.isArray(itemPoly.lines) || !itemPoly.lines[itemPoly.selected_line] || !itemPoly.lines[itemPoly.selected_line].ABs) {
            return ret;
        }

        const candidate = itemPoly.lines[itemPoly.selected_line];
        const AB = candidate.ABs;
        const pattern = this.getPlanningPattern(itemPoly, candidate);
        candidate.ABs = pattern.ABs;
        candidate.lines = pattern.lines;
        const selected = pattern.ab || (itemPoly.selected_AB_back === 1 ? (AB.mirroredAB || AB.endAB) : (AB.initialAB || AB.startAB));
        if (selected && Array.isArray(selected.c) && selected.c.length >= 2) {
            ret = itemPoly.selected_AB === 1 ? selected.c : [selected.c[1], selected.c[0]];
        } else {
            const legacyAB = itemPoly.selected_AB_back === 1 ? AB.endAB : AB.startAB;
            const legacy = legacyAB && legacyAB.c;
            if (Array.isArray(legacy) && legacy.length >= 2) {
                ret = itemPoly.selected_AB === 1 ? legacy : [legacy[1], legacy[0]];
            }
        }
        this.showLabel(true, itemPoly);
        return ret;
    };

    //muda para proxima linha
    handleClickPR = (best, poly) => {
        let polygon = poly ? poly : this.state.sel_poly;
        if (polygon) {
            this.updateText(polygon);
            if (polygon.layer === null) {
                this.preLines(null);
            }
            if (best) {
                polygon.selected_line = polygon.best;
            } else {
                polygon.selected_line =
                    ((polygon.selected_line + 1) < polygon.lines.length) ?
                        (polygon.selected_line + 1) :
                        (0);
            }
            this.intersectLine(polygon, this.mymap._layers[polygon.guid]);
            this.showLabel(true, polygon);
            this.resetDownloadJob();
        }
    };

    handleClickIAB = () => {
        let polygon = this.state.sel_poly;
        if (polygon) {
            polygon.selected_AB === 0 ? polygon.selected_AB = 1 : polygon.selected_AB = 0;
            this.resetRef();
            this.ensurePlanningLines(polygon, polygon.lines[polygon.selected_line], this.mymap._layers[polygon.guid]);
            this.showAB(polygon, this.mymap._layers[polygon.guid]);
            this.refreshStrategyDirectionForAB(polygon);
        }
        this.resetDownloadJob();
    };

    handleClickIABS = () => {
        let polygon = this.state.sel_poly;
        if (polygon) {
            polygon.selected_AB_back === 0 ? polygon.selected_AB_back = 1 : polygon.selected_AB_back = 0;
            this.resetRef();
            const layer = this.mymap && this.mymap._layers ? this.mymap._layers[polygon.guid] : null;
            this.intersectLine(polygon, layer);
            if (this.state.play) {
                this.startLine(true);
            } else {
                this.refreshStrategyDirectionForAB(polygon);
            }
        }
        if (!polygon) return;
        this.resetDownloadJob();
    };

    //abre a janela para criar as linhas de acordo com o amgulo
    handleClickA = () => {
        let polygon = this.state.sel_poly;
        if (polygon) {
            let p = this.state.polygons.find(e => e.guid === polygon.guid);
            const angulo = p?.yaw ? p?.yaw : p?.yaw_value ? p?.yaw_value : this.state.angulo;
            const space = p?.space === undefined || p?.space === null ? 0 : p.space;

            if (this.state.ruler_a) {
                this.regua(null, 'r');
            }
            this.setState({ angle: true, space: space, angulo: angulo });
        }
        this.showLabel(true, this.state.sel_poly);
    };

    //cria linhas para algulo
    handleClickAA = () => {

        let angulo = this.state.angulo;
        this.setState({ angle: false, angulo: 0 });

        let polygon = this.state.sel_poly;
        if (polygon) {
            this.updateText(polygon);
            this.resetRef();
            this.preLines(Number(angulo));
            this.handleClickPR(true);
            this.resetDownloadJob();
        }
    };

    cancelAA = () => {
        if (this.state.ruler_a) {
            this.showAB(this.state.sel_poly, this.mymap._layers[this.state.sel_poly.guid]);
            this.regua(null, 'r')
        }
        this.setState({ angle: false, angulo: 0 });
    };

    handleChange = name => (event) => {
        if (name === 'space' && this.state.sel_poly) {
            this.state.sel_poly.space = event.target.value;
            this.state.sel_poly.planningVersion = 2;
            this.keepData('polygons', this.state.polygons);
        }
        this.setState({
            [name]: event.target.value,
        }, () => {
            if (name === 'dsc' || name === 'tbico' || name === 'fabricante') {
                this.calcCali();
            } else if (name === 'dateTimeTrabalho') {
                this.updateTimetable(this.time.tTotal);
            }
        });
    };

    handleChangeEst = name => (event) => {
        let valor = event.target.value;
        if (name === 'cost') {
            this.setState({
                cost: event.target.value,
            }, () => {
                this.updateValorFinal(null, 'update');
            });
        } else {
            this.setState({
                [name]: event.target.value,
                uEstimative: true
            }, () => {
                if (name === 'cVoo' || name === 'cLucro' || name === 'cImp') {
                    this.updateValorFinal(null, 'update');
                } else if (name === 'speed_apl') {
                    this.setState({ speed: valor });
                }
            });
        }
        this.keepData(name, event.target.value);
        this.resetDownloadJob();
    };

    handleChangeEstReset = name => (event) => {
        let valor = event.target.value;

        this.setState({
            [name]: event.target.value,
            uEstimative: true
        }, () => {
            if (name === 'speed_apl') {
                this.setState({ speed: valor });
            }
        });
        this.keepData(name, event.target.value);
        this.resetDownloadJob();
        this.resetRef();
    };

    handleChangeVlr = name => (event) => {
        this.setState({
            [name]: event.target.value,
        }, () => {
            if (name === 'cVoo' || name === 'cLucro' || name === 'cImp') {
                this.updateValorFinal(null, 'update');
                this.setState({ dificuldade: 1 });
            }
        });
        this.keepData(name, event.target.value);
    };

    handleChangeFinal = nameTemp => (event) => {
        const valueTemp = event.target.value;
        const name = nameTemp;
        this.setState({
            [name]: event.target.value,
        }, () => {
            let area = (this.areaTotal / 10000);
            let custo = Number(this.state.cVoo);
            let imp = Number(this.state.cImp);
            let value = parseInt(valueTemp * 100) / 100;
            let vf = name === 'vVoo' ? value : value * area;

            let lucro = -imp - 100 * ((custo / vf) - 1);

            this.setState({
                cLucro: (isNaN(lucro) ? 0 : lucro), dificuldade: 1
            }, () => {
                this.updateValorFinal(lucro, name);
            });
            this.keepData('cLucro', lucro);
        });
        this.keepData(name, valueTemp);
        this.resetDownloadJob();
    };

    handleChangeSpeed = name => (event) => {
        let value = event.target.value;
        this.setState({
            speed: value,
            speed_apl: value,
            speed_travel: value,
            speed_loop: value,
            uEstimative: true,
        }, () => {
            this.keepData(name, value);
        });
        this.resetDownloadJob();
        this.resetRef();
    };
    handleChangeS = (event, newValue) => {
        if (newValue !== this.state.dificuldade && this.state.openType !== 'view') {
            let diff = this.dificult[newValue];

            let loop = this.time.tLoop * diff;
            let app = this.time.tApl * diff;
            let total = this.time.tTotal - this.time.tLoop - this.time.tApl + loop + app;
            let cVoo = total / 60 / 60 * Number(this.state.cost);

            let cost = Number(this.time.cVoo);
            let imp = Number(this.state.cImp);
            let vLucro = Number(this.state.vLucro_old);

            let lucro = (cVoo - cost + vLucro);
            let lucro_per = lucro * 100 / ((cost + lucro) * 100 / (100 - imp));

            this.setState({
                cLucro: isNaN(lucro_per) ? 0 : lucro_per,
                dificuldade: newValue,
            }, () => {
                this.keepData("dificuldade", newValue);
                this.updateValorFinal();
            });
        }

    };

    handleChangeTab = name => (event, newValue) => {
        this.setState({
            [name]: newValue ? newValue : event.target.value,
        });
    };

    handleChangeCoordinates = name => event => {
        this.validate(name, event.target.value.trim());
    };

    validate = (name, value) => {
        //regex: /\d{1,2}º\d\d'(\d\d|\d\d\.\d{1,4}) (N|S)/
        //geo.toCoordinate(this.state.lat_input);
        //geo.toDMS(this.state.lat, 'latitude', 4);
        let update = this.state[name];
        if (name === 'lat' || name === 'latL') {
            update.input = value;
            if (/\d{1,2}(°|º)\d{1,2}'(\d{1,2}|\d{1,2}\.\d{1,4})( |")(N|S)/.test(value)) {
                update.value = geo.toCoordinate(geo.toFixDMS(value));
                update.error = false;
            } else {
                update.error = true;
            }
        } else if (name === 'lng' || name === 'lngL') {
            update.input = value;
            //TODO:fix res
            if ((/\d{1,2}(°|º)\d{1,2}'(\d{1,2}|\d{1,2}\.\d{1,4})( |")(W|E)/.test(value))
                || (/\d{1,2}(°|º)\d{1,2}'(\d{1,2}|\d{1,2}\.\d{1,4})( |")(O|L)/.test(value))) {
                update.value = geo.toCoordinate(geo.toFixDMS(value));
                update.error = false;
            } else {
                update.error = true;
            }
        }

        this.setState(update);
    };

    zoomInL = () => {
        this.mymap.zoomIn();
    };

    zoomOutL = () => {
        this.mymap.zoomOut();
    };

    editMark = () => {
        this.setState({ edit: true });
        this.drawEditToolbar.enable();
    };

    saveEdit = () => {
        this.setState({ edit: false });
        this.drawEditToolbar.save();
        this.drawEditToolbar.disable();
    };

    deletePoly = () => {
        if (this.state.base || this.state.fuel) {
            this.cancelCreate();
        }
        if (this.state.sel_poly) {
            const element = this.state.sel_poly.guid;
            this.removeLayer(this.featureGroupP, this.mymap._layers[element]);
            let polygon = this.state.sel_poly;
            if (polygon) {
                if (polygon.layer) {
                    this.removeLayer(this.featureGroupE, this.mymap._layers[polygon.layer]);
                    this.removeLayer(this.featureGroupE, this.mymap._layers[(polygon.layer).replace("_lines", "_abL")]);
                    this.removeLayer(this.featureGroupE, this.mymap._layers[(polygon.layer).replace("_lines", "_abFG")]);
                    this.removeLayer(this.featureGroupE, this.mymap._layers[(polygon.layer).replace("_lines", "_abFR")]);
                }
            }
        }
        this.setState({ delete: true });
        this.drawDeleteToolbar.enable();
    };

    saveDelete = () => {
        this.setState({ delete: false });
        let x = false;
        let polygons = this.state.polygons;
        if (this.state.sel_poly) {
            polygons.splice(polygons.indexOf(this.state.sel_poly), 1);
            if (this.state.sel_poly.type === 'X') {
                x = true;
            }
        };
        if (x) {
            this.resetPolygonMap(polygons);
        }
        //this.handleClickPR(true);
        this.setState({ sel_poly: null, polygons: polygons });

        this.drawDeleteToolbar.save();
        this.drawDeleteToolbar.disable();

        let a = false;
        for (let i = 0; i < polygons.length; i++) {
            if (polygons[i].lines && polygons[i].lines.length > 0) {
                a = true;
            }
        }
        this.setState({
            dEstimative: a,
        }, () => {
            this.exibirEstimativa();

        });
        this.keepData('polygons', polygons);
    };

    handleListItemClick = guid => {
        let polyMap = this.mymap._layers[guid];
        let polygon = this.state.polygons.filter((item) => item.guid === guid);
        if (polygon.length > 0) {
            this.handleClickP(polyMap, polygon[0]);
        }
    };

    showMenu = () => {
        let dF = document.getElementById('divFloat');
        if (!dF.className.includes('div-listFloatP')) {
            dF.classList.toggle("div-listFloatP");
        } else {
            dF.classList.remove("div-listFloatP");
        }
    };

    nextIndex = (listP) => {
        let lastI = 1;
        let retorno = this.text_polygon + lastI;
        for (let i = 0; i < listP.length; i++) {
            if (listP[i].name === retorno) {
                i = -1;
                lastI++;
            }
            retorno = this.text_polygon + lastI;
        }
        return retorno;
    };

    updateText = (polygon) => {
        if (polygon) {
            polygon.config = true;
            let polyMap = this.mymap._layers[polygon.guid];
            if (polyMap) {
                let name = polygon.config ? `✔️ ${polygon.name}` : polygon.name;
                polyMap.setTooltipContent(name);
            }
        }
    };

    //upload de arquivos KML e KMZ
    loadFile = file => {
        this.setState({ progress: true });
        for (let index = 0; index < file.target.files.length; index++) {
            const filePath = file.target.files[index];

            let ext = fileName => fileName.split(".").pop();

            if (ext(filePath.name.toLowerCase()) === 'kml') {
                this.fileReader = new FileReader();
                this.fileReader.onloadend = ((e) => {
                    const content = this.fileReader.result;
                    let parser = new DOMParser();
                    let xmlDoc = parser.parseFromString(content, "text/xml");
                    let track = new togeojson['kml'](xmlDoc);

                    this.writeFileMap(track);
                });
                this.fileReader.readAsText(filePath);
            } else if (ext(filePath.name.toLowerCase()) === 'kmz') {
                let getDom = xml => (new DOMParser()).parseFromString(xml, "text/xml")
                let getKmlDom = (kmzFile) => {
                    let zip = new jszip()
                    return zip.loadAsync(kmzFile)
                        .then(zip => {
                            let kmlDom = null
                            zip.forEach((relPath, file) => {
                                if (ext(relPath) === 'kml') {
                                    kmlDom = file.async("string").then(getDom)
                                }
                            })
                            return kmlDom || Promise.reject("No kml file found")
                        });
                }

                let geoJson = getKmlDom(filePath).then(kmlDom => {
                    let geoJsonObject = new togeojson['kml'](kmlDom);
                    return geoJsonObject
                })
                geoJson.then(gj => this.writeFileMap(gj))
            } else if (ext(filePath.name.toLowerCase()) === 'zip') {
                this.fileReader = new FileReader();
                this.fileReader.onloadend = ((e) => {
                    shpjs(this.fileReader.result)
                        .then((geojson) => {
                            geojson.forEach(element => {
                                this.writeFileMap(element);
                            });
                        })
                        .catch(e => {
                            console.log(e);
                        });
                });
                this.fileReader.readAsArrayBuffer(filePath);
            }
        };
        this.setState({ progress: false });
        //
    };

    //desenha os polygons do arquivo 
    writeFileMap = (track) => {
        this.setState({ progress: true });

        if (track.features.length > 200) {
            this.itens_import = track.features;
            let list = [];
            for (let i = 0; i < track.features.length; i++) {
                let feature = track.features[i];
                if (feature.geometry.type === 'Polygon' || feature.geometry.type === 'GeometryCollection') {
                    let guid = feature.properties.guid ? feature.properties.guid : tools.newGuid();
                    let name = feature.properties.name ? feature.properties.name : this.nextIndex(this.state.polygons);
                    list.push({
                        name: name,
                        guid: guid
                    });
                }
            }
            this.setState({ itensImport: list, showImport: true });
        } else {
            setTimeout(this.fileMap(track.features), 20);
        }
    };

    fileMap = (tFeatures) => {
        let polys = this.state.polygons;
        for (let i = 0; i < tFeatures.length; i++) {
            //const element = turfS(track.features[i], {tolerance: 0.00005, highQuality: true});
            let features = tFeatures[i];
            if (features.geometry.type === 'Polygon') {
                polys = this.loadPolyFile(features.properties, features.geometry.coordinates[0], polys, true);
            } else if (features.geometry.type === 'GeometryCollection') {
                let geometries = features.geometry.geometries;
                for (let j = 0; j < geometries.length; j++) {
                    let element = geometries[j];
                    if (element.type === 'Polygon') {
                        polys = this.loadPolyFile(features.properties, element.coordinates[0], polys, true);
                    }
                }
            }
        }

        this.setState({ polygons: polys });
        if (polys.length > 0) {
            this.mymap.fitBounds(this.featureGroupP.getBounds());
        }
        this.setState({ progress: false });
    };

    loadPolyFile = (props, coordinates, polys, simplify) => {
        try {
            let polygonCoordinates = coordinates;

            if (!simplify && Array.isArray(coordinates) && coordinates.length > 0) {
                const firstPoint = coordinates[0];
                const lastPoint = coordinates[coordinates.length - 1];

                if (
                    Array.isArray(firstPoint) &&
                    Array.isArray(lastPoint) &&
                    (firstPoint[0] !== lastPoint[0] || firstPoint[1] !== lastPoint[1])
                ) {
                    polygonCoordinates = coordinates.concat([firstPoint]);
                }
            }

            let element = simplify ? geo.simplify(coordinates, 0.000002) : turf.polygon([polygonCoordinates]);
            let latlngs = this.geojsonToLeafletArray(element.geometry.coordinates[0]);
            let guid = props.guid ? props.guid : tools.newGuid();
            let name = props.name ? props.name : this.nextIndex(this.state.polygons);
            let tempPoly = new oPolygon(this.props);
            tempPoly.guid = guid;
            tempPoly.name = name;
            tempPoly.type = props.type && props.type !== '' ? props.type : guid.includes('_xcl') ? 'X' : 'N';
            tempPoly.x = props.type === 'X' ? guid.split('_xcl')[0] : '';

            tempPoly.points = JSON.stringify(latlngs);

            tempPoly.faixa = props.faixa ? props.faixa : this.state.faixa;
            tempPoly.space = props.space === undefined || props.space === null || props.space === '' ? 0 : props.space;
            tempPoly.planningVersion = props.planningVersion === 2 ? 2 : tempPoly.planningVersion;
            const importedFlow = props.fluxo !== null && props.fluxo !== '' && typeof props.fluxo !== 'undefined'
                ? props.fluxo
                : (props.average_value !== null && props.average_value !== '' && typeof props.average_value !== 'undefined'
                    ? props.average_value
                    : props.flow_rate);
            tempPoly.fluxo = importedFlow !== null && importedFlow !== '' && typeof importedFlow !== 'undefined'
                ? importedFlow
                : this.state.fluxo;

            polys = polys.concat(tempPoly);
            this.drawPolygon(tempPoly, polys);
            return polys;
        } catch (e) {
            notification.open({
                message: this.props.res.ERRO,
                description: this.props.res.ERRO_MSG,
                icon: <MaterialIcon icon="error" className="text-danger" />
            });
            return polys;
        }
    };

    geojsonToLeafletArray = (poly) => {
        let array = [];
        if (!Array.isArray(poly)) return array;

        for (let i = 0; i < poly.length; i++) {
            const element = poly[i];
            if (!Array.isArray(element) || element.length < 2) continue;
            array = array.concat([[element[1], element[0]]]);
        }
        return array
    };

    showGoto = () => {
        if (this.state.goto) {
            this.setState({ goto: false });
        } else {
            const centerLat = this.mymap.getCenter().lat;
            const centerLng = this.mymap.getCenter().lng;

            let lat = {
                error: false,
                input: this.formatCoordText(centerLat, 'latitude'),
                value: centerLat
            };

            let lng = {
                error: false,
                input: this.formatCoordText(centerLng, 'longitude'),
                value: centerLng
            };

            this.setState({ goto: true, lat: lat, lng: lng });
        }
    };

    goto = (type) => {
        this.setState({ goto: false });
        if (!type) {
            this.mymap.setView([this.state.lat.value, this.state.lng.value]);
        } else if (type === 'poly') {
            this.mymap.fitBounds(this.featureGroupP.getBounds());
        } else if (type === 'home') {
            if (this.state.home !== Config.place) {
                this.mymap.setView(this.state.home);
            }
        } else if (type === 'sel_poly') {
            if (this.state.sel_poly) {
                let bounds = this.mymap._layers[this.state.sel_poly.guid].getBounds();
                bounds.isValid() && this.mymap.fitBounds(bounds);
            }
        }
    };

    drawPolygon = (poly, polygons) => {
        const baseColor = this.getPolygonBaseColor(poly, polygons);
        let myStyle = {
            color: baseColor,
            fillColor: baseColor,
            weight: 4,
            opacity: 0.8,
            fillOpacity: 0.8,
            pane: this.getPlanningPolygonPane(poly.type)
        };

        if (poly.type === 'X' || poly.x) {
            myStyle = {
                color: this.color_x,
                fillColor: this.color_x,
                weight: 2,
                opacity: 1,
                pane: this.getPlanningPolygonPane(poly.type)
            };
        } else if (poly.type === 'T') {
            myStyle = {
                color: this.color_t,
                fillColor: this.color_t,
                weight: 2,
                opacity: 1,
                pane: this.planningPanes.T
            };
        } else if (poly.type === 'F') {
            myStyle = {
                color: baseColor,
                fillColor: baseColor,
                weight: 2,
                opacity: 1,
                fillOpacity: 0.8,
                pane: this.planningPanes.F
            };
        }

        let coords = [];

        if (typeof poly.points === 'string') {
            try {
                coords = JSON.parse(poly.points);
            } catch (e) {
                coords = [];
            }
        } else if (Array.isArray(poly.points)) {
            if (poly.points.length > 0 && poly.points[0] && typeof poly.points[0] === 'object' &&
                poly.points[0].lat !== undefined && poly.points[0].lng !== undefined) {
                coords = poly.points.map(p => [p.lat, p.lng]);
            } else {
                coords = poly.points;
            }
        }

        if (!coords || !coords.length) return;

        let myLayer = L.polygon(coords, myStyle);
        //let myLayer = L.geoJSON(element, { style: myStyle });
        let guid = poly.guid;
        let name = poly.config ? `✔️ ${poly.name}` : poly.name;
        myLayer._leaflet_id = guid;

        myLayer.bindTooltip(name,
            { permanent: true, direction: "center", className: 'tool-tip-L tool-tip-size16-L' }
        ).openTooltip();

        myLayer.addTo(this.featureGroupP);
        if (poly.type === 'F') {
            let colorPolygons = Array.isArray(polygons) ? polygons.slice() : (this.state.polygons || []).slice();
            if (!colorPolygons.some(item => item && item.guid === poly.guid)) colorPolygons.push(poly);
            this.refreshFlowPolygonColors(colorPolygons);
        }
        myLayer.on("click", (event) => this.handlePolygonPointSelection(event, poly));
        if (!poly.area || (poly.area && poly.area === 0)) {
            poly.area = L.GeometryUtil.geodesicArea(myLayer.getLatLngs()[0]);
        }
    };

    limitChar = (string, limit) => {
        let ret = string;
        let size = SPW(string, { font: "Arial", size: 16 });
        if (size > limit) {
            ret = string.slice(0, (string.length * (limit - 16) / size)) + '...';
        }
        return ret;
    };

    showArea = () => {
        this.setState({ showImport: true });
    };

    listDrawPoly = (itens) => {
        this.setState({ showImport: false });

        let polygons = this.state.polygons || [];
        let areaFilterSelection = this.state.areaFilterSelection
            ? this.state.areaFilterSelection.slice()
            : [];

        for (let i = 0; i < itens.length; i++) {
            let polygon = itens[i];

            let isNew = (polygons.filter(item => {
                return polygon.guid === item.guid;
            }).length === 0);

            if (!isNew) continue;

            let points = JSON.parse(polygon.points);
            points.push(points[0]);

            let element = geo.simplify(this.geojsonToLeafletArray(points), 0.000002);
            polygon.points = JSON.stringify(
                this.geojsonToLeafletArray(element.geometry.coordinates[0])
            );

            this.drawPolygon(polygon, polygons.concat(polygon));
            let tempPoly = new oPolygon(this.props);
            tempPoly.id = polygon.id;
            tempPoly.guid = polygon.guid;
            tempPoly.name = polygon.name;
            tempPoly.points = polygon.points;
            tempPoly.id_property = polygon.id_property ? polygon.id_property : null;
            tempPoly.x = polygon.x;
            tempPoly.old = polygon.old;
            tempPoly.type = polygon.type && polygon.type === 'T'
                ? 'T'
                : (polygon.type && polygon.type !== ''
                    ? polygon.type
                    : (polygon.guid.includes('_xcl') ? 'X' : 'N'));

            tempPoly.faixa = polygon.faixa ? polygon.faixa : this.state.faixa;
            tempPoly.fluxo = polygon.fluxo ? polygon.fluxo : this.state.fluxo;

            polygons.push(tempPoly);

            if (areaFilterSelection.indexOf(tempPoly.guid) < 0) {
                areaFilterSelection.push(tempPoly.guid);
            }

            if (tempPoly.type === 'X' || tempPoly.type === 'T') {
                this.resetPolygonMap();
            }
        }

        this.keepData('polygons', polygons);

        this.setState(
            {
                polygons: polygons,
                areaFilterSelection: areaFilterSelection
            },
            () => {
                this.recalculateOverlaps();

                if (itens.length > 0) {
                    this.mymap.fitBounds(this.featureGroupP.getBounds());
                }
            }
        );
    };

    openAreaList = () => {
        const polygons = this.state.polygons || [];
        const existing = this.state.areaFilterSelection;

        let current = [];

        if (Array.isArray(existing)) {
            let allVisible = false;

            if (this.mymap && this.mymap._layers && polygons.length > 0) {
                allVisible = polygons.every(function (p) {
                    return p && p.guid && !!(this.mymap._layers[p.guid]);
                }.bind(this));
            }

            if (existing.length === 0 && allVisible) {
                current = polygons.map(function (p) { return p.guid; });
            } else {
                current = existing.slice();
            }
        } else {
            current = polygons.map(function (p) { return p.guid; });
        }

        this.setState({
            openAreaList: true,
            areaFilterSelection: current,
            areaFilterSelectionBackup: current.slice()
        }, () => {
            this.applyAreaFilter();
        });
    };

    saveAreaList = () => {
        const polygons = this.state.polygons || [];
        const list = this.state.areaFilterSelection || [];

        const validGuids = polygons.map(function (p) { return p.guid; });
        const selectedGuids = list.filter(function (g) { return validGuids.indexOf(g) >= 0; });

        let newSelPoly = null;

        if (selectedGuids.length === 1) {
            newSelPoly = polygons.find(function (p) {
                return p &&
                    p.guid === selectedGuids[0] &&
                    p.type !== 'X' &&
                    p.type !== 'XL';
            }) || null;
        } else if (selectedGuids.length > 1) {
            const currentSel = this.state.sel_poly;
            if (
                currentSel &&
                selectedGuids.indexOf(currentSel.guid) >= 0 &&
                currentSel.type !== 'X' &&
                currentSel.type !== 'XL'
            ) {
                newSelPoly = currentSel;
            }
        }

        this.setState(
            {
                openAreaList: false,
                areaFilterSelection: selectedGuids.slice(),
                areaFilterSelectionBackup: selectedGuids.slice(),
                sel_polygons: selectedGuids.slice(),
                sel_poly: newSelPoly
            },
            () => {
                this.applyAreaFilter();
            }
        );
    };

    toggleAreaFilter = (guid) => {
        let list = this.state.areaFilterSelection
            ? this.state.areaFilterSelection.slice()
            : [];

        const index = list.indexOf(guid);

        if (index >= 0) {
            list.splice(index, 1);
        } else {
            list.push(guid);
        }

        this.setState({ areaFilterSelection: list }, () => {
            this.applyAreaFilter();
        });
    };

    applyAreaFilter = () => {
        if (!this.mymap || !this.mymap._layers) return;

        const polygons = this.state.polygons || [];
        const selectedGuids = this.state.areaFilterSelection || [];
        const hasSelection = selectedGuids.length > 0;

        for (let i = 0; i < polygons.length; i++) {
            const poly = polygons[i];
            if (!poly || !poly.guid) continue;

            const guid = poly.guid;
            const layer = this.mymap._layers[guid];

            const shouldShow = hasSelection
                ? selectedGuids.indexOf(guid) >= 0
                : false;

            if (!shouldShow) {
                if (layer && this.featureGroupP) {
                    this.removeLayer(this.featureGroupP, layer);
                }
                if (poly.layer && this.mymap._layers[poly.layer]) {
                    this.removeLayer(this.featureGroupE, this.mymap._layers[poly.layer]);
                }
                this.hideAB(poly);
            } else if (!layer) {
                this.drawPolygon(poly, polygons);
            }
        }

        let sel_polygons = (this.state.sel_polygons || []).filter(function (g) {
            return selectedGuids.indexOf(g) >= 0;
        });

        let sel_poly = this.state.sel_poly;

        if (sel_poly && selectedGuids.indexOf(sel_poly.guid) < 0) {
            sel_poly = null;
        }

        if (!sel_poly && selectedGuids.length === 1) {
            sel_poly = polygons.find(function (p) {
                return p &&
                    p.guid === selectedGuids[0] &&
                    p.type !== 'X' &&
                    p.type !== 'XL';
            }) || null;
        }

        this.setState({
            sel_polygons: sel_polygons,
            sel_poly: sel_poly
        }, () => {
            this.recalculateOverlaps();
        });
    };

    cancelAreaList = () => {
        const backup = Array.isArray(this.state.areaFilterSelectionBackup)
            ? this.state.areaFilterSelectionBackup.slice()
            : (this.state.areaFilterSelection || []);

        this.setState(
            {
                openAreaList: false,
                areaFilterSelection: backup
            },
            () => {
                this.applyAreaFilter();
            }
        );
    };

    changeGPolygons = event => {
        this.setState({
            groupPolygons: event.target.value,
            //estra: false
        });
        if (event.target.value !== 'all') {
            this.handleListItemClick(event.target.value)
        } else {
            this.exibirEstimativa();
            this.handleClickP();
        }
    };

    handleChangeSelectEstra = event => {
        this.setState({
            estrategia: event.target.value,
            //uEstimative: true
        });

        let polygon = this.state.sel_poly;
        if (polygon) {
            this.updateText(polygon);
            polygon.estrategia = event.target.value;
            polygon.estrategia_manual = true;
            polygon.selected_Out = this.strategy.filter(item => { return item.value === event.target.value })[0].id;
            polygon.is_selected = true;
            this.intersectLine(polygon, this.mymap._layers[polygon.guid]);
            if (polygon.out.length > 0) {
                this.exibirEstimativa(polygon);
            }
            if (this.state.play) {
                this.startLine(true);
            } else {
                this.drawSelectedStrategyDirection(polygon);
            }
        }
        this.resetDownloadJob();
    };

    clickEstimative = () => {
        this.setState({ isCalculating: true }, () => {
            const polygons = this.checkDistance(this.state.polygons);
            if (!polygons.length) {
                this.setState({ isCalculating: false });
                return;
            }
            let lastPoly = null;
            const run = (i) => {
                if (this.state.aproveitamento && lastPoly) {
                    polygons[i].carga_inicial = lastPoly.carga_final;
                } else {
                    polygons[i].carga_inicial = Units.toCanonicalVolume(this.state.carga, this.props.res, this.state.aplicacao === 'S' ? 'kg' : 'L');
                }
                lastPoly = polygons[i];

                if (polygons[i].type !== 'X' && polygons[i].type !== 'XL' && polygons[i].type !== 'T') {
                    let indexPoly = -1;
                    if (this.arrPoly.length > 0) {
                        indexPoly = this.arrPoly.findIndex(item => item.guid === polygons[i].guid);
                    }
                    if (indexPoly > -1) {
                        this.tempPoly[indexPoly].selected_line = polygons[i].selected_line;
                        polygons[i].out = [];
                        this.selectPrePro(indexPoly);
                    } else {
                        if (polygons[i].lines && polygons[i].lines.length > 0) {
                            this.loadEstimativa(polygons[i], this.state.horas_dia, (result) => {
                                if (!result) {
                                    if (i < polygons.length - 1) {
                                        run(++i);
                                    } else {
                                        this.resetDownloadJob();
                                        this.setState({ isCalculating: false });
                                    }
                                    return;
                                }
                                polygons[i].carga_final = result.carga_final;
                                this.updateEstimativa(result);

                                this.updateAreaData(polygons[i]);

                                if (i < polygons.length - 1) {
                                    run(++i);
                                } else {
                                    this.resetDownloadJob();
                                    this.setState({ isCalculating: false });
                                }
                            });
                            if (i === (polygons.length - 1)) {
                                this.handleClickP();
                            }
                        } else {
                            if (i < polygons.length - 1) {
                                run(++i);
                            } else {
                                this.resetDownloadJob();
                                this.setState({ isCalculating: false });
                            }
                        }
                    }
                } else {
                    if (i < polygons.length - 1) {
                        run(++i);
                    } else {
                        this.resetDownloadJob();
                        this.setState({ isCalculating: false });
                    }
                }
            };
            run(0);
        });
        //this.setState({ tab: '1' });
        this.setState({ treatmentDetails: true, saveData: true });
    };

    updateAreaData = (polygon) => {
        const latlngs = this.selectedAB(polygon);
        const angle = this.getAngleFromCoordinates(latlngs[0][1], latlngs[0][0], latlngs[1][1], latlngs[1][0]);
        const direction = this.getCardinalDirection(angle);

        const newAreaData = {
            direction: direction,
            startPoint: { lat: latlngs[0][1], lng: latlngs[0][0] },
            endPoint: { lat: latlngs[1][1], lng: latlngs[1][0] }
        };

        this.setState(prevState => {
            const updatedAreaData = [...prevState.areaData];
            const index = updatedAreaData.findIndex(area =>
                area.startPoint.lat === newAreaData.startPoint.lat &&
                area.startPoint.lng === newAreaData.startPoint.lng &&
                area.endPoint.lat === newAreaData.endPoint.lat &&
                area.endPoint.lng === newAreaData.endPoint.lng
            );

            if (index !== -1) {
                updatedAreaData[index] = newAreaData;
            } else {
                updatedAreaData.push(newAreaData);
            }

            return {
                areaData: updatedAreaData
            };
        });
    };

    checkDistance = (polygons) => {
        const operationalPolygons = polygons.filter(polygon => polygon.type !== 'R');
        let polys = [];
        let left = JSON.parse(JSON.stringify(operationalPolygons));
        let base = [this.base.lat, this.base.lng];
        while (left.length > 0) {
            let short = 0;
            let ind = -1;
            let indSel = 0;
            for (let i = 0; i < left.length; i++) {
                const poly = left[i];
                if (!poly || !poly.out || poly.out.length === 0) {
                    continue;
                }
                let selIndex = (typeof poly.selected_Out === 'number'
                    && poly.selected_Out >= 0
                    && poly.selected_Out < poly.out.length)
                    ? poly.selected_Out
                    : 0;
                let sel = poly.out[selIndex];//??? .endPath[1]
                if (sel && sel.endPath && sel.endPath.length > 1) {
                    let latlngF = L.latLng(base);
                    let latlngS = L.latLng([sel.endPath[1], sel.endPath[0]]);
                    let temp = latlngF.distanceTo(latlngS);
                    if (short === 0 || temp < short) {
                        short = temp;
                        ind = i;
                        indSel = selIndex;
                    }
                }
            }
            if (ind >= 0) {
                let poly = left[ind];
                polys.push(poly);
                let sel = poly.out[indSel];
                if (sel && sel.center && sel.center.length > 1) {
                    base = [sel.center[1], sel.center[0]];
                }
                left.splice(ind, 1);
            } else if (polys.length === 0) {
                return operationalPolygons;
            } else {
                polys = polys.concat(left);
                break;
            }
        }
        if (polys.length > 0 && this.state.aproveitamento) {
            polys[0].carga_inicial = Units.toCanonicalVolume(this.state.carga, this.props.res, this.state.aplicacao === 'S' ? 'kg' : 'L');
        }

        return polys;
    };

    calcEstimativa = () => {
        let tApl = 0;
        let tVoo = 0;
        let tTotal = 0;
        let tLoop = 0;
        let tTras = 0;

        let aTlPul = 0;
        let comTl = 0;
        let flxMedApl = 0;

        for (let i = 0; i < this.strategy.length; i++) {
            this.strategy[i].time = 0;
        }

        let polys = this.checkDistance(this.state.polygons) || [];
        this.area = 0;
        let travel = 0;
        let last = 0;
        this.areaTotal = 0;
        let fuelPoints = [];
        //let time_remening
        for (let i = 0; i < polys.length; i++) {
            const element = polys[i];

            if (!element || !element.out || element.out.length === 0) {
                continue;
            }

            let selIndex = (typeof element.selected_Out === 'number'
                && element.selected_Out >= 0
                && element.selected_Out < element.out.length)
                ? element.selected_Out
                : 0;

            const out = element.out[selIndex];
            /*
                        this.featureGroupTest.clearLayers();
            
                        new L.geoJSON(out.path, {
                            style: {
                                "color": 'white',
                                "weight": 2,
                                "opacity": 1
                            }
                                }).addTo(this.featureGroupTest);*/

            if (out && out.startPath && out.startPath.length > 1) {
                let latlngS = L.latLng([out.startPath[1], out.startPath[0]]);
                let latlngF = null;
                if (i === 0 || !polys[i - 1] || !polys[i - 1].out || polys[i - 1].out.length === 0) {
                    latlngF = L.latLng([this.base.lat, this.base.lng]);
                    /*new L.polyline([latlngF, latlngS], {
                        color: 'red',
                        weight: 3,
                        opacity: 0.5,
                        smoothFactor: 1
                    }).addTo(this.featureGroupTest);*/
                } else {
                    const prev = polys[i - 1];
                    let prevIndex = (typeof prev.selected_Out === 'number'
                        && prev.selected_Out >= 0
                        && prev.selected_Out < prev.out.length)
                        ? prev.selected_Out
                        : 0;
                    const prevOut = prev.out[prevIndex];
                    if (prevOut && prevOut.endPath && prevOut.endPath.length > 1) {
                        latlngF = L.latLng([prevOut.endPath[1], prevOut.endPath[0]]);
                    } else {
                        latlngF = L.latLng([this.base.lat, this.base.lng]);
                    }
                    /*new L.polyline([latlngF, latlngS], {
                        color: 'blue',
                        weight: 3,
                        opacity: 0.5,
                        smoothFactor: 1
                    }).addTo(this.featureGroupTest);*/
                }
                travel += latlngF.distanceTo(latlngS);
                last = i;
            }

            if (Array.isArray(out.fuelPoint)) {
                fuelPoints = fuelPoints.concat(out.fuelPoint);
            }

            const refuelCount = planningPolygonRefuelCount(element, out, this.state.aproveitamento);
            let loop = out.loopTime || 0;
            let app = out.appTime || 0;
            let fuelTime = out.fuelTime || 0;
            tApl += app;
            tVoo += loop + app + fuelTime;
            tTotal += loop + app + fuelTime + (refuelCount * Number(this.state.r_time) * 60);
            tLoop += loop;
            tTras += fuelTime;
            aTlPul += element.aTlPul || 0;
            comTl += element.comTl || 0;
            flxMedApl += refuelCount;

            this.areaTotal += element.area || 0;
        }

        if (fuelPoints.length > 0) {
            for (let i = 0; i < this.fuel.length; i++) {
                const element = this.fuel[i];
                if (fuelPoints.includes(element.guid)) {//incluir no seletor de "out"
                    if (element.status !== 'T') {
                        element.status = 'T';
                        this.create_update_fuel(element);
                    }
                } else {
                    if (element.status !== 'Y') {
                        element.status = 'Y';
                        this.create_update_fuel(element);
                    }
                }
            }
        }

        if (this.state.aproveitamento) {
            tTotal += (Number(this.state.r_time) * 60);
            flxMedApl += 1;
        }
        if (travel > 0 && polys[last] && polys[last].out && polys[last].out.length > 0) {
            let lastIndex = (typeof polys[last].selected_Out === 'number'
                && polys[last].selected_Out >= 0
                && polys[last].selected_Out < polys[last].out.length)
                ? polys[last].selected_Out
                : 0;
            const lastOut = polys[last].out[lastIndex];
            if (lastOut && lastOut.endPath && lastOut.endPath.length > 1) {
                let latlngF = L.latLng([this.base.lat, this.base.lng]);
                let latlngS = L.latLng([lastOut.endPath[1], lastOut.endPath[0]]);
                travel += latlngF.distanceTo(latlngS);
                if (this.state.horas_base) {
                    travel += (latlngF.distanceTo(latlngS)) * Math.ceil(tTotal / 60 / 60 / this.state.horas_dia) * 2;
                }
                let tValue = ((travel / 1000) / Number(this.state.speed_travel)) * 60 * 60;
                tVoo += tValue;
                tTotal += tValue;
                tTras += tValue;
                this.travel_time = tValue;
                /*new L.polyline([latlngF, latlngS], {
                    color: 'orange',
                    weight: 3,
                    opacity: 0.5,
                    smoothFactor: 1
                }).addTo(this.featureGroupTest);*/
            }
        }
        this.time = {
            tApl: tApl,
            tVoo: tVoo,
            tTotal: tTotal,
            tLoop: tLoop,
            tTras: tTras,
            aTlPul: aTlPul,
            comTl: comTl,
            flxMedApl: flxMedApl,
        };
        this.keepData('time', this.time);
        this.keepData('area', this.areaTotal);

        this.updateTimetable(tTotal);

        this.updateValorFinal(null, 'update');
        this.exibirEstimativa();
    };

    exibirEstimativa = (polygon) => {
        if (polygon && polygon.type === 'R') polygon = { lines: [], out: [] };
        let estrategia = '';
        let temp_time = null;
        let groupPolygons = 'all';
        if (!polygon) {
            for (let i = 0; i < this.strategy.length; i++) {
                this.strategy[i].time = 0;
            }
            temp_time = this.time;
        } else {
            if (polygon.lines && polygon.lines.length > 0) {
                groupPolygons = polygon.guid;
            }

            let estrategiaBySelectedOut = '';
            let selectedOutItem = null;

            if (typeof polygon.selected_Out === 'number' && this.strategy && this.strategy[polygon.selected_Out]) {
                estrategiaBySelectedOut = this.strategy[polygon.selected_Out].value;
            }

            if (
                polygon &&
                polygon.out &&
                Array.isArray(polygon.out) &&
                polygon.out.length > 0 &&
                polygon.estrategia
            ) {
                estrategia = polygon.estrategia;
            } else if (
                polygon.is_selected &&
                polygon.out &&
                Array.isArray(polygon.out) &&
                polygon.out.length > 0 &&
                estrategiaBySelectedOut
            ) {
                estrategia = estrategiaBySelectedOut;
            }

            if (
                polygon &&
                polygon.out &&
                Array.isArray(polygon.out) &&
                polygon.out.length > 0
            ) {
                if (estrategiaBySelectedOut) {
                    selectedOutItem = polygon.out.find(item => {
                        return item && item.type === estrategiaBySelectedOut;
                    });
                }

                if (!selectedOutItem && polygon.estrategia) {
                    selectedOutItem = polygon.out.find(item => {
                        return item && item.type === polygon.estrategia;
                    });
                }

                if (selectedOutItem && !polygon.estrategia_manual && selectedOutItem.type) {
                    estrategia = selectedOutItem.type;
                }

                for (let i = 0; i < this.strategy.length; i++) {
                    this.strategy[i].time = 0;
                }

                for (let i = 0; i < polygon.out.length; i++) {
                    const outItem = polygon.out[i];
                    if (!outItem || !outItem.type) continue;

                    const strategyIndex = this.strategy.findIndex(item => item.value === outItem.type);
                    if (strategyIndex > -1) {
                        this.strategy[strategyIndex].time =
                            (outItem.loopTime || 0) +
                            (outItem.appTime || 0) +
                            (outItem.fuelTime || 0);
                    }
                }

                if (selectedOutItem) {
                    const refuelCount = planningPolygonRefuelCount(polygon, selectedOutItem, this.state.aproveitamento);
                    let loop = selectedOutItem.loopTime || 0;
                    let app = selectedOutItem.appTime || 0;
                    let fuelTime = selectedOutItem.fuelTime || 0;
                    temp_time = {
                        tApl: app,
                        tVoo: loop + app + fuelTime,
                        tTotal: loop + app + fuelTime + (refuelCount * Number(this.state.r_time) * 60),
                        tLoop: loop,
                        tTras: fuelTime,
                        aTlPul: polygon.aTlPul || 0,
                        comTl: polygon.comTl || 0,
                        flxMedApl: refuelCount,
                    };
                } else {
                    temp_time = {
                        tApl: 0,
                        tVoo: 0,
                        tTotal: 0,
                        tLoop: 0,
                        tTras: 0,
                        aTlPul: 0,
                        comTl: 0,
                        flxMedApl: 0,
                    };
                }
            } else {
                temp_time = {
                    tApl: 0,
                    tVoo: 0,
                    tTotal: 0,
                    tLoop: 0,
                    tTras: 0,
                    aTlPul: 0,
                    comTl: 0,
                    flxMedApl: 0,
                };
            }
        }

        this.setState({
            estrategia: estrategia,
            time: temp_time,
            groupPolygons: groupPolygons
        }, () => {
            this.updateValorFinal(null, 'update');
        });
    };

    loadEstimativa = (poly, day1, callback) => {
        if (poly && poly.type === 'R') {
            if (typeof callback === 'function') callback(null);
            return;
        }
        this.setState({ progress: true });

        let apiUrl = Config.server + '/estimate';
        let method = 'POST';

        const formData = new URLSearchParams();

        if (!poly.lines[poly.selected_line] && poly.selected_line === 8) {
            if (poly.lines[99]) {
                poly.selected_line = 99;
            } else {
                poly.selected_line = 0;
            }
        }
        if (!poly.lines[poly.selected_line]) poly.selected_line = 0;

        const polyLayer = (this.mymap && this.mymap._layers) ? this.mymap._layers[poly.guid] : null;
        if (!polyLayer || typeof polyLayer.toGeoJSON !== 'function') {
            this.setState({ progress: false });
            if (typeof callback === 'function') {
                callback(null);
            }
            return;
        }
        const selectedItem = poly.lines[poly.selected_line];
        this.ensurePlanningLines(poly, selectedItem, polyLayer);
        const ab = this.selectedAB(poly);
        const line = 0;
        if (!selectedItem || ab.length < 2 || !selectedItem.lines || selectedItem.lines.length === 0) {
            this.setState({ progress: false });
            if (typeof callback === 'function') callback(null);
            return;
        }
        let polyMap = polyLayer.toGeoJSON();
        /********* */
        let polysX = [];
        this.state.polygons.forEach(element => {
            if (element.type === 'X') {
                const layerX = (this.mymap && this.mymap._layers) ? this.mymap._layers[element.guid] : null;
                if (layerX && typeof layerX.toGeoJSON === 'function') {
                    polysX.push(layerX.toGeoJSON());
                }
            }
        });
        formData.append('ab', JSON.stringify(ab));
        formData.append('lines', JSON.stringify(selectedItem.lines));
        formData.append('interPoly', JSON.stringify(polysX));
        /********* */
        formData.append('polygon', JSON.stringify(polyMap));
        formData.append('guid', poly.guid);
        if (this.base.lng !== '' && this.fuel.length > 0) {
            formData.append('base', JSON.stringify([this.base.lng, this.base.lat]));
            formData.append('fuel', JSON.stringify(this.fuel));
        } else if (this.base.lng !== '') {
            formData.append('base', JSON.stringify([this.base.lng, this.base.lat]));
            formData.append('fuel', JSON.stringify([{ lng: this.base.lng, lat: this.base.lat }]));
        } else {
            this.setState({ progress: false });
            return;
        }
        formData.append('carga', this.state.aplicacao === 'S' ? this.state.carga : Units.toCanonicalVolume(this.state.carga, this.props.res));
        formData.append('cost', this.state.cost);
        formData.append('horasDia', this.state.horas_dia);
        formData.append('day1', day1);
        formData.append('tempoFuel', this.state.r_time);
        formData.append('fluxo', Units.toCanonicalFlow(poly.fluxo, this.props.res, this.state.aplicacao === 'S' ? 'kg' : 'L', 'ha'));
        formData.append('faixa', Units.toCanonicalLength(poly.faixa, this.props.res));
        if (this.state.aproveitamento) {
            formData.append('carga_inicial', poly.carga_inicial);
        }
        formData.append('pointA', JSON.stringify(ab[0]));
        formData.append('line', line);
        formData.append('planningABBack', poly.selected_AB_back === 1 ? 1 : 0);
        formData.append('type', '');//poly.estrategia);
        formData.append('space', Units.toCanonicalLength(this.state.size_loop, this.props.res));
        formData.append('spaceH', Units.toCanonicalLength(this.state.size_h_loop, this.props.res));

        formData.append('speedB', Units.toCanonicalSpeed(this.state.speed_loop, this.props.res));
        formData.append('speedApp', Units.toCanonicalSpeed(this.state.speed_apl, this.props.res));
        formData.append('speedTra', Units.toCanonicalSpeed(this.state.speed_travel, this.props.res));

        let options = {
            method: method,
            body: formData,
            headers: {
                'Authorization': localStorage.getItem('access-token-jwt')
            }
        }

        fetch(apiUrl, options)
            .then((res) => {
                if (res.status !== 200) throw res;
                else return res.json();
            })
            .then(
                (result) => {
                    this.setState({ progress: false });
                    if (result.msgErro) {
                        notification.open({
                            message: result.msgErro,
                            icon: <MaterialIcon icon="error" className="text-danger" />
                        });
                    } else {
                        callback(result);
                    }
                },
                (error) => {
                    this.setState({ progress: false });
                    if (error.status === 405) {
                        notification.open({
                            message: this.props.res.PERMISSAO,
                            description: this.props.res.PERMISSAO_MSG,
                            icon: <MaterialIcon icon="error" className="text-danger" />
                        });
                    } else if (error.status === 401 || error.status === 403) {
                        console.log(error);
                        this.props.link('/login');
                    }
                    else {
                        console.log(error);
                        notification.open({
                            message: this.props.res.ERRO,
                            description: this.props.res.ERRO_SALDO,
                            icon: <MaterialIcon icon="error" className="text-danger" />
                        });
                    }
                }
            );
    };

    updateEstimativa = (resultado, update = false) => {
        let polygons = this.state.polygons;
        for (let i = 0; i < polygons.length; i++) {
            if (resultado && polygons[i] && polygons[i].guid === resultado.guid) {
                const sourceVolume = this.state.aplicacao === 'S' ? 'kg' : 'L';
                let consumo = Units.toCanonicalFlow(polygons[i].fluxo, this.props.res, sourceVolume) * polygons[i].area / 10000;
                let aTlPul = polygons[i].area / 10000;
                let comTl = consumo;
                let flxMedApl = Math.ceil(consumo / Units.toCanonicalVolume(this.state.carga, this.props.res, sourceVolume));
                polygons[i].aTlPul = aTlPul;
                polygons[i].comTl = comTl;

                let best = 0;

                const estrategiaManual = polygons[i].estrategia_manual === true && polygons[i].estrategia
                    ? polygons[i].estrategia
                    : '';

                polygons[i].out = [];
                polygons[i].best_Out = 0;
                polygons[i].selected_Out = 0;
                polygons[i].estrategia = '';
                if (!estrategiaManual) {
                    polygons[i].estrategia_manual = false;
                }

                let qtdFaixas = 0;
                if (
                    polygons[i].lines &&
                    polygons[i].lines[polygons[i].selected_line] &&
                    polygons[i].lines[polygons[i].selected_line].lines
                ) {
                    qtdFaixas = polygons[i].lines[polygons[i].selected_line].lines.length;
                }

                const planningConfig = this.state && this.state.autoPlanningConfig ? this.state.autoPlanningConfig : null;
                const planningStrategyMode = planningConfig && planningConfig.planningStrategyMode
                    ? planningConfig.planningStrategyMode
                    : 'tempo';

                const estrategiaPorFaixa = planningStrategyMode === 'faixas'
                    ? this.getPlanningStrategyByRange(qtdFaixas)
                    : '';

                let encontrouEstrategiaManual = false;
                let encontrouEstrategiaPorFaixa = false;

                for (let j = 0; j < resultado.out.length; j++) {
                    let out = resultado.out[j];

                    if (this.state.aproveitamento) {
                        flxMedApl = resultado.out[j].qtdFuel;
                    }

                    let appTime = out.appTime;
                    let loopTime = out.loopTime;
                    let fuelTime = out.fuelTime;
                    let travelTime = out.travelTime;
                    let tVoo = appTime + loopTime + fuelTime;
                    let cVoo = tVoo +
                        (flxMedApl * (Number(this.state.r_time) * 60)) /
                        60 / 60 * this.state.cost;

                    if (!update) {
                        polygons[i].out.push({
                            type: out.type,
                            first_line: out.first,
                            appTime: appTime,
                            fuelTime: fuelTime,
                            trasTime: travelTime,
                            loopTime: loopTime,
                            tVoo: tVoo,
                            cVoo: cVoo,
                            cLucro: isNaN(this.state.cLucro) ? 0 : this.state.cLucro,
                            path: out.path,
                            startPath: out.startPath,
                            endPath: out.endPath,
                            center: out.center,
                            qtdFuel: out.qtdFuel,
                            fuelPoint: out.fuelPoint
                        });

                        if (best === 0 || best > tVoo) {
                            polygons[i].best_Out = j;
                            best = tVoo;
                        }

                        if (estrategiaManual) {
                            if (resultado.out[j].type === estrategiaManual) {
                                const item = this.strategy.filter(item => item.value === estrategiaManual)[0];
                                polygons[i].selected_Out = item ? item.id : j;
                                polygons[i].estrategia = estrategiaManual;
                                polygons[i].estrategia_manual = true;
                                encontrouEstrategiaManual = true;
                            }
                        } else if (estrategiaPorFaixa) {
                            if (resultado.out[j].type === estrategiaPorFaixa) {
                                const item = this.strategy.filter(item => item.value === estrategiaPorFaixa)[0];
                                polygons[i].selected_Out = item ? item.id : j;
                                polygons[i].estrategia = estrategiaPorFaixa;
                                polygons[i].estrategia_manual = false;
                                encontrouEstrategiaPorFaixa = true;
                            }
                        }
                    } else {
                        if (best === 0 || best > tVoo) {
                            best = tVoo;
                        }
                    }

                    //this.travel_time = travelTime;
                }

                if (!update && polygons[i].out.length > 0) {
                    if (estrategiaManual) {
                        if (!encontrouEstrategiaManual) {
                            const type = resultado.out[polygons[i].best_Out]?.type;
                            const item = this.strategy.filter(item => item.value === type)[0];

                            polygons[i].selected_Out = item ? item.id : polygons[i].best_Out;
                            polygons[i].estrategia = type;
                            polygons[i].estrategia_manual = false;
                        }
                    } else if (estrategiaPorFaixa) {
                        if (!encontrouEstrategiaPorFaixa) {
                            const type = resultado.out[polygons[i].best_Out]?.type;
                            const item = this.strategy.filter(item => item.value === type)[0];

                            polygons[i].selected_Out = item ? item.id : polygons[i].best_Out;
                            polygons[i].estrategia = type;
                            polygons[i].estrategia_manual = false;
                        }
                    } else {
                        const type = resultado.out[polygons[i].best_Out]?.type;
                        const item = this.strategy.filter(item => item.value === type)[0];

                        polygons[i].selected_Out = item ? item.id : polygons[i].best_Out;
                        polygons[i].estrategia = type;
                        polygons[i].estrategia_manual = false;
                    }
                }

                if (this.state.aproveitamento && polygons[i].out.length > 0) {
                    let selectedOutItem = polygons[i].out.find(item => {
                        return item && item.type === polygons[i].estrategia;
                    });

                    if (selectedOutItem) {
                        flxMedApl = selectedOutItem.qtdFuel;
                    }
                }
                polygons[i].flxMedApl = flxMedApl;

                this.intersectLine(polygons[i], this.mymap._layers[polygons[i].guid]);
                this.setState({ polygons: polygons, uEstimative: false }, () => {
                    if (!update) {
                        this.calcEstimativa();
                    } else {
                        update(best);
                    }
                });
                break;
            }
        }
        this.keepData('polygons', polygons);
    };

    downloadRel = (type, arrAngles) => {
        let apiUrl = Config.server + '/relorcamento';
        let method = 'POST';

        let lucro = Number(this.state.cLucro);
        let imp = Number(this.state.cImp);
        let diff = 1;// this.dificult[this.state.dificuldade];

        const filterGuids = this.state.areaFilterSelection || [];
        const hasFilter = filterGuids.length > 0;

        const polyN = [];

        for (let i = 0; i < (this.state.polygons || []).length; i++) {
            const p = this.state.polygons[i];
            if (!p) continue;

            if (!p.type || (p.type !== 'N' && p.type !== 'X' && p.type !== 'XL' && p.type !== 'T' && p.type !== 'F' && p.type !== 'R')) {
                p.type = 'N';
            }

            if (p.type === 'N' && p.lines && p.lines.length > 0) {
                if (hasFilter && p.guid && filterGuids.indexOf(p.guid) < 0) {
                    continue;
                }
                polyN.push(p);
            }
        }

        if (polyN.length === 0) {
            this.setState({ progress: false });
            notification.open({
                message: this.props.res.AREA || 'Selecione ao menos uma área.',
                description: this.props.res.AREA_MSG || 'Não há áreas selecionadas para gerar o relatório.',
                icon: <MaterialIcon icon="error" className="text-danger" />
            });
            return;
        }

        let poly = [];
        for (let i = 0; i < polyN.length; i++) {
            const element = polyN[i];

            if (element.out && element.out.length > 0) {
                let loop = element.out[element.selected_Out].loopTime * diff;
                let app = element.out[element.selected_Out].appTime * diff;
                let tVoo = loop + app + element.out[element.selected_Out].fuelTime;
                let tTotal = loop + app + element.out[element.selected_Out].fuelTime + (element.flxMedApl * (Number(this.state.r_time) * 60));
                let cVoo = tTotal / 60 / 60 * Number(this.state.cost);
                let suggested = cVoo / (1 - ((lucro + imp) / 100));
                const estrategia = this.strategy.filter(function (item) { return item.id === element.selected_Out; });
                let yaw = element.lines[element.selected_line].yaw;
                if (yaw < 0) {
                    yaw = yaw + 360;
                }

                let angles = [];
                if (arrAngles) {
                    angles = arrAngles.filter(function (item) { return item.guid === polyN[i].guid; });
                    angles = angles.length > 0 ? angles[0] : [];
                }

                if (element.selected_AB === 1) {
                    yaw = yaw < 180 ? yaw + 180 : yaw - 180;
                }
                yaw = yaw < 0 ? yaw + 360 : yaw > 360 ? yaw - 360 : yaw;

                let equip = null;
                if ((type === 'keep' && this.state.equip_plan) || (type === 'send' && this.state.equip_orc)) {
                    equip = element.equip;
                }

                const area = Units.convertArea(element.area, 'm2', this.props.res);

                let fluxo = Number(element.fluxo);
                if (isNaN(fluxo)) {
                    fluxo = 0;
                }

                let totalFlow = element.comTl;
                if (totalFlow == null || isNaN(totalFlow)) {
                    totalFlow = fluxo * area;
                    if (isNaN(totalFlow)) {
                        totalFlow = 0;
                    }
                }

                let supplies = element.flxMedApl;
                if (supplies == null || isNaN(supplies)) {
                    supplies = 0;
                }

                let faixa = Number(element.faixa);
                if (isNaN(faixa)) {
                    faixa = 0;
                }

                poly.push({
                    guid: element.guid,
                    name: element.name,
                    type: element.type,
                    area: area,
                    flow: fluxo,
                    totalFlow: totalFlow,
                    supplies: supplies,
                    totalTime: tTotal,
                    flyingTime: tVoo,
                    loopTime: loop,
                    appTime: app,
                    value: suggested,
                    estrategia: estrategia[0].value,
                    rumo: yaw,
                    faixas: element.lines[element.selected_line].lines.length,
                    poly: element.points,
                    angles: angles,
                    faixa: faixa,
                    fluxo: fluxo,
                    detalhes: {
                        typeApp: this.state.aplicacao === 'S' ? 'Sólido' : 'Líquido',//element.detalhes?.typeApp,
                        typeService: JSON.stringify(element.detalhes && element.detalhes.typeService),
                        otherService: element.detalhes && element.detalhes.otherService,
                        areaRisk: JSON.stringify(element.detalhes && element.detalhes.areaRisk),
                        areaRiskOthers: element.detalhes && element.detalhes.areaRiskOthers,
                        equipment: element.detalhes && element.detalhes.equipment,
                        equipmentName: element.detalhes && element.detalhes.equipmentName,
                        name: element.detalhes && element.detalhes.name,
                        manufacturerEquipment: element.detalhes && element.detalhes.manufacturerEquipment,
                        equipmentType: element.detalhes && element.detalhes.equipmentType,
                        electrostatic: element.detalhes && element.detalhes.electrostatic,
                        jetType: element.detalhes && element.detalhes.jetType,
                        sprayTip: element.detalhes && element.detalhes.sprayTip,
                        deflectionAngle: element.detalhes && element.detalhes.deflectionAngle,
                        quantityNozzle: element.detalhes && element.detalhes.quantityNozzle,
                        screen: element.detalhes && element.detalhes.screen,
                        flowRegulator: element.detalhes && element.detalhes.flowRegulator,
                        angleBlades: element.detalhes && element.detalhes.angleBlades,
                        quantityAtomizer: element.detalhes && element.detalhes.quantityAtomizer,
                        minimumSpeed: element.detalhes && element.detalhes.minimumSpeed,
                        averageSpeed: element.detalhes && element.detalhes.averageSpeed,
                        maximumSpeed: element.detalhes && element.detalhes.maximumSpeed,
                        applicationRange: element.detalhes && element.detalhes.applicationRange,
                        applicationFee: element.detalhes && element.detalhes.applicationFee,
                        sprayClassification: element.detalhes && element.detalhes.sprayClassification,
                        minimumCoveredArea: element.detalhes && element.detalhes.minimumCoveredArea,
                        averageCoveredArea: element.detalhes && element.detalhes.averageCoveredArea,
                        maximumCoveredArea: element.detalhes && element.detalhes.maximumCoveredArea,
                        minimumTotalVolume: element.detalhes && element.detalhes.minimumTotalVolume,
                        averageTotalVolume: element.detalhes && element.detalhes.averageTotalVolume,
                        maximumTotalVolume: element.detalhes && element.detalhes.maximumTotalVolume,
                        minimumEquipmentVolume: element.detalhes && element.detalhes.minimumEquipmentVolume,
                        averageEquipmentVolume: element.detalhes && element.detalhes.averageEquipmentVolume,
                        maximumEquipmentVolume: element.detalhes && element.detalhes.maximumEquipmentVolume,
                        minimumPressure: element.detalhes && element.detalhes.minimumPressure,
                        averagePressure: element.detalhes && element.detalhes.averagePressure,
                        maximumPressure: element.detalhes && element.detalhes.maximumPressure,
                        minimumTemperature: element.detalhes && element.detalhes.minimumTemperature,
                        averageTemperature: element.detalhes && element.detalhes.averageTemperature,
                        maximumTemperature: element.detalhes && element.detalhes.maximumTemperature,
                        minimumHumidity: element.detalhes && element.detalhes.minimumHumidity,
                        averageHumidity: element.detalhes && element.detalhes.averageHumidity,
                        maximumHumidity: element.detalhes && element.detalhes.maximumHumidity,
                        minimumDeltaT: element.detalhes && element.detalhes.minimumDeltaT,
                        averageDeltaT: element.detalhes && element.detalhes.averageDeltaT,
                        maximumDeltaT: element.detalhes && element.detalhes.maximumDeltaT,
                        minimumPressure: element.detalhes && element.detalhes.minimumPressure,
                        averagePressure: element.detalhes && element.detalhes.averagePressure,
                        maximumPressure: element.detalhes && element.detalhes.maximumPressure,
                        leftWing: (element.detalhes && element.detalhes.equipmentType === 'Atomizador')
                            ? {
                                position: JSON.stringify(element.detalhes && element.detalhes.leftWing),
                                inputFields: JSON.stringify(element.detalhes && element.detalhes.leftWingDistance)
                            }
                            : (element.detalhes && element.detalhes.leftWing),
                        leftCenter: (element.detalhes && element.detalhes.equipmentType === 'Atomizador')
                            ? {
                                position: JSON.stringify(element.detalhes && element.detalhes.leftCenter),
                                inputFields: JSON.stringify(element.detalhes && element.detalhes.leftCenterDistance)
                            }
                            : (element.detalhes && element.detalhes.leftCenter),
                        rightCenter: (element.detalhes && element.detalhes.equipmentType === 'Atomizador')
                            ? {
                                position: JSON.stringify(element.detalhes && element.detalhes.rightCenter),
                                inputFields: JSON.stringify(element.detalhes && element.detalhes.rightCenterDistance)
                            }
                            : (element.detalhes && element.detalhes.rightCenter),
                        rightWing: (element.detalhes && element.detalhes.equipmentType === 'Atomizador')
                            ? {
                                position: JSON.stringify(element.detalhes && element.detalhes.rightWing),
                                inputFields: JSON.stringify(element.detalhes && element.detalhes.rightWingDistance)
                            }
                            : (element.detalhes && element.detalhes.rightWing),
                        useEquipmentReport: element.detalhes && element.detalhes.useEquipmentReport,
                        useCultureReport: element.detalhes && element.detalhes.useCultureReport,
                        useProductReport: element.detalhes && element.detalhes.useProductReport,
                        useInfoReport: element.detalhes && element.detalhes.useInfoReport,
                        agriculturelCulture: element.detalhes && element.detalhes.agriculturelCulture,
                        target: element.detalhes && element.detalhes.target,
                        cultureVariety: element.detalhes && element.detalhes.cultureVariety,
                        cultureQuantityApplications: element.detalhes && element.detalhes.cultureQuantityApplications,
                        cultureCycle: element.detalhes && element.detalhes.cultureCycle,
                        cultureHeight: element.detalhes && element.detalhes.cultureHeight,
                        culturePopulationDensity: element.detalhes && element.detalhes.culturePopulationDensity,
                        culturePlantingTime: element.detalhes && element.detalhes.culturePlantingTime,
                        culturePestSurvey: element.detalhes && element.detalhes.culturePestSurvey,
                        dosage: element.detalhes && element.detalhes.dosage,
                        tailVolume: element.detalhes && element.detalhes.tailVolume,
                        mixingRecommendation: element.detalhes && element.detalhes.mixingRecommendation,
                        tempMin: element.detalhes && element.detalhes.tempMin,
                        tempMax: element.detalhes && element.detalhes.tempMax,
                        humidityMin: element.detalhes && element.detalhes.humidityMin,
                        humidityMax: element.detalhes && element.detalhes.humidityMax,
                        deltaT: element.detalhes && element.detalhes.deltaT,
                        selectedProducts: JSON.stringify(element.detalhes && element.detalhes.selectedProducts),
                        dosageDetails: JSON.stringify(element.detalhes && element.detalhes.dosageDetails),
                        selectedProductsSolids: JSON.stringify(element.detalhes && element.detalhes.selectedProductsSolids)
                    }
                });
            }
        }

        let polysX = [];
        (this.state.polygons || []).forEach(function (element) {
            if (element && element.type === 'X') {
                polysX.push(element.points);
            }
        });

        const formData = new URLSearchParams();

        formData.append('culture', this.props.res.LINGUA);
        formData.append('moneyUnit', this.props.res.SIMBOLO_MOEDA);
        formData.append('title', this.state.title_est);
        formData.append('customer', this.state.client_est);
        formData.append('pilot', this.state.pilot_est);
        formData.append('aeronave', this.state.plane_est);
        formData.append('faixa', Units.toCanonicalLength(this.state.faixa, this.props.res));
        formData.append('altura', Units.toCanonicalLength(this.state.altura, this.props.res));
        formData.append('lat', JSON.stringify(this.state.lat));
        formData.append('lng', JSON.stringify(this.state.lng));
        formData.append('custoHora', this.state.cost);
        formData.append('impostos', this.state.cImp);
        formData.append('lucro', this.state.cLucro);
        formData.append('dificuldade', this.state.dificuldade);
        formData.append('tempoReabastecimento', this.state.r_time);
        formData.append('coordBase', JSON.stringify(this.base));
        formData.append('coordPista', JSON.stringify(this.fuel));
        formData.append('vVoo', this.state.vVoo);
        formData.append('vVooHa', this.state.vVooHA);
        formData.append('vLucro', this.state.vLucro);
        formData.append('vImp', this.state.vImp);
        formData.append('tTras', this.time.tTras);
        formData.append('type', type);
        if (type === 'keep') {
            formData.append('keep', this.type_rel);
        }
        formData.append('tTotal', this.time.tTotal);
        formData.append('tLoop', this.time.tLoop);
        formData.append('tApl', this.time.tApl);
        formData.append('comTl', this.time.comTl);
        formData.append('aTlPul', this.time.aTlPul); //Verificar Obj
        formData.append('flxMedApl', this.time.flxMedApl);
        formData.append('cVoo', this.state.cVoo);
        formData.append('cImp', this.state.cImp);
        formData.append('diasTrabalho', Math.ceil(this.time.tTotal / 60 / 60 / this.state.horas_dia));

        formData.append('patterns', JSON.stringify(poly));
        formData.append('patternsX', JSON.stringify(polysX));
        formData.append(
            'calibracao',
            (type === 'keep' && this.state.equip_plan) ? 'plan' :
                (type === 'send' && this.state.equip_orc) ? 'orc' :
                    null
        );

        let options = {
            method: method,
            body: formData,
            headers: {
                'Authorization': localStorage.getItem('access-token-jwt')
            }
        };

        fetch(apiUrl, options)
            .then((res) => {
                var contentType = res.headers && res.headers.get && res.headers.get('content-type');
                contentType = contentType || '';

                if (res.status !== 200) {
                    if (contentType.indexOf('application/json') === 0 || contentType.indexOf('text/json') === 0) {
                        return res.json().then(function (jsonErr) {
                            throw { status: res.status, data: jsonErr };
                        });
                    }
                    throw res;
                }

                if (contentType.indexOf('application/pdf') === 0) {
                    return res.blob().then(function (blob) {
                        return { kind: 'pdf', data: blob };
                    });
                }

                if (contentType.indexOf('application/json') === 0 || contentType.indexOf('text/json') === 0) {
                    return res.json().then(function (jsonData) {
                        return { kind: 'json', data: jsonData };
                    });
                }

                return res.blob().then(function (blob) {
                    return { kind: 'other', data: blob };
                });
            })
            .then(
                (payload) => {
                    this.setState({ progress: false });

                    if (!payload) {
                        notification.open({
                            message: this.props.res.ERRO,
                            description: this.props.res.ERRO_MSG,
                            icon: <MaterialIcon icon="error" className="text-danger" />
                        });
                        return;
                    }

                    if (payload.kind === 'pdf') {
                        var result = payload.data;

                        var file_name =
                            (type === "keep" ? "ORC" : "COT") +
                            (this.state.title_est
                                ? this.state.title_est.replace(/[^a-z0-9_]/gi, "")
                                : Date.now()) +
                            ".pdf";

                        if (result && result.size > 0) {
                            saveAs(result, file_name);
                        } else {
                            notification.open({
                                message: this.props.res.ERRO,
                                description: this.props.res.ERRO_MSG,
                                icon: <MaterialIcon icon="error" className="text-danger" />
                            });
                        }
                        return;
                    }

                    if (payload.kind === 'json') {
                        var json = payload.data || {};

                        var msg =
                            (json && (json.msgErro || json.message || json.error)) ||
                            this.props.res.ERRO_MSG;

                        notification.open({
                            message: this.props.res.ERRO,
                            description: msg,
                            icon: <MaterialIcon icon="error" className="text-danger" />
                        });
                        return;
                    }

                    notification.open({
                        message: this.props.res.ERRO,
                        description: this.props.res.ERRO_MSG,
                        icon: <MaterialIcon icon="error" className="text-danger" />
                    });
                },
                (error) => {
                    this.setState({ progress: false });

                    if (error && error.status === 405) {
                        notification.open({
                            message: this.props.res.PERMISSAO,
                            description: this.props.res.PERMISSAO_MSG,
                            icon: <MaterialIcon icon="error" className="text-danger" />
                        });
                    } else if (error && (error.status === 401 || error.status === 403)) {
                        this.props.link('/login');
                    } else if (error && error.data) {
                        var ejson = error.data;
                        var msg2 =
                            (ejson && (ejson.msgErro || ejson.message || ejson.error)) ||
                            this.props.res.ERRO_MSG;

                        notification.open({
                            message: this.props.res.ERRO,
                            description: msg2,
                            icon: <MaterialIcon icon="error" className="text-danger" />
                        });
                    } else {
                        notification.open({
                            message: this.props.res.ERRO,
                            description: this.props.res.ERRO_MSG,
                            icon: <MaterialIcon icon="error" className="text-danger" />
                        });
                    }
                }
            );
    };

    getLado = (polygon) => {
        let lado = 'RIGHT';//'LEFT' : 'RIGHT'
        if (polygon.selected_AB === 1) {
            lado = 'RIGHT';
        } else {
            lado = 'LEFT';
        }
        return lado;
    };

    saveJob = () => {
        this.setState({ save: false });
        let apiUrl = Config.server + '/job';
        let method = 'POST';

        if (this.state.id > 0) {
            apiUrl = apiUrl + '/' + this.state.id;
            method = 'PUT';
        }

        const formData = new URLSearchParams();

        if (this.state.id > 0) {
            formData.append('id', this.state.id);
            formData.append('guid', this.state.guid);
        }

        const areaDetails = (this.state.polygons || []).map((polygon) => {
            const details = polygon.detalhes || {};

            return {
                typeApp: this.state.aplicacao === 'S' ? 'Sólido' : 'Líquido',
                datetime: this.state.dateTimeTrabalho,
                selectedService: details.selectedService,
                typeService: details.typeService,
                otherService: details.otherService,
                areaRisk: details.areaRisk,
                areaRiskOthers: details.areaRiskOthers,
                equipmentID: details.equipmentID,
                equipment: details.equipmentName,
                name: details.name,
                equipmentType: details.equipmentType,
                agriculturelCulture: details.agriculturelCulture,
                target: details.target,
                cultureVariety: details.cultureVariety,
                cultureQuantityApplications: details.cultureQuantityApplications,
                cultureCycle: details.cultureCycle,
                cultureHeight: details.cultureHeight,
                culturePopulationDensity: details.culturePopulationDensity,
                culturePlantingTime: details.culturePlantingTime,
                culturePestSurvey: details.culturePestSurvey,
                product: this.state.aplicacao === 'S' ? details.selectedProductsSolids : details.dosageDetails,
                tailVolume: details.tailVolume,
                mixingRecommendation: details.mixingRecommendation,
                tempMin: details.tempMin,
                tempMax: details.tempMax,
                humidityMin: details.humidityMin,
                humidityMax: details.humidityMax,
                windSpeed: details.windSpeed,
                windDirection: details.windDirection,
                application_period: details.application_period,
                deltaT: details.deltaT,
                flightDirection: this.state.areaData || []
            };
        });

        const polygonsToSave = (this.state.polygons || []).map((polygon) => {
            let polygonPoints = polygon.points;

            if (polygonPoints && typeof polygonPoints !== 'string') {
                try {
                    polygonPoints = JSON.stringify(polygonPoints);
                } catch (e) {
                    polygonPoints = '[]';
                }
            }

            return Object.assign({}, polygon, { points: polygonPoints });
        });

        const selectedPlanes = (this.state.planes || []).filter((item) => (this.state.plane_est_ids || []).indexOf(item.id) >= 0);
        const selectedPilots = (this.state.pilots || []).filter((item) => (this.state.pilot_est_ids || []).indexOf(item.id) >= 0);
        const selectedPlane = (this.state.planes || []).find((item) => item.id === this.state.plane_est_id);
        const selectedPilot = (this.state.pilots || []).find((item) => item.id === this.state.pilot_est_id);

        const stateToSave = Object.assign({}, this.state, {
            scheduledDate: this.state.dateTimeTrabalho ? new Date(this.state.dateTimeTrabalho).getTime() : null,
            polygons: polygonsToSave,
            plane_est: selectedPlanes.length ? selectedPlanes.map((item) => item.original_name ? item.original_name : item.name).join(', ') : (selectedPlane && selectedPlane.original_name ? selectedPlane.original_name : this.state.plane_est),
            pilot_est: selectedPilots.length ? selectedPilots.map((item) => item.original_name ? item.original_name : item.name).join(', ') : (selectedPilot && selectedPilot.original_name ? selectedPilot.original_name : this.state.pilot_est)
        });

        formData.append(
            'json',
            JSON.stringify({
                fuel: this.fuel,
                base: this.base,
                travel_time: this.travel_time,
                state: Units.toCanonicalPlanning(stateToSave, this.props.res),
                planningDetails: areaDetails
            })
        );

        const options = {
            method: method,
            body: formData,
            headers: {
                Authorization: localStorage.getItem('access-token-jwt')
            }
        };

        fetch(apiUrl, options)
            .then((res) => {
                if (res.status !== 200) throw res;
                return res.json();
            })
            .then(
                (result) => {
                    window.history.replaceState(null, 'Travicar', '/app/estimativa/edit/' + result.guid_link);

                    this.setState(
                        {
                            save: true,
                            progress: false,
                            id: result.id_job,
                            guid: result.guid_link,
                            download_id: result.id_job_link
                        },
                        () => {
                            notification.open({
                                message: this.props.res.SUCESSO,
                                description: this.props.res.SALVAR_TRABALHO,
                                icon: <MaterialIcon icon="check_circle" className="text-success" />
                            });

                            if (result.shared && result.shared_company_name) {
                                setTimeout(() => {
                                    notification.open({
                                        message: this.props.res.SUCESSO,
                                        description: `${this.props.res.PLANEJAMENTO_COMPARTILHADO_COM} ${result.shared_company_name}`,
                                        icon: <MaterialIcon icon="check_circle" className="text-success" />
                                    });
                                }, 800);
                            }

                            const savedGuid = result.guid_link;
                            const selectedPlaneId = (this.state.plane_est_ids && this.state.plane_est_ids.length) ? this.state.plane_est_ids : this.state.plane_est_id;
                            const shared = result.shared === true;

                            this.updateListPlanning((freshAutoPlanningConfig) => {
                                this.trySendOrOpenDialogAfterSave(savedGuid, selectedPlaneId, freshAutoPlanningConfig, shared);
                            });
                        }
                    );
                },
                (error) => {
                    this.setState({ progress: false, save: true });
                    if (error.status === 405) {
                        notification.open({
                            message: this.props.res.PERMISSAO,
                            description: this.props.res.PERMISSAO_MSG,
                            icon: <MaterialIcon icon="error" className="text-danger" />
                        });
                    } else if (error.status === 401 || error.status === 403) {
                        this.props.link('/login');
                    } else {
                        notification.open({
                            message: this.props.res.ERRO,
                            description: this.props.res.ERRO_MSG,
                            icon: <MaterialIcon icon="error" className="text-danger" />
                        });
                    }
                }
            );
    };

    downloadSelectedPolygons = async () => {
        if (this.downloadingSelectedPolygons) return;
        const selectedGuids = Array.isArray(this.state.sel_polygons) ? this.state.sel_polygons : [];
        const singleGuid = this.state.sel_poly && this.state.sel_poly.guid;
        const selected = new Set(selectedGuids.length > 1 ? selectedGuids : singleGuid ? [singleGuid] : selectedGuids);
        const polygons = (this.state.polygons || []).filter(polygon => selected.has(polygon.guid));
        if (!polygons.length) return;
        if (polygons.length !== selected.size) {
            notification.open({ message: this.props.res.ERRO, description: this.props.res.DOWNLOAD_POLYGONS_NOT_FOUND });
            return;
        }
        this.downloadingSelectedPolygons = true;
        try {
            await downloadPolygons(polygons, polygon => {
                const layer = this.mymap && this.mymap._layers && this.mymap._layers[polygon.guid];
                return layer && typeof layer.toGeoJSON === 'function' ? layer.toGeoJSON() : null;
            });
        } catch (error) {
            notification.open({ message: this.props.res.ERRO, description: this.props.res.DOWNLOAD_KMZ_ERROR });
        } finally {
            this.downloadingSelectedPolygons = false;
        }
    };

    downloadJob = () => {
        if (this.state.download_id > 0) {
            let apiUrl = Config.server + '/job_link_download/' + this.state.download_id;
            let method = 'GET';

            let options = {
                method: method,
                headers: {
                    'Authorization': localStorage.getItem('access-token-jwt')
                }
            }

            fetch(apiUrl, options)
                .then((res) => {
                    if (res.status !== 200) throw res;
                    else return res.blob();
                })
                .then(
                    (result) => {
                        this.setState({ progress: false });
                        let file_name = 'ORC' + (this.state.title_est ? this.state.title_est.replace(/[^a-z0-9_]/gi, "") : Date.now()) + '.zjob';
                        saveAs(result, file_name);
                        this.download = true;
                    },
                    (error) => {
                        this.setState({ progress: false });
                        if (error.status === 405) {
                            notification.open({
                                message: this.props.res.PERMISSAO,
                                description: this.props.res.PERMISSAO_MSG,
                                icon: <MaterialIcon icon="error" className="text-danger" />
                            });
                        } else if (error.status === 401 || error.status === 403) {
                            console.log(error);
                            this.props.link('/login');
                        }
                        else {
                            console.log(error);
                            notification.open({
                                message: this.props.res.ERRO,
                                description: this.props.res.ERRO_MSG,
                                icon: <MaterialIcon icon="error" className="text-danger" />
                            });
                        }
                    }
                );
        }
    };

    resetDownloadJob = () => {
        this.setState({ download_id: -1 });
        if (this.download) {
            this.setState({ id: -1 });
            this.download = false;
        }
    };

    showAdd = (type) => {
        if ((this.state.edit_add && type) || (this.state.edit_speed && !type)) {
            this.setState({ edit_add: false, edit_speed: false });
        } else if (type) {
            this.setState({ edit_add: true, edit_speed: false });
        } else {
            this.setState({ edit_speed: true, edit_add: false, calibracao: false });
        }
    };

    add_list = () => {
        let list = this.state.add_list;
        list.push({
            guid: tools.newGuid(),
            name: this.state.list_name,
            value: 0
        });
        this.setState({ add_list: list });
        this.keepData('add_list', list);
    };

    handleChangeNameList = name => (event) => {
        let list = this.state.add_list;
        for (let i = 0; i < list.length; i++) {
            if (name === list[i].guid) {
                list[i].value = event.target.value.replace(/^0+/, '');
            }
        }
        this.setState({ add_list: list });
        this.keepData('add_list', list);
    };

    updateValorFinal = (lucroFix, name) => {
        if (this.time)
            this.time.cVoo = (this.time.tTotal ? this.time.tTotal : 0) / 60 / 60 * Number(this.state.cost);

        let custo = this.time.cVoo;//valor
        let lucro = lucroFix ? lucroFix : Number(this.state.cLucro);//%
        let imp = Number(this.state.cImp);//%

        let s = custo / (1 - ((lucro + imp) / 100));
        let vL = lucro !== 0 ? s * lucro / 100 : 0;
        let vI = imp !== 0 ? s * imp / 100 : 0;

        this.setState({
            cVoo: this.time.cVoo,
            vVoo: name !== 'vVoo' ? s.toFixed(2) : Math.round(s * 100) / 100,
            vVooHA: name !== 'vVooHA' ? this.updateValorHa(s).toFixed(2) : this.updateValorHa(s),
            vLucro: vL,
            vImp: vI,
            vLucro_old: name === 'update' || name === 'vVoo' || name === 'vVooHA' || name ? vL : this.state.vLucro_old,
            cLucroHora: vL / (this.time.tTotal / 3600)
        }, this.keepData);
    };

    updateValorHa = (vVoo) => {
        let valor = vVoo / (this.areaTotal / 10000);
        //return Math.round(valor * 100) / 100;
        return this.areaTotal > 0 ? Math.round(valor * 100) / 100 : 0;
    };

    safeClearLayers = (group) => {
        if (!group) return;

        try {
            group.clearLayers();
        } catch (_) {
            if (!group._layers) return;

            Object.keys(group._layers).forEach((layerId) => {
                delete group._layers[layerId];

                if (this.mymap && this.mymap._layers) {
                    delete this.mymap._layers[layerId];
                }
            });
        }
    };

    clear = () => {
        this.setState({ clear: false });
        let d_estimate = {};
        try {
            d_estimate = JSON.parse(localStorage.getItem('d-estimate'));
        } catch (e) { }

        this.resetRef();

        this.safeClearLayers(this.featureGroupE);
        this.safeClearLayers(this.featureGroupP);
        this.safeClearLayers(this.featureGroupPM);
        this.safeClearLayers(this.featureGroupM);
        this.safeClearLayers(this.overlapGroup);

        this.setState({
            polygons: [],
            areaFilterSelection: [],
            sel_polygons: [],
            sel_poly: null,

            client_est: '',
            pilot_est: '',
            plane_est: '',

            areaData: [],

            aplicacao: 'L',

            aTlPul: 0,
            comTl: 0,
            flxMedApl: 0,

            tApl: 0,
            tVoo: 0,
            tTotal: 0,
            tLoop: 0,
            tTras: 0,

            cVoo: 0,
            //cImp: 0,
            //cLucro: 0,

            vVoo: 0,
            vVooHA: 0,
            vImp: 0,
            vLucro: 0,

            tab: '2',
            openType: 'new',

            title_est: this.dName,
            id: -1,
            guid: null
        }, () => {
            window.history.replaceState(null, "Travicar", "/app/estimativa");
            this.saveDelete();
            this.keepData('title_est', '');
            this.fuel = [];
            this.keepData('fuel', '[]');
            d_estimate.title_est = undefined;
            d_estimate.plane_est = undefined;
            d_estimate.client_est = undefined;
            d_estimate.pilot_est = undefined;
            d_estimate.polygons = undefined;
            d_estimate.fuel = undefined;
            localStorage.setItem('d-estimate', JSON.stringify(d_estimate));
            this.list_markers();
        });
    };

    qtdPoly = 0;
    totalPoly = 0;
    arrPoly = [];
    tempPoly = [];
    lastPoly = null;
    callBackRetorno = null;

    resetRef = () => {
        this.qtdPoly = 0;
        this.totalPoly = 0;
        this.arrPoly = [];
        this.tempPoly = [];
        this.callBackRetorno = null;
        this.lastPoly = null;
        this.time = {
            tApl: 0,
            tVoo: 0,
            tTotal: 0,
            tLoop: 0,
            tTras: 0,
            aTlPul: 0,
            comTl: 0,
            flxMedApl: 0,
        };
    };

    setRef = (type, func) => {
        this.callBackRetorno = func;
        if (this.arrPoly.length > 0) {
            func("keep", this.arrPoly);
        } else {
            this.polyRef(type);
        }
    };

    polyRef = (type) => {
        this.setState({ progress: true });

        const allPolys = this.state.polygons || [];
        const filterGuids = this.state.areaFilterSelection || [];

        const polys = [];

        for (let i = 0; i < allPolys.length; i++) {
            const p = allPolys[i];
            if (!p) continue;
            if (p.type === 'X' || p.type === 'T' || p.type === 'R') continue;
            if (!p.lines || !Array.isArray(p.lines) || p.lines.length === 0) continue;

            if (filterGuids.length > 0 && p.guid && filterGuids.indexOf(p.guid) < 0) {
                continue;
            }

            polys.push(p);
        }

        this.arrPoly = [];
        this.tempPoly = [];
        this.qtdPoly = 0;
        this.lastPoly = null;
        this.totalPoly = polys.length;

        if (polys.length === 0) {
            this.setState({ progress: false });
            notification.open({
                message: this.props.res.AREA,
                description: this.props.res.AREA_MSG,
                icon: <MaterialIcon icon="error" className="text-danger" />
            });
            this.resetDownloadJob();
            return;
        }

        let i = 0;

        const run = () => {
            if (i >= polys.length) {
                return;
            }

            const poly = polys[i];

            if (!poly || !poly.guid || !poly.lines || poly.lines.length === 0) {
                i++;
                run();
                return;
            }

            this.arrPoly.push({ guid: poly.guid, total: 0, qtd: 0, arr: [] });
            this.tempPoly.push({ guid: poly.guid, arr: [] });

            if (this.state.aproveitamento && this.lastPoly) {
                poly.carga_inicial = this.lastPoly.carga_final;
            } else {
                poly.carga_inicial = Units.toCanonicalVolume(this.state.carga, this.props.res, this.state.aplicacao === 'S' ? 'kg' : 'L');
            }
            this.lastPoly = poly;

            const k = i;

            this.refine(poly, k, () => {
                i++;
                run();
            });
        };

        run();
    };

    complete = (i) => {
        if (this.arrPoly[i].total === this.arrPoly[i].qtd) {
            this.qtdPoly++;
        }
        if (this.totalPoly === this.qtdPoly) {
            //call relatorio
            //this.downloadRel("keep", this.arrPoly);
            this.callBackRetorno("keep", this.arrPoly);
            this.resetDownloadJob();
        }
    };

    refine = (poly, k, callback) => {
        const element = poly//this.state.polygons[i];

        if (!element ||
            element.type === 'X' ||
            element.type === 'T' ||
            element.type === 'R' ||
            !element.lines ||
            element.lines.length === 0) {

            if (typeof callback === 'function') {
                callback();
            }
            return;
        }

        const filterGuids = this.state.areaFilterSelection || [];
        if (filterGuids.length > 0 && element.guid && filterGuids.indexOf(element.guid) < 0) {
            if (typeof callback === 'function') {
                callback();
            }
            return;
        }

        this.arrPoly[k].total = element.lines.length;

        if (!this.tempPoly[k]) {
            this.tempPoly[k] = { guid: element.guid, arr: [] };
        }

        let j = 0;

        const run = (jIndex) => {
            if (jIndex >= element.lines.length) {
                if (this.tempPoly[k].arr && this.tempPoly[k].arr.length > 0) {
                    try {
                        const cargaObj = this.tempPoly[k].arr.reduce(function (a, b) {
                            return { carga_final: Math.min(a.carga_final, b.carga_final) };
                        });
                        element.carga_final = cargaObj.carga_final;
                        poly.carga_final = cargaObj.carga_final;
                    } catch (e) {
                        if (this.tempPoly[k].arr[0]) {
                            element.carga_final = this.tempPoly[k].arr[0].carga_final;
                            poly.carga_final = this.tempPoly[k].arr[0].carga_final;
                        }
                    }
                }

                if (typeof callback === 'function') {
                    callback();
                }
                this.complete(k);
                return;
            }
            const line = element.lines[jIndex];
            if (!line) {
                jIndex++;
                if (jIndex < element.lines.length) {
                    run(jIndex);
                } else {
                    if (typeof callback === 'function') {
                        callback();
                    }
                    this.complete(k);
                }
                return;
            }

            element.selected_line = jIndex;

            this.loadEstimativa(element, this.state.horas_dia, (result_orcamento) => {
                if (!result_orcamento) {
                    jIndex++;
                    if (jIndex < element.lines.length) {
                        run(jIndex);
                    } else {
                        if (typeof callback === 'function') {
                            callback();
                        }
                        this.complete(k);
                    }
                    return;
                }

                if (result_orcamento.msgErro) {
                    notification.open({
                        message: result_orcamento.msgErro,
                        icon: <MaterialIcon icon="error" className="text-danger" />
                    });

                    jIndex++;
                    if (jIndex < element.lines.length) {
                        run(jIndex);
                    } else {
                        if (typeof callback === 'function') {
                            callback();
                        }
                        this.complete(k);
                    }
                    return;
                }

                if (result_orcamento.out && result_orcamento.out.length > 0) {
                    let selected = 0;
                    let best = 0;

                    for (let i = 0; i < result_orcamento.out.length; i++) {
                        const orc = result_orcamento.out[i];
                        const tVoo = orc.appTime + orc.loopTime + orc.fuelTime;
                        if (best === 0 || best > tVoo) {
                            best = tVoo;
                            selected = i;
                        }
                    }

                    this.arrPoly[k].qtd++;
                    result_orcamento.out[selected].path = null;

                    this.arrPoly[k].arr.push([
                        line.yaw,
                        result_orcamento.out[selected],
                        line.qtd
                    ]);

                    if (!this.tempPoly[k].arr) {
                        this.tempPoly[k].arr = [];
                    }
                    this.tempPoly[k].arr.push(result_orcamento);

                    jIndex++;
                    if (jIndex < element.lines.length) {
                        run(jIndex);
                    } else {
                        if (this.tempPoly[k].arr.length > 0) {
                            try {
                                const cargaObj2 = this.tempPoly[k].arr.reduce(function (a, b) {
                                    return { carga_final: Math.min(a.carga_final, b.carga_final) };
                                });
                                element.carga_final = cargaObj2.carga_final;
                                poly.carga_final = cargaObj2.carga_final;
                            } catch (e2) {
                                if (this.tempPoly[k].arr[0]) {
                                    element.carga_final = this.tempPoly[k].arr[0].carga_final;
                                    poly.carga_final = this.tempPoly[k].arr[0].carga_final;
                                }
                            }
                        }

                        if (typeof callback === 'function') {
                            callback();
                        }
                        this.complete(k);
                    }
                } else {
                    notification.open({
                        message: this.props.res.ERRO,
                        description: this.props.res.ERRO_MSG,
                        icon: <MaterialIcon icon="error" className="text-danger" />
                    });

                    jIndex++;
                    if (jIndex < element.lines.length) {
                        run(jIndex);
                    } else {
                        if (typeof callback === 'function') {
                            callback();
                        }
                        this.complete(k);
                    }
                }
            });
        };

        if (j < element.lines.length) {
            run(j);
        } else {
            if (typeof callback === 'function') {
                callback();
            }
            this.complete(k);
        }
    };

    updateSetRef = (type, arr) => {
        this.setState({ progress: true }, () => {
            const proPolys = this.tempPoly;
            let tempPoly = [];

            const run = (i, j) => {
                this.updateEstimativa(proPolys[i].arr[j], (best) => {
                    if (tempPoly[i] === undefined) {
                        tempPoly[i] = { tempElement: null, tempBest: 0, itemID: 0 };
                    }
                    if (tempPoly[i].tempBest === 0 || tempPoly[i].tempBest > best) {
                        tempPoly[i].tempElement = proPolys[i].arr[j];
                        tempPoly[i].tempBest = best;
                        tempPoly[i].itemID = j;
                    }
                    if (j === proPolys[i].arr.length - 1) {
                        proPolys[i].selected_line = tempPoly[i].itemID;
                        const polygons = this.state.polygons.filter(item => item.guid === this.tempPoly[i].guid);
                        if (polygons.length > 0) {
                            polygons[0].selected_line = tempPoly[i].itemID;
                        }
                        this.selectPrePro(i);
                        if (i === proPolys.length - 1) {
                            this.setState({ progress: false });
                        }
                    }
                });
            }
            let count = 1;
            for (let i = 0; i < proPolys.length; i++) {
                for (let j = 0; j < proPolys[i].arr.length; j++) {
                    count++;
                    setTimeout(() => {
                        run(i, j);
                    }, 5 * count);
                }
            }
        });
    };

    selectPrePro = (i) => {
        const polygons = this.state.polygons.filter(item => item.guid === this.tempPoly[i].guid);
        if (polygons.length > 0) {
            this.intersectLine(polygons[0], this.mymap._layers[polygons[0].guid]);
            this.showLabel(true, polygons[0]);
            this.updateEstimativa(this.tempPoly[i].arr[this.tempPoly[i].selected_line]);
            this.handleClickP();
        }
    };

    regua = (start, type, side) => {
        if (type) {
            this.ruler_p.type = type;
        }
        this.removeLayer(this.featureGroupTest, this.mymap._layers['regua']);
        this.removeLayer(this.featureGroupTest, this.mymap._layers['reguaM1']);
        this.removeLayer(this.featureGroupTest, this.mymap._layers['reguaM2']);

        this.ruler_p.second.lat = null;
        this.ruler_p.second.lng = null;
        if (!start && (this.state.ruler_a || this.ruler_p.first.lat)) {
            this.setState({ ruler_a: false });
            if (this.ruler_p.type === 'ab' && this.state.sel_poly) {
                this.showAB(this.state.sel_poly, this.mymap._layers[this.state.sel_poly.guid]);
            }
            this.ruler_p = { first: { lat: null, lng: null }, second: { lat: null, lng: null } };
            this.drawCreateToolbar.disable();
        } else {
            this.setState({ ruler_a: true });
            if (this.ruler_p.type === 'ab') {
                let dIcon = L.icon({
                    iconUrl: side === 'second' ? iconB : iconA,
                    iconSize: [40, 40],
                    iconAnchor: [20, 35]
                });
                this.drawCreateToolbar = new L.Draw.Polyline(this.mymap, {
                    showLength: false,
                    icon: dIcon,
                    shapeOptions: {
                        stroke: true,
                        color: '#fcba03',
                        weight: 4,
                        opacity: 0.5,
                        fill: false,
                        clickable: true
                    }
                });
            } else {
                this.drawCreateToolbar = new L.Draw.Polyline(this.mymap, {
                    metric: this.props.res.LINGUA !== 'en-US',
                    feet: true,
                });
            }
            this.drawCreateToolbar.enable();
            if (start) {
                this.drawCreateToolbar.addVertex(start);
            }
            if (type === 'ab' && this.state.sel_poly) {
                this.hideAB(this.state.sel_poly);
            }
        }
    };

    completeRuler = () => {
        if (this.drawCreateToolbar) {
            this.drawCreateToolbar.disable();
        }

        let latlngs = [
            [this.ruler_p.first.lat, this.ruler_p.first.lng],
            [this.ruler_p.second.lat, this.ruler_p.second.lng]
        ];
        let latlngF = L.latLng([this.ruler_p.first.lat, this.ruler_p.first.lng]);
        let latlngS = L.latLng([this.ruler_p.second.lat, this.ruler_p.second.lng]);
        let text = latlngF.distanceTo(latlngS);
        let polyline;
        let m1, m2;
        if (this.ruler_p.type === 'ab') {
            let myStyle = {
                color: '#f5c749',
                weight: 2,
                opacity: 1,
                pane: this.planningPanes.AB
            };
            polyline = L.polyline(latlngs, myStyle);
            polyline._leaflet_id = 'regua';

            let dIcon = L.icon({
                iconUrl: this.ruler_p?.side ? iconB : iconA,
                iconSize: [40, 40],
                iconAnchor: [20, 35]
            });

            m1 = L.marker([this.ruler_p.first.lat, this.ruler_p.first.lng], {
                icon: dIcon,
                pane: this.planningPanes.AB
            });

            dIcon = L.icon({
                iconUrl: this.ruler_p?.side ? iconA : iconB,
                iconSize: [40, 40],
                iconAnchor: [20, 35]
            });

            m2 = L.marker([this.ruler_p.second.lat, this.ruler_p.second.lng], {
                icon: dIcon,
                pane: this.planningPanes.AB
            });

            let angle = turf.bearing(turf.point([this.ruler_p.first.lng, this.ruler_p.first.lat]), turf.point([this.ruler_p.second.lng, this.ruler_p.second.lat]));
            angle = angle < 0 ? angle + 360 : angle > 360 ? angle - 360 : angle;
            this.setState({ angulo: tools.round(angle, 2) });
        } else {
            polyline = L.polyline(latlngs);
            polyline._leaflet_id = 'regua';
            polyline.bindTooltip(this.formatRegua(text), { permanent: true }).openTooltip()

            m1 = L.marker([this.ruler_p.first.lat, this.ruler_p.first.lng], {
                icon: new L.DivIcon({
                    iconSize: new L.Point(10, 10),
                    className: 'leaflet-div-icon leaflet-editing-icon my-own-icon',
                })
            });

            m2 = L.marker([this.ruler_p.second.lat, this.ruler_p.second.lng], {
                icon: new L.DivIcon({
                    iconSize: new L.Point(10, 10),
                    className: 'leaflet-div-icon leaflet-editing-icon my-own-icon',
                })
            });
        }
        polyline.addTo(this.featureGroupTest);

        m1.on('mousedown', (e) => {
            this.ruler_p.side = this.ruler_p.side === 'second' ? 'first' : 'second';
            this.mymap.dragging.disable();
            this.regua([this.ruler_p.second.lat, this.ruler_p.second.lng], this.ruler_p.type, this.ruler_p.side);
        })
        m1._leaflet_id = 'reguaM1';
        m1.addTo(this.featureGroupTest);

        m2.on('mousedown', (e) => {

            this.mymap.dragging.disable();
            this.regua([this.ruler_p.first.lat, this.ruler_p.first.lng], this.ruler_p.type, this.ruler_p.side);
        })
        m2._leaflet_id = 'reguaM2';
        m2.addTo(this.featureGroupTest);

        if (!this.state.angle && this.ruler_p.type === 'ab') {
            this.handleClickAA();
        }
    };

    handleCheck = (name, update) => (event) => {
        let state = { [name]: !this.state[name] };
        if (update) {
            state.uEstimative = true;
        }
        this.setState(state);
        this.keepData(name, !this.state[name]);
    };

    indexLine = 0;
    temp_poly = null;
    startLine = (play) => {
        if (this.state.sel_poly !== null && this.state.sel_poly.layer !== null && play) {
            const polygon = this.state.sel_poly;

            this.mymap.fitBounds(this.mymap._layers[(polygon.layer)].getBounds());

            this.removeLayer(this.featureGroupE, this.mymap._layers[(polygon.layer).replace("_lines", "_abL")]);
            this.removeLayer(this.featureGroupE, this.mymap._layers[(polygon.layer).replace("_lines", "_abFG")]);
            this.removeLayer(this.featureGroupE, this.mymap._layers[(polygon.layer).replace("_lines", "_abFR")]);

            this.temp_poly = {};
            const candidate = polygon.lines[polygon.selected_line];
            this.ensurePlanningLines(polygon, candidate, this.mymap._layers[polygon.guid]);
            this.temp_poly.linhas = JSON.parse(JSON.stringify(this.getPlanningPattern(polygon, candidate).orderedLines));
            this.temp_poly.layer = polygon.layer;
            this.temp_poly.selected_AB = polygon.selected_AB;

            this.indexLine = 0;
            const line = this.temp_poly.linhas[this.indexLine].linhas;
            this.drawLine(this.temp_poly, line);

            this.setState({ sel_faixa: this.indexLine, tab: '1', itens_faixa: this.temp_poly.linhas });
        } else {
            this.clearStrategyDirectionArrows();
            if (this.state.sel_poly && this.state.sel_poly.lines && this.state.sel_poly.lines.length > 0) {
                this.showAB(this.state.sel_poly, this.mymap._layers[this.state.sel_poly.guid]);
            }
        }
        this.setState({ play: play });
    };

    moveLine = (direction, value) => {
        if (this.temp_poly) {
            const linhas = this.temp_poly.linhas;
            if (direction === "R") {
                if (this.indexLine < linhas.length - 1) {
                    this.indexLine++;
                    let line = linhas[this.indexLine].linhas;
                    this.drawLine(this.temp_poly, line);
                }
            } else if (direction === "L") {
                if (this.indexLine > 0) {
                    this.indexLine--;
                    let line = linhas[this.indexLine].linhas;
                    this.drawLine(this.temp_poly, line);
                }
            } else if (direction === "T") {
                this.indexLine = value;
                let line = linhas[this.indexLine].linhas;
                this.drawLine(this.temp_poly, line);
            }
            this.setState({ sel_faixa: this.indexLine });
        }
    };

    clearStrategyDirectionArrows = () => {
        if (this.strategyDirectionArrowLayer && this.featureGroupE) {
            this.removeLayer(this.featureGroupE, this.strategyDirectionArrowLayer);
        }
        this.strategyDirectionArrowLayer = null;
    };

    refreshStrategyDirectionForAB = (polygon) => {
        if (!polygon) {
            this.clearStrategyDirectionArrows();
            return;
        }

        const currentShot = this.temp_poly && this.temp_poly.linhas
            ? this.temp_poly.linhas[this.indexLine]
            : null;
        if (this.state.play && currentShot && currentShot.linhas) {
            this.temp_poly.selected_AB = polygon.selected_AB;
            const candidate = polygon.lines[polygon.selected_line];
            const pattern = this.getPlanningPattern(polygon, candidate);
            this.temp_poly.linhas = toolsPlan.numberPlanningLines(this.temp_poly.linhas, candidate.ABs, polygon.selected_AB_back, polygon.selected_AB, pattern.ab);
            this.setState({ itens_faixa: this.temp_poly.linhas });
            this.drawLine(this.temp_poly, currentShot.linhas);
        } else {
            this.drawSelectedStrategyDirection(polygon);
        }
    };

    drawSelectedStrategyDirection = (polygon) => {
        if (
            !polygon ||
            this.state.play ||
            !this.state.sel_poly ||
            this.state.sel_poly.guid !== polygon.guid ||
            !Array.isArray(polygon.lines)
        ) {
            this.clearStrategyDirectionArrows();
            return;
        }

        const candidate = polygon.lines[polygon.selected_line];
        if (!candidate || !Array.isArray(candidate.lines) || candidate.lines.length === 0) {
            this.clearStrategyDirectionArrows();
            return;
        }

        const orderedLines = this.getPlanningPattern(polygon, candidate).orderedLines;
        const firstShot = orderedLines && orderedLines[0];
        if (firstShot && firstShot.linhas) {
            this.drawStrategyDirectionArrows(firstShot.linhas, polygon.selected_AB !== 1);
        } else {
            this.clearStrategyDirectionArrows();
        }
    };

    drawStrategyDirectionArrows = (line, reverseDirection = false) => {
        this.clearStrategyDirectionArrows();
        if (!line || !this.featureGroupE) return;

        const lineCoordinates = [];
        const collectLineStrings = (value) => {
            if (!value) return;
            if (Array.isArray(value)) {
                value.forEach(collectLineStrings);
                return;
            }

            if (value.type === 'FeatureCollection') {
                (value.features || []).forEach(collectLineStrings);
                return;
            }

            if (value.type === 'Feature') {
                collectLineStrings(value.geometry);
                return;
            }

            if (value.type === 'LineString' && Array.isArray(value.coordinates)) {
                lineCoordinates.push(value.coordinates);
            } else if (value.type === 'MultiLineString' && Array.isArray(value.coordinates)) {
                lineCoordinates.push(...value.coordinates);
            } else if (value.type === 'GeometryCollection') {
                (value.geometries || []).forEach(collectLineStrings);
            }
        };
        collectLineStrings(line);

        const arrowLayer = L.layerGroup();
        let arrowsAdded = 0;
        lineCoordinates.forEach(coordinates => {
            if (arrowsAdded >= 24 || !Array.isArray(coordinates) || coordinates.length < 2) return;

            const lineFeature = turf.lineString(coordinates);
            const lengthKm = turf.length(lineFeature, { units: 'kilometers' });
            if (!Number.isFinite(lengthKm) || lengthKm <= 0) return;

            const start = turf.point(coordinates[0]);
            const end = turf.point(coordinates[coordinates.length - 1]);
            const rotation = turf.bearing(start, end) - 90 + (reverseDirection ? 180 : 0);
            const arrowCount = Math.min(8, Math.max(2, Math.ceil(lengthKm / 0.12)));
            const arrowIcon = L.divIcon({
                html: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" style="transform: rotate(${rotation}deg);">
                    <path d="M3 10.5h11.2L10 6.3l1.4-1.4L19 12l-7.6 7.1-1.4-1.4 4.2-4.2H3z" fill="#f4511e" stroke="#ffffff" stroke-width="1.5" stroke-linejoin="round"/>
                </svg>`,
                iconSize: [20, 20],
                iconAnchor: [10, 10],
                className: ''
            });

            for (let i = 1; i <= arrowCount && arrowsAdded < 24; i++) {
                const point = turf.along(lineFeature, lengthKm * i / (arrowCount + 1), { units: 'kilometers' });
                const arrowPoint = point.geometry.coordinates;
                arrowLayer.addLayer(L.marker([arrowPoint[1], arrowPoint[0]], {
                    icon: arrowIcon,
                    pane: this.planningPanes.directionArrows,
                    interactive: false,
                    keyboard: false
                }));
                arrowsAdded++;
            }
        });

        if (arrowsAdded > 0) {
            this.strategyDirectionArrowLayer = arrowLayer;
            this.featureGroupE.addLayer(arrowLayer);
        }
    };

    drawLine = (polygon, line) => {
        if (polygon.layer !== null && polygon.layer) {
            this.removeLayer(this.featureGroupE, this.mymap._layers[(polygon.layer).replace("_lines", "_abL")]);
            this.clearStrategyDirectionArrows();

            let myStyle = {
                "color": '#f5c749',
                "weight": 2,
                "opacity": 1,
                pane: this.planningPanes.AB
            };

            let myLayer = L.geoJSON(line, { style: myStyle, pane: this.planningPanes.AB });
            myLayer._leaflet_id = (polygon.layer).replace("_lines", "_abL");
            myLayer.addTo(this.featureGroupE);
            const reverseDirection = (polygon.selected_AB !== 1) !== (this.indexLine % 2 === 1);
            this.drawStrategyDirectionArrows(line, reverseDirection);
        }
    };

    endLine = (polygon) => {
        if (polygon.layer !== null && polygon.layer) {
            this.removeLayer(this.featureGroupE, this.mymap._layers[(polygon.layer).replace("_lines", "_abL")]);
            this.clearStrategyDirectionArrows();
        }
    };

    getAuto = (api, variavel) => {
        let apiUrl = Config.server + '/' + api;
        let method = 'GET';

        let options = {
            method: method,
            headers: {
                'Authorization': localStorage.getItem('access-token-jwt')
            }
        }

        fetch(apiUrl, options)
            .then((res) => {
                if (res.status !== 200) throw res;
                else return res.json();
            })
            .then(
                (result) => {
                    if (result.length > 0) {
                        const updateState = {
                            [variavel]: result,
                        };

                        if (variavel === 'clients' && !this.state.client_est) {
                            if (this.prefilledClientName) {
                                updateState.client_est = this.prefilledClientName;
                            } else if (this.prefilledClientId) {
                                const client = result.find(item => Number(item.id) === Number(this.prefilledClientId));
                                if (client && client.name) {
                                    updateState.client_est = client.name;
                                }
                            }
                        }

                        this.setState(updateState, () => {
                            if (variavel === 'clients' && updateState.client_est) {
                                this.keepData('client_est', updateState.client_est);
                            }
                        });
                    }
                },
                (error) => {
                    this.setState({ progress: false });
                    if (error.status === 405) {
                        notification.open({
                            message: this.props.res.PERMISSAO,
                            description: this.props.res.PERMISSAO_MSG,
                            icon: <MaterialIcon icon="error" className="text-danger" />
                        });
                    } else if (error.status === 401 || error.status === 403) {
                        console.log(error);
                        this.props.link('/login');
                    } else if (error.status === 400) {
                        error.json().then(
                            (errCode) => {
                                notification.open({
                                    message: this.props.res[errCode.code],
                                    icon: <MaterialIcon icon="error" className="text-danger" />
                                });
                            });
                    } else {
                        console.log(error);
                        notification.open({
                            message: this.props.res.ERRO,
                            description: this.props.res.ERRO_MSG,
                            icon: <MaterialIcon icon="error" className="text-danger" />
                        });
                    }
                }
            );
    };

    showAutoComplete = (divName) => () => {
        let dF = document.getElementById(divName);
        if (!dF.className.includes('autoDiv')) {
            dF.classList.remove("sr-only");
            dF.classList.toggle("autoDiv");
        } else {
            dF.classList.remove("autoDiv");
            dF.classList.toggle("sr-only");
        }
    };

    setCalibracao = (item) => {
        this.setState(!this.state.calibracao ?
            {
                tempPoly: item,
                calibracao: true
            }
            : (this.state.calibracao && item !== this.state.tempPoly) ?
                {
                    tempPoly: item,
                }
                : {
                    calibracao: false
                }, () => {
                    if (this.state.calibracao) {
                        this.calcCali();
                        if (document.getElementById('divFloat').className.includes('div-listFloatP'))
                            this.showMenu();
                    }
                });
    };

    calcCali = () => {
        if (this.state.tempPoly) {
            let tempCali = toolsCali.calcTotal(this.state.speed_apl, this.state.tempPoly.nPulverizador,
                this.state.tempPoly.fluxo, this.state.tempPoly.faixa, this.state.dsc,
                this.state.fabricante, this.state.tbico, this.bico_label, this.fabricante_label);
            this.setState({ list_data1: tempCali.list_data1, list_local: tempCali.list_local });
        }
    };

    updateEquipamento = (item) => {
        let text = item[0] + ' ' + item[1];
        let polys = this.state.polygons;
        let poly = this.state.tempPoly;
        poly.equip_label = text;
        poly.equip = item;
        this.setState({ polygons: polys, calibracao: false });
    };

    listEquipment = (aircraft) => {
        const apiUrl = Config.server + '/plane_equipment';

        const options = {
            method: 'GET',
            headers: {
                'Authorization': localStorage.getItem('access-token-jwt')
            }
        }

        fetch(apiUrl, options)
            .then((res) => {
                if (res.status !== 200) throw res;
                else return res.json();
            })
            .then(
                (result) => {
                    this.readCalibrations();
                    this.readConfigurations();
                    if (result.length > 0) {
                        const filterSelectedPlane = this.state.planes.filter(plane => plane.name === aircraft).map(plane => plane.id);
                        const equipmentPlane = result.filter(plane => plane.id_plane == filterSelectedPlane);
                        this.setState({
                            equipmentData: equipmentPlane,
                            selectedPlane: aircraft,
                        });
                    }
                },
                (error) => {
                    if (error.status === 405) {
                        notification.open({
                            message: this.props.res.PERMISSAO,
                            description: this.props.res.PERMISSAO_MSG,
                            icon: <MaterialIcon icon="error" className="text-danger" />
                        });
                    } else if (error.status === 401 || error.status === 403) {
                        this.props.link('/login');
                    } else {
                        notification.open({
                            message: this.props.res.ERRO,
                            description: this.props.res.ERRO_MSG,
                            icon: <MaterialIcon icon="error" className="text-danger" />
                        });
                    }
                }
            );
    };

    handleChangeEquipment = (event) => {
        const equipmentValue = event.target.value;

        this.setState(prevState => {
            const polygonsCopy = [...prevState.polygons];
            const polygonToUpdate = { ...polygonsCopy[prevState.openedDialogDetail] };

            const equipmentUsed = this.state.equipmentData.filter(equip => equip.id === this.state.equipmentId);

            if (equipmentUsed[0]?.equipmentType === 'Bico Hidráulico') {
                let positionNozzle;
                if (this.state.equipmentConfigurationData[0]?.quantityNozzle > 0) {
                    positionNozzle = JSON.parse(this.state.equipmentConfigurationData[0]?.nozzlePosition || "{}");
                }
                polygonToUpdate.detalhes = {
                    ...polygonToUpdate.detalhes,
                    equipment: equipmentValue,
                    equipmentID: equipmentUsed[0].id,
                    equipmentName: equipmentUsed[0]?.equipment,
                    name: equipmentUsed[0]?.name,
                    manufacturerEquipment: equipmentUsed[0]?.manufacturerEquipment,
                    equipmentType: equipmentUsed[0]?.equipmentType,
                    electrostatic: equipmentUsed[0]?.electrostatic,
                    jetType: equipmentUsed[0]?.jetType,
                    sprayTip: equipmentUsed[0]?.sprayTip,
                    deflectionAngle: equipmentUsed[0]?.deflectionAngle,
                    quantityNozzle: equipmentUsed[0]?.quantityNozzle,
                    minimumSpeed: this.state.equipmentCalibrationData[0]?.minimumSpeed,
                    averageSpeed: this.state.equipmentCalibrationData[0]?.averageSpeed,
                    maximumSpeed: this.state.equipmentCalibrationData[0]?.maximumSpeed,
                    applicationRange: this.state.equipmentCalibrationData[0]?.applicationRange,
                    applicationFee: this.state.equipmentCalibrationData[0]?.applicationFee,
                    sprayClassification: this.state.equipmentCalibrationData[0]?.sprayClassification,
                    minimumCoveredArea: this.state.equipmentCalibrationData[0]?.minimumCoveredArea,
                    averageCoveredArea: this.state.equipmentCalibrationData[0]?.averageCoveredArea,
                    maximumCoveredArea: this.state.equipmentCalibrationData[0]?.maximumCoveredArea,
                    minimumTotalVolume: this.state.equipmentCalibrationData[0]?.minimumTotalVolume,
                    averageTotalVolume: this.state.equipmentCalibrationData[0]?.averageTotalVolume,
                    maximumTotalVolume: this.state.equipmentCalibrationData[0]?.maximumTotalVolume,
                    minimumEquipmentVolume: this.state.equipmentCalibrationData[0]?.minimumEquipmentVolume,
                    averageEquipmentVolume: this.state.equipmentCalibrationData[0]?.averageEquipmentVolume,
                    maximumEquipmentVolume: this.state.equipmentCalibrationData[0]?.maximumEquipmentVolume,
                    minimumPressure: this.state.equipmentCalibrationData[0]?.minimumPressure,
                    averagePressure: this.state.equipmentCalibrationData[0]?.averagePressure,
                    maximumPressure: this.state.equipmentCalibrationData[0]?.maximumPressure,
                    leftWing: positionNozzle?.asaEsquerda,
                    leftCenter: positionNozzle?.barrigaEsquerda,
                    rightCenter: positionNozzle?.barrigaDireita,
                    rightWing: positionNozzle?.asaDireita,
                }
            } else if (equipmentUsed[0]?.equipmentType === 'Atomizador') {
                let positionAtomizer;
                if (this.state.equipmentConfigurationData[0]?.quantityAtomizer > 0) {
                    positionAtomizer = JSON.parse(this.state.equipmentConfigurationData[0]?.atomizerPosition || "{}");
                }

                polygonToUpdate.detalhes = {
                    ...polygonToUpdate.detalhes,
                    equipment: equipmentValue,
                    equipmentID: equipmentUsed[0].id,
                    equipmentName: equipmentUsed[0]?.equipment,
                    name: equipmentUsed[0]?.name,
                    manufacturerEquipment: equipmentUsed[0]?.manufacturerEquipment,
                    equipmentType: equipmentUsed[0]?.equipmentType,
                    electrostatic: equipmentUsed[0]?.electrostatic,
                    screen: equipmentUsed[0]?.screen,
                    flowRegulator: equipmentUsed[0]?.flowRegulator,
                    angleBlades: equipmentUsed[0]?.angleBlades,
                    quantityAtomizer: equipmentUsed[0]?.quantityAtomizer,
                    minimumSpeed: this.state.equipmentCalibrationData[0]?.minimumSpeed,
                    averageSpeed: this.state.equipmentCalibrationData[0]?.averageSpeed,
                    maximumSpeed: this.state.equipmentCalibrationData[0]?.maximumSpeed,
                    applicationRange: this.state.equipmentCalibrationData[0]?.applicationRange,
                    applicationFee: this.state.equipmentCalibrationData[0]?.applicationFee,
                    sprayClassification: this.state.equipmentCalibrationData[0]?.sprayClassification,
                    minimumCoveredArea: this.state.equipmentCalibrationData[0]?.minimumCoveredArea,
                    averageCoveredArea: this.state.equipmentCalibrationData[0]?.averageCoveredArea,
                    maximumCoveredArea: this.state.equipmentCalibrationData[0]?.maximumCoveredArea,
                    minimumTotalVolume: this.state.equipmentCalibrationData[0]?.minimumTotalVolume,
                    averageTotalVolume: this.state.equipmentCalibrationData[0]?.averageTotalVolume,
                    maximumTotalVolume: this.state.equipmentCalibrationData[0]?.maximumTotalVolume,
                    minimumEquipmentVolume: this.state.equipmentCalibrationData[0]?.minimumEquipmentVolume,
                    averageEquipmentVolume: this.state.equipmentCalibrationData[0]?.averageEquipmentVolume,
                    maximumEquipmentVolume: this.state.equipmentCalibrationData[0]?.maximumEquipmentVolume,
                    minimumPressure: this.state.equipmentCalibrationData[0]?.minimumPressure,
                    averagePressure: this.state.equipmentCalibrationData[0]?.averagePressure,
                    maximumPressure: this.state.equipmentCalibrationData[0]?.maximumPressure,
                    leftWing: positionAtomizer && positionAtomizer?.asaEsquerda ? positionAtomizer?.asaEsquerda.position : '',
                    leftCenter: positionAtomizer && positionAtomizer?.barrigaEsquerda ? positionAtomizer?.barrigaEsquerda?.position : '',
                    rightCenter: positionAtomizer && positionAtomizer?.barrigaDireita ? positionAtomizer?.barrigaDireita?.position : '',
                    rightWing: positionAtomizer && positionAtomizer?.asaDireita ? positionAtomizer?.asaDireita?.position : '',
                    leftWingDistance: positionAtomizer && positionAtomizer?.asaEsquerda ? positionAtomizer?.asaEsquerda.inputFields : '',
                    leftCenterDistance: positionAtomizer && positionAtomizer?.barrigaEsquerda ? positionAtomizer?.barrigaEsquerda.inputFields : '',
                    rightCenterDistance: positionAtomizer && positionAtomizer?.barrigaDireita ? positionAtomizer?.barrigaDireita.inputFields : '',
                    rightWingDistance: positionAtomizer && positionAtomizer?.asaDireita ? positionAtomizer?.asaDireita.inputFields : '',
                }
            }

            polygonsCopy[prevState.openedDialogDetail] = polygonToUpdate;

            return { polygons: polygonsCopy };
        });
    };

    handleChangeCulture = (event) => {
        const cultureValue = event.target.value;

        this.setState(prevState => {
            const polygonsCopy = [...prevState.polygons];
            const polygonToUpdate = { ...polygonsCopy[prevState.openedDialogDetail] };

            polygonToUpdate.detalhes = {
                ...polygonToUpdate.detalhes,
                agriculturelCulture: cultureValue,

            }

            polygonsCopy[prevState.openedDialogDetail] = polygonToUpdate;

            return { polygons: polygonsCopy };
        });
    };

    listEquipmentCalibration = (id_equipment) => {
        const apiUrl = Config.server + `/plane_equipment_calibration/${id_equipment}`;

        const options = {
            method: 'GET',
            headers: {
                'Authorization': localStorage.getItem('access-token-jwt')
            }
        }

        fetch(apiUrl, options)
            .then((res) => {
                if (res.status !== 200) throw res;
                else return res.json();
            })
            .then(
                (result) => {
                    this.setState({
                        equipmentId: id_equipment,
                        equipmentCalibrationData: result,
                    });
                },
                (error) => {
                    if (error.status === 405) {
                        notification.open({
                            message: this.props.res.PERMISSAO,
                            description: this.props.res.PERMISSAO_MSG,
                            icon: <MaterialIcon icon="error" className="text-danger" />
                        });
                    } else if (error.status === 401 || error.status === 403) {
                        this.props.link('/login');
                    } else {
                        notification.open({
                            message: this.props.res.ERRO,
                            description: this.props.res.ERRO_MSG,
                            icon: <MaterialIcon icon="error" className="text-danger" />
                        });
                    }
                }
            );
    };

    listEquipmentConfiguration = (id_equipment) => {
        const apiUrl = Config.server + `/plane_equipment_configuration/${id_equipment}`;

        const options = {
            method: 'GET',
            headers: {
                'Authorization': localStorage.getItem('access-token-jwt')
            }
        }

        fetch(apiUrl, options)
            .then((res) => {
                if (res.status !== 200) throw res;
                else return res.json();
            })
            .then(
                (result) => {
                    this.setState({
                        equipmentConfigurationData: result,
                    })
                },
                (error) => {
                    if (error.status === 405) {
                        notification.open({
                            message: this.props.res.PERMISSAO,
                            description: this.props.res.PERMISSAO_MSG,
                            icon: <MaterialIcon icon="error" className="text-danger" />
                        });
                    } else if (error.status === 401 || error.status === 403) {
                        this.props.link('/login');
                    } else {
                        notification.open({
                            message: this.props.res.ERRO,
                            description: this.props.res.ERRO_MSG,
                            icon: <MaterialIcon icon="error" className="text-danger" />
                        });
                    }
                }
            );
    };

    openProductList = () => {
        this.setState(prevState => ({ productList: !prevState.productList }));
    };

    handleUseReport = (event, information) => {
        const { checked } = event.target;

        this.setState(prevState => {
            const polygonsCopy = [...prevState.polygons];

            if (prevState.openedDialogDetail != null && polygonsCopy[prevState.openedDialogDetail]) {
                polygonsCopy[prevState.openedDialogDetail].detalhes = {
                    ...polygonsCopy[prevState.openedDialogDetail].detalhes,
                    [information]: checked,
                };
            }

            return { ...prevState, polygons: polygonsCopy };
        });
    };

    handleClickOpenDetails = (index) => {
        this.setState({ openedDialogDetail: index, openDialogDetail: true });
    };

    handleOpenCloneDialog = () => () => {
        this.setState({ openCloneDialog: true, });
    };

    cloneData = (sourceAreaIndex) => {
        const { polygons, openedDialogDetail } = this.state;

        if (sourceAreaIndex !== undefined && openedDialogDetail !== undefined) {
            const sourcePolygon = polygons[sourceAreaIndex];
            const targetPolygon = polygons[openedDialogDetail];
            const sourceDetails = JSON.parse(JSON.stringify(sourcePolygon.detalhes));

            const targetArea = targetPolygon.area;
            const dosageDetails = {};
            for (const [productName, { dosage }] of Object.entries(sourceDetails.dosageDetails || {})) {
                dosageDetails[productName] = {
                    dosage,
                    total: dosage * targetArea,
                };
            }

            const selectedProducts = sourceDetails.selectedProducts.map(product => {
                return this.state.list_all_prod.find(p => p.id === product.id || p.name === product.name);
            }).filter(p => p !== undefined);

            const updatedPolygons = polygons.map((polygon, index) => {
                if (index === openedDialogDetail) {
                    return {
                        ...polygon,
                        detalhes: {
                            ...sourceDetails,
                            selectedProducts,
                            dosageDetails,
                        },
                    };
                }
                return polygon;
            });

            this.setState({ polygons: updatedPolygons, openCloneDialog: false });
        }
    };

    handleClose = () => {
        this.setState({ openDialogDetail: false, selectedTab: 0 });
    };

    handleChangeApplicationData = (event) => {
        const value = event.target.value;
        /*this.setState(prevState => {
            const updatedPolygons = prevState.polygons.map(polygon => ({
                ...polygon,
                detalhes: {
                    ...polygon.detalhes,
                    [key]: value,
                },
            }));

            return { ...prevState, polygons: updatedPolygons };
        });*/
        this.setState({ aplicacao: value === 'Sólido' ? 'S' : 'L' });
    };

    handleChangeCultureData = (key, value) => () => {
        this.setState(prevState => {
            const polygonsCopy = [...prevState.polygons];

            if (prevState.openedDialogDetail != null && polygonsCopy[prevState.openedDialogDetail]) {
                polygonsCopy[prevState.openedDialogDetail].detalhes = {
                    ...polygonsCopy[prevState.openedDialogDetail].detalhes,
                    [key]: value,
                };
            }

            return { ...prevState, polygons: polygonsCopy };
        });
    };

    handleChangeCultures = name => event => {
        this.setState({
            [name]: event.target.value,
        });
    };

    getProd = () => {
        return new Promise((resolve, reject) => {
            const apiUrl = Config.server + '/product';
            const options = {
                method: 'GET',
                headers: {
                    'Authorization': localStorage.getItem('access-token-jwt')
                }
            };

            fetch(apiUrl, options)
                .then((res) => {
                    if (res.status !== 200) throw res;
                    else return res.json();
                })
                .then((result) => {
                    if (Array.isArray(result)) {
                        const list = result.map(function (item, key) {
                            return Object.assign({}, item, { index: key });
                        });

                        this.setState(
                            { list_all_prod: list },
                            () => {
                                if (typeof this.getProdCustom === 'function') {
                                    this.getProdCustom();
                                }
                                resolve();
                            }
                        );
                    } else {
                        resolve();
                    }
                })
                .catch((error) => {
                    if (error && error.status === 401) {
                        this.props.link('/login');
                    } else {
                        console.log(error);
                        notification.open({
                            message: this.props.res.ERRO,
                            description: this.props.res.ERRO_MSG,
                            icon: <MaterialIcon icon="error" className="text-danger" />
                        });
                    }
                    reject(error);
                });
        });
    };

    getProdCustom = () => {
        const apiUrl = Config.server + '/product_custom';
        const options = {
            method: 'GET',
            headers: {
                'Authorization': localStorage.getItem('access-token-jwt')
            }
        };

        fetch(apiUrl, options)
            .then(function (res) {
                if (res.status !== 200) throw res;
                return res.json();
            })
            .then((result) => {
                if (!Array.isArray(result) || !result.length) return;

                const atual = Array.isArray(this.state.list_all_prod) ? this.state.list_all_prod : [];

                const normalizarItem = function (item, indexBase) {
                    const id = Number(item.id);
                    return {
                        id: id,
                        name: item.name,
                        index: indexBase,
                        source: 'custom',
                        is_custom: true,
                        uid: ('custom:' + id)
                    };
                };

                const incoming = result.map(function (it, k) {
                    return normalizarItem(it, (atual.length + k));
                });

                const map = new Map(
                    atual.map(function (p) {
                        const baseUid = (
                            p.uid
                                ? String(p.uid)
                                : (String(p.source || '').toLowerCase() === 'custom'
                                    ? ('custom:' + (p.id != null ? p.id : p.id_product_custom))
                                    : (p.id || p.code || p.name)
                                )
                        );
                        return [String(baseUid).toLowerCase(), p];
                    })
                );

                for (let i = 0; i < incoming.length; i++) {
                    const novo = incoming[i];
                    const key = String(novo.uid).toLowerCase();
                    if (map.has(key)) {
                        const merged = Object.assign({}, map.get(key), novo);
                        map.set(key, merged);
                    } else {
                        map.set(key, novo);
                    }
                }

                this.setState({ list_all_prod: Array.from(map.values()) });
            })
            .catch((error) => {
                if (error && error.status === 401) {
                    this.props.link('/login');
                } else {
                    console.log(error);
                    notification.open({
                        message: this.props.res.ERRO,
                        description: this.props.res.ERRO_MSG,
                        icon: <MaterialIcon icon="error" className="text-danger" />
                    });
                }
            });
    };

    handleFilterChange = (e) => {
        const filter = e.target.value;
        let filteredProducts;

        if (filter) {
            filteredProducts = this.state.list_all_prod.filter(product =>
                product.name.toLowerCase().includes(filter.toLowerCase())
            );
        } else {
            filteredProducts = this.state.list_all_prod;
        }

        this.setState({ filter, filteredProducts });
    };

    handleProductSelect = (product) => {
        this.setState(prevState => {
            const maxProducts = 6;
            const currentPolygonIndex = prevState.openedDialogDetail;
            if (currentPolygonIndex == null) {
                return prevState;
            }

            const polygonsCopy = [...prevState.polygons];
            const currentPolygon = polygonsCopy[currentPolygonIndex];
            const detalhes = currentPolygon.detalhes || {};
            let selectedProducts = detalhes.selectedProducts || [];

            if (selectedProducts.includes(product)) {
                selectedProducts = selectedProducts.filter(p => p !== product);
            } else {
                if (selectedProducts.length < maxProducts) {
                    selectedProducts.push(product);
                } else {
                    notification.open({
                        message: this.props.res.ATENCAO,
                        description: this.props.res.ERRO_MAX_PRODUTO,
                        icon: <MaterialIcon icon="error_outline" className="text-danger" />
                    });
                }
            }

            detalhes.selectedProducts = selectedProducts;

            polygonsCopy[currentPolygonIndex] = { ...currentPolygon, detalhes };

            const productValidation = this.productsValidation();
            if (!productValidation) {
                if (prevState.polygons[currentPolygonIndex].detalhes) {
                    prevState.polygons[currentPolygonIndex].detalhes.useProductReport = false;
                }
            }

            return { ...prevState, polygons: polygonsCopy };
        });
    };

    handleTabChange = (newTab) => {
        this.setState({ selectedTab: newTab });
    };

    handleCheckType = (type, name) => (event) => {
        this.setState((prevState) => {
            const polygons = [...prevState.polygons];

            if (prevState.openedDialogDetail != null && polygons[prevState.openedDialogDetail]) {
                const polygonToUpdate = { ...polygons[prevState.openedDialogDetail] };

                polygonToUpdate.detalhes = polygonToUpdate.detalhes || {};
                polygonToUpdate.detalhes[type] = polygonToUpdate.detalhes[type] || {};

                polygonToUpdate.detalhes[type][name] = !polygonToUpdate.detalhes[type][name];

                polygons[prevState.openedDialogDetail] = polygonToUpdate;
            }

            return { polygons };
        });
    };

    handleRadioChange = (type, name) => (event) => {
        this.setState((prevState) => {
            const polygons = [...prevState.polygons];

            if (prevState.openedDialogDetail != null && polygons[prevState.openedDialogDetail]) {
                const polygonToUpdate = { ...polygons[prevState.openedDialogDetail] };

                polygonToUpdate.detalhes = polygonToUpdate.detalhes || {};
                polygonToUpdate.detalhes[type] = name;

                polygons[prevState.openedDialogDetail] = polygonToUpdate;
            }

            return { polygons };
        });
    };

    handleChangeDetails = (name) => (event) => {
        const { value } = event.target;

        this.setState((prevState) => {
            const openedDialogDetail = prevState.openedDialogDetail;
            if (openedDialogDetail != null && prevState.polygons[openedDialogDetail]) {
                const polygons = [...prevState.polygons];
                polygons[openedDialogDetail].detalhes = {
                    ...polygons[openedDialogDetail].detalhes,
                    [name]: value,
                };

                return { ...prevState, polygons };
            }

            return prevState;
        });
    };

    nextPage = () => {
        this.setState(prevState => ({
            currentPage: prevState.currentPage + 1
        }));
    };

    prevPage = () => {
        this.setState(prevState => ({
            currentPage: prevState.currentPage - 1
        }));
    };

    jumpToPage = (pageNumber) => {
        this.setState({
            currentPage: pageNumber
        });
    };

    renderPaginationControls() {
        const { currentPage, itemsPerPage, filteredProducts } = this.state;
        const pageCount = Math.ceil(filteredProducts.length / itemsPerPage);

        return (
            <div style={{ textAlign: 'center' }}>
                <Button
                    onClick={this.prevPage}
                    disabled={currentPage === 1}
                >
                    <ArrowLeftIcon style={{ fontSize: '2rem' }} />
                </Button>
                <Button
                    onClick={this.nextPage}
                    disabled={currentPage === pageCount}
                >
                    <ArrowRightIcon style={{ fontSize: '2rem' }} />
                </Button>
            </div>
        );
    };

    handleChangeDosage = (productName) => (event) => {
        const { value } = event.target;

        this.setState((prevState) => {
            const openedDialogDetail = prevState.openedDialogDetail;
            if (openedDialogDetail != null && prevState.polygons[openedDialogDetail]) {
                const polygons = [...prevState.polygons];
                const currentPolygon = polygons[openedDialogDetail];
                const detalhes = currentPolygon.detalhes || {};
                const dosageValue = Units.toCanonicalFlow(parseFloat(value), this.props.res, 'L', 'ha');
                const polygonArea = parseFloat(currentPolygon.aTlPul.toFixed(2)) || 0;
                const totalProductValue = dosageValue * polygonArea;
                let dosageDetails = detalhes.dosageDetails || {};

                if (!dosageDetails[productName]) {
                    dosageDetails[productName] = {};
                }

                const isDosageValid = !isNaN(dosageValue) && dosageValue > 0;

                dosageDetails[productName].isValid = isDosageValid;
                dosageDetails[productName].dosage = dosageValue;
                dosageDetails[productName].total = totalProductValue;

                detalhes.dosageDetails = dosageDetails;

                polygons[openedDialogDetail].detalhes = detalhes;

                return { ...prevState, polygons };
            }

            return prevState;
        });
    };

    productsValidation = () => {
        //if (this.state.polygons[this.state.openedDialogDetail].detalhes.typeApp === 'Líquido') {
        if (this.state.aplicacao === 'L') {
            const currentPolygon = this.state.polygons[this.state.openedDialogDetail];
            if (!currentPolygon || !currentPolygon.detalhes) {
                return false;
            }
            const { selectedProducts, dosageDetails = {} } = currentPolygon.detalhes;

            return selectedProducts.every(product => dosageDetails[product.name]?.isValid);

            //} else if (this.state.polygons[this.state.openedDialogDetail].detalhes.typeApp === 'Sólido') {
        } else if (this.state.aplicacao === 'S') {
            const currentPolygon = this.state.polygons[this.state.openedDialogDetail];
            if (!currentPolygon || !currentPolygon.detalhes) {
                return false;
            }
            const { selectedProductsSolids = [] } = currentPolygon.detalhes;
            const allSolidProductsValid = selectedProductsSolids.every(p => p.name && p.dosage && parseFloat(p.dosage) > 0);

            return allSolidProductsValid;
        }
    };

    renderDosageInputs() {
        const { res } = this.props;
        const currentPolygon = this.state.polygons[this.state.openedDialogDetail] || {};
        const { selectedProducts = [], dosageDetails = {} } = currentPolygon.detalhes || {};

        const sortedSelectedProducts = selectedProducts.sort((a, b) => a.name.localeCompare(b.name));

        return sortedSelectedProducts.map((product) => {
            const dosageInfo = dosageDetails[product.name] || {};
            const dosage = dosageInfo.dosage || 0;
            const dosageDisplay = Units.convertFlow(dosage, 'L', 'ha', res);
            const totalProductValue = dosage * currentPolygon.aTlPul;
            const totalProductDisplay = Units.convertVolume(totalProductValue, 'L', res);

            return (
                <FormControl key={product.name} style={{ width: '100%', padding: '0.5rem 0', display: 'flex', flexDirection: 'row' }}>
                    <TextField
                        id={`dosage-${product.name}`}
                        onChange={this.handleChangeDosage(product.name)}
                        value={dosageDisplay}
                        type='number'
                        label={`${res.DOSAGEM} ${product.name}`}
                        style={{ paddingRight: '0.5rem', width: '50%' }}
                        InputProps={{
                            endAdornment: <InputAdornment position="end">{Units.getFlowUnit(res, 'L')}</InputAdornment>,
                        }}
                    />
                    <TextField
                        id={`total_product-${product.name}`}
                        label={res.TOTAL_PRODUTO}
                        value={totalProductDisplay.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                        InputProps={{
                            readOnly: true,
                            endAdornment: <InputAdornment position="end">{Units.getVolumeUnit(res, 'L')}</InputAdornment>,
                        }}
                        style={{ paddingLeft: '0.5rem', width: '50%' }}
                    />
                </FormControl>
            );
        });
    };

    handleAddProduct = () => {
        this.setState(prevState => {
            const updatedPolygon = JSON.parse(JSON.stringify(prevState.polygons[prevState.openedDialogDetail]));

            if (!updatedPolygon.detalhes.selectedProductsSolids) {
                updatedPolygon.detalhes.selectedProductsSolids = [];
            }

            updatedPolygon.detalhes.selectedProductsSolids.push({ name: '', dosage: '', total: '' });
            updatedPolygon.detalhes.useProductReport = false;

            return { polygons: [...prevState.polygons.slice(0, prevState.openedDialogDetail), updatedPolygon, ...prevState.polygons.slice(prevState.openedDialogDetail + 1)] };
        });
    };

    handleChangeProductSolid = (index, field, event) => {
        const { value } = event.target;
        this.setState(prevState => {
            const updatedPolygon = JSON.parse(JSON.stringify(prevState.polygons[prevState.openedDialogDetail]));

            if (updatedPolygon.detalhes.selectedProductsSolids[index]) {
                updatedPolygon.detalhes.selectedProductsSolids[index][field] = value;

                if (field === 'dosage') {
                    const polygonArea = parseFloat(updatedPolygon.aTlPul.toFixed(2)) || 0;
                    const dosageValue = Units.toCanonicalFlow(parseFloat(value), this.props.res, 'kg', 'ha');
                    const totalProductValue = dosageValue * polygonArea;
                    updatedPolygon.detalhes.selectedProductsSolids[index]['dosage'] = dosageValue;
                    updatedPolygon.detalhes.selectedProductsSolids[index]['total'] = totalProductValue;

                    const allSolidDosagesValid = updatedPolygon.detalhes.selectedProductsSolids.every(p => p.dosage && parseFloat(p.dosage) > 0);
                    if (!allSolidDosagesValid) {
                        updatedPolygon.detalhes.useProductReport = false;
                    }
                }
            }

            return { polygons: [...prevState.polygons.slice(0, prevState.openedDialogDetail), updatedPolygon, ...prevState.polygons.slice(prevState.openedDialogDetail + 1)] };
        });
    };

    handleDeleteProduct = (indexToDelete) => {
        this.setState(prevState => {
            const updatedPolygon = JSON.parse(JSON.stringify(prevState.polygons[prevState.openedDialogDetail]));

            if (updatedPolygon.detalhes.selectedProductsSolids) {
                updatedPolygon.detalhes.selectedProductsSolids.splice(indexToDelete, 1);
            }

            return { polygons: [...prevState.polygons.slice(0, prevState.openedDialogDetail), updatedPolygon, ...prevState.polygons.slice(prevState.openedDialogDetail + 1)] };
        });
    };

    renderProductInputs = () => {
        const { res } = this.props;
        const currentPolygon = this.state.polygons[this.state.openedDialogDetail];
        const products = currentPolygon?.detalhes?.selectedProductsSolids || [];

        return products.map((product, index) => (
            <FormControl key={index} style={{ width: '100%', padding: '0.5rem 0', display: 'flex', flexDirection: 'row' }}>
                <TextField
                    label="Produto"
                    value={product.name}
                    onChange={(e) => this.handleChangeProductSolid(index, 'name', e)}
                    style={{ paddingRight: '0.5rem', width: '33%' }}
                />
                <TextField
                    label="Dosagem"
                    type="number"
                    value={Units.convertFlow(product.dosage || 0, 'kg', 'ha', res)}
                    onChange={(e) => this.handleChangeProductSolid(index, 'dosage', e)}
                    style={{ paddingRight: '0.5rem', width: '33%' }}
                    InputProps={{
                        endAdornment: <InputAdornment position="end">{Units.getFlowUnit(res, 'kg')}</InputAdornment>,
                    }}
                />
                <TextField
                    label="Total"
                    type="number"
                    value={Number(product.total ?? 0).toFixed(2)}
                    onChange={(e) => this.handleChangeProductSolid(index, 'total', e)}
                    style={{ paddingRight: '0.5rem', width: '33%' }}
                    InputProps={{
                        readOnly: true,
                        endAdornment: <InputAdornment position="end">kg</InputAdornment>,
                    }}
                />
                <Button
                    onClick={() => this.handleDeleteProduct(index)}
                    style={{ marginLeft: '0.5rem' }}
                >
                    <DeleteIcon />
                </Button>
            </FormControl>
        ));
    };

    loadCultures = () => {
        const apiUrl = Config.server + '/domain/CULTURA';

        const options = {
            method: 'GET',
            headers: {
                'Authorization': localStorage.getItem('access-token-jwt'),
            }
        }

        fetch(apiUrl, options)
            .then((res) => {
                if (res.status !== 200) throw res;
                else return res.json();
            })
            .then(
                (result) => {
                    this.setState({
                        cultureData: result
                    });
                },
                (error) => {
                    if (error.status === 405) {
                        notification.open({
                            message: this.props.res.PERMISSAO,
                            description: this.props.res.PERMISSAO_MSG,
                            icon: <MaterialIcon icon="error" className="text-danger" />
                        });
                    } else if (error.status === 401 || error.status === 403) {
                        this.props.link('/login');
                    }
                    else {
                        console.log(error);
                        notification.open({
                            message: this.props.res.ERRO,
                            description: this.props.res.ERRO_MSG,
                            icon: <MaterialIcon icon="error" className="text-danger" />
                        });
                    }
                }
            );
    };

    readCalibrations = () => {
        const apiUrl = Config.server + `/plane_equipment_calibration`;

        const options = {
            method: 'GET',
            headers: {
                'Authorization': localStorage.getItem('access-token-jwt')
            }
        }

        fetch(apiUrl, options)
            .then((res) => {
                if (res.status !== 200) throw res;
                else return res.json();
            })
            .then(
                (result) => {
                    this.setState({
                        calibrationData: result
                    });
                },
                (error) => {
                    if (error.status === 405) {
                        notification.open({
                            message: this.props.res.PERMISSAO,
                            description: this.props.res.PERMISSAO_MSG,
                            icon: <MaterialIcon icon="error" className="text-danger" />
                        });
                    } else if (error.status === 401 || error.status === 403) {
                        this.props.link('/login');
                    } else {
                        notification.open({
                            message: this.props.res.ERRO,
                            description: this.props.res.ERRO_MSG,
                            icon: <MaterialIcon icon="error" className="text-danger" />
                        });
                    }
                }
            );
    };

    readConfigurations = () => {
        const apiUrl = Config.server + `/plane_equipment_configuration`;

        const options = {
            method: 'GET',
            headers: {
                'Authorization': localStorage.getItem('access-token-jwt')
            }
        }

        fetch(apiUrl, options)
            .then((res) => {
                if (res.status !== 200) throw res;
                else return res.json();
            })
            .then(
                (result) => {
                    this.setState({
                        configurationData: result
                    });
                },
                (error) => {
                    if (error.status === 405) {
                        notification.open({
                            message: this.props.res.PERMISSAO,
                            description: this.props.res.PERMISSAO_MSG,
                            icon: <MaterialIcon icon="error" className="text-danger" />
                        });
                    } else if (error.status === 401 || error.status === 403) {
                        this.props.link('/login');
                    } else {
                        notification.open({
                            message: this.props.res.ERRO,
                            description: this.props.res.ERRO_MSG,
                            icon: <MaterialIcon icon="error" className="text-danger" />
                        });
                    }
                }
            );
    };

    validationService = () => {
        this.saveJob()
    };

    handleServiceChange = (event) => {
        const { value } = event.target;
        this.setState((prevState) => {
            const polygons = [...prevState.polygons];
            if (prevState.openedDialogDetail !== null) {
                polygons[prevState.openedDialogDetail] = {
                    ...polygons[prevState.openedDialogDetail],
                    detalhes: {
                        ...polygons[prevState.openedDialogDetail].detalhes,
                        selectedService: value
                    }
                };
            }
            return { polygons };
        });
    };

    getArrowRotation = (direction) => {
        const directions = {
            N: 0,
            NE: 45,
            L: 90,
            SE: 135,
            S: 180,
            SO: 225,
            O: 270,
            NO: 315,
        };
        return directions[direction] || 0;
    };

    executePlanning = () => {
        this.handleClickB('all');
        this.waitBetterRoute(40);
    };

    waitBetterRoute = (attemptsRemaining) => {
        if (!attemptsRemaining || attemptsRemaining <= 0) {
            this.clickEstimative();
            return;
        }

        const polys = this.state.polygons || [];
        let temLinhas = false;

        for (let i = 0; i < polys.length; i++) {
            const p = polys[i];
            if (p && p.lines && p.lines.length > 0) {
                temLinhas = true;
                break;
            }
        }

        if (temLinhas) {
            this.clickEstimative();
        } else {
            setTimeout(() => {
                this.waitBetterRoute(attemptsRemaining - 1);
            }, 500);
        }
    };

    criaPoly = () => {
        this.resetClick();

        if (!this.markClick) {
            const defaultName = this.nextIndex(this.state.polygons);

            this.setState(
                {
                    polyCreate: true,
                    polyNameEditing: true,
                    nameP: defaultName,
                    valid_nameP: true,
                    areaFilterSelection: []
                },
                () => {
                    this.drawCreateToolbar = new L.Draw.Polygon(this.mymap, {
                        allowIntersection: false,
                        showArea: true,
                        metric: ['ha']
                    });
                    this.drawCreateToolbar.enable();
                }
            );
        }

        this.markClick = true;
    };

    resetPolygons = (id_property, isFixed) => {
        if (!this.featureGroupP) return;

        this.featureGroupP.clearLayers();

        let hasPoly = false;
        const polygons = this.state.polygons || [];

        for (let i = 0; i < polygons.length; i++) {
            const poly = polygons[i];
            if (poly.points) {
                this.drawPolygon(poly, polygons);
                hasPoly = true;
            }
        }

        if (hasPoly && !isFixed && this.mymap && this.featureGroupP) {
            const bounds = this.featureGroupP.getBounds();
            if (bounds && bounds.isValid && bounds.isValid()) {
                this.mymap.fitBounds(bounds);
            }
        }
    };

    resetClick = () => {
        if (this.state.polyCreate) {
            this.cancelCreate();
        }
        if (this.state.create_circle) {
            this.cancelCreateCirculo();
        }
        if (this.state.ruler_a) {
            this.cancelRuler();
        }
        if (this.state.polyEdit) {
            this.cancelPolyEdit();
        }
        if (this.state.polyDelete) {
            this.cancelDelete();
        }
    };

    cancelCreateCirculo = () => {
        this.markClick = false;
        this.setState({ create_circle: false });
        this.drawCreateToolbar.disable();
    };

    cancelRuler = () => {
        if (this.ruler_p.first.lat) {
            this.regua();
        }
    };

    cancelEdit = () => {
        if (this.drawEditToolbar) {
            try {
                this.drawEditToolbar.revertLayers();
                this.drawEditToolbar.disable();
            } catch (e) { }
        }

        if (this.tabID && this.state.polyTab !== undefined && this.state.polyTab !== null) {
            const currentTabKey = this.tabID[Number(this.state.polyTab)];
            const list = this.state[currentTabKey] || [];

            for (let i = 0; i < list.length; i++) {
                const element = list[i];
                const layer =
                    this.mymap && this.mymap._layers
                        ? this.mymap._layers[element.guid]
                        : null;

                if (layer) {
                    this.setPolygonBaseStyle(layer, element, list);
                }
            }
        }

        this.setState({
            edit: false,
            polyEdit: false,
            polyLabelText: ''
        });
    };

    cancelDelete = () => {
        this.setState({
            delete: false,
            polyDelete: false,
            polyLabelText: ''
        });

        if (this.drawDeleteToolbar) {
            try {
                this.drawDeleteToolbar.revertLayers();
                this.drawDeleteToolbar.disable();
            } catch (e) { }
        }

        if (
            this.sel_save &&
            this.sel_save.length > 0 &&
            this.tabID &&
            this.state.polyTab !== undefined &&
            this.state.polyTab !== null
        ) {
            const currentTabKey = this.tabID[Number(this.state.polyTab)];
            const list = this.state[currentTabKey] || [];

            this.sel_save.forEach(feature => {
                const tempPolygons = list.filter(item => feature.includes(item.guid));
                for (let j = 0; j < tempPolygons.length; j++) {
                    this.drawPolygon(tempPolygons[j], currentTabKey);
                }
            });

            return;
        }

        if (this.state.sel_poly) {
            this.drawPolygon(this.state.sel_poly);
            if (this.mymap && this.mymap._layers) {
                this.intersectLine(this.state.sel_poly, this.mymap._layers[this.state.sel_poly.guid]);
            }
        }
    };

    savePolyName = () => {
        if (!this.state.valid_nameP) return;

        var newName = (this.state.nameP || '').toString().trim();
        if (!newName) return;

        if (!this.state.polyCreate && this.state.sel_poly && this.state.sel_poly.guid) {
            var guid = this.state.sel_poly.guid;
            var updatedPoly = null;

            var polygons = (this.state.polygons || []).map(p => {
                if (p.guid !== guid) return p;

                var np = Object.assign(new oPolygon(this.props), p);
                np.name = newName;
                updatedPoly = np;
                return np;
            });

            this.setState({
                polygons: polygons,
                polyNameEditing: false
            });

            if (updatedPoly && updatedPoly.id) {
                try {
                    this.updateArea(updatedPoly, false);
                } catch (e) { }
            }

            var layer = this.mymap && this.mymap._layers ? this.mymap._layers[guid] : null;
            if (layer) {
                try {
                    if (layer._tooltip) {
                        layer.unbindTooltip();
                    }
                    layer.bindTooltip(newName, {
                        permanent: true,
                        direction: "center",
                        className: 'tool-tip-L tool-tip-size16-L'
                    }).openTooltip();
                } catch (e) { }
            }
        } else {
            this.setState({
                polyNameEditing: false
            });
        }
    };

    cancelCreate = () => {
        this.markClick = false;

        if (this.drawCreateToolbar) {
            try {
                this.drawCreateToolbar.disable();
            } catch (e) { }
        }

        this.setState({
            base: false,
            fuel: false,
            polyCreate: false,
            polyNameEditing: false,
            nameP: '',
            valid_nameP: false
        });
    };

    showItem = () => {
        const poly = this.state.sel_poly;
        if (!poly) return;

        const currentName = poly.name || '';

        this.setState({
            polyNameEditing: true,
            nameP: currentName,
            valid_nameP: currentName.toString().trim().length > 0
        });
    };

    editPoly = () => {
        this.resetClick();

        const sel = this.state.sel_poly;
        if (!sel || !sel.guid) return;

        if (!this.mymap || !this.mymap._layers) return;

        const layer = this.mymap._layers[sel.guid];
        if (!layer || !layer.editing) return;

        const polygons = this.state.polygons || [];

        let original = null;
        for (let i = 0; i < polygons.length; i++) {
            if (polygons[i].guid === sel.guid) {
                original = JSON.parse(JSON.stringify(polygons[i]));
                break;
            }
        }

        this._polyEditGuid = sel.guid;
        this._polyEditLayer = layer;
        this._polyEditBackup = original;

        for (let i = 0; i < polygons.length; i++) {
            const item = polygons[i];
            const lyr = this.mymap._layers[item.guid];
            if (lyr && lyr.editing && lyr.editing.disable) {
                try {
                    lyr.editing.disable();
                } catch (e) { }

                this.setPolygonBaseStyle(lyr, item, polygons);
            }
        }

        this.setState({ polyEdit: true });

        try {
            layer.editing.enable();
            layer.setStyle({ color: this.color_edit });
        } catch (e) { }

        const self = this;
        const guid = sel.guid;

        if (this._polyEditHandler && this._polyEditLayer) {
            try {
                this._polyEditLayer.off('edit', this._polyEditHandler);
            } catch (e) { }
        }

        this._polyEditHandler = function () {
            let latlng = [];
            let area = 0;

            if (layer._mRadius) {
                area = layer._mRadius * layer._mRadius * Math.PI;
                latlng = geo.cicleToPolygon(
                    [layer._latlng.lng, layer._latlng.lat],
                    layer._mRadius
                );
            } else {
                if (layer._latlngs && layer._latlngs[0]) {
                    for (let c = 0; c < layer._latlngs[0].length; c++) {
                        const el = layer._latlngs[0][c];
                        latlng.push([el.lat, el.lng]);
                    }
                }
                if (L.GeometryUtil && L.GeometryUtil.geodesicArea) {
                    try {
                        area = L.GeometryUtil.geodesicArea(layer.getLatLngs()[0]);
                    } catch (e) { area = 0; }
                }
            }

            const newPolygons = (self.state.polygons || []).map(p => {
                if (p.guid !== guid) return p;
                const np = Object.assign(new oPolygon(self.props), p);
                np.points = JSON.stringify(latlng);
                np.area = area;

                if (layer._mRadius) {
                    np.radius = layer._mRadius;
                    np.point = [layer._latlng.lat, layer._latlng.lng];
                }

                return np;
            });

            self.setState({ polygons: newPolygons });
        };

        layer.on('edit', this._polyEditHandler);

        this.recalculateOverlaps();
    };

    savePolyEdit = () => {
        const guid = this._polyEditGuid;
        const layer = this._polyEditLayer;

        if (layer && layer.editing && layer.editing.disable) {
            try {
                layer.editing.disable();
            } catch (e) { }
        }

        if (layer && this._polyEditHandler) {
            try {
                layer.off('edit', this._polyEditHandler);
            } catch (e) { }
        }

        if (guid && this.mymap && this.mymap._layers) {
            const polys = this.state.polygons || [];
            let poly = null;
            let polyIndex = -1;

            for (let i = 0; i < polys.length; i++) {
                if (polys[i].guid === guid) {
                    poly = polys[i];
                    polyIndex = i;
                    break;
                }
            }

            const lyr = this.mymap._layers[guid];

            if (lyr && poly) {
                try {
                    const latlngs = lyr.getLatLngs && lyr.getLatLngs();
                    let coords = [];

                    if (latlngs && latlngs.length > 0) {
                        const ring = latlngs[0];
                        for (let i = 0; i < ring.length; i++) {
                            coords.push([ring[i].lat, ring[i].lng]);
                        }
                    }

                    if (coords.length > 0) {
                        poly.points = JSON.stringify(coords);
                    }

                    if (polyIndex >= 0) {
                        const newPolys = polys.slice();
                        newPolys[polyIndex] = poly;
                        this.setState({ polygons: newPolys });
                    }
                } catch (e) { }

                this.setPolygonBaseStyle(lyr, poly, polys);

                if (poly.id) {
                    try {
                        this.updateArea(poly, false);
                    } catch (e) { }
                }
            }
        }

        this._polyEditBackup = null;
        this._polyEditGuid = null;
        this._polyEditHandler = null;
        this._polyEditLayer = null;

        this.setState({ polyEdit: false }, () => {
            this.recalculateOverlaps();
        });
    };

    cancelPolyEdit = () => {
        const guid = this._polyEditGuid;
        const layer = this._polyEditLayer;
        const backup = this._polyEditBackup;

        if (layer && layer.editing && layer.editing.disable) {
            try {
                layer.editing.disable();
            } catch (e) { }
        }

        if (backup && guid) {
            const newPolygons = (this.state.polygons || []).map(p => {
                if (p.guid !== guid) return p;
                const np = Object.assign(new oPolygon(this.props), backup);
                return np;
            });

            this.setState({ polygons: newPolygons });

            if (this.featureGroupP && layer) {
                try {
                    this.featureGroupP.removeLayer(layer);
                } catch (e) { }
            }

            let restored = null;
            for (let i = 0; i < newPolygons.length; i++) {
                if (newPolygons[i].guid === guid) {
                    restored = newPolygons[i];
                    break;
                }
            }
            if (restored) {
                this.drawPolygon(restored, newPolygons);
            }
        } else {
            if (guid && this.mymap && this.mymap._layers) {
                const polys = this.state.polygons || [];
                let poly = null;
                for (let i = 0; i < polys.length; i++) {
                    if (polys[i].guid === guid) {
                        poly = polys[i];
                        break;
                    }
                }
                const lyr = this.mymap._layers[guid];
                if (lyr && poly) {
                    this.setPolygonBaseStyle(lyr, poly, polys);
                }
            }
        }

        if (layer && this._polyEditHandler) {
            try {
                layer.off('edit', this._polyEditHandler);
            } catch (e) { }
        }

        this._polyEditBackup = null;
        this._polyEditGuid = null;
        this._polyEditHandler = null;
        this._polyEditLayer = null;

        this.setState({ polyEdit: false }, () => {
            this.recalculateOverlaps();
        });
    };

    updateArea = (area, update) => {
        let apiUrl = Config.server + '/area';
        let method = 'PUT';
        let poly = area;

        const formData = new URLSearchParams();
        if (poly.id) {
            formData.append('id', poly.id);
        }
        if (poly.id_client) {
            formData.append('id_client', poly.id_client);
            if (poly.id_property) {
                formData.append('id_property', poly.id_property);
            }
        }
        if (poly.id_region) {
            formData.append('id_region', poly.id_region);
        }
        formData.append('guid', poly.guid);
        formData.append('points', poly.points);
        formData.append('type', poly.type || 'N');
        formData.append('name', poly.name || '');

        let options = {
            method: method,
            body: formData,
            headers: {
                'Authorization': localStorage.getItem('access-token-jwt')
            }
        };

        fetch(apiUrl, options)
            .then((res) => {
                if (res.status !== 200) throw res;
                else return res.json();
            })
            .then(
                (result) => {
                    if (update) {
                        let tab = poly.id_client ? 0 : 1;
                        if (tab === 0) {
                            let temp_here = this.state[this.tabID[0]].filter(item => item.guid !== poly.guid);
                            let temp_there = this.state[this.tabID[1]];
                            temp_there.push(poly);
                            this.setState({ [this.tabID[0]]: temp_here, [this.tabID[1]]: temp_there });
                        } else {
                            let temp_here = this.state[this.tabID[1]].filter(item => item.guid !== poly.guid);
                            let temp_there = this.state[this.tabID[0]];
                            temp_there.push(poly);
                            this.setState({ [this.tabID[1]]: temp_here, [this.tabID[0]]: temp_there });
                        }
                    }

                    if (result) {
                        poly.id = result;
                    }
                },
                (error) => {
                    if (error.status === 405) {
                        notification.open({
                            message: this.props.res.PERMISSAO,
                            description: this.props.res.PERMISSAO_MSG,
                            icon: <MaterialIcon icon="error" className="text-danger" />
                        });
                    } else if (error.status === 401 || error.status === 403) {
                        this.props.link('/login');
                    } else {
                        notification.open({
                            message: this.props.res.ERRO,
                            description: this.props.res.ERRO_MSG,
                            icon: <MaterialIcon icon="error" className="text-danger" />
                        });
                    }
                }
            );
    };

    clearEstimateLayersOnly = () => {
        if (!this.mymap || !this.mymap._layers) return;

        const keys = Object.keys(this.mymap._layers);

        for (let i = 0; i < keys.length; i++) {
            const id = keys[i];
            if (typeof id !== 'string') continue;

            if (
                id.indexOf('_lines') >= 0 ||
                id.indexOf('_abL') >= 0 ||
                id.indexOf('_abFG') >= 0 ||
                id.indexOf('_abFR') >= 0
            ) {
                try {
                    this.mymap.removeLayer(this.mymap._layers[id]);
                } catch (e) { }
            }
        }

        if (this.featureGroupE && this.featureGroupE.clearLayers) {
            try { this.featureGroupE.clearLayers(); } catch (e) { }
        }
    };

    resetEstimatePlanning = () => {
        this.clearEstimateLayersOnly();

        this.temp_poly = null;
        this.indexLine = 0;

        const polygons = (this.state.polygons || []).map(p => {
            if (!p) return p;
            const np = Object.assign({}, p);
            np.lines = [];
            np.out = [];
            np.best = 0;
            np.selected_line = 0;
            np.selected_Out = 0;
            np.selected_AB = 0;
            np.selected_AB_back = 0;
            np.yaw = null;
            np.yaw_value = null;
            np.layer = null;
            return np;
        });

        this.setState({
            polygons: polygons,
            play: false,
            sel_faixa: 0,
            itens_faixa: [],
            isCalculating: false
        });
    };

    resetPolygonTypePlanning = (callback) => {
        this.clearEstimateLayersOnly();
        this.clearStrategyDirectionArrows();
        for (const id of ['regua', 'reguaM1', 'reguaM2']) {
            this.removeLayer(this.featureGroupTest, this.mymap && this.mymap._layers[id]);
        }
        if (this.state.ruler_a && this.drawCreateToolbar) this.drawCreateToolbar.disable();
        this.ruler_p = { type: 'r', first: { lat: null, lng: null }, second: { lat: null, lng: null } };

        this.temp_poly = null;
        this.indexLine = 0;
        this.area = 0;
        this.areaTotal = 0;
        this.travel_time = 0;
        this.resetRef();
        this.strategy.forEach(strategy => { strategy.time = 0; });

        const polygons = (this.state.polygons || []).map(p => {
            if (!p) return p;

            const np = Object.assign({}, p);

            np.lines = [];
            np.out = [];
            np.ABs = [];
            np.ab = null;
            np.best = 0;
            np.selected_line = 0;
            np.selected_Out = 0;
            np.selected_AB = 0;
            np.selected_AB_back = 0;
            np.yaw = null;
            np.yaw_value = null;
            np.layer = null;
            np.guid_p = null;
            np.estrategia = '';
            np.estrategia_manual = false;
            np.is_selected = false;
            np.config = false;
            np.best_Out = 0;
            np.first_line = 0;
            np.speed_apl = 0;
            np.carga_inicial = 0;
            np.carga_final = 0;
            for (const key of ['aTlPul', 'comTl', 'flxMedApl', 'tApl', 'tVoo', 'area_polygon', 'spray', 'liters']) np[key] = 0;
            for (const key of ['patternguid', 'currentpatternguid', 'shapeguid', 'patterntype', 'abedge', 'latlngpointa', 'latlngpointb',
                'numberofswaths', 'racetrackswaths', 'angles', 'arrAngles', 'reportAngles', 'planningAngles']) delete np[key];

            return np;
        });

        this.setState({
            polygons: polygons,
            play: false,
            sel_faixa: 0,
            itens_faixa: [],
            isCalculating: false,
            ruler_a: false,
            sel_poly: null,
            sel_polygons: [],
            line_poly: false,
            groupPolygons: 'all',
            dEstimative: false,
            uEstimative: false,
            estrategia: '',
            areaData: [],
            totals: null,
            timetable: [],
            time: this.time,
            time_spray: 0,
            time_voo: 0,
            time_total: 0,
            liters_total: 0,
            area_polygon_total: 0,
            spray_total: 0,
            cVoo: 0,
            vVoo: '0.00',
            vVooHA: '0.00',
            vLucro: 0,
            vImp: 0,
            vLucro_old: 0,
            cLucroHora: 0
        }, () => {
            this.keepData('polygons', polygons);
            this.keepData('time', this.time);
            this.keepData('area', 0);
            this.keepData('travel_time', 0);
            this.keepData('totals', null);
            this.keepData('timetable', []);
            this.resetDownloadJob();
            if (typeof callback === 'function') callback();
        });
    };

    changeType = (type) => {
        if (!this.state.sel_poly || (this.state.sel_polygons || []).length > 1 ||
            this.state.openType === 'view' || this.state.disable || this.state.split || this.state.delete ||
            this.state.polyEdit || this.state.progress || this.state.isCalculating) return;
        const polygon = (this.state.polygons || []).find(item => item && item.guid === this.state.sel_poly.guid);
        if (!polygon) return;
        const nextType = type || (polygon.type === 'N' ? 'X' : 'N');
        if (!['N', 'X', 'T', 'R'].includes(nextType) || polygon.type === nextType) return;
        polygon.type = nextType;
        if (polygon.poly_type) polygon.poly_type = nextType;
        if (nextType !== 'X') polygon.x = '';
        this.setState({ anchorMN: null, type_poly: nextType });
        // Exclusion changes affect the routes and estimates of the other areas too.
        this.resetPolygonTypePlanning(() => {
            const updated = this.state.polygons.find(item => item && item.guid === polygon.guid);
            const layer = this.mymap && this.mymap._layers[updated.guid];
            this.removeLayer(this.featureGroupP, layer);
            this.drawPolygon(updated, this.state.polygons);
            this.recalculateOverlaps();
        });
    };

    getChangePatternButton = () => {
        const polygon = this.state.sel_poly;
        if (!polygon) return null;
        const { res } = this.props;
        const options = { N: ['check', res.POLY_N], X: ['close', res.POLY_X], T: ['indeterminate_check_box', res.POLY_T], R: ['block', res.POLY_R] };
        const [icon, title] = options[polygon.type] || options.N;
        const disabled = (this.state.sel_polygons || []).length > 1 || this.state.openType === 'view' || this.state.disable || this.state.split || this.state.delete ||
            this.state.polyEdit || this.state.progress || this.state.isCalculating;
        return <span>
            <Button className="buttonS buttonMenu" disabled={disabled} onClick={() => this.changeType()} title={title}>
                <MaterialIcon icon={icon} className="iconMap" />
            </Button>
            <Button className="buttonS buttonMenu buttonMenuPS" disabled={disabled} onClick={this.setAnchor('type')} title={res.TIPO}>
                <MaterialIcon icon="arrow_drop_down" className="iconMap" />
            </Button>
        </span>;
    };

    getMergeSourceGuids = () => {
        const selected = (this.state.sel_polygons || []).length > 0
            ? this.state.sel_polygons
            : (this.state.sel_poly ? [this.state.sel_poly.guid] : []);
        return selected.filter(guid => {
            const polygon = (this.state.polygons || []).find(item => item && item.guid === guid);
            return polygon && polygon.type !== 'X' && polygon.type !== 'XL';
        });
    };

    mergePlanningExclusions = (features, polygons) => {
        const candidates = [];
        polygons.forEach(polygon => {
            if (!polygon || (polygon.type !== 'X' && polygon.type !== 'XL')) return;
            try {
                const layer = this.mymap && this.mymap._layers ? this.mymap._layers[polygon.guid] : null;
                const feature = layer && typeof layer.toGeoJSON === 'function'
                    ? layer.toGeoJSON()
                    : L.polygon(typeof polygon.points === 'string' ? JSON.parse(polygon.points) : polygon.points).toGeoJSON();
                candidates.push({ feature, sources: [polygon], generated: false });
            } catch (_) { }
        });
        features.forEach(feature => {
            if (feature && feature.geometry && feature.geometry.type === 'Polygon') {
                candidates.push({ feature, sources: [], generated: true });
            }
        });

        const result = [];
        let index;
        while ((index = candidates.findIndex(item => item.generated)) >= 0) {
            const current = candidates.splice(index, 1)[0];
            let changed;
            do {
                changed = false;
                for (let i = candidates.length - 1; i >= 0; i--) {
                    const candidate = candidates[i];
                    try {
                        if (!turf.intersect(current.feature, candidate.feature)) continue;
                        const union = turf.union(current.feature, candidate.feature);
                        // A flat exclusion cannot represent holes or disconnected parts.
                        if (!union || union.geometry.type !== 'Polygon' || union.geometry.coordinates.length !== 1) continue;
                        current.feature = union;
                        current.sources.push(...candidate.sources);
                        candidates.splice(i, 1);
                        changed = true;
                    } catch (_) { }
                }
            } while (changed);
            result.push(current);
        }
        return result;
    };

    merge = (polyFinal) => {
        if (!polyFinal || !polyFinal.poly || !polyFinal.poly.geometry) {
            return;
        }

        const polygonsBeforeMerge = (this.state.polygons || []).map(p => p ? { ...p } : p);

        let simpl = geo.simplify(polyFinal.poly.geometry.coordinates[0], 0.000002);
        let latlngs = this.geojsonToLeafletArray(simpl.geometry.coordinates[0]);

        let guid = tools.newGuid();
        let name = this.nextIndex(this.state.polygons);

        let polys = { ob: [] };
        let itens = [];
        let ids = [];
        let mergeNames = [];
        let origemPolygons = [];

        const selectedGuids = this.getMergeSourceGuids();

        if (!selectedGuids || selectedGuids.length === 0) return;

        let origemAtualizada = Array.isArray(this.state.origemPolygons)
            ? this.state.origemPolygons.map(op => op ? { ...op } : op)
            : [];

        selectedGuids.forEach(element => {
            let l = (this.mymap && this.mymap._layers) ? this.mymap._layers[element] : null;
            this.removeLayer(this.featureGroupP, l);

            let temp_poly = this.state.polygons.filter(itemP => itemP.guid === element);
            if (temp_poly.length > 0) {
                const basePoly = temp_poly[0];

                for (let i = 0; i < origemAtualizada.length; i++) {
                    const op = origemAtualizada[i];
                    if (op && op.guid_link === basePoly.guid) {
                        origemAtualizada[i] = { ...op, guid_link: guid };
                    }
                }

                const hasOld = !!(basePoly.old && Array.isArray(basePoly.old.ob) && basePoly.old.ob.length > 0);
                const sourceList = hasOld ? basePoly.old.ob : [basePoly];

                for (let i = 0; i < sourceList.length; i++) {
                    const src = sourceList[i];
                    if (!src || !src.guid) continue;

                    if (src.type === 'X' || src.type === 'XL') continue;

                    origemPolygons.push({
                        id_property: src.id_property,
                        id: src.id,
                        guid: src.guid,
                        name: src.name,
                        points: src.points,
                        type: src.type,
                        guid_link: guid
                    });
                }

                polys.ob = polys.ob.concat(temp_poly);
                if (basePoly.id) ids.push(basePoly.id);
            }
        });

        itens = this.state.polygons.filter(item => !selectedGuids.includes(item.guid));

        let firstPoly = polys.ob.length > 0 ? polys.ob[0] : null;

        let tempRumo = {
            type: 'N',
            guid: guid,
            name: name,
            points: JSON.stringify(latlngs),
            old: polys,
            lines: [],
            out: [],
            selected_line: 0,
            selected_Out: 0,
            selected_AB: 0,
            selected_AB_back: 0,
            best: 0,
            area: 0,
            yaw: null,
            yaw_value: null,
            guid_p: guid,
            layer: null,
            faixa: (firstPoly && firstPoly.faixa) ? firstPoly.faixa : this.state.faixa,
            space: (firstPoly && firstPoly.space !== undefined && firstPoly.space !== null)
                ? firstPoly.space
                : (this.state.space === undefined || this.state.space === null ? 0 : this.state.space),
            planningVersion: 2
        };

        mergeNames.push({
            guid: tempRumo.guid,
            name: tempRumo.name.toString(),
            valid: true
        });

        this.drawPolygon(tempRumo, 'estimate');
        itens.push(tempRumo);

        if (typeof this.updateArea === 'function') {
            this.updateArea(tempRumo);
        }

        let select = [guid];

        let x = polyFinal.x;
        if (x) {
            if (x.type === 'Feature') x = { features: [x] };
            if (Array.isArray(x)) x = { features: x };

            if (x.features) {
                const exclusions = this.mergePlanningExclusions(x.features, itens);
                for (let i = 0; i < exclusions.length; i++) {
                    const { feature: element, sources } = exclusions[i];
                    sources.forEach(polygon => {
                        const layer = this.mymap && this.mymap._layers ? this.mymap._layers[polygon.guid] : null;
                        this.removeLayer(this.featureGroupP, layer);
                        if (polygon.id) ids.push(polygon.id);
                        origemPolygons.push({ ...polygon, guid_link: guid });
                    });
                    const sourceGuids = new Set(sources.map(polygon => polygon.guid));
                    itens = itens.filter(polygon => !sourceGuids.has(polygon.guid));
                    simpl = geo.simplify(element.geometry.coordinates[0], 0.000002);
                    let latlngs2 = this.geojsonToLeafletArray(simpl.geometry.coordinates[0]);

                    let tempRumoX = {
                        guid: tools.newGuid(),
                        name: 'xcl' + (i + 1),
                        points: JSON.stringify(latlngs2),
                        x: guid,
                        type: 'X',
                        lines: [],
                        layer: null
                    };

                    mergeNames.push({
                        guid: tempRumoX.guid,
                        name: tempRumoX.name.toString(),
                        valid: true
                    });

                    setTimeout(() => this.drawPolygon(tempRumoX, 'estimate'), 20 * i);

                    if (typeof this.updateArea === 'function') {
                        this.updateArea(tempRumoX);
                    }

                    itens.push(tempRumoX);
                    select.push(tempRumoX.guid);
                }
            }
        }

        if (ids.length > 0) {
            this.deleteArea(ids.join(','));
        }

        const origemMap = new Map();
        const origemFinal = origemAtualizada.concat(origemPolygons).filter(item => item && item.guid);
        for (let i = 0; i < origemFinal.length; i++) {
            origemMap.set(origemFinal[i].guid, origemFinal[i]);
        }

        this.setState(
            {
                polygons: itens,
                origemPolygons: Array.from(origemMap.values()),
                sel_poly: tempRumo,
                sel_polygons: select,
                past_merge: true,
                mergeNameEditing: true,
                mergeNames: mergeNames,
                startPolygons: polygonsBeforeMerge
            },
            () => {
                const layer = (this.mymap && this.mymap._layers) ? this.mymap._layers[guid] : null;
                if (layer) {
                    this.handleClickP(layer, tempRumo);
                }
            }
        );
    };

    desfazerMerge = () => {
        const origem = Array.isArray(this.state.origemPolygons) ? this.state.origemPolygons.slice() : [];
        if (!origem.length) {
            return;
        }

        const polygons = Array.isArray(this.state.polygons) ? this.state.polygons.slice() : [];
        if (!polygons.length) {
            return;
        }

        //this.resetEstimatePlanning();

        const selectedGuids = Array.isArray(this.state.sel_polygons)
            ? this.state.sel_polygons.filter(g => !!g)
            : [];

        if (this.state.sel_poly && this.state.sel_poly.guid && selectedGuids.indexOf(this.state.sel_poly.guid) < 0) {
            selectedGuids.push(this.state.sel_poly.guid);
        }
        const selectedPolyGuid = this.state.sel_poly && this.state.sel_poly.guid
            ? this.state.sel_poly.guid
            : null;

        const linksToUndo = [];
        const addLink = (linkGuid) => {
            if (!linkGuid) return;
            if (linksToUndo.indexOf(linkGuid) < 0) {
                linksToUndo.push(linkGuid);
            }
        };

        selectedGuids.forEach((guid) => {
            const op = origem.find(item => item && item.guid_link === guid);
            if (op && op.guid_link) {
                addLink(op.guid_link);
                return;
            }

            const poly = polygons.find(p => p && p.guid === guid);
            if (poly && poly.x) {
                addLink(poly.x);
            }
        });

        if (!linksToUndo.length && this.state.sel_poly && this.state.sel_poly.guid) {
            const fallback = origem.find(item => item && item.guid_link === this.state.sel_poly.guid);
            if (fallback && fallback.guid_link) {
                addLink(fallback.guid_link);
            }
        }

        if (!linksToUndo.length) {
            return;
        }

        let nextPolygons = polygons.slice();
        const restoredGuids = [];

        linksToUndo.forEach((linkGuid) => {
            const removeGuids = [];
            const toRestore = origem.filter(item => item && item.guid_link === linkGuid);

            if (!toRestore.length) return;

            for (let i = 0; i < nextPolygons.length; i++) {
                const p = nextPolygons[i];
                if (!p) continue;
                if (p.guid === linkGuid || p.x === linkGuid) {
                    removeGuids.push(p.guid);
                }
            }

            for (let i = 0; i < removeGuids.length; i++) {
                const guid = removeGuids[i];
                const poly = nextPolygons.find(p => p && p.guid === guid);
                const layer = (this.mymap && this.mymap._layers) ? this.mymap._layers[guid] : null;

                if (layer && this.featureGroupP && (selectedPolyGuid === guid || (poly && (poly.type === 'X' || poly.type === 'XL')))) {
                    this.removeLayer(this.featureGroupP, layer);
                }

                if (poly) {
                    this.hideAB(poly);
                    if (poly.layer && this.mymap && this.mymap._layers && this.mymap._layers[poly.layer] && this.featureGroupE) {
                        this.removeLayer(this.featureGroupE, this.mymap._layers[poly.layer]);
                    }
                }
            }

            nextPolygons = nextPolygons.filter(p => p && removeGuids.indexOf(p.guid) < 0);

            for (let i = 0; i < toRestore.length; i++) {
                const op = toRestore[i];
                if (!op || !op.guid) continue;

                const exists = nextPolygons.find(p => p && p.guid === op.guid);
                if (exists) continue;
                const restored = Object.assign(new oPolygon(this.props), op, {
                    old: null,
                    x: op.x || '',
                    lines: [],
                    out: [],
                    selected_line: 0,
                    selected_Out: 0,
                    selected_AB: 0,
                    selected_AB_back: 0,
                    best: 0,
                    yaw: null,
                    yaw_value: null,
                    layer: null
                });

                this.drawPolygon(restored, nextPolygons.concat(restored));
                nextPolygons.push(restored);
                restoredGuids.push(restored.guid);
            }
        });

        const nextOrigem = origem.filter(item => item && linksToUndo.indexOf(item.guid_link) < 0);

        let areaFilterSelection = Array.isArray(this.state.areaFilterSelection)
            ? this.state.areaFilterSelection.filter(g => linksToUndo.indexOf(g) < 0)
            : [];

        for (let i = 0; i < restoredGuids.length; i++) {
            if (areaFilterSelection.indexOf(restoredGuids[i]) < 0) {
                areaFilterSelection.push(restoredGuids[i]);
            }
        }

        let nextSelPoly = null;
        for (let i = 0; i < nextPolygons.length; i++) {
            const p = nextPolygons[i];
            if (p && restoredGuids.indexOf(p.guid) >= 0 && p.type !== 'X' && p.type !== 'XL') {
                nextSelPoly = p;
                break;
            }
        }

        this.setState(
            {
                polygons: nextPolygons,
                origemPolygons: nextOrigem,
                sel_polygons: restoredGuids.slice(),
                sel_poly: nextSelPoly,
                areaFilterSelection: areaFilterSelection,
                mergeNameEditing: false,
                mergeNames: [],
                past_merge: nextOrigem.length > 0,
                startPolygons: null,
                polyNameEditing: false
            },
            () => {
                this.keepData('polygons', this.state.polygons);
            }
        );
    };

    junta = () => {
        this.showPro(true);
        this.setState({ merge: false });

        this.resetEstimatePlanning();

        const selectedGuids = this.getMergeSourceGuids();

        if (selectedGuids.length > 1) {
            let apiUrl = Config.server + '/merge_polygons';
            let method = 'POST';

            const formData = new URLSearchParams();
            let polys = [];
            let polysX = [];

            selectedGuids.forEach(element => {
                const oPoly = this.state.polygons.filter(item => item.guid === element);
                if (!oPoly.length) return;

                const lyr = this.mymap._layers[element];
                if (lyr && typeof lyr.toGeoJSON === 'function') {
                    polys.push(
                        geo.simplify(lyr.toGeoJSON().geometry.coordinates[0], 0.000002)
                    );
                }
            });

            formData.append('polygons', JSON.stringify(polys));
            formData.append('polygons_xcl', JSON.stringify(polysX));
            formData.append('size', this.state.gap_size);
            formData.append('type', this.state.type);

            fetch(apiUrl, {
                method,
                body: formData,
                headers: {
                    'Authorization': localStorage.getItem('access-token-jwt')
                }
            })
                .then(res => res.status === 200 ? res.json() : Promise.reject(res))
                .then(result => {
                    this.showPro(false);
                    if (result.poly) {
                        this.merge(result);
                    }
                })
                .catch(() => this.showPro(false));
        } else {
            this.showPro(false);
        }
    };

    showPro = (b) => {
        let dF = document.getElementById('divPro');
        if (!dF) return;

        dF.classList.remove("sr-only");
        if (!b) {
            dF.classList.toggle("sr-only");
        }
    };

    handleChangeMergeName = (guid) => (e) => {
        const value = e.target.value;

        const mergeNames = (this.state.mergeNames || []).map(item => {
            if (!item) return item;
            if (item.guid === guid) {
                return {
                    ...item,
                    name: value,
                    valid: value.trim().length > 0
                };
            }
            return item;
        });

        this.setState({ mergeNames });
    };

    saveMergeNames = () => {
        let polygons = this.state.polygons || [];
        const mergeNames = this.state.mergeNames || [];

        if (!mergeNames.length) {
            this.setState({
                mergeNameEditing: false,
                mergeNames: []
            });
            return;
        }

        const getLayer = (guid) => {
            if (this.mymap && this.mymap._layers) {
                return this.mymap._layers[guid];
            }
            return null;
        };

        mergeNames.forEach(item => {
            if (!item || !item.guid) return;

            polygons = polygons.map(poly => {
                if (!poly) return poly;

                if (poly.guid === item.guid) {
                    const newPoly = { ...poly, name: item.name };

                    if (typeof this.updateArea === 'function') {
                        this.updateArea(newPoly);
                    }

                    const layer = getLayer(newPoly.guid);
                    if (layer && this.featureGroupP) {
                        this.removeLayer(this.featureGroupP, layer);
                    }
                    this.drawPolygon(newPoly, 'estimate');

                    return newPoly;
                }

                return poly;
            });
        });

        this.setState(
            {
                polygons,
                mergeNameEditing: false,
                mergeNames: [],
                polyNameEditing: false
            },
            () => {
                this.keepData('polygons', this.state.polygons);
            }
        );
    };

    cancelMergeNames = () => {
        const backup = this.state.startPolygons || [];
        const current = this.state.polygons || [];

        if (!backup.length) {
            this.setState({
                mergeNameEditing: false,
                mergeNames: [],
                past_merge: false
            });
            return;
        }

        const layerByGuid = (guid) =>
            (this.mymap && this.mymap._layers) ? this.mymap._layers[guid] : null;

        current.forEach(p => {
            if (!p) return;
            const existsInBackup = backup.some(b => b && b.guid === p.guid);
            if (!existsInBackup) {
                const layer = layerByGuid(p.guid);
                if (layer && this.featureGroupP) {
                    this.removeLayer(this.featureGroupP, layer);
                }
            }
        });

        backup.forEach(p => {
            if (!p) return;
            const layer = layerByGuid(p.guid);
            if (!layer) {
                this.drawPolygon(p, 'estimate');
            }
        });

        this.setState(
            {
                polygons: backup,
                startPolygons: null,
                sel_poly: null,
                sel_polygons: [],
                mergeNameEditing: false,
                mergeNames: [],
                past_merge: false,
                areaFilterSelection: this.state.areaFilterSelectionStart
            },
            () => {
                this.keepData('polygons', this.state.polygons);
            }
        );
    };

    deleteArea = (ids, callback) => {
        let apiUrl = Config.server + '/area';
        let method = 'DELETE';

        const formData = new URLSearchParams();
        formData.append('ids', ids);

        let options = {
            method: method,
            body: formData,
            headers: {
                'Authorization': localStorage.getItem('access-token-jwt')
            }
        }

        fetch(apiUrl, options)
            .then((res) => {
                if (res.status !== 200) throw res;
                else return res.json();
            })
            .then(
                (result) => {
                    if (callback) {
                        callback();
                    }
                },
                (error) => {
                    if (error.status === 405) {
                        notification.open({
                            message: this.props.res.PERMISSAO,
                            description: this.props.res.PERMISSAO_MSG,
                            icon: <MaterialIcon icon="error" className="text-danger" />
                        });
                    } else if (error.status === 401 || error.status === 403) {
                        console.log(error);
                        this.props.link('/login');
                    }
                    else {
                        console.log(error);
                        notification.open({
                            message: this.props.res.ERRO,
                            description: this.props.res.ERRO_MSG,
                            icon: <MaterialIcon icon="error" className="text-danger" />
                        });
                    }
                }
            );
    };

    recalculateOverlaps = () => {
        if (!this.mymap) return;

        if (!this.overlapGroup) {
            this.overlapGroup = L.featureGroup().addTo(this.mymap);
        }

        this.overlapGroup.clearLayers();

        let selectedGuids = this.state.areaFilterSelection || [];
        let polygonsAll = this.state.polygons || [];
        let polygons = [];

        for (let i = 0; i < polygonsAll.length; i++) {
            let p = polygonsAll[i];
            if (!p || !p.guid) continue;
            if (selectedGuids.indexOf(p.guid) >= 0) {
                polygons.push(p);
            }
        }

        let polyList = [];

        for (let i = 0; i < polygons.length; i++) {
            let poly = polygons[i];
            if (!poly || !poly.guid || !poly.points) continue;

            let coords = null;
            try {
                coords = (typeof poly.points === 'string') ? JSON.parse(poly.points) : poly.points;
            } catch (e) {
                coords = null;
            }

            if (!coords || !Array.isArray(coords) || coords.length < 3) continue;

            let ring = [];
            for (let k = 0; k < coords.length; k++) {
                let c = coords[k];
                if (!c || c.length < 2) continue;

                let lat = Number(c[0]);
                let lng = Number(c[1]);
                if (isNaN(lat) || isNaN(lng)) continue;

                ring.push([lng, lat]);
            }

            if (ring.length < 3) continue;

            let first = ring[0];
            let last = ring[ring.length - 1];
            if (first[0] !== last[0] || first[1] !== last[1]) {
                ring.push(first);
            }

            let turfPoly = null;
            try {
                turfPoly = turf.polygon([ring]);
            } catch (e) {
                turfPoly = null;
            }
            if (!turfPoly) continue;

            let cleaned = null;
            try {
                cleaned = turf.unkinkPolygon(turfPoly);
            } catch (e) {
                cleaned = { type: 'FeatureCollection', features: [turfPoly] };
            }

            let feats = cleaned && cleaned.features ? cleaned.features : [];
            for (let f = 0; f < feats.length; f++) {
                polyList.push({
                    guid: poly.guid,
                    turf: feats[f]
                });
            }
        }

        let drawOrder = this.getLeafletDrawOrder();
        let orderIndex = {};
        for (let i = 0; i < drawOrder.length; i++) {
            orderIndex[drawOrder[i]] = i;
        }

        const getIndex = (guid) => {
            if (guid && orderIndex.hasOwnProperty(guid)) return orderIndex[guid];
            return -1;
        };

        let topGuids = {};

        for (let i = 0; i < polyList.length; i++) {
            for (let j = i + 1; j < polyList.length; j++) {
                let a = polyList[i];
                let b = polyList[j];

                if (!a || !b) continue;
                if (!a.turf || !b.turf) continue;
                if (!a.guid || !b.guid) continue;
                if (a.guid === b.guid) continue;

                let intersection = null;
                try {
                    intersection = turf.intersect(a.turf, b.turf);
                } catch (e) {
                    intersection = null;
                }

                if (!intersection) continue;

                let idxA = getIndex(a.guid);
                let idxB = getIndex(b.guid);

                let topGuid = b.guid;

                if (idxA >= 0 && idxB >= 0) {
                    topGuid = (idxA > idxB) ? a.guid : b.guid;
                } else {
                    let posA = -1;
                    let posB = -1;
                    for (let p = 0; p < polygons.length; p++) {
                        if (polygons[p] && polygons[p].guid === a.guid) posA = p;
                        if (polygons[p] && polygons[p].guid === b.guid) posB = p;
                    }
                    if (posA >= 0 && posB >= 0) {
                        topGuid = (posA > posB) ? a.guid : b.guid;
                    }
                }

                topGuids[topGuid] = true;

                L.geoJSON(intersection, {
                    pane: 'overlapPane',
                    interactive: false,
                    style: {
                        color: '#1565c0',
                        weight: 0,
                        fillColor: '#1565c0',
                        fillOpacity: 0.75
                    }
                }).addTo(this.overlapGroup);
            }
        }

        this.updateOverlapLabels(topGuids);
    };

    updateOverlapLabels = (topGuids, hasAny) => {
        let polygons = this.state.polygons || [];
        let nameByGuid = {};

        for (let i = 0; i < polygons.length; i++) {
            let poly = polygons[i];
            if (poly && poly.guid) {
                nameByGuid[poly.guid] = poly.name || '';
            }
        }

        let groups = [this.featureGroupP, this.featureGroupPM, this.featureGroupE];

        for (let g = 0; g < groups.length; g++) {
            let group = groups[g];
            if (!group) continue;

            group.eachLayer(layer => {
                if (!layer || !(layer instanceof L.Polygon)) return;

                let guid = layer._leaflet_id;
                if (!guid) return;

                let baseName = nameByGuid[guid] || '';
                if (!baseName) return;

                if (!layer._origStyle) {
                    layer._origStyle = {
                        color: layer.options && layer.options.color,
                        weight: layer.options && layer.options.weight,
                        opacity: layer.options && layer.options.opacity,
                        fill: layer.options && typeof layer.options.fill !== 'undefined' ? layer.options.fill : true,
                        fillColor: layer.options && layer.options.fillColor,
                        fillOpacity: layer.options && layer.options.fillOpacity
                    };
                }

                let isTop = topGuids && topGuids[guid];

                let label = baseName;
                if (isTop) {
                    label = baseName + ' (Sobreposição)';
                }

                layer.unbindTooltip();
                layer.bindTooltip(label, {
                    permanent: true,
                    direction: "center",
                    className: 'tool-tip-L tool-tip-size16-L'
                }).openTooltip();

                if (isTop) {
                    layer.setStyle({
                        color: '#1565c0',
                        weight: 3,
                        opacity: 1,
                        fill: true,
                        fillColor: '#1565c0',
                        fillOpacity: 0.35
                    });

                    if (layer.bringToFront) {
                        layer.bringToFront();
                    }
                } else {
                    if (layer._origStyle) {
                        layer.setStyle({
                            color: layer._origStyle.color,
                            weight: layer._origStyle.weight,
                            opacity: layer._origStyle.opacity,
                            fill: layer._origStyle.fill,
                            fillColor: layer._origStyle.fillColor,
                            fillOpacity: layer._origStyle.fillOpacity
                        });
                    }
                }
            });
        }
    };

    getLeafletDrawOrder = () => {
        let order = [];
        let groups = [this.featureGroupP, this.featureGroupPM, this.featureGroupE];

        for (let g = 0; g < groups.length; g++) {
            let group = groups[g];
            if (!group || !group._layers) continue;

            let keys = Object.keys(group._layers);
            for (let i = 0; i < keys.length; i++) {
                let layer = group._layers[keys[i]];
                if (!layer) continue;
                if (!(layer instanceof L.Polygon)) continue;

                let guid = layer._leaflet_id;
                if (guid && order.indexOf(guid) < 0) {
                    order.push(guid);
                }
            }
        }

        return order;
    };

    toggleAllAreaFilters = () => {
        const polygons = Array.isArray(this.state.polygons) ? this.state.polygons : [];
        const allGuids = polygons
            .map((p) => p && p.guid)
            .filter((g) => !!g);

        const selected = Array.isArray(this.state.areaFilterSelection)
            ? this.state.areaFilterSelection
            : [];

        const selectedSet = {};
        for (let i = 0; i < selected.length; i++) selectedSet[selected[i]] = true;

        let selectedCount = 0;
        for (let i = 0; i < allGuids.length; i++) {
            if (selectedSet[allGuids[i]]) selectedCount++;
        }

        const allSelected = allGuids.length > 0 && selectedCount === allGuids.length;

        this.setState({
            areaFilterSelection: allSelected ? [] : allGuids
        });
    };

    selectorEstimate = (start) => {
        this.resetClick();
        this.markClick = true;

        if (this.state.create) this.cancelCreate();
        if (this.state.edit) this.cancelEdit();
        if (this.state.ruler_a) this.cancelRuler();

        if (!start && this.state.selector && this.state.selectorMode === 'poly') {
            this.cancelSelectorEstimate();
            return;
        }

        this.setState({ selector: true, selectorMode: 'poly' });

        const options = {
            showArea: false,
            showLength: false,
            shapeOptions: {
                stroke: true,
                color: '#3388ff',
                weight: 3,
                opacity: 0.5,
                fill: false,
                fillColor: null,
                fillOpacity: 0,
                clickable: false,
                dashArray: '10, 10',
                dashOffset: '10'
            },
            metric: true,
            feet: true,
            nautic: false,
            precision: {}
        };

        this.drawCreateToolbar = new L.Draw.Polygon(this.mymap, options);
        this.drawCreateToolbar.enable();
    };

    clearSelPoly = () => {
        this.setState({ sel_poly: null, sel_polygons: [] });
        for (let i = 0; i < this.state.polygons.length; i++) {
            const pg = this.state.polygons[i];
            const lyr = (this.mymap && this.mymap._layers) ? this.mymap._layers[pg.guid] : null;

            if (!lyr || typeof lyr.setStyle !== 'function') {
                continue;
            }

            this.setPolygonBaseStyle(lyr, pg, this.state.polygons);
        }
    };

    selectorEstimateRet = (start) => {
        this.resetClick();
        this.markClick = true;

        if (this.state.create) this.cancelCreate();
        if (this.state.edit) this.cancelEdit();
        if (this.state.ruler_a) this.cancelRuler();

        if (!start && this.state.selector && this.state.selectorMode === 'rect') {
            this.cancelSelectorEstimate();
            return;
        }
        //
        this.clearSelPoly();
        this.setState({ selector: true, selectorMode: 'rect' });

        const options = {
            shapeOptions: {
                stroke: true,
                color: '#3388ff',
                weight: 3,
                opacity: 0.5,
                fill: false,
                fillColor: null,
                fillOpacity: 0,
                clickable: false,
                dashArray: '10, 10',
                dashOffset: '10'
            },
            metric: true
        };

        this.drawCreateToolbar = new L.Draw.Rectangle(this.mymap, options);
        this.drawCreateToolbar.enable();
    };

    cancelSelectorEstimate = (silent) => {
        if (this.drawCreateToolbar) {
            try { this.drawCreateToolbar.disable(); } catch (e) { }
        }

        if (this.mymap && this.mymap._layers) {
            const layer = this.mymap._layers.selector;
            if (layer) {
                this.removeLayer(this.featureGroupP, layer);
                try { this.mymap.removeLayer(layer); } catch (e) { }
            }

            const layerM = this.mymap._layers.selectorM;
            if (layerM) {
                this.removeLayer(this.featureGroupP, layerM);
                try { this.mymap.removeLayer(layerM); } catch (e) { }
            }
        }

        this.setState({ selector: false });

        if (!silent) {
            this.markClick = false;
        }
    };

    completeSelectorEstimate = (layer) => {
        if (!layer) {
            this.cancelSelectorEstimate(true);
            return;
        }

        const getRingLatLngs = (leafletLayer) => {
            if (!leafletLayer || !leafletLayer.getLatLngs) return [];

            let latlngs = [];
            try { latlngs = leafletLayer.getLatLngs(); } catch (e) { latlngs = []; }

            let ring = latlngs;

            while (Array.isArray(ring) && ring.length > 0 && Array.isArray(ring[0])) {
                ring = ring[0];
            }

            if (!Array.isArray(ring)) return [];

            const points = [];
            for (let i = 0; i < ring.length; i++) {
                const p = ring[i];
                if (p && typeof p.lat === 'number' && typeof p.lng === 'number') {
                    points.push({ lat: p.lat, lng: p.lng });
                }
            }

            return points;
        };

        const pointInPolygon = (point, polygonRing) => {
            const x = point.lng;
            const y = point.lat;

            let inside = false;

            for (let i = 0, j = polygonRing.length - 1; i < polygonRing.length; j = i++) {
                const xi = polygonRing[i].lng;
                const yi = polygonRing[i].lat;
                const xj = polygonRing[j].lng;
                const yj = polygonRing[j].lat;

                const denom = (yj - yi) === 0 ? 1e-12 : (yj - yi);
                const intersects = ((yi > y) !== (yj > y)) && (x < ((xj - xi) * (y - yi)) / denom + xi);

                if (intersects) inside = !inside;
            }

            return inside;
        };

        const ringsOverlap = (ringA, ringB) => {
            if (!ringA || ringA.length < 3) return false;
            if (!ringB || ringB.length < 3) return false;

            for (let i = 0; i < ringA.length; i++) {
                if (pointInPolygon(ringA[i], ringB)) return true;
            }

            for (let i = 0; i < ringB.length; i++) {
                if (pointInPolygon(ringB[i], ringA)) return true;
            }

            return false;
        };

        let selectorBounds = null;
        try { selectorBounds = layer.getBounds ? layer.getBounds() : null; } catch (err) { selectorBounds = null; }

        const selectorMode = this.state.selectorMode;
        const selectorRing = selectorMode === 'rect' ? [] : getRingLatLngs(layer);

        const polygons = Array.isArray(this.state.polygons) ? this.state.polygons : [];
        const selectedGuids = [];

        for (let i = 0; i < polygons.length; i++) {
            const poly = polygons[i];
            if (!poly || !poly.guid) continue;

            const polyLayer = (this.mymap && this.mymap._layers) ? this.mymap._layers[poly.guid] : null;
            if (!polyLayer || !polyLayer.getBounds) continue;

            let polyBounds = null;
            try { polyBounds = polyLayer.getBounds(); } catch (err) { polyBounds = null; }
            if (!polyBounds || !polyBounds.isValid || !polyBounds.isValid()) continue;

            let boundsHit = false;
            if (selectorBounds && selectorBounds.isValid && selectorBounds.isValid()) {
                try { boundsHit = polyBounds.intersects(selectorBounds); } catch (err) { boundsHit = false; }
            }

            if (!boundsHit) continue;

            let hit = false;

            if (selectorMode === 'rect') {
                hit = true;
            } else {
                const polyRing = getRingLatLngs(polyLayer);
                if (!polyRing || polyRing.length < 3) continue;

                hit = ringsOverlap(polyRing, selectorRing);
            }

            if (!hit) continue;

            selectedGuids.push(poly.guid);
        }

        const currentSelected = Array.isArray(this.state.sel_polygons) ? this.state.sel_polygons : [];

        const selectedMap = {};
        for (let i = 0; i < currentSelected.length; i++) {
            selectedMap[currentSelected[i]] = true;
        }

        const mergedSelected = currentSelected.slice();
        for (let i = 0; i < selectedGuids.length; i++) {
            const guid = selectedGuids[i];
            if (!selectedMap[guid]) {
                selectedMap[guid] = true;
                mergedSelected.push(guid);
            }
        }

        let selectedPoly = this.state.sel_poly || null;

        if (selectedPoly && selectedPoly.guid && !selectedMap[selectedPoly.guid]) {
            selectedPoly = null;
        }

        if (!selectedPoly && mergedSelected.length > 0) {
            const lastGuid = mergedSelected[mergedSelected.length - 1];
            selectedPoly = polygons.find(p => p && p.guid === lastGuid) || null;
        }

        this.ignoreNextMapClick = true;
        this.ignoreNextPolygonClick = true;

        setTimeout(() => {
            this.ignoreNextMapClick = false;
            this.ignoreNextPolygonClick = false;
        }, 250);

        this.setState(
            {
                sel_polygons: mergedSelected,
                sel_poly: selectedPoly,
                selector: false
            },
            () => {
                this.recalculateOverlaps();
                this.syncPolygonSelectionStyles();
            }
        );

        try { this.mymap.removeLayer(layer); } catch (err) { }

        try {
            if (this.drawCreateToolbar) {
                this.drawCreateToolbar.disable();
            }
        } catch (err) { }

        this.markClick = false;
    };

    syncPolygonSelectionStyles = () => {
        const selected = Array.isArray(this.state.sel_polygons)
            ? this.state.sel_polygons
            : [];

        const selectedMap = {};
        for (let i = 0; i < selected.length; i++) {
            selectedMap[selected[i]] = true;
        }

        if (!this.mymap || !this.mymap._layers) return;

        for (let i = 0; i < this.state.polygons.length; i++) {
            const poly = this.state.polygons[i];
            if (!poly || !poly.guid) continue;

            const layer = this.mymap._layers[poly.guid];
            if (!layer || !layer.setStyle) continue;

            if (selectedMap[poly.guid]) {
                layer.setStyle({ color: this.color_selected });
                if (layer.bringToFront) layer.bringToFront();
            } else {
                this.setPolygonBaseStyle(layer, poly, this.state.polygons);
            }
        }
    };

    setAnchor = (type) => (event) => {
        if (event) {
            this.setState({ anchorMN: event.currentTarget, typeTool: type });
        } else {
            this.setState({ anchorMN: null }, () => setTimeout(() => this.setState({ typeTool: type }), 200));
        }
    };
    movePoly = (guid, move) => {
        const polygons = this.state.polygons;
        let index = polygons.findIndex(p => {
            p.blink = false;
            return p && p.guid === guid;
        });
        if (index < 0) return;
        this.setState({ polygons: polygons }, () => {
            if (move === 'up') {
                if (index === 0) return;
                let temp = polygons[index - 1];
                polygons[index - 1] = polygons[index];
                polygons[index] = temp;
                polygons[index - 1].blink = true;
                polygons[index].blink = true;
            } else if (move === 'down') {
                if (index === polygons.length - 1) return;
                let temp = polygons[index + 1];
                polygons[index + 1] = polygons[index];
                polygons[index] = temp;
                polygons[index + 1].blink = true;
                polygons[index].blink = true;
            }

            this.setState({ polygons: polygons });
        });
    };

    handleBackToServiceOrder = () => {
        if (!this.state.serviceOrderID) return;
        this.props.link(`/app/ordem-servico/edit/${this.state.serviceOrderID}`);
    };

    list_hangars = () => {
        const apiUrl = Config.server + '/point/H';

        const options = {
            method: 'GET',
            headers: {
                'Authorization': localStorage.getItem('access-token-jwt')
            }
        };

        this.hangarsPromise = fetch(apiUrl, options)
            .then((res) => {
                if (res.status !== 200) throw res;
                return res.json();
            })
            .then(
                (result) => {
                    this.hangarsLoaded = true;
                    this.hangars = Array.isArray(result)
                        ? result.filter(item => this.getPlanningReplay3DPointLatLng(item))
                        : [];

                    if (this.hangars.length === 1 && !this.getPlanningReplay3DPointLatLng(this.base)) {
                        const h = this.hangars[0];
                        const point = this.getPlanningReplay3DPointLatLng(h);

                        if (point) {
                            const itemBase = {
                                lat: point.lat,
                                lng: point.lng,
                                guid: h.guid ? h.guid : tools.newGuid(),
                                type: h.type || 'H'
                            };

                            this.create_update_base(itemBase);
                            this.setState({ setBase: true });
                        }
                    }

                    return this.hangars;
                },
                (error) => {
                    this.hangarsLoaded = true;
                    this.hangars = [];

                    if (error && error.status === 405) {
                        notification.open({
                            message: this.props.res.PERMISSAO,
                            description: this.props.res.PERMISSAO_MSG,
                            icon: <MaterialIcon icon="error" className="text-danger" />
                        });
                    } else if (error && (error.status === 401 || error.status === 403)) {
                        console.log(error);
                        this.props.link('/login');
                    } else {
                        console.log(error);
                        notification.open({
                            message: this.props.res.ERRO,
                            description: this.props.res.ERRO_MSG,
                            icon: <MaterialIcon icon="error" className="text-danger" />
                        });
                    }

                    return [];
                }
            );

        return this.hangarsPromise;
    };

    getAutoPlanningConfigFromProfiles = (profiles) => {
        const defaultConfig = this.parseAutoPlanningConfig(null);

        if (!Array.isArray(profiles) || profiles.length === 0) {
            return defaultConfig;
        }

        const firstProfile = profiles[0];
        if (!firstProfile || typeof firstProfile !== 'object') {
            return defaultConfig;
        }

        const planningList = Array.isArray(firstProfile.planning) ? firstProfile.planning : [];
        const firstPlanning = planningList.length > 0 ? planningList[0] : null;

        if (firstPlanning && firstPlanning.resumo_config !== undefined) {
            return this.parseAutoPlanningConfig(firstPlanning.resumo_config);
        }

        if (firstProfile.resumo_config !== undefined) {
            return this.parseAutoPlanningConfig(firstProfile.resumo_config);
        }

        return defaultConfig;
    };

    parseAutoPlanningConfig = (rawConfig) => {
        const defaultConfig = {
            checkAutoPlan: false,
            checkAutoSend: false,
            planningStrategyMode: 'tempo',
            planningStrategyRanges: {}
        };

        let parsed = rawConfig;

        if (!rawConfig) return defaultConfig;

        if (typeof rawConfig === 'string') {
            const text = rawConfig.trim();
            if (!text) return defaultConfig;

            try {
                parsed = JSON.parse(text);
            } catch (e) {
                return defaultConfig;
            }
        }

        if (!parsed || typeof parsed !== 'object') return defaultConfig;

        return {
            checkAutoPlan: !!parsed.checkAutoPlan,
            checkAutoSend: !!parsed.checkAutoSend,
            planningStrategyMode: parsed.planningStrategyMode || 'tempo',
            planningStrategyRanges: parsed.planningStrategyRanges && typeof parsed.planningStrategyRanges === 'object'
                ? parsed.planningStrategyRanges
                : {}
        };
    };

    getAutoSendFlagNow = (configData) => {
        const config = configData || (this.state && this.state.autoPlanningConfig ? this.state.autoPlanningConfig : null);
        if (!config) return false;
        return !!config.checkAutoSend;
    };

    getSavedPlanningGuid = (value) => {
        if (value === 0) return null;

        if (typeof value === 'string') {
            const text = String(value).trim();
            if (text) return text;
        }

        if (!value) return null;

        if (value.guid) return value.guid;

        if (value.list_plan && value.list_plan.length > 0 && value.list_plan[0] && value.list_plan[0].guid) {
            return value.list_plan[0].guid;
        }

        if (this.state && this.state.menuItem && this.state.menuItem.list_plan && this.state.menuItem.list_plan.length > 0) {
            return this.state.menuItem.list_plan[0].guid || null;
        }

        if (this.state && this.state.menuItemListItem && this.state.menuItemListItem.guid) {
            return this.state.menuItemListItem.guid;
        }

        return null;
    };

    getSavedPlanningPlaneId = (value) => {
        if (value === 0) return 0;

        if (typeof value === 'number') {
            if (!isNaN(value)) return Number(value);
        }

        if (typeof value === 'string') {
            const text = String(value).trim();
            if (text !== '' && !isNaN(text)) return Number(text);
        }

        if (!value) return null;

        if (value.id_plane !== undefined && value.id_plane !== null) return value.id_plane;

        if (
            value.list_plan &&
            value.list_plan.length > 0 &&
            value.list_plan[0] &&
            value.list_plan[0].id_plane !== undefined &&
            value.list_plan[0].id_plane !== null
        ) {
            return value.list_plan[0].id_plane;
        }

        if (this.state && this.state.menuItem && this.state.menuItem.list_plan && this.state.menuItem.list_plan.length > 0) {
            const firstPlan = this.state.menuItem.list_plan[0];
            if (firstPlan && firstPlan.id_plane !== undefined && firstPlan.id_plane !== null) return firstPlan.id_plane;
        }

        return null;
    };

    getSavedPlanningPlaneIds = (planeIdData) => {
        let ids = [];

        function addId(value) {
            if (value === undefined || value === null || value === '') return;
            const id = Number(value);
            if (!isNaN(id) && isFinite(id) && ids.indexOf(id) < 0) ids.push(id);
        }

        if (Array.isArray(planeIdData)) {
            planeIdData.forEach(addId);
        } else {
            addId(planeIdData);
        }

        if (!ids.length && Array.isArray(this.state.plane_est_ids)) {
            this.state.plane_est_ids.forEach(addId);
        }

        if (!ids.length) {
            const singlePlaneId = this.getSavedPlanningPlaneId(planeIdData);
            addId(singlePlaneId);
        }

        return ids;
    };

    trySendOrOpenDialogAfterSave = (guidData, planeIdData, autoPlanningConfig, shared) => {
        if (shared === true) {
            this.setState({
                openSendPlaneDialog: false,
                sendPlaneGuid: null,
                sendPlaneId: null,
                sendPlaneIds: []
            });
            return;
        }

        const planningGuid = this.getSavedPlanningGuid(guidData);
        const planeIds = this.getSavedPlanningPlaneIds(planeIdData);

        if (!planningGuid) return;
        if (!planeIds.length) return;

        const configFromArgument = autoPlanningConfig && typeof autoPlanningConfig === 'object'
            ? autoPlanningConfig
            : null;

        const configFromProfiles =
            !configFromArgument && this.state && Array.isArray(this.state.dataPlanejamento)
                ? this.getAutoPlanningConfigFromProfiles(this.state.dataPlanejamento)
                : null;

        const shouldAutoSend = this.getAutoSendFlagNow(configFromArgument || configFromProfiles);

        if (shouldAutoSend === true) {
            this.sendPlanningToPlane(planningGuid, planeIds, { closeDialogOnStart: true });
            return;
        }

        this.setState({
            openSendPlaneDialog: true,
            sendPlaneGuid: planningGuid,
            sendPlaneId: planeIds[0],
            sendPlaneIds: planeIds
        });
    };

    closeSendPlaneDialog = () => {
        if (this.state.sendingPlaneNow) return;

        this.setState({
            openSendPlaneDialog: false,
            sendPlaneGuid: null,
            sendPlaneId: null,
            sendPlaneIds: []
        });
    };

    confirmSendPlane = () => {
        const planningGuid = this.state.sendPlaneGuid;
        const planeIds = this.getSavedPlanningPlaneIds(this.state.sendPlaneIds && this.state.sendPlaneIds.length ? this.state.sendPlaneIds : this.state.sendPlaneId);

        if (!planningGuid) {
            this.closeSendPlaneDialog();
            return;
        }

        if (!planeIds.length) {
            this.closeSendPlaneDialog();
            return;
        }

        this.sendPlanningToPlane(planningGuid, planeIds, { closeDialogOnStart: true });
    };

    sendPlanningToPlane = (planningGuid, planeId, options) => {
        const closeDialogOnStart = !!(options && options.closeDialogOnStart);
        const planeIds = this.getSavedPlanningPlaneIds(planeId);

        if (!planningGuid) return;
        if (!planeIds.length) return;

        if (closeDialogOnStart) {
            this.setState({ openSendPlaneDialog: false, sendingPlaneNow: true });
        } else {
            this.setState({ sendingPlaneNow: true });
        }

        const apiUrl = Config.server + '/transfer';
        const formData = new URLSearchParams();

        formData.append('list_plane', JSON.stringify(planeIds));
        formData.append('guid', String(planningGuid));
        formData.append('type', 'job');

        const optionsFetch = {
            method: 'POST',
            body: formData,
            headers: {
                Authorization: localStorage.getItem('access-token-jwt')
            }
        };

        fetch(apiUrl, optionsFetch)
            .then((resData) => {
                if (resData.status !== 200) throw resData;
                return resData.json();
            })
            .then(
                (result) => {
                    this.setState({
                        sendingPlaneNow: false,
                        openSendPlaneDialog: false,
                        sendPlaneGuid: null,
                        sendPlaneId: null,
                        sendPlaneIds: []
                    });

                    if (result && result.msg) {
                        notification.open({
                            message: this.props.res.ENVIANDO_PLANEJAMENTO || this.props.res.ENVIANDO_TRABALHO,
                            icon: <MaterialIcon icon="check_circle" className="text-success" />
                        });

                        setTimeout(() => {
                            if (this.updateList) this.updateList(1, true);
                        }, 200);
                    } else {
                        notification.open({
                            message: this.props.res.ERRO,
                            description: this.props.res.ERRO_MSG,
                            icon: <MaterialIcon icon="error" className="text-danger" />
                        });
                    }
                },
                (error) => {
                    this.setState({ sendingPlaneNow: false });

                    if (error && error.status === 405) {
                        notification.open({
                            message: this.props.res.PERMISSAO,
                            description: this.props.res.PERMISSAO_MSG,
                            icon: <MaterialIcon icon="error" className="text-danger" />
                        });
                    } else if (error && (error.status === 401 || error.status === 403)) {
                        this.props.link('/login');
                    } else {
                        notification.open({
                            message: this.props.res.ERRO,
                            description: this.props.res.ERRO_MSG,
                            icon: <MaterialIcon icon="error" className="text-danger" />
                        });
                    }
                }
            );
    };

    buildWaypointIcon = () => {
        if (this.waypointIcon) return this.waypointIcon;

        this.waypointIcon = L.icon({
            iconUrl: pinWaypoint,
            iconSize: [30, 30],
            iconAnchor: [15, 30],
            popupAnchor: [0, -28]
        });

        return this.waypointIcon;
    };

    formatWaypointPopup = (latlng) => {
        const latValue = (this.state && this.state.lat && this.state.lat.value != null)
            ? this.state.lat.value
            : (latlng && latlng.lat != null ? latlng.lat : null);

        const lngValue = (this.state && this.state.lng && this.state.lng.value != null)
            ? this.state.lng.value
            : (latlng && latlng.lng != null ? latlng.lng : null);

        const latText = this.formatCoordText(latValue, 'latitude');
        const lngText = this.formatCoordText(lngValue, 'longitude');

        return `
        <div style="font-size: 12px; line-height: 1.35;">
            <div><b>${this.props.res.LAT}:</b> ${latText}</div>
            <div><b>${this.props.res.LNG}:</b> ${lngText}</div>
        </div>
    `;
    };

    openWaypointPopup = () => {
        if (this.waypointMarker) {
            this.waypointMarker.openPopup();
        }
    };

    closeWaypointPopup = () => {
        if (this.waypointMarker) {
            this.waypointMarker.closePopup();
        }
    };

    createWaypointMarker = (latlng) => {
        const icon = this.buildWaypointIcon();

        const marker = L.marker(latlng, {
            icon: icon,
            keyboard: false
        });

        marker.bindPopup(this.formatWaypointPopup(latlng), { closeButton: true, autoClose: false, closeOnClick: false });

        marker.on('click', (ev) => {
            if (ev && ev.originalEvent) {
                L.DomEvent.stopPropagation(ev.originalEvent);
            }
            this.openWaypointPopup();
        });

        marker.addTo(this.mymap);

        this.waypointMarker = marker;
        this.openWaypointPopup();
    };

    moveWaypointMarker = (latlng) => {
        if (!this.waypointMarker) {
            this.createWaypointMarker(latlng);
            return;
        }

        this.waypointMarker.setLatLng(latlng);
        this.waypointMarker.setPopupContent(this.formatWaypointPopup(latlng));
        this.openWaypointPopup();
    };

    formatCoordText = (value, type) => {
        const mode = (this.state && this.state.coordMode) ? this.state.coordMode : 'dms';

        if (value == null || value === '' || !isFinite(Number(value))) return '';

        if (mode === 'dd') {
            return Number(value).toFixed(6);
        }

        return geo.toDMS(Number(value), type, 4, this.props.res);
    };

    applyCoordModeToState = () => {
        const latValue = (this.state && this.state.lat && this.state.lat.value != null) ? this.state.lat.value : null;
        const lngValue = (this.state && this.state.lng && this.state.lng.value != null) ? this.state.lng.value : null;

        const lat = {
            error: false,
            input: this.formatCoordText(latValue, 'latitude'),
            value: latValue
        };

        const lng = {
            error: false,
            input: this.formatCoordText(lngValue, 'longitude'),
            value: lngValue
        };

        this.setState({ lat: lat, lng: lng });

        if (this.waypointMarker) {
            const ll = this.waypointMarker.getLatLng();
            this.waypointMarker.setPopupContent(this.formatWaypointPopup(ll));
            if (this.waypointMarker.isPopupOpen()) this.waypointMarker.openPopup();
        }
    };

    toggleCoordMode = () => {
        const mode = (this.state && this.state.coordMode) ? this.state.coordMode : 'dms';
        const nextMode = (mode === 'dms') ? 'dd' : 'dms';

        this.setState({ coordMode: nextMode }, () => {
            this.applyCoordModeToState();
        });
    };

    gotoWaypoint = () => {
        if (!this.mymap) return;
        if (!this.waypointMarker) return;

        const ll = this.waypointMarker.getLatLng();
        if (!ll || ll.lat == null || ll.lng == null) return;

        const target = [ll.lat, ll.lng];
        const zoom = this.mymap.getZoom();

        const applyOffsetAndOpen = () => {
            if (!this.mymap) return;

            this.mymap.off('moveend', applyOffsetAndOpen);

            this.mymap.panBy([-180, 80], { animate: true });

            if (this.waypointMarker && this.waypointMarker.openPopup) {
                this.waypointMarker.openPopup();
            }
        };

        this.mymap.on('moveend', applyOffsetAndOpen);

        this.mymap.setView(target, zoom, { animate: true });

        setTimeout(() => {
            if (this.mymap) {
                applyOffsetAndOpen();
            }
        }, 350);
    };


    getPlaneParameter = (plane, field) => {
        if (!plane) {
            return null;
        }

        const value = plane[field];
        if (value === undefined || value === null || value === '') {
            return null;
        }

        const numberValue = Number(String(value).replace(',', '.'));
        if (isNaN(numberValue)) {
            return null;
        }

        return numberValue;
    };

    applyPlaneParameters = (plane, callback) => {
        if (!plane) {
            if (callback) callback();
            return;
        }

        const nextState = {};
        const applicationSpeed = this.getPlaneParameter(plane, 'application_speed');
        const travelSpeed = this.getPlaneParameter(plane, 'travel_speed');
        const balloonSpeed = this.getPlaneParameter(plane, 'balloon_speed');
        const flowRate = this.getPlaneParameter(plane, 'flow_rate');
        const hopperLoad = this.getPlaneParameter(plane, 'hopper_load');
        const swathWidth = this.getPlaneParameter(plane, 'swath_width');
        const flightHeight = this.getPlaneParameter(plane, 'flight_height');
        const balloonWidth = this.getPlaneParameter(plane, 'balloon_width');
        const balloonLength = this.getPlaneParameter(plane, 'balloon_length');

        if (applicationSpeed !== null) {
            nextState.speed = applicationSpeed;
            nextState.speed_apl = applicationSpeed;
        }
        if (travelSpeed !== null) nextState.speed_travel = travelSpeed;
        if (balloonSpeed !== null) nextState.speed_loop = balloonSpeed;
        if (flowRate !== null) nextState.fluxo = flowRate;
        if (hopperLoad !== null) nextState.carga = hopperLoad;
        if (swathWidth !== null) {
            nextState.faixa = swathWidth;
            nextState.space = 0;
        }
        if (flightHeight !== null) nextState.altura = flightHeight;
        if (balloonWidth !== null) nextState.size_loop = balloonWidth;
        if (balloonLength !== null) nextState.size_h_loop = balloonLength;

        if (Object.keys(nextState).length === 0) {
            if (callback) callback();
            return;
        }

        nextState.uEstimative = true;

        this.setState(nextState, () => {
            for (let field in nextState) {
                if (field !== 'uEstimative') {
                    this.keepData(field, nextState[field]);
                }
            }
            this.resetDownloadJob();
            this.resetRef();
            if (callback) callback();
        });
    };

    applySelectedPlaneParameters = (callback, force) => {
        if (this.savedPlanning && !force) {
            if (callback) callback();
            return;
        }

        let ids = this.state.plane_est_ids && this.state.plane_est_ids.length ? this.state.plane_est_ids : [];
        let selectedPlane = null;

        if (ids.length) {
            selectedPlane = (this.state.planes || []).filter((item) => item.id === ids[0])[0];
        } else if (this.state.plane_est) {
            const planeNames = String(this.state.plane_est).split(',').map(item => item.trim()).filter(Boolean);
            const selectedPlanes = (this.state.planes || []).filter((item) => planeNames.indexOf(String(item.name || '').trim()) >= 0 || planeNames.indexOf(String(item.original_name || '').trim()) >= 0);
            selectedPlane = selectedPlanes[0];

            if (selectedPlanes.length) {
                ids = selectedPlanes.map((item) => item.id);
            }
        }

        if (!selectedPlane) {
            if (callback) callback();
            return;
        }

        if (!this.state.plane_est_ids || !this.state.plane_est_ids.length) {
            this.setState({
                plane_est_id: selectedPlane.id,
                plane_est_ids: ids,
                plane_est_id_company: selectedPlane.id_company,
                plane_est_id_companies: (this.state.planes || []).filter((item) => ids.indexOf(item.id) >= 0).map((item) => item.id_company)
            }, () => {
                this.applyPlaneParameters(selectedPlane, callback);
            });
            return;
        }

        this.applyPlaneParameters(selectedPlane, callback);
    };

    getLastPlanningDetail = () => {
        let apiUrl = Config.server + '/job_detail_last';
        let method = 'GET';

        let options = {
            method: method,
            headers: {
                'Authorization': localStorage.getItem('access-token-jwt')
            }
        };

        fetch(apiUrl, options)
            .then((res) => {
                if (res.status !== 200) throw res;
                return res.json();
            })
            .then((result) => {
                const state = result && result.state;
                if (!state) return;

                const getVal = (v, current) => (v !== undefined && v !== null ? v : current);

                this.setState({
                    pilot_est: getVal(state.pilot_est, this.state.pilot_est),

                    aplicacao: getVal(state.aplicacao, this.state.aplicacao),

                    altura: getVal(state.altura, this.state.altura),
                    carga: getVal(state.carga, this.state.carga),

                    speed: getVal(state.speed, this.state.speed),
                    speed_apl: getVal(state.speed_apl, this.state.speed_apl),
                    speed_loop: getVal(state.speed_loop, this.state.speed_loop),
                    speed_travel: getVal(state.speed_travel, this.state.speed_travel),
                    size_loop: getVal(state.size_loop, this.state.size_loop),
                    size_h_loop: getVal(state.size_h_loop, this.state.size_h_loop),

                    r_time: getVal(state.r_time, this.state.r_time),
                    horas_dia: getVal(state.horas_dia, this.state.horas_dia),

                    faixa: getVal(state.faixa, this.state.faixa),
                    fluxo: getVal(state.fluxo, this.state.fluxo),
                }, () => {
                    this.applySelectedPlaneParameters();
                });
            })
            .catch((error) => {
                if (error.status === 405) {
                    notification.open({
                        message: this.props.res.PERMISSAO,
                        description: this.props.res.PERMISSAO_MSG,
                        icon: <MaterialIcon icon="error" className="text-danger" />
                    });
                } else if (error.status === 401 || error.status === 403) {
                    console.log(error);
                    this.props.link('/login');
                }
                else {
                    console.log(error);
                    notification.open({
                        message: this.props.res.ERRO,
                        description: this.props.res.ERRO_MSG,
                        icon: <MaterialIcon icon="error" className="text-danger" />
                    });
                }
            });
    };

    updateListPlanning = (callback) => {
        const apiUrl = Config.server + '/profile_auto_planning';

        const options = {
            method: 'GET',
            headers: {
                Authorization: localStorage.getItem('access-token-jwt')
            }
        };

        const defaultConfig = this.parseAutoPlanningConfig(null);

        fetch(apiUrl, options)
            .then((res) => {
                if (res.status !== 200) throw res;
                return res.json();
            })
            .then(
                (profiles) => {
                    const autoPlanningConfig = this.getAutoPlanningConfigFromProfiles(profiles);

                    this.setState(
                        {
                            dataPlanejamento: Array.isArray(profiles) ? profiles : [],
                            autoPlanningConfig: autoPlanningConfig
                        },
                        () => {
                            if (callback) callback(autoPlanningConfig);
                        }
                    );
                },
                (error) => {
                    if (callback) callback(defaultConfig);

                    if (error && error.status === 405) {
                        notification.open({
                            message: this.props.res.PERMISSAO,
                            description: this.props.res.PERMISSAO_MSG,
                            icon: <MaterialIcon icon="error" className="text-danger" />
                        });
                    } else if (error && (error.status === 401 || error.status === 403)) {
                        this.props.link('/login');
                    } else {
                        notification.open({
                            message: this.props.res.ERRO,
                            description: this.props.res.ERRO_MSG,
                            icon: <MaterialIcon icon="error" className="text-danger" />
                        });
                    }
                }
            );
    };

    getPlanningStrategyByRange = (qtdFaixas) => {
        const config = this.state && this.state.autoPlanningConfig ? this.state.autoPlanningConfig : null;
        const ranges = config && config.planningStrategyRanges ? config.planningStrategyRanges : null;

        if (!ranges || typeof ranges !== 'object') return '';

        for (let i = 0; i < this.strategy.length; i++) {
            const strategyItem = this.strategy[i];
            const strategyKey = strategyItem && strategyItem.value ? strategyItem.value : null;
            const range = strategyKey ? ranges[strategyKey] : null;

            if (!range || typeof range !== 'object') continue;

            const noMax = !!range.noMax;
            const hasMin = !(range.min === '' || range.min === null || range.min === undefined);
            const hasMax = !(range.max === '' || range.max === null || range.max === undefined);

            if (!hasMin && !hasMax && !noMax) continue;

            const min = hasMin ? Number(range.min) : null;
            const max = hasMax ? Number(range.max) : null;

            if (hasMin && isNaN(min)) continue;
            if (hasMax && isNaN(max)) continue;

            const minValue = min !== null ? min : 0;
            const maxValue = noMax || max === null ? null : max;

            if (
                (maxValue === null && qtdFaixas >= minValue) ||
                (maxValue !== null && qtdFaixas >= minValue && qtdFaixas <= maxValue)
            ) {
                return strategyKey;
            }
        }

        return '';
    };

    readPilots = () => {
        const apiUrl = `${Config.server}/pilot`;
        const apiUrlPerm = `${Config.server}/pilot/perm`;

        const options = {
            method: 'GET',
            headers: {
                'Authorization': localStorage.getItem('access-token-jwt')
            }
        };

        Promise.all([
            fetch(apiUrl, options),
            fetch(apiUrlPerm, options)
        ])
            .then((responses) => {
                for (let i = 0; i < responses.length; i++) {
                    if (responses[i].status !== 200) throw responses[i];
                }
                return Promise.all(responses.map((res) => res.json()));
            })
            .then((result) => {
                const pilots = Array.isArray(result[0]) ? result[0] : [];
                const permPilots = Array.isArray(result[1]) ? result[1] : [];

                const merged = [];
                const seen = {};

                for (let i = 0; i < pilots.length; i++) {
                    const pilot = pilots[i];
                    if (pilot && pilot.id != null && !seen[pilot.id]) {
                        seen[pilot.id] = true;
                        merged.push(Object.assign({}, pilot, {
                            original_name: pilot.name ? String(pilot.name) : '',
                            id_company: pilot.id_company != null ? pilot.id_company : null
                        }));
                    }
                }

                for (let i = 0; i < permPilots.length; i++) {
                    const pilot = permPilots[i];
                    if (!pilot || pilot.id == null) continue;

                    const pilotName = pilot.name ? String(pilot.name) : '';
                    const companyName = pilot.company_name ? String(pilot.company_name) : '';

                    const mergedPilot = Object.assign({}, pilot, {
                        original_name: pilotName,
                        name: companyName ? pilotName + ' - ' + companyName : pilotName,
                        id_company: pilot.id_company != null ? pilot.id_company : null
                    });

                    if (!seen[pilot.id]) {
                        seen[pilot.id] = true;
                        merged.push(mergedPilot);
                    }
                }

                this.setState({
                    pilots: merged,
                }, () => {
                    if ((!this.state.pilot_est_ids || !this.state.pilot_est_ids.length) && this.state.pilot_est) {
                        const pilotNames = String(this.state.pilot_est).split(',').map(item => item.trim()).filter(Boolean);
                        const selectedPilots = merged.filter(item =>
                            pilotNames.indexOf(String(item.name || '').trim()) >= 0 ||
                            pilotNames.indexOf(String(item.original_name || '').trim()) >= 0
                        );

                        if (selectedPilots.length) {
                            this.setState({
                                pilot_est: selectedPilots.map(item => item.name).join(', '),
                                pilot_est_id: selectedPilots[0].id,
                                pilot_est_ids: selectedPilots.map(item => item.id),
                                pilot_est_id_company: selectedPilots[0].id_company,
                                pilot_est_id_companies: selectedPilots.map(item => item.id_company)
                            });
                        }
                    }
                });
            })
            .catch((error) => {
                if (error.status === 405) {
                    notification.open({
                        message: this.props.res.PERMISSAO,
                        description: this.props.res.PERMISSAO_MSG,
                        icon: <MaterialIcon icon="error" className="text-danger" />
                    });
                } else if (error.status === 401 || error.status === 403) {
                    this.props.link('/login');
                } else {
                    notification.open({
                        message: this.props.res.ERRO,
                        description: this.props.res.ERRO_MSG,
                        icon: <MaterialIcon icon="error" className="text-danger" />
                    });
                }
            });
    };

    readPlanes = () => {
        const apiUrl = `${Config.server}/plane`;
        const apiUrlPerm = `${Config.server}/plane/perm`;

        const options = {
            method: 'GET',
            headers: {
                'Authorization': localStorage.getItem('access-token-jwt')
            }
        };

        Promise.all([
            fetch(apiUrl, options),
            fetch(apiUrlPerm, options)
        ])
            .then((responses) => {
                for (let i = 0; i < responses.length; i++) {
                    if (responses[i].status !== 200) throw responses[i];
                }
                return Promise.all(responses.map((res) => res.json()));
            })
            .then((result) => {
                const planes = Array.isArray(result[0]) ? result[0] : [];
                const permPlanes = Array.isArray(result[1]) ? result[1] : [];

                const merged = [];
                const seen = {};

                for (let i = 0; i < planes.length; i++) {
                    const planeItem = planes[i];
                    if (planeItem && planeItem.id != null && !seen[planeItem.id]) {
                        seen[planeItem.id] = true;
                        merged.push(Object.assign({}, planeItem, {
                            original_name: planeItem.name ? String(planeItem.name) : '',
                            id_company: planeItem.id_company != null ? planeItem.id_company : null
                        }));
                    }
                }

                for (let i = 0; i < permPlanes.length; i++) {
                    const plane = permPlanes[i];
                    if (!plane || plane.id == null) continue;

                    const planeName = plane.name ? String(plane.name) : '';
                    const companyName = plane.company_name ? String(plane.company_name) : '';

                    const mergedPlane = Object.assign({}, plane, {
                        original_name: planeName,
                        name: companyName ? planeName + ' - ' + companyName : planeName,
                        id_company: plane.id_company != null ? plane.id_company : null
                    });

                    if (!seen[plane.id]) {
                        seen[plane.id] = true;
                        merged.push(mergedPlane);
                    }
                }

                this.setState({
                    planes: merged,
                }, () => {
                    this.applySelectedPlaneParameters();
                });
            })
            .catch((error) => {
                if (error.status === 405) {
                    notification.open({
                        message: this.props.res.PERMISSAO,
                        description: this.props.res.PERMISSAO_MSG,
                        icon: <MaterialIcon icon="error" className="text-danger" />
                    });
                } else if (error.status === 401 || error.status === 403) {
                    this.props.link('/login');
                } else {
                    notification.open({
                        message: this.props.res.ERRO,
                        description: this.props.res.ERRO_MSG,
                        icon: <MaterialIcon icon="error" className="text-danger" />
                    });
                }
            });
    };


    normalizePlanningReplay3DNumber = (value) => {
        if (value === null || value === undefined || value === '') return null;
        const number = Number(value);
        return Number.isFinite(number) ? number : null;
    };

    getPlanningReplay3DCanonicalLength = (value) => {
        const length = this.normalizePlanningReplay3DNumber(value);
        return Number.isFinite(length) ? Units.toCanonicalLength(length, this.props.res) : null;
    };

    getPlanningReplay3DCanonicalSpeed = (value) => {
        const speed = this.normalizePlanningReplay3DNumber(value);
        return Number.isFinite(speed) ? Units.toCanonicalSpeed(speed, this.props.res) : null;
    };

    getPlanningReplay3DCanonicalFlow = (value, applicationType = this.state.aplicacao) => {
        const flow = this.normalizePlanningReplay3DNumber(value);
        if (!Number.isFinite(flow)) return null;

        return Units.toCanonicalFlow(flow, this.props.res, applicationType === 'S' ? 'kg' : 'L', 'ha');
    };

    getPlanningReplay3DCanonicalVolume = (value, applicationType = this.state.aplicacao) => {
        const volume = this.normalizePlanningReplay3DNumber(value);
        if (!Number.isFinite(volume)) return null;

        return Units.toCanonicalVolume(volume, this.props.res, applicationType === 'S' ? 'kg' : 'L');
    };

    normalizePlanningReplay3DCoord = (raw) => {
        if (!raw) return null;

        if (Array.isArray(raw)) {
            if (raw.length < 2) return null;
            const first = this.normalizePlanningReplay3DNumber(raw[0]);
            const second = this.normalizePlanningReplay3DNumber(raw[1]);
            const third = this.normalizePlanningReplay3DNumber(raw[2]);

            if (!Number.isFinite(first) || !Number.isFinite(second)) return null;
            if (Math.abs(first) <= 180 && Math.abs(second) <= 90) {
                return { lat: second, lng: first, alt: Number.isFinite(third) ? third : null };
            }

            return { lat: first, lng: second, alt: Number.isFinite(third) ? third : null };
        }

        if (typeof raw === 'object') {
            const lat = this.normalizePlanningReplay3DNumber(raw.lat !== undefined ? raw.lat : raw.latitude);
            const lng = this.normalizePlanningReplay3DNumber(raw.lng !== undefined ? raw.lng : (raw.lon !== undefined ? raw.lon : raw.longitude));
            const alt = this.normalizePlanningReplay3DNumber(raw.alt !== undefined ? raw.alt : (raw.altitude !== undefined ? raw.altitude : raw.height));

            if (Number.isFinite(lat) && Number.isFinite(lng)) {
                return { lat: lat, lng: lng, alt: Number.isFinite(alt) ? alt : null };
            }
        }

        return null;
    };

    parsePlanningReplay3DJson = (value) => {
        if (typeof value !== 'string') return value;

        const text = value.trim();
        if (!text) return null;

        try {
            return JSON.parse(text);
        } catch (error) {
            return value;
        }
    };

    addPlanningReplay3DLineFromCoords = (coords, output) => {
        if (!Array.isArray(coords)) return;

        const line = [];
        for (let i = 0; i < coords.length; i++) {
            const point = this.normalizePlanningReplay3DCoord(coords[i]);
            if (point) line.push(point);
        }

        if (line.length > 1) output.push(line);
    };

    addPlanningReplay3DLinesFromGeometry = (geometry, output) => {
        if (!geometry) return;

        const type = geometry.type;
        const coords = geometry.coordinates;

        if (type === 'LineString') {
            this.addPlanningReplay3DLineFromCoords(coords, output);
            return;
        }

        if (type === 'MultiLineString') {
            if (!Array.isArray(coords)) return;
            for (let i = 0; i < coords.length; i++) {
                this.addPlanningReplay3DLineFromCoords(coords[i], output);
            }
            return;
        }

        if (type === 'GeometryCollection' && Array.isArray(geometry.geometries)) {
            for (let i = 0; i < geometry.geometries.length; i++) {
                this.addPlanningReplay3DLinesFromGeometry(geometry.geometries[i], output);
            }
        }
    };

    getPlanningReplay3DPathLines = (path) => {
        const lines = [];
        const parsedPath = this.parsePlanningReplay3DJson(path);

        if (!parsedPath) return lines;

        if (parsedPath.type === 'FeatureCollection' && Array.isArray(parsedPath.features)) {
            for (let i = 0; i < parsedPath.features.length; i++) {
                if (parsedPath.features[i]) {
                    this.addPlanningReplay3DLinesFromGeometry(parsedPath.features[i].geometry, lines);
                }
            }
            return lines;
        }

        if (parsedPath.type === 'Feature' && parsedPath.geometry) {
            this.addPlanningReplay3DLinesFromGeometry(parsedPath.geometry, lines);
            return lines;
        }

        if (parsedPath.type && parsedPath.coordinates) {
            this.addPlanningReplay3DLinesFromGeometry(parsedPath, lines);
            return lines;
        }

        if (Array.isArray(parsedPath)) {
            const directLine = [];
            for (let i = 0; i < parsedPath.length; i++) {
                const point = this.normalizePlanningReplay3DCoord(parsedPath[i]);
                if (point) directLine.push(point);
            }

            if (directLine.length > 2 && directLine.length % 2 === 0) {
                for (let i = 0; i < directLine.length; i += 2) {
                    if (directLine[i] && directLine[i + 1]) lines.push([directLine[i], directLine[i + 1]]);
                }
            } else if (directLine.length > 1) {
                lines.push(directLine);
            }
        }

        return lines;
    };

    flattenPlanningReplay3DLines = (lines) => {
        const points = [];
        if (!Array.isArray(lines)) return points;

        for (let i = 0; i < lines.length; i++) {
            const line = lines[i];
            if (!Array.isArray(line)) continue;
            for (let j = 0; j < line.length; j++) {
                if (line[j]) points.push(line[j]);
            }
        }

        return points;
    };

    distancePlanningReplay3DMeters = (pointA, pointB) => {
        if (!pointA || !pointB) return 0;

        const lat1 = this.normalizePlanningReplay3DNumber(pointA.lat);
        const lng1 = this.normalizePlanningReplay3DNumber(pointA.lng);
        const lat2 = this.normalizePlanningReplay3DNumber(pointB.lat);
        const lng2 = this.normalizePlanningReplay3DNumber(pointB.lng);

        if (!Number.isFinite(lat1) || !Number.isFinite(lng1) || !Number.isFinite(lat2) || !Number.isFinite(lng2)) {
            return 0;
        }

        const rad = Math.PI / 180;
        const earthRadius = 6371000;
        const dLat = (lat2 - lat1) * rad;
        const dLng = (lng2 - lng1) * rad;
        const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(lat1 * rad) * Math.cos(lat2 * rad) *
            Math.sin(dLng / 2) * Math.sin(dLng / 2);
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

        return earthRadius * c;
    };

    getPlanningReplay3DProjection = (referencePoint) => {
        const refLat = referencePoint && Number.isFinite(referencePoint.lat) ? referencePoint.lat : 0;
        const refLng = referencePoint && Number.isFinite(referencePoint.lng) ? referencePoint.lng : 0;
        const rad = Math.PI / 180;
        const metersPerDegLat = 111320;
        const metersPerDegLng = 111320 * Math.cos(refLat * rad);
        const safeMetersPerDegLng = Math.abs(metersPerDegLng) < 1 ? 1 : metersPerDegLng;

        return {
            toXY: (point) => ({
                x: (point.lng - refLng) * safeMetersPerDegLng,
                y: (point.lat - refLat) * metersPerDegLat
            }),
            toLatLng: (point) => ({
                lat: refLat + (point.y / metersPerDegLat),
                lng: refLng + (point.x / safeMetersPerDegLng)
            })
        };
    };

    normalizePlanningReplay3DVector = (vector) => {
        const length = Math.sqrt((vector.x * vector.x) + (vector.y * vector.y));
        if (!Number.isFinite(length) || length <= 0.00001) return { x: 1, y: 0 };
        return { x: vector.x / length, y: vector.y / length };
    };

    getPlanningReplay3DLineDirection = (line) => {
        if (!Array.isArray(line) || line.length < 2) return { x: 1, y: 0 };

        const first = line[0];
        const last = line[line.length - 1];
        const projection = this.getPlanningReplay3DProjection(first);
        const firstXY = projection.toXY(first);
        const lastXY = projection.toXY(last);

        return this.normalizePlanningReplay3DVector({
            x: lastXY.x - firstXY.x,
            y: lastXY.y - firstXY.y
        });
    };


    getPlanningReplay3DLineLengthMeters = (line) => {
        if (!Array.isArray(line) || line.length < 2) return 0;

        let total = 0;
        for (let i = 1; i < line.length; i++) {
            total += this.distancePlanningReplay3DMeters(line[i - 1], line[i]);
        }

        return total;
    };

    getPlanningReplay3DLineCenter = (line) => {
        if (!Array.isArray(line) || line.length === 0) return null;

        let lat = 0;
        let lng = 0;
        let count = 0;

        for (let i = 0; i < line.length; i++) {
            if (!line[i]) continue;
            lat += line[i].lat;
            lng += line[i].lng;
            count++;
        }

        if (!count) return null;

        return { lat: lat / count, lng: lng / count };
    };

    getPlanningReplay3DVectorDot = (vectorA, vectorB) => {
        if (!vectorA || !vectorB) return 0;
        return (vectorA.x * vectorB.x) + (vectorA.y * vectorB.y);
    };

    orientPlanningReplay3DLineByDirection = (line, direction) => {
        if (!Array.isArray(line) || line.length < 2 || !direction) return line;

        const lineDirection = this.getPlanningReplay3DLineDirection(line);
        return this.getPlanningReplay3DVectorDot(lineDirection, direction) < 0
            ? this.reversePlanningReplay3DLine(line)
            : line;
    };

    preparePlanningReplay3DOperationalLines = (lines, referencePoint, widthMeters) => {
        if (!Array.isArray(lines)) return [];

        const candidates = [];
        const safeWidth = Number.isFinite(widthMeters) && widthMeters > 0 ? widthMeters : 30;

        for (let i = 0; i < lines.length; i++) {
            const line = lines[i];
            if (!Array.isArray(line) || line.length < 2) continue;

            const length = this.getPlanningReplay3DLineLengthMeters(line);
            const center = this.getPlanningReplay3DLineCenter(line);
            if (!center || length <= 1) continue;

            candidates.push({
                line: line,
                length: length,
                center: center,
                originalIndex: i
            });
        }

        if (candidates.length <= 1) {
            return candidates.map(item => item.line);
        }

        let longest = candidates[0];
        for (let i = 1; i < candidates.length; i++) {
            if (candidates[i].length > longest.length) longest = candidates[i];
        }

        const mainDirection = this.getPlanningReplay3DLineDirection(longest.line);
        if (!mainDirection) return candidates.map(item => item.line);

        const normalDirection = { x: -mainDirection.y, y: mainDirection.x };
        const projection = this.getPlanningReplay3DProjection(longest.center);
        const originXY = projection.toXY(longest.center);

        const getAxis = (point) => {
            const xy = projection.toXY(point);
            const delta = {
                x: xy.x - originXY.x,
                y: xy.y - originXY.y
            };

            return {
                forward: (delta.x * mainDirection.x) + (delta.y * mainDirection.y),
                lateral: (delta.x * normalDirection.x) + (delta.y * normalDirection.y)
            };
        };

        for (let i = 0; i < candidates.length; i++) {
            const line = this.orientPlanningReplay3DLineByDirection(candidates[i].line, mainDirection);
            const firstAxis = getAxis(line[0]);
            const lastAxis = getAxis(line[line.length - 1]);
            const centerAxis = getAxis(candidates[i].center);

            candidates[i].line = line;
            candidates[i].orderValue = centerAxis.lateral;
            candidates[i].forwardMin = Math.min(firstAxis.forward, lastAxis.forward);
            candidates[i].forwardMax = Math.max(firstAxis.forward, lastAxis.forward);
        }

        candidates.sort((itemA, itemB) => {
            if (itemA.orderValue === itemB.orderValue) return itemA.forwardMin - itemB.forwardMin;
            return itemA.orderValue - itemB.orderValue;
        });
        const corridorTolerance = Math.max(safeWidth * 0.55, 24);
        const groups = [];

        for (let i = 0; i < candidates.length; i++) {
            const candidate = candidates[i];
            let targetGroup = null;

            for (let j = 0; j < groups.length; j++) {
                if (Math.abs(groups[j].orderValue - candidate.orderValue) <= corridorTolerance) {
                    targetGroup = groups[j];
                    break;
                }
            }

            if (!targetGroup) {
                targetGroup = {
                    orderValue: candidate.orderValue,
                    items: []
                };
                groups.push(targetGroup);
            }

            targetGroup.items.push(candidate);

            const total = targetGroup.items.reduce((acc, item) => acc + item.orderValue, 0);
            targetGroup.orderValue = total / targetGroup.items.length;
        }

        groups.sort((groupA, groupB) => groupA.orderValue - groupB.orderValue);

        if (referencePoint && groups.length > 1) {
            const firstGroup = groups[0];
            const lastGroup = groups[groups.length - 1];
            const firstDistance = Math.min(
                this.distancePlanningReplay3DMeters(referencePoint, firstGroup.items[0].line[0]),
                this.distancePlanningReplay3DMeters(referencePoint, firstGroup.items[firstGroup.items.length - 1].line[firstGroup.items[firstGroup.items.length - 1].line.length - 1])
            );
            const lastDistance = Math.min(
                this.distancePlanningReplay3DMeters(referencePoint, lastGroup.items[0].line[0]),
                this.distancePlanningReplay3DMeters(referencePoint, lastGroup.items[lastGroup.items.length - 1].line[lastGroup.items[lastGroup.items.length - 1].line.length - 1])
            );

            if (lastDistance < firstDistance) {
                groups.reverse();
            }
        }

        const orderedLines = [];

        for (let groupIndex = 0; groupIndex < groups.length; groupIndex++) {
            const group = groups[groupIndex];
            const desiredDirection = groupIndex % 2 === 0
                ? mainDirection
                : { x: -mainDirection.x, y: -mainDirection.y };

            for (let i = 0; i < group.items.length; i++) {
                group.items[i].line = this.orientPlanningReplay3DLineByDirection(group.items[i].line, desiredDirection);

                const firstAxis = getAxis(group.items[i].line[0]);
                const lastAxis = getAxis(group.items[i].line[group.items[i].line.length - 1]);
                group.items[i].forwardStart = firstAxis.forward;
                group.items[i].forwardEnd = lastAxis.forward;
            }

            group.items.sort((itemA, itemB) => {
                return itemA.forwardStart - itemB.forwardStart;
            });

            for (let i = 0; i < group.items.length; i++) {
                orderedLines.push(group.items[i].line);
            }
        }

        return orderedLines;
    };

    offsetPlanningReplay3DPoint = (point, direction, distanceMeters) => {
        if (!point || !direction || !Number.isFinite(distanceMeters)) return point;

        const projection = this.getPlanningReplay3DProjection(point);
        const xy = projection.toXY(point);
        const dir = this.normalizePlanningReplay3DVector(direction);

        return projection.toLatLng({
            x: xy.x + (dir.x * distanceMeters),
            y: xy.y + (dir.y * distanceMeters)
        });
    };

    getPlanningReplay3DOperationLeadMeters = () => {
        const loopLength = this.getPlanningReplay3DCanonicalLength(this.state.size_h_loop);
        const loopWidth = this.getPlanningReplay3DCanonicalLength(this.state.size_loop);
        const length = Number.isFinite(loopLength) && loopLength > 0 ? loopLength : 600;
        const width = Number.isFinite(loopWidth) && loopWidth > 0 ? loopWidth : 400;
        return Math.max(55, Math.min(length * 0.24, Math.max(width * 0.42, 85), 145));
    };

    reversePlanningReplay3DLine = (line) => {
        const reversed = [];
        if (!Array.isArray(line)) return reversed;

        for (let i = line.length - 1; i >= 0; i--) {
            reversed.push(line[i]);
        }

        if (line.planningStripKey !== undefined && line.planningStripKey !== null) {
            reversed.planningStripKey = line.planningStripKey;
        }
        if (line.planningStripName !== undefined && line.planningStripName !== null) {
            reversed.planningStripName = line.planningStripName;
        }

        return reversed;
    };


    applyPlanningReplay3DLineMeta = (line, stripKey) => {
        if (!Array.isArray(line)) return line;

        if (stripKey !== undefined && stripKey !== null && stripKey !== '') {
            line.planningStripKey = stripKey;
            line.planningStripName = this.props.res.FAIXA_APP + ' ' + stripKey;
        }

        return line;
    };


    orientPlanningReplay3DLineByReference = (line, referencePoint) => {
        if (!Array.isArray(line) || line.length < 2 || !referencePoint) return line;

        const first = line[0];
        const last = line[line.length - 1];
        const distanceFirst = this.distancePlanningReplay3DMeters(referencePoint, first);
        const distanceLast = this.distancePlanningReplay3DMeters(referencePoint, last);

        return distanceLast < distanceFirst ? this.reversePlanningReplay3DLine(line) : line;
    };

    getPlanningReplay3DSelectedOut = (polygon) => {
        if (!polygon) return null;

        if (Array.isArray(polygon.out) && polygon.out.length > 0) {
            const selectedIndex = typeof polygon.selected_Out === 'number' ? polygon.selected_Out : 0;
            if (selectedIndex >= 0 && selectedIndex < polygon.out.length && polygon.out[selectedIndex]) {
                return polygon.out[selectedIndex];
            }

            if (polygon.estrategia) {
                for (let i = 0; i < polygon.out.length; i++) {
                    if (polygon.out[i] && polygon.out[i].type === polygon.estrategia) {
                        return polygon.out[i];
                    }
                }
            }

            if (typeof polygon.best_Out === 'number' && polygon.best_Out >= 0 && polygon.best_Out < polygon.out.length && polygon.out[polygon.best_Out]) {
                return polygon.out[polygon.best_Out];
            }

            for (let i = 0; i < polygon.out.length; i++) {
                if (polygon.out[i]) return polygon.out[i];
            }
        }

        if (Array.isArray(polygon.lines) && polygon.lines.length > 0) {
            const selectedIndex = typeof polygon.selected_Out === 'number' ? polygon.selected_Out : 0;
            const strategyItem = this.strategy && this.strategy[selectedIndex];
            return {
                type: polygon.estrategia || (strategyItem && strategyItem.value) || 'BACKTOBACK',
                startPath: null,
                endPath: null,
                path: null,
                fuelPoint: []
            };
        }

        return null;
    };

    getPlanningReplay3DLinesFromPolygon = (polygon, out) => {
        let lines = out && out.path ? this.getPlanningReplay3DPathLines(out.path) : [];
        if (lines && lines.length > 0) return lines;

        if (!polygon || !Array.isArray(polygon.lines) || polygon.lines.length === 0) return [];

        const selectedLineIndex = typeof polygon.selected_line === 'number' ? polygon.selected_line : 0;
        const selectedLine = polygon.lines[selectedLineIndex] || polygon.lines[0];
        const rawLines = selectedLine && Array.isArray(selectedLine.lines) ? selectedLine.lines : [];
        const output = [];

        for (let i = 0; i < rawLines.length; i++) {
            const item = rawLines[i];
            if (!item) continue;

            if (item.linhas) {
                const itemLines = this.getPlanningReplay3DPathLines(item.linhas);
                for (let j = 0; j < itemLines.length; j++) output.push(itemLines[j]);
                continue;
            }

            if (item.line) {
                const itemLines = this.getPlanningReplay3DPathLines(item.line);
                for (let j = 0; j < itemLines.length; j++) output.push(itemLines[j]);
                continue;
            }

            if (item.geometry) {
                this.addPlanningReplay3DLinesFromGeometry(item.geometry, output);
                continue;
            }

            const itemLines = this.getPlanningReplay3DPathLines(item);
            for (let j = 0; j < itemLines.length; j++) output.push(itemLines[j]);
        }

        return output.filter(line => Array.isArray(line) && line.length >= 2);
    };


    getPlanningReplay3DStrategyIndex = (polygon, out) => {
        if (polygon && typeof polygon.selected_Out === 'number' && polygon.selected_Out >= 0 && polygon.selected_Out < this.strategy.length) {
            return polygon.selected_Out;
        }

        const type = polygon && polygon.estrategia ? polygon.estrategia : (out && out.type ? out.type : '');
        if (type) {
            for (let i = 0; i < this.strategy.length; i++) {
                if (this.strategy[i] && this.strategy[i].value === type) {
                    return i;
                }
            }
        }

        return 0;
    };

    getPlanningReplay3DStrategyValue = (polygon, out) => {
        const strategyIndex = this.getPlanningReplay3DStrategyIndex(polygon, out);
        if (this.strategy[strategyIndex] && this.strategy[strategyIndex].value) {
            return this.strategy[strategyIndex].value;
        }

        return out && out.type ? out.type : 'BACKTOBACK';
    };

    getPlanningReplay3DSelectedStrategyLine = (polygon) => {
        if (!polygon || !Array.isArray(polygon.lines) || polygon.lines.length === 0) return null;

        const selectedLineIndex = typeof polygon.selected_line === 'number' ? polygon.selected_line : 0;
        return polygon.lines[selectedLineIndex] || polygon.lines[0] || null;
    };

    getPlanningReplay3DOrderedStrategyItems = (polygon, out) => {
        const selectedLine = this.getPlanningReplay3DSelectedStrategyLine(polygon);
        if (!selectedLine || !Array.isArray(selectedLine.lines) || selectedLine.lines.length === 0) {
            return [];
        }

        const strategyValue = this.getPlanningReplay3DStrategyValue(polygon, out);
        return this.getPlanningPattern(polygon, selectedLine, strategyValue).orderedLines;
    };

    getPlanningReplay3DStrategyPathLines = (polygon, out) => {
        const orderedItems = this.getPlanningReplay3DOrderedStrategyItems(polygon, out);
        const output = [];
        const width = this.getPlanningReplay3DCanonicalLength((polygon && polygon.faixa) || this.state.faixa);
        const safeWidth = Number.isFinite(width) && width > 0 ? width : 30;

        for (let i = 0; i < orderedItems.length; i++) {
            const item = orderedItems[i];
            if (!item) continue;

            let itemLines = [];
            if (item.linhas) {
                itemLines = this.getPlanningReplay3DPathLines(item.linhas);
            } else if (item.line) {
                itemLines = this.getPlanningReplay3DPathLines(item.line);
            } else if (item.geometry) {
                const geometryLines = [];
                this.addPlanningReplay3DLinesFromGeometry(item.geometry, geometryLines);
                itemLines = geometryLines;
            } else {
                itemLines = this.getPlanningReplay3DPathLines(item);
            }

            itemLines = itemLines.filter(function (line) {
                return Array.isArray(line) && line.length >= 2;
            });

            const planningStripKey = item && item.key !== undefined && item.key !== null ? item.key : null;

            if (itemLines.length > 1 && typeof this.buildPlanningReplay3DContinuousPasses === 'function') {
                const continuousPasses = this.buildPlanningReplay3DContinuousPasses(itemLines, polygon, safeWidth);
                if (continuousPasses && continuousPasses.length > 0) {
                    for (let j = 0; j < continuousPasses.length; j++) {
                        if (continuousPasses[j] && Array.isArray(continuousPasses[j].line) && continuousPasses[j].line.length >= 2) {
                            output.push(this.applyPlanningReplay3DLineMeta(continuousPasses[j].line, planningStripKey));
                        }
                    }
                    continue;
                }
            }

            if (itemLines.length > 0) {
                output.push(this.applyPlanningReplay3DLineMeta(itemLines[0], planningStripKey));
            }
        }

        return output.filter(function (line) {
            return Array.isArray(line) && line.length >= 2;
        });
    };

    getPlanningReplay3DReferencePointForBase = () => {
        const polygons = this.getPlanningReplay3DOrderedPolygons();

        for (let i = 0; i < polygons.length; i++) {
            const polygon = polygons[i];
            const out = this.getPlanningReplay3DSelectedOut(polygon);
            if (!out) continue;

            const outStart = this.normalizePlanningReplay3DCoord(out.startPath);
            if (outStart) {
                return outStart;
            }

            const lines = this.getPlanningReplay3DStrategyPathLines(polygon, out) || this.getPlanningReplay3DLinesFromPolygon(polygon, out);
            if (Array.isArray(lines) && lines.length > 0 && Array.isArray(lines[0]) && lines[0].length > 0) {
                return this.normalizePlanningReplay3DCoord(lines[0][0]);
            }
        }

        return null;
    };

    getPlanningReplay3DPointLatLng = (item) => {
        if (!item) return null;

        const lat = this.normalizePlanningReplay3DNumber(item.lat || item.latitude);
        const lng = this.normalizePlanningReplay3DNumber(item.lng || item.lon || item.longitude);

        if (Number.isFinite(lat) && Number.isFinite(lng)) {
            return { lat: lat, lng: lng, alt: null };
        }

        return null;
    };

    getPlanningReplay3DInitialFuelPoint = (referencePoint) => {
        const polygons = this.getPlanningReplay3DOrderedPolygons();
        let nearestFuelPoint = null;
        let nearestDistance = Infinity;

        for (let i = 0; i < polygons.length; i++) {
            const polygon = polygons[i];
            const out = this.getPlanningReplay3DSelectedOut(polygon);

            if (!out || !out.fuelPoint) {
                continue;
            }

            const directPoint = this.normalizePlanningReplay3DCoord(out.fuelPoint);
            if (directPoint) {
                return directPoint;
            }

            if (!Array.isArray(out.fuelPoint)) {
                const singlePoint = this.getPlanningReplay3DFuelPoint(out.fuelPoint);
                if (singlePoint) {
                    return singlePoint;
                }

                continue;
            }

            for (let j = 0; j < out.fuelPoint.length; j++) {
                const fuelPoint = this.getPlanningReplay3DFuelPoint(out.fuelPoint[j]);

                if (!fuelPoint) {
                    continue;
                }

                if (!referencePoint) {
                    return fuelPoint;
                }

                const distance = this.distancePlanningReplay3DMeters(referencePoint, fuelPoint);
                if (Number.isFinite(distance) && distance < nearestDistance) {
                    nearestDistance = distance;
                    nearestFuelPoint = fuelPoint;
                }
            }
        }

        return nearestFuelPoint;
    };

    getPlanningReplay3DNearestPoint = (items, referencePoint) => {
        if (!Array.isArray(items) || items.length === 0) return null;

        let nearestPoint = null;
        let nearestDistance = Infinity;

        for (let i = 0; i < items.length; i++) {
            const point = this.getPlanningReplay3DPointLatLng(items[i]);
            if (!point) continue;

            if (!referencePoint) {
                return point;
            }

            const distance = this.distancePlanningReplay3DMeters(referencePoint, point);

            if (Number.isFinite(distance) && distance < nearestDistance) {
                nearestDistance = distance;
                nearestPoint = point;
            }
        }

        return nearestPoint;
    };

    getPlanningReplay3DInitialBasePoint = () => {
        const referencePoint = this.getPlanningReplay3DReferencePointForBase();
        const fuelPoint = this.getPlanningReplay3DInitialFuelPoint(referencePoint);

        if (fuelPoint) {
            return fuelPoint;
        }

        const basePoint = this.getPlanningReplay3DPointLatLng(this.base);
        if (basePoint) {
            return basePoint;
        }

        const markers = Array.isArray(this.state.markers) ? this.state.markers.filter(marker => marker && marker.type === 'H') : [];
        const nearestMarker = this.getPlanningReplay3DNearestPoint(markers, referencePoint);
        if (nearestMarker) {
            return nearestMarker;
        }

        const nearestHangar = this.getPlanningReplay3DNearestPoint(this.hangars, referencePoint);
        if (nearestHangar) {
            return nearestHangar;
        }

        return null;
    };

    isPlanningReplay3DOperationalPolygon = (polygon) => {
        if (!polygon) return false;
        const type = String(polygon.type || '').trim().toUpperCase();
        return type === 'N' || type === 'POLYGON';
    };

    hasPlanningReplay3DData = () => {
        const polygons = Array.isArray(this.state.polygons) ? this.state.polygons : [];
        for (let i = 0; i < polygons.length; i++) {
            if (!this.isPlanningReplay3DOperationalPolygon(polygons[i])) continue;

            const out = this.getPlanningReplay3DSelectedOut(polygons[i]);
            const lines = this.getPlanningReplay3DLinesFromPolygon(polygons[i], out);
            if (lines && lines.length > 0) {
                return true;
            }
        }

        return false;
    };

    addPlanningReplay3DPoint = (list, point, options) => {
        if (!point) return;

        const opts = options || {};
        const lat = this.normalizePlanningReplay3DNumber(point.lat);
        const lng = this.normalizePlanningReplay3DNumber(point.lng);

        if (!Number.isFinite(lat) || !Number.isFinite(lng)) return;

        const previous = list.length > 0 ? list[list.length - 1] : null;
        const pointTelemetryType = opts.telemetryType || (opts.applicationType === 'refuel' ? 'refuel' : (!!opts.spray ? 'spray' : 'transit'));
        const pointApplicationType = opts.applicationType || (!!opts.spray ? 'app' : null);
        let pointTimeSec = Number.isFinite(opts.tSec) ? opts.tSec : 0;

        if (previous && Math.abs(previous.lat - lat) < 0.0000001 && Math.abs(previous.lng - lng) < 0.0000001 && previous.spray === !!opts.spray) {
            const sameTime = Math.abs((Number(previous.tSec) || 0) - pointTimeSec) < 0.0001;
            const sameTelemetryType = (previous.telemetryType || '') === (pointTelemetryType || '');
            const sameApplicationType = (previous.applicationType || null) === (pointApplicationType || null);
            const sameFuelLevel = (!Number.isFinite(previous.fuelLevel) && !Number.isFinite(opts.fuelLevel)) ||
                (Number.isFinite(previous.fuelLevel) && Number.isFinite(opts.fuelLevel) && Math.abs(previous.fuelLevel - opts.fuelLevel) < 0.0001);

            if (sameTime && sameTelemetryType && sameApplicationType && sameFuelLevel) {
                return;
            }

            if (sameTime) {
                pointTimeSec += 0.05;
            }
        }

        list.push({
            lat: lat,
            lng: lng,
            alt: Number.isFinite(opts.alt) ? opts.alt : 6,
            tSec: pointTimeSec,
            spray: !!opts.spray,
            width: Number.isFinite(opts.width) ? opts.width : 30,
            speed: Number.isFinite(opts.speed) ? opts.speed : null,
            flow: Number.isFinite(opts.flow) ? opts.flow : null,
            fluxo: Number.isFinite(opts.flow) ? opts.flow : null,
            fuelLevel: Number.isFinite(opts.fuelLevel) ? opts.fuelLevel : null,
            fuelCapacity: Number.isFinite(opts.fuelCapacity) ? opts.fuelCapacity : null,
            fuelPercent: Number.isFinite(opts.fuelPercent) ? opts.fuelPercent : null,
            refuelIndex: Number.isFinite(opts.refuelIndex) ? opts.refuelIndex : null,
            refuelCount: Number.isFinite(opts.refuelCount) ? opts.refuelCount : null,
            name: opts.name || '',
            applicationType: pointApplicationType,
            telemetryType: pointTelemetryType,
            spraySource: opts.spraySource || (!!opts.spray ? 'explicit_track' : 'none'),
            planningStripKey: opts.planningStripKey !== undefined && opts.planningStripKey !== null ? opts.planningStripKey : null,
            planningStripName: opts.planningStripName || null,
            shotNumber: Number.isFinite(opts.shotNumber) ? opts.shotNumber : null,
            balloonMeasureWidthMeters: Number.isFinite(opts.balloonMeasureWidthMeters) ? opts.balloonMeasureWidthMeters : null,
            balloonMeasureLengthMeters: Number.isFinite(opts.balloonMeasureLengthMeters) ? opts.balloonMeasureLengthMeters : null,
            balloonMeasureWidthMaxMeters: Number.isFinite(opts.balloonMeasureWidthMaxMeters) ? opts.balloonMeasureWidthMaxMeters : null,
            balloonMeasureLengthMaxMeters: Number.isFinite(opts.balloonMeasureLengthMaxMeters) ? opts.balloonMeasureLengthMaxMeters : null
        });
    };

    appendPlanningReplay3DTransit = (timeline, fromPoint, toPoint, currentTime, speedKmH, altitude, width, name) => {
        if (!fromPoint || !toPoint) return currentTime;

        const safeSpeed = Number.isFinite(speedKmH) && speedKmH > 0 ? speedKmH : 110;
        const distance = this.distancePlanningReplay3DMeters(fromPoint, toPoint);
        const duration = Math.max(2, distance / (safeSpeed / 3.6));
        const startTime = currentTime;
        const steps = Math.max(1, Math.min(30, Math.ceil(distance / 300)));

        for (let i = 1; i <= steps; i++) {
            const factor = i / steps;
            const point = {
                lat: fromPoint.lat + ((toPoint.lat - fromPoint.lat) * factor),
                lng: fromPoint.lng + ((toPoint.lng - fromPoint.lng) * factor)
            };
            this.addPlanningReplay3DPoint(timeline, point, {
                tSec: startTime + (duration * factor),
                spray: false,
                alt: altitude,
                width: width,
                speed: safeSpeed,
                name: name || this.props.res.TRANSLADO,
                telemetryType: name === this.props.res.ABASTECIMENTO ? 'refuel' : 'transit',
                applicationType: name === this.props.res.ABASTECIMENTO ? 'refuel' : null,
                spraySource: 'none'
            });
        }

        return startTime + duration;
    };

    appendPlanningReplay3DTransitWithAltitude = (timeline, fromPoint, toPoint, currentTime, speedKmH, startAltitude, endAltitude, width, name) => {
        if (!fromPoint || !toPoint) return currentTime;

        const safeSpeed = Number.isFinite(speedKmH) && speedKmH > 0 ? speedKmH : 110;
        const distance = this.distancePlanningReplay3DMeters(fromPoint, toPoint);
        const duration = Math.max(2, distance / (safeSpeed / 3.6));
        const startTime = currentTime;
        const steps = Math.max(4, Math.min(60, Math.ceil(distance / 220)));
        const safeStartAltitude = Number.isFinite(startAltitude) && startAltitude > 0 ? startAltitude : 6;
        const safeEndAltitude = Number.isFinite(endAltitude) && endAltitude > 0 ? endAltitude : safeStartAltitude;

        for (let i = 1; i <= steps; i++) {
            const factor = i / steps;
            const smoothFactor = factor * factor * (3 - (2 * factor));
            const point = {
                lat: fromPoint.lat + ((toPoint.lat - fromPoint.lat) * factor),
                lng: fromPoint.lng + ((toPoint.lng - fromPoint.lng) * factor)
            };

            this.addPlanningReplay3DPoint(timeline, point, {
                tSec: startTime + (duration * factor),
                spray: false,
                alt: safeStartAltitude + ((safeEndAltitude - safeStartAltitude) * smoothFactor),
                width: width,
                speed: safeSpeed,
                name: name || this.props.res.TRANSLADO,
                telemetryType: 'transit',
                applicationType: null,
                spraySource: 'none'
            });
        }

        return startTime + duration;
    };

    appendPlanningReplay3DSmoothTransitWithAltitude = (timeline, fromPoint, toPoint, fromDirection, toDirection, currentTime, speedKmH, startAltitude, endAltitude, width, name) => {
        if (!fromPoint || !toPoint) return currentTime;

        const safeSpeed = Number.isFinite(speedKmH) && speedKmH > 0 ? speedKmH : 110;
        const distance = this.distancePlanningReplay3DMeters(fromPoint, toPoint);

        if (!Number.isFinite(distance) || distance <= 1) return currentTime;

        const directDirection = this.getPlanningReplay3DPointDirection(fromPoint, toPoint, fromDirection || toDirection || { x: 1, y: 0 });
        const dirFrom = this.normalizePlanningReplay3DVector(fromDirection || directDirection);
        const dirTo = this.normalizePlanningReplay3DVector(toDirection || directDirection);
        const safeStartAltitude = Number.isFinite(startAltitude) && startAltitude > 0 ? startAltitude : 6;
        const safeEndAltitude = Number.isFinite(endAltitude) && endAltitude > 0 ? endAltitude : safeStartAltitude;

        if (!dirFrom || !dirTo || distance < Math.max(60, (Number.isFinite(width) && width > 0 ? width : 30) * 2.5)) {
            return this.appendPlanningReplay3DTransitWithAltitude(
                timeline,
                fromPoint,
                toPoint,
                currentTime,
                speedKmH,
                safeStartAltitude,
                safeEndAltitude,
                width,
                name
            );
        }

        const safeWidth = Number.isFinite(width) && width > 0 ? width : 30;
        const projection = this.getPlanningReplay3DProjection(fromPoint);
        const p0 = projection.toXY(fromPoint);
        const p3 = projection.toXY(toPoint);
        const directionDot = Math.max(-1, Math.min(1, (dirFrom.x * dirTo.x) + (dirFrom.y * dirTo.y)));
        const turnAngleFactor = (1 - directionDot) / 2;
        const handleDistance = Math.max(
            safeWidth * (7.0 + (turnAngleFactor * 7.5)),
            Math.min(distance * (0.62 + (turnAngleFactor * 0.20)), Math.max(230, safeWidth * (22 + (turnAngleFactor * 11))))
        );
        const p1 = {
            x: p0.x + (dirFrom.x * handleDistance),
            y: p0.y + (dirFrom.y * handleDistance)
        };
        const p2 = {
            x: p3.x - (dirTo.x * handleDistance),
            y: p3.y - (dirTo.y * handleDistance)
        };

        const bezierPoint = (a, b, c, d, t) => {
            const inv = 1 - t;
            const inv2 = inv * inv;
            const inv3 = inv2 * inv;
            const t2 = t * t;
            const t3 = t2 * t;

            return {
                x: (inv3 * a.x) + (3 * inv2 * t * b.x) + (3 * inv * t2 * c.x) + (t3 * d.x),
                y: (inv3 * a.y) + (3 * inv2 * t * b.y) + (3 * inv * t2 * c.y) + (t3 * d.y)
            };
        };

        const curvePoints = [];
        const steps = Math.max(42, Math.min(160, Math.ceil(distance / 14)));

        for (let i = 1; i <= steps; i++) {
            curvePoints.push(projection.toLatLng(bezierPoint(p0, p1, p2, p3, i / steps)));
        }

        let totalDistance = 0;
        let previousPoint = fromPoint;
        for (let i = 0; i < curvePoints.length; i++) {
            totalDistance += this.distancePlanningReplay3DMeters(previousPoint, curvePoints[i]);
            previousPoint = curvePoints[i];
        }

        const duration = Math.max(2, totalDistance / (safeSpeed / 3.6));
        const startTime = currentTime;
        let consumedDistance = 0;
        previousPoint = fromPoint;

        for (let i = 0; i < curvePoints.length; i++) {
            const point = curvePoints[i];
            consumedDistance += this.distancePlanningReplay3DMeters(previousPoint, point);
            previousPoint = point;
            const factor = consumedDistance / Math.max(totalDistance, 1);
            const smoothFactor = factor * factor * (3 - (2 * factor));

            this.addPlanningReplay3DPoint(timeline, point, {
                tSec: startTime + (duration * factor),
                spray: false,
                alt: safeStartAltitude + ((safeEndAltitude - safeStartAltitude) * smoothFactor),
                width: width,
                speed: safeSpeed,
                name: name || this.props.res.TRANSLADO,
                telemetryType: 'transit',
                applicationType: null,
                spraySource: 'none'
            });
        }

        return startTime + duration;
    };

    appendPlanningReplay3DSmoothTransit = (timeline, fromPoint, toPoint, fromDirection, toDirection, currentTime, speedKmH, altitude, width, name) => {
        if (!fromPoint || !toPoint) return currentTime;

        const safeSpeed = Number.isFinite(speedKmH) && speedKmH > 0 ? speedKmH : 110;
        const distance = this.distancePlanningReplay3DMeters(fromPoint, toPoint);

        if (!Number.isFinite(distance) || distance <= 1) return currentTime;

        const directDirection = this.getPlanningReplay3DPointDirection(fromPoint, toPoint, fromDirection || toDirection || { x: 1, y: 0 });
        const dirFrom = this.normalizePlanningReplay3DVector(fromDirection || directDirection);
        const dirTo = this.normalizePlanningReplay3DVector(toDirection || directDirection);

        if (!dirFrom || !dirTo || distance < Math.max(60, (Number.isFinite(width) && width > 0 ? width : 30) * 2.5)) {
            return this.appendPlanningReplay3DTransit(
                timeline,
                fromPoint,
                toPoint,
                currentTime,
                speedKmH,
                altitude,
                width,
                name
            );
        }

        const safeWidth = Number.isFinite(width) && width > 0 ? width : 30;
        const projection = this.getPlanningReplay3DProjection(fromPoint);
        const p0 = projection.toXY(fromPoint);
        const p3 = projection.toXY(toPoint);
        const directionDot = Math.max(-1, Math.min(1, (dirFrom.x * dirTo.x) + (dirFrom.y * dirTo.y)));
        const turnAngleFactor = (1 - directionDot) / 2;
        const handleDistance = Math.max(
            safeWidth * (4.8 + (turnAngleFactor * 5.5)),
            Math.min(distance * (0.50 + (turnAngleFactor * 0.18)), Math.max(150, safeWidth * (15 + (turnAngleFactor * 9))))
        );
        const p1 = {
            x: p0.x + (dirFrom.x * handleDistance),
            y: p0.y + (dirFrom.y * handleDistance)
        };
        const p2 = {
            x: p3.x - (dirTo.x * handleDistance),
            y: p3.y - (dirTo.y * handleDistance)
        };

        const bezierPoint = (a, b, c, d, t) => {
            const inv = 1 - t;
            const inv2 = inv * inv;
            const inv3 = inv2 * inv;
            const t2 = t * t;
            const t3 = t2 * t;

            return {
                x: (inv3 * a.x) + (3 * inv2 * t * b.x) + (3 * inv * t2 * c.x) + (t3 * d.x),
                y: (inv3 * a.y) + (3 * inv2 * t * b.y) + (3 * inv * t2 * c.y) + (t3 * d.y)
            };
        };

        const curvePoints = [];
        const steps = Math.max(18, Math.min(90, Math.ceil(distance / 22)));

        for (let i = 1; i <= steps; i++) {
            curvePoints.push(projection.toLatLng(bezierPoint(p0, p1, p2, p3, i / steps)));
        }

        let totalDistance = 0;
        let previousPoint = fromPoint;
        for (let i = 0; i < curvePoints.length; i++) {
            totalDistance += this.distancePlanningReplay3DMeters(previousPoint, curvePoints[i]);
            previousPoint = curvePoints[i];
        }

        const duration = Math.max(2, totalDistance / (safeSpeed / 3.6));
        const startTime = currentTime;
        let consumedDistance = 0;
        previousPoint = fromPoint;

        for (let i = 0; i < curvePoints.length; i++) {
            const point = curvePoints[i];
            consumedDistance += this.distancePlanningReplay3DMeters(previousPoint, point);
            previousPoint = point;

            this.addPlanningReplay3DPoint(timeline, point, {
                tSec: startTime + (duration * (consumedDistance / Math.max(totalDistance, 1))),
                spray: false,
                alt: altitude,
                width: width,
                speed: safeSpeed,
                name: name || this.props.res.TRANSLADO,
                telemetryType: 'transit',
                applicationType: null,
                spraySource: 'none'
            });
        }

        return startTime + duration;
    };


    appendPlanningReplay3DInterAreaBalloon = (timeline, fromPoint, toPoint, fromDirection, toDirection, currentTime, speedKmH, altitude, width, name) => {
        if (!fromPoint || !toPoint) return currentTime;

        if (!fromDirection || !toDirection) {
            return this.appendPlanningReplay3DTransit(
                timeline,
                fromPoint,
                toPoint,
                currentTime,
                speedKmH,
                altitude,
                width,
                name
            );
        }

        const safeSpeed = Number.isFinite(speedKmH) && speedKmH > 0 ? speedKmH : 110;
        const distance = this.distancePlanningReplay3DMeters(fromPoint, toPoint);

        if (!Number.isFinite(distance) || distance <= 1) return currentTime;

        const projection = this.getPlanningReplay3DProjection(fromPoint);
        const p0 = projection.toXY(fromPoint);
        const p3 = projection.toXY(toPoint);
        const dirFrom = this.normalizePlanningReplay3DVector(fromDirection);
        const dirTo = this.normalizePlanningReplay3DVector(toDirection);
        const controlDistance = Math.max(160, Math.min(distance * 0.46, 620));
        const p1 = {
            x: p0.x + (dirFrom.x * controlDistance),
            y: p0.y + (dirFrom.y * controlDistance)
        };
        const p2 = {
            x: p3.x - (dirTo.x * controlDistance),
            y: p3.y - (dirTo.y * controlDistance)
        };

        const curvePoints = [];
        const steps = Math.max(56, Math.min(180, Math.ceil(distance / 30)));

        for (let i = 1; i <= steps; i++) {
            const t = i / steps;
            const inv = 1 - t;
            const xy = {
                x: (inv * inv * inv * p0.x) +
                    (3 * inv * inv * t * p1.x) +
                    (3 * inv * t * t * p2.x) +
                    (t * t * t * p3.x),
                y: (inv * inv * inv * p0.y) +
                    (3 * inv * inv * t * p1.y) +
                    (3 * inv * t * t * p2.y) +
                    (t * t * t * p3.y)
            };

            curvePoints.push(projection.toLatLng(xy));
        }

        let totalDistance = 0;
        let previousPoint = fromPoint;

        for (let i = 0; i < curvePoints.length; i++) {
            totalDistance += this.distancePlanningReplay3DMeters(previousPoint, curvePoints[i]);
            previousPoint = curvePoints[i];
        }

        const duration = Math.max(8, totalDistance / (safeSpeed / 3.6));
        const startTime = currentTime;
        let consumedDistance = 0;
        previousPoint = fromPoint;

        for (let i = 0; i < curvePoints.length; i++) {
            const point = curvePoints[i];
            consumedDistance += this.distancePlanningReplay3DMeters(previousPoint, point);
            previousPoint = point;

            this.addPlanningReplay3DPoint(timeline, point, {
                tSec: startTime + (duration * (consumedDistance / Math.max(totalDistance, 1))),
                spray: false,
                alt: altitude,
                width: width,
                speed: safeSpeed,
                name: name || this.props.res.BALAO_ENTRE_AREAS,
                telemetryType: 'balloon',
                applicationType: null,
                spraySource: 'none',
                balloonMeasureWidthMeters: null,
                balloonMeasureLengthMeters: null
            });
        }

        return startTime + duration;
    };


    getPlanningReplay3DPolygonBoundary = (polygon) => {
        const layerBoundary = [];
        if (polygon && polygon.layer && typeof polygon.layer.getLatLngs === 'function') {
            const latLngs = polygon.layer.getLatLngs();
            const rawLayerPoints = Array.isArray(latLngs) && Array.isArray(latLngs[0]) ? latLngs[0] : latLngs;

            if (Array.isArray(rawLayerPoints)) {
                for (let i = 0; i < rawLayerPoints.length; i++) {
                    const rawPoint = rawLayerPoints[i];
                    const lat = this.normalizePlanningReplay3DNumber(rawPoint && rawPoint.lat);
                    const lng = this.normalizePlanningReplay3DNumber(rawPoint && rawPoint.lng);

                    if (Number.isFinite(lat) && Number.isFinite(lng)) {
                        layerBoundary.push({ lat: lat, lng: lng });
                    }
                }
            }

            if (layerBoundary.length >= 3) return layerBoundary;
        }

        if (!polygon || !polygon.points) return [];

        let parsed = polygon.points;
        if (typeof parsed === 'string') {
            try {
                parsed = JSON.parse(parsed);
            } catch (error) {
                return [];
            }
        }

        if (!Array.isArray(parsed)) return [];

        const boundary = [];
        for (let i = 0; i < parsed.length; i++) {
            let point = this.normalizePlanningReplay3DCoord(parsed[i]);

            if (Array.isArray(parsed[i]) && parsed[i].length >= 2) {
                const first = this.normalizePlanningReplay3DNumber(parsed[i][0]);
                const second = this.normalizePlanningReplay3DNumber(parsed[i][1]);

                if (Number.isFinite(first) && Number.isFinite(second)) {
                    const asLeaflet = { lat: first, lng: second };
                    const asGeoJson = { lat: second, lng: first };

                    if (Math.abs(first) <= 90 && Math.abs(second) <= 180) {
                        point = asLeaflet;
                    } else if (Math.abs(second) <= 90 && Math.abs(first) <= 180) {
                        point = asGeoJson;
                    }
                }
            }

            if (point) boundary.push(point);
        }

        if (boundary.length > 1) {
            const first = boundary[0];
            const last = boundary[boundary.length - 1];
            if (Math.abs(first.lat - last.lat) < 0.0000001 && Math.abs(first.lng - last.lng) < 0.0000001) {
                boundary.pop();
            }
        }

        return boundary;
    };

    isPlanningReplay3DPointInsideBoundary = (point, boundary) => {
        if (!point || !Array.isArray(boundary) || boundary.length < 3) return true;

        const x = this.normalizePlanningReplay3DNumber(point.lng);
        const y = this.normalizePlanningReplay3DNumber(point.lat);
        if (!Number.isFinite(x) || !Number.isFinite(y)) return false;

        let inside = false;

        for (let i = 0, j = boundary.length - 1; i < boundary.length; j = i++) {
            const xi = this.normalizePlanningReplay3DNumber(boundary[i].lng);
            const yi = this.normalizePlanningReplay3DNumber(boundary[i].lat);
            const xj = this.normalizePlanningReplay3DNumber(boundary[j].lng);
            const yj = this.normalizePlanningReplay3DNumber(boundary[j].lat);

            if (!Number.isFinite(xi) || !Number.isFinite(yi) || !Number.isFinite(xj) || !Number.isFinite(yj)) {
                continue;
            }

            const intersects = ((yi > y) !== (yj > y)) &&
                (x < ((xj - xi) * (y - yi) / ((yj - yi) || 0.0000000001)) + xi);

            if (intersects) inside = !inside;
        }

        return inside;
    };

    densifyPlanningReplay3DLine = (line, spacingMeters) => {
        if (!Array.isArray(line) || line.length < 2) return Array.isArray(line) ? line : [];

        const safeSpacing = Number.isFinite(spacingMeters) && spacingMeters > 0 ? spacingMeters : 15;
        const output = [];

        for (let i = 0; i < line.length; i++) {
            const current = line[i];
            if (!current) continue;

            if (i === 0) {
                output.push(current);
                continue;
            }

            const previous = line[i - 1];
            const distance = this.distancePlanningReplay3DMeters(previous, current);
            const steps = Math.max(1, Math.ceil(distance / safeSpacing));

            for (let step = 1; step <= steps; step++) {
                const factor = step / steps;
                output.push({
                    lat: previous.lat + ((current.lat - previous.lat) * factor),
                    lng: previous.lng + ((current.lng - previous.lng) * factor)
                });
            }
        }

        return output;
    };

    clipPlanningReplay3DLineToPolygonSegments = (line, polygon, widthMeters) => {
        if (!Array.isArray(line) || line.length < 2) return [];

        const boundary = this.getPlanningReplay3DPolygonBoundary(polygon);
        if (!boundary || boundary.length < 3) return [line];

        const safeWidth = Number.isFinite(widthMeters) && widthMeters > 0 ? widthMeters : 30;
        const sampledLine = this.densifyPlanningReplay3DLine(line, Math.max(6, Math.min(18, safeWidth * 0.28)));
        const segments = [];
        let currentSegment = [];

        for (let i = 0; i < sampledLine.length; i++) {
            const point = sampledLine[i];
            const inside = this.isPlanningReplay3DPointInsideBoundary(point, boundary);

            if (inside) {
                currentSegment.push(point);
            } else if (currentSegment.length > 0) {
                segments.push(currentSegment);
                currentSegment = [];
            }
        }

        if (currentSegment.length > 0) {
            segments.push(currentSegment);
        }

        const validSegments = [];
        for (let i = 0; i < segments.length; i++) {
            const segment = segments[i];
            const segmentLength = this.getPlanningReplay3DLineLengthMeters(segment);
            if (Array.isArray(segment) && segment.length >= 2 && segmentLength > Math.max(10, safeWidth * 0.8)) {
                validSegments.push(segment);
            }
        }

        return validSegments;
    };

    clipPlanningReplay3DLineToPolygon = (line, polygon, widthMeters) => {
        const segments = this.clipPlanningReplay3DLineToPolygonSegments(line, polygon, widthMeters);
        if (!segments || !segments.length) return [];

        let bestSegment = segments[0];
        let bestLength = this.getPlanningReplay3DLineLengthMeters(bestSegment);

        for (let i = 1; i < segments.length; i++) {
            const segmentLength = this.getPlanningReplay3DLineLengthMeters(segments[i]);
            if (segmentLength > bestLength) {
                bestSegment = segments[i];
                bestLength = segmentLength;
            }
        }

        return bestSegment || [];
    };

    trimPlanningReplay3DApplicationLine = (line, widthMeters) => {
        if (!Array.isArray(line) || line.length < 2) return line;

        const safeWidth = Number.isFinite(widthMeters) && widthMeters > 0 ? widthMeters : 30;
        const leadTrimMeters = Math.max(8, Math.min(safeWidth * 0.35, 28));
        const length = this.getPlanningReplay3DLineLengthMeters(line);

        if (!Number.isFinite(length) || length <= (leadTrimMeters * 2.5)) {
            return line;
        }

        const projection = this.getPlanningReplay3DProjection(line[0]);
        const points = [];

        for (let i = 0; i < line.length; i++) {
            const xy = projection.toXY(line[i]);
            points.push({
                point: line[i],
                x: xy.x,
                y: xy.y,
                distance: 0
            });
        }

        let total = 0;
        for (let i = 1; i < points.length; i++) {
            const dx = points[i].x - points[i - 1].x;
            const dy = points[i].y - points[i - 1].y;
            total += Math.sqrt((dx * dx) + (dy * dy));
            points[i].distance = total;
        }

        const startDistance = leadTrimMeters;
        const endDistance = total - leadTrimMeters;
        const output = [];

        const interpolateAtDistance = (distanceValue) => {
            if (distanceValue <= 0) return line[0];
            if (distanceValue >= total) return line[line.length - 1];

            for (let i = 1; i < points.length; i++) {
                if (points[i].distance < distanceValue) continue;

                const prev = points[i - 1];
                const curr = points[i];
                const segmentLength = curr.distance - prev.distance;
                const factor = segmentLength > 0 ? (distanceValue - prev.distance) / segmentLength : 0;

                return projection.toLatLng({
                    x: prev.x + ((curr.x - prev.x) * factor),
                    y: prev.y + ((curr.y - prev.y) * factor)
                });
            }

            return line[line.length - 1];
        };

        output.push(interpolateAtDistance(startDistance));

        for (let i = 1; i < points.length - 1; i++) {
            if (points[i].distance > startDistance && points[i].distance < endDistance) {
                output.push(line[i]);
            }
        }

        output.push(interpolateAtDistance(endDistance));

        return output.length >= 2 ? output : line;
    };

    isPlanningReplay3DContinuationLine = (fromPoint, currentDirection, toPoint, nextDirection, widthMeters) => {
        if (!fromPoint || !toPoint || !currentDirection || !nextDirection) return false;

        const projection = this.getPlanningReplay3DProjection(fromPoint);
        const fromXY = projection.toXY(fromPoint);
        const toXY = projection.toXY(toPoint);
        const dirA = this.normalizePlanningReplay3DVector(currentDirection);
        const dirB = this.normalizePlanningReplay3DVector(nextDirection);
        const safeWidth = Number.isFinite(widthMeters) && widthMeters > 0 ? widthMeters : 30;

        const sameDirectionDot = (dirA.x * dirB.x) + (dirA.y * dirB.y);
        if (sameDirectionDot < 0.94) return false;

        const delta = {
            x: toXY.x - fromXY.x,
            y: toXY.y - fromXY.y
        };
        const normal = { x: -dirA.y, y: dirA.x };
        const lateralDistance = Math.abs((delta.x * normal.x) + (delta.y * normal.y));
        const forwardDistance = (delta.x * dirA.x) + (delta.y * dirA.y);
        return lateralDistance <= Math.max(safeWidth * 1.10, 32) &&
            forwardDistance >= -(safeWidth * 1.20) &&
            forwardDistance <= Math.max(safeWidth * 18, 850);
    };

    getPlanningReplay3DFlowForPolygon = (polygon) => {
        const polygonFlow = this.getPlanningReplay3DCanonicalFlow(polygon && polygon.fluxo, polygon && polygon.aplicacao);
        if (Number.isFinite(polygonFlow) && polygonFlow > 0) return polygonFlow;

        const stateFlow = this.getPlanningReplay3DCanonicalFlow(this.state.fluxo);
        return Number.isFinite(stateFlow) && stateFlow > 0 ? stateFlow : null;
    };

    getPlanningReplay3DFuelCapacity = () => {
        const capacity = this.getPlanningReplay3DCanonicalVolume(this.state.carga);
        return Number.isFinite(capacity) && capacity > 0 ? capacity : null;
    };

    getPlanningReplay3DRefuelMinutes = () => {
        const minutes = this.normalizePlanningReplay3DNumber(this.state.r_time);
        return Number.isFinite(minutes) && minutes > 0 ? minutes : 0;
    };

    getPlanningReplay3DRefuelGroundAltitude = () => {
        return 0.5;
    };

    getPlanningReplay3DFuelStateOptions = (fuelState) => {
        if (!fuelState || !Number.isFinite(fuelState.capacity) || fuelState.capacity <= 0) {
            return {};
        }

        const level = Number.isFinite(fuelState.level) ? Math.max(0, Math.min(fuelState.capacity, fuelState.level)) : fuelState.capacity;

        return {
            fuelLevel: level,
            fuelCapacity: fuelState.capacity,
            fuelPercent: fuelState.capacity > 0 ? (level / fuelState.capacity) * 100 : null,
            refuelIndex: fuelState.refuelIndex || 0,
            refuelCount: fuelState.refuelCount || 0
        };
    };

    getPlanningReplay3DPointDirection = (fromPoint, toPoint, fallbackDirection) => {
        if (!fromPoint || !toPoint) {
            return this.normalizePlanningReplay3DVector(fallbackDirection || { x: 1, y: 0 });
        }

        const projection = this.getPlanningReplay3DProjection(fromPoint);
        const fromXY = projection.toXY(fromPoint);
        const toXY = projection.toXY(toPoint);
        const direction = {
            x: toXY.x - fromXY.x,
            y: toXY.y - fromXY.y
        };

        if (Math.abs(direction.x) < 0.0001 && Math.abs(direction.y) < 0.0001) {
            return this.normalizePlanningReplay3DVector(fallbackDirection || { x: 1, y: 0 });
        }

        return this.normalizePlanningReplay3DVector(direction);
    };

    getPlanningReplay3DRequiredFuelForLine = (estimatedConsumption, fuelState) => {
        const safeConsumption = Number.isFinite(estimatedConsumption) && estimatedConsumption > 0 ? estimatedConsumption : 0;

        return safeConsumption;
    };

    getPlanningReplay3DConfiguredLoopLength = (width) => {
        const loopLength = this.getPlanningReplay3DCanonicalLength(this.state.size_h_loop);
        const fallbackLoopWidth = this.getPlanningReplay3DCanonicalLength(this.state.size_loop);
        const safeWidth = Number.isFinite(width) && width > 0 ? width : 30;

        if (Number.isFinite(loopLength) && loopLength > 0) {
            return loopLength;
        }

        if (Number.isFinite(fallbackLoopWidth) && fallbackLoopWidth > 0) {
            return fallbackLoopWidth;
        }

        return Math.max(240, safeWidth * 8);
    };

    propagatePlanningReplay3DFuelState = (timeline, fuelState) => {
        if (!Array.isArray(timeline) || !fuelState || !Number.isFinite(fuelState.capacity) || fuelState.capacity <= 0) {
            return timeline;
        }

        let lastLevel = fuelState.capacity;
        let lastCapacity = fuelState.capacity;
        let lastPercent = 100;
        let lastRefuelIndex = 0;
        let lastRefuelCount = 0;

        for (let i = 0; i < timeline.length; i++) {
            const item = timeline[i];
            if (!item) continue;

            if (Number.isFinite(item.fuelCapacity) && item.fuelCapacity > 0) {
                lastCapacity = item.fuelCapacity;
            }

            if (Number.isFinite(item.fuelLevel)) {
                lastLevel = Math.max(0, Math.min(lastCapacity, item.fuelLevel));
            }

            if (Number.isFinite(item.fuelPercent)) {
                lastPercent = Math.max(0, Math.min(100, item.fuelPercent));
            } else if (Number.isFinite(lastLevel) && Number.isFinite(lastCapacity) && lastCapacity > 0) {
                lastPercent = (lastLevel / lastCapacity) * 100;
            }

            if (Number.isFinite(item.refuelIndex)) {
                lastRefuelIndex = item.refuelIndex;
            }

            if (Number.isFinite(item.refuelCount)) {
                lastRefuelCount = item.refuelCount;
            }

            item.fuelCapacity = lastCapacity;
            item.fuelLevel = lastLevel;
            item.fuelPercent = lastPercent;
            item.refuelIndex = lastRefuelIndex;
            item.refuelCount = lastRefuelCount;
        }

        return timeline;
    };

    estimatePlanningReplay3DApplicationConsumption = (line, polygon, speedKmH, width) => {
        if (!Array.isArray(line) || line.length < 2) return 0;

        const flow = this.getPlanningReplay3DFlowForPolygon(polygon);
        if (!Number.isFinite(flow) || flow <= 0) return 0;

        const safeWidth = Number.isFinite(width) && width > 0 ? width : 30;
        const effectiveApplicationWidth = Math.max(1, safeWidth);
        const boundary = this.getPlanningReplay3DPolygonBoundary(polygon);
        const sampleSpacingMeters = Math.max(10, Math.min(22, safeWidth * 0.30));
        const sampledLine = this.densifyPlanningReplay3DLine(line, sampleSpacingMeters);

        if (!Array.isArray(sampledLine) || sampledLine.length < 2) return 0;

        let previousPoint = sampledLine[0];
        let appliedAreaM2 = 0;

        for (let i = 1; i < sampledLine.length; i++) {
            const point = sampledLine[i];
            if (!point) continue;

            const inside = boundary && boundary.length >= 3
                ? this.isPlanningReplay3DPointInsideBoundary(point, boundary)
                : true;

            if (inside) {
                const distance = this.distancePlanningReplay3DMeters(previousPoint, point);
                if (Number.isFinite(distance) && distance > 0) {
                    appliedAreaM2 += distance * effectiveApplicationWidth;
                }
            }

            previousPoint = point;
        }

        return Math.max(0, flow * (appliedAreaM2 / 10000));
    };

    appendPlanningReplay3DRefuelWait = (timeline, point, currentTime, altitude, width, fuelState, name) => {
        if (!point || !fuelState || !Number.isFinite(fuelState.capacity) || fuelState.capacity <= 0) {
            return currentTime;
        }

        const waitMinutes = this.getPlanningReplay3DRefuelMinutes();
        const configuredDuration = this.normalizePlanningReplay3DNumber(fuelState.refuelDurationSec);
        const duration = Number.isFinite(configuredDuration) && configuredDuration >= 0
            ? configuredDuration
            : Math.max(0, waitMinutes * 60);
        const startTime = currentTime;
        const refuelAltitude = this.getPlanningReplay3DRefuelGroundAltitude();

        fuelState.refuelCount = (fuelState.refuelCount || 0) + 1;
        fuelState.refuelIndex = fuelState.refuelCount;

        this.addPlanningReplay3DPoint(timeline, point, Object.assign({
            tSec: startTime,
            spray: false,
            alt: refuelAltitude,
            width: width,
            speed: 0,
            name: name || this.props.res.INICIO_ABASTECIMENTO,
            telemetryType: 'refuel',
            applicationType: 'refuel',
            spraySource: 'none'
        }, this.getPlanningReplay3DFuelStateOptions(fuelState)));

        if (duration > 0) {
            const holdSteps = 4;
            for (let i = 1; i < holdSteps; i++) {
                this.addPlanningReplay3DPoint(timeline, point, Object.assign({
                    tSec: startTime + (duration * (i / holdSteps)),
                    spray: false,
                    alt: refuelAltitude,
                    width: width,
                    speed: 0,
                    name: name || this.props.res.ABASTECENDO,
                    telemetryType: 'refuel',
                    applicationType: 'refuel',
                    spraySource: 'none'
                }, this.getPlanningReplay3DFuelStateOptions(fuelState)));
            }
        }

        fuelState.level = fuelState.capacity;

        this.addPlanningReplay3DPoint(timeline, point, Object.assign({
            tSec: startTime + duration,
            spray: false,
            alt: refuelAltitude,
            width: width,
            speed: 0,
            name: name || this.props.res.FIM_ABASTECIMENTO,
            telemetryType: 'refuel',
            applicationType: 'refuel',
            spraySource: 'none'
        }, this.getPlanningReplay3DFuelStateOptions(fuelState)));

        return startTime + duration;
    };


    appendPlanningReplay3DRefuelExitTurn = (timeline, fromPoint, toPoint, currentDirection, targetDirection, currentTime, speedKmH, altitude, width, name) => {
        if (!fromPoint || !toPoint) return currentTime;

        const safeSpeed = Number.isFinite(speedKmH) && speedKmH > 0 ? speedKmH : 110;
        const safeWidth = Number.isFinite(width) && width > 0 ? width : 30;
        const projection = this.getPlanningReplay3DProjection(fromPoint);
        const startXY = projection.toXY(fromPoint);
        const endXY = projection.toXY(toPoint);
        const startDirection = this.normalizePlanningReplay3DVector(currentDirection || targetDirection || { x: 1, y: 0 });
        const endDirection = this.normalizePlanningReplay3DVector(targetDirection || currentDirection || { x: 1, y: 0 });
        const distance = this.distancePlanningReplay3DMeters(fromPoint, toPoint);
        const safeDistance = Number.isFinite(distance) && distance > 0 ? distance : 0;

        if (safeDistance <= 1) {
            return currentTime;
        }

        const handleDistance = Math.max(
            safeWidth * 7,
            Math.min(safeDistance * 0.38, 520)
        );

        const p0 = startXY;
        const p1 = {
            x: startXY.x + (startDirection.x * handleDistance),
            y: startXY.y + (startDirection.y * handleDistance)
        };
        const p2 = {
            x: endXY.x - (endDirection.x * handleDistance),
            y: endXY.y - (endDirection.y * handleDistance)
        };
        const p3 = endXY;

        const bezierPoint = (a, b, c, d, t) => {
            const inv = 1 - t;
            const inv2 = inv * inv;
            const inv3 = inv2 * inv;
            const t2 = t * t;
            const t3 = t2 * t;

            return {
                x: (inv3 * a.x) + (3 * inv2 * t * b.x) + (3 * inv * t2 * c.x) + (t3 * d.x),
                y: (inv3 * a.y) + (3 * inv2 * t * b.y) + (3 * inv * t2 * c.y) + (t3 * d.y)
            };
        };

        const curvePoints = [];
        const steps = Math.max(36, Math.min(150, Math.ceil(safeDistance / 18)));

        for (let i = 1; i <= steps; i++) {
            curvePoints.push(projection.toLatLng(bezierPoint(p0, p1, p2, p3, i / steps)));
        }

        if (!curvePoints.length) return currentTime;

        let totalDistance = this.distancePlanningReplay3DMeters(fromPoint, curvePoints[0]);
        for (let i = 1; i < curvePoints.length; i++) {
            totalDistance += this.distancePlanningReplay3DMeters(curvePoints[i - 1], curvePoints[i]);
        }

        const duration = Math.max(4, totalDistance / (safeSpeed / 3.6));
        const startTime = currentTime;
        let consumedDistance = this.distancePlanningReplay3DMeters(fromPoint, curvePoints[0]);

        for (let i = 0; i < curvePoints.length; i++) {
            const point = curvePoints[i];

            if (i > 0) {
                consumedDistance += this.distancePlanningReplay3DMeters(curvePoints[i - 1], point);
            }

            this.addPlanningReplay3DPoint(timeline, point, {
                tSec: startTime + (duration * (consumedDistance / totalDistance)),
                spray: false,
                alt: altitude,
                width: width,
                speed: safeSpeed,
                name: name || this.props.res.RETORNO_ABASTECIMENTO,
                telemetryType: 'transit',
                applicationType: null,
                spraySource: 'none'
            });
        }

        return startTime + duration;
    };

    appendPlanningReplay3DTargetAlignedReturnBalloon = (timeline, fromPoint, toPoint, fromDirection, targetDirection, currentTime, speedKmH, altitude, width, name) => {
        if (!fromPoint || !toPoint) return currentTime;

        const safeSpeed = Number.isFinite(speedKmH) && speedKmH > 0 ? speedKmH : 110;
        const safeWidth = Number.isFinite(width) && width > 0 ? width : 30;
        const targetDir = this.normalizePlanningReplay3DVector(targetDirection || fromDirection || { x: 1, y: 0 });
        const startDir = this.normalizePlanningReplay3DVector(fromDirection || targetDir);

        if (!targetDir || !startDir) {
            return currentTime;
        }

        const projection = this.getPlanningReplay3DProjection(toPoint);
        const endXY = projection.toXY(toPoint);
        const startXY = projection.toXY(fromPoint);
        const normal = { x: -targetDir.y, y: targetDir.x };
        const localStart = {
            x: ((startXY.x - endXY.x) * targetDir.x) + ((startXY.y - endXY.y) * targetDir.y),
            y: ((startXY.x - endXY.x) * normal.x) + ((startXY.y - endXY.y) * normal.y)
        };
        const localStartDir = this.normalizePlanningReplay3DVector({
            x: (startDir.x * targetDir.x) + (startDir.y * targetDir.y),
            y: (startDir.x * normal.x) + (startDir.y * normal.y)
        }) || { x: 1, y: 0 };
        const distance = this.distancePlanningReplay3DMeters(fromPoint, toPoint);

        if (!Number.isFinite(distance) || distance <= 1) {
            return currentTime;
        }

        const loopLength = this.getPlanningReplay3DCanonicalLength(this.state.size_h_loop);
        const loopWidth = this.getPlanningReplay3DCanonicalLength(this.state.size_loop);
        const safeLoopLength = Number.isFinite(loopLength) && loopLength > 0 ? loopLength * 1.35 : Math.max(700, safeWidth * 22);
        const safeLoopWidth = Number.isFinite(loopWidth) && loopWidth > 0 ? loopWidth * 1.45 : Math.max(520, safeWidth * 17);
        const sideSign = localStart.y >= 0 ? -1 : 1;
        const entryBack = Math.max(safeLoopLength * 0.86, safeWidth * 14, Math.min(distance * 0.52, safeLoopLength * 1.55));
        const loopDepth = Math.max(safeLoopWidth * 1.12, safeWidth * 12, Math.min(distance * 0.48, safeLoopWidth * 2.05));
        const startBack = Math.max(entryBack, Math.abs(localStart.x) * 0.42, safeWidth * 14);
        const outerX = Math.min(localStart.x - (safeWidth * 2.5), -startBack);
        const outerY = sideSign * Math.max(loopDepth, Math.abs(localStart.y) * 0.95 + (safeWidth * 5));
        const alignX = -Math.max(entryBack * 0.48, safeWidth * 8);

        const toLatLngLocal = (point) => {
            return projection.toLatLng({
                x: endXY.x + (targetDir.x * point.x) + (normal.x * point.y),
                y: endXY.y + (targetDir.y * point.x) + (normal.y * point.y)
            });
        };

        const bezierPoint = (p0, p1, p2, p3, t) => {
            const inv = 1 - t;
            const inv2 = inv * inv;
            const inv3 = inv2 * inv;
            const t2 = t * t;
            const t3 = t2 * t;

            return {
                x: (inv3 * p0.x) + (3 * inv2 * t * p1.x) + (3 * inv * t2 * p2.x) + (t3 * p3.x),
                y: (inv3 * p0.y) + (3 * inv2 * t * p1.y) + (3 * inv * t2 * p2.y) + (t3 * p3.y)
            };
        };

        const addBezier = (points, p0, p1, p2, p3, steps) => {
            const safeSteps = Math.max(26, steps);
            for (let i = 1; i <= safeSteps; i++) {
                points.push(bezierPoint(p0, p1, p2, p3, i / safeSteps));
            }
        };

        const localPoints = [];
        const p0 = localStart;
        const pMid = { x: outerX, y: outerY };
        const pAlign = { x: alignX, y: 0 };
        const pEnd = { x: 0, y: 0 };
        const firstDistance = Math.hypot(pMid.x - p0.x, pMid.y - p0.y);
        const secondDistance = Math.hypot(pAlign.x - pMid.x, pAlign.y - pMid.y);
        const thirdDistance = Math.hypot(pEnd.x - pAlign.x, pEnd.y - pAlign.y);
        const firstHandle = Math.max(safeWidth * 6, Math.min(firstDistance * 0.58, safeLoopLength * 0.76));
        const midHandle = Math.max(safeWidth * 8, Math.min(Math.max(firstDistance, secondDistance) * 0.48, safeLoopLength * 0.86));
        const alignHandle = Math.max(safeWidth * 8, Math.min(thirdDistance * 0.74, safeLoopLength * 0.58));

        addBezier(
            localPoints,
            p0,
            {
                x: p0.x + (localStartDir.x * firstHandle),
                y: p0.y + (localStartDir.y * firstHandle)
            },
            {
                x: pMid.x - (entryBack * 0.28),
                y: pMid.y
            },
            pMid,
            Math.ceil(firstDistance / 7)
        );
        addBezier(
            localPoints,
            pMid,
            {
                x: pMid.x + midHandle,
                y: pMid.y
            },
            {
                x: pAlign.x - (midHandle * 0.70),
                y: pAlign.y + (sideSign * Math.max(safeWidth * 3.2, Math.min(loopDepth * 0.30, safeLoopWidth * 0.28)))
            },
            pAlign,
            Math.ceil(secondDistance / 7)
        );
        addBezier(
            localPoints,
            pAlign,
            {
                x: pAlign.x + alignHandle,
                y: 0
            },
            {
                x: pEnd.x - alignHandle,
                y: 0
            },
            pEnd,
            Math.ceil(thirdDistance / 7)
        );

        const curvePoints = [];
        for (let i = 0; i < localPoints.length; i++) {
            curvePoints.push(toLatLngLocal(localPoints[i]));
        }

        if (!curvePoints.length) return currentTime;

        let totalDistance = this.distancePlanningReplay3DMeters(fromPoint, curvePoints[0]);
        for (let i = 1; i < curvePoints.length; i++) {
            totalDistance += this.distancePlanningReplay3DMeters(curvePoints[i - 1], curvePoints[i]);
        }

        const duration = Math.max(10, totalDistance / (safeSpeed / 3.6));
        const startTime = currentTime;
        let consumedDistance = this.distancePlanningReplay3DMeters(fromPoint, curvePoints[0]);

        for (let i = 0; i < curvePoints.length; i++) {
            const point = curvePoints[i];

            if (i > 0) {
                consumedDistance += this.distancePlanningReplay3DMeters(curvePoints[i - 1], point);
            }

            this.addPlanningReplay3DPoint(timeline, point, {
                tSec: startTime + (duration * (consumedDistance / Math.max(totalDistance, 1))),
                spray: false,
                alt: altitude,
                width: width,
                speed: safeSpeed,
                name: name || this.props.res.RETORNO_PARA + ' ' + this.props.res.APLICACAO,
                telemetryType: 'balloon',
                applicationType: null,
                spraySource: 'none',
                balloonMeasureWidthMeters: Math.max(safeLoopWidth, Math.abs(outerY)),
                balloonMeasureLengthMeters: Math.max(safeLoopLength, Math.abs(outerX)),
                balloonMeasureWidthMaxMeters: Math.max(safeLoopWidth, Math.abs(outerY)),
                balloonMeasureLengthMaxMeters: Math.max(safeLoopLength, Math.abs(outerX))
            });
        }

        return startTime + duration;
    };

    appendPlanningReplay3DRefuelCycle = (timeline, currentPoint, nextPoint, currentDirection, nextDirection, currentTime, travelSpeed, altitude, width, fuelState, refuelPoint, areaName) => {
        if (!fuelState || !refuelPoint || !currentPoint || !nextPoint) {
            return {
                currentTime: currentTime,
                currentPoint: currentPoint,
                currentDirection: currentDirection
            };
        }

        const directionToRefuel = this.getPlanningReplay3DPointDirection(currentPoint, refuelPoint, currentDirection);
        const configuredLoopLength = this.getPlanningReplay3DConfiguredLoopLength(width);
        const configuredLoopHeight = this.getPlanningReplay3DCanonicalLength(this.state.size_h_loop);
        const safeLoopHeight = Number.isFinite(configuredLoopHeight) && configuredLoopHeight > 0 ? configuredLoopHeight : configuredLoopLength;
        const operationLeadMeters = this.getPlanningReplay3DOperationLeadMeters();
        const refuelAltitude = this.getPlanningReplay3DRefuelGroundAltitude();

        currentTime = this.appendPlanningReplay3DRefuelExitTurn(
            timeline,
            currentPoint,
            refuelPoint,
            currentDirection,
            directionToRefuel,
            currentTime,
            travelSpeed,
            altitude,
            width,
            this.props.res.RETORNO_ABASTECIMENTO
        );

        currentTime = this.appendPlanningReplay3DRefuelWait(
            timeline,
            refuelPoint,
            currentTime,
            refuelAltitude,
            width,
            fuelState,
            this.props.res.ABASTECIMENTO
        );

        const approachDistance = Math.max(configuredLoopLength * 2.20, safeLoopHeight * 2.20, operationLeadMeters * 5.80, width * 13);
        const approachPoint = this.offsetPlanningReplay3DPoint(nextPoint, { x: -nextDirection.x, y: -nextDirection.y }, approachDistance);
        const returnDirection = this.getPlanningReplay3DPointDirection(refuelPoint, approachPoint, nextDirection);
        const returnDistance = this.distancePlanningReplay3DMeters(refuelPoint, approachPoint);
        const safeNextDirection = this.normalizePlanningReplay3DVector(nextDirection || returnDirection);
        const safeReturnDirection = this.normalizePlanningReplay3DVector(returnDirection || safeNextDirection);
        const returnAlignmentDot = (safeReturnDirection.x * safeNextDirection.x) + (safeReturnDirection.y * safeNextDirection.y);
        const useReturnBalloon = returnAlignmentDot < 0.25;
        const curveStartDistance = useReturnBalloon
            ? Math.max(width * 10, Math.min(returnDistance * 0.40, configuredLoopLength * 0.86, safeLoopHeight * 0.78, 620))
            : Math.max(width * 5, Math.min(returnDistance * 0.24, configuredLoopLength * 0.48, 300));
        const curveStartPoint = this.offsetPlanningReplay3DPoint(
            approachPoint,
            { x: -safeReturnDirection.x, y: -safeReturnDirection.y },
            curveStartDistance
        );

        currentTime = this.appendPlanningReplay3DTransitWithAltitude(
            timeline,
            refuelPoint,
            curveStartPoint,
            currentTime,
            travelSpeed,
            refuelAltitude,
            altitude,
            width,
            this.props.res.RETORNO_PARA + ' ' + (areaName || this.props.res.APLICACAO)
        );

        if (useReturnBalloon) {
            currentTime = this.appendPlanningReplay3DSoftTransitBalloon(
                timeline,
                curveStartPoint,
                approachPoint,
                safeReturnDirection,
                safeNextDirection,
                currentTime,
                travelSpeed,
                altitude,
                width,
                this.props.res.RETORNO_PARA + ' ' + (areaName || this.props.res.APLICACAO)
            );
        } else {
            currentTime = this.appendPlanningReplay3DSmoothTransit(
                timeline,
                curveStartPoint,
                approachPoint,
                safeReturnDirection,
                safeNextDirection,
                currentTime,
                travelSpeed,
                altitude,
                width,
                this.props.res.RETORNO_PARA + ' ' + (areaName || this.props.res.APLICACAO)
            );
        }

        currentTime = this.appendPlanningReplay3DTransit(
            timeline,
            approachPoint,
            nextPoint,
            currentTime,
            travelSpeed,
            altitude,
            width,
            this.props.res.ENTRADA_FAIXA_APOS_ABASTECIMENTO
        );

        return {
            currentTime: currentTime,
            currentPoint: nextPoint,
            currentDirection: nextDirection
        };
    };

    appendPlanningReplay3DSegmentedApplicationLine = (timeline, line, polygon, currentTime, speedKmH, altitude, width, name, fuelState, planningStripKey, planningStripName) => {
        if (!Array.isArray(line) || line.length < 2) {
            return {
                currentTime: currentTime,
                currentPoint: Array.isArray(line) && line.length ? line[line.length - 1] : null,
                completed: true,
                interrupted: false,
                remainingLine: null
            };
        }

        const safeSpeed = Number.isFinite(speedKmH) && speedKmH > 0 ? speedKmH : 110;
        const safeWidth = Number.isFinite(width) && width > 0 ? width : 30;
        const safeFlow = this.getPlanningReplay3DFlowForPolygon(polygon);
        const boundary = this.getPlanningReplay3DPolygonBoundary(polygon);
        const sampleSpacingMeters = Math.max(10, Math.min(22, safeWidth * 0.30));
        const sampledLine = this.densifyPlanningReplay3DLine(line, sampleSpacingMeters);

        if (!Array.isArray(sampledLine) || sampledLine.length < 2) {
            return {
                currentTime: currentTime,
                currentPoint: line[line.length - 1],
                completed: true,
                interrupted: false,
                remainingLine: null
            };
        }

        let previousPoint = timeline.length > 0
            ? { lat: timeline[timeline.length - 1].lat, lng: timeline[timeline.length - 1].lng }
            : sampledLine[0];
        let time = currentTime;
        let lastPoint = previousPoint;

        for (let i = 0; i < sampledLine.length; i++) {
            const point = sampledLine[i];
            if (!point) continue;

            const distance = this.distancePlanningReplay3DMeters(previousPoint, point);
            const duration = distance > 0 ? Math.max(0.4, distance / (safeSpeed / 3.6)) : 0.4;
            const inside = boundary && boundary.length >= 3
                ? this.isPlanningReplay3DPointInsideBoundary(point, boundary)
                : true;

            let canSpray = !!inside;
            let targetPoint = point;
            let targetDistance = distance;
            let targetDuration = duration;
            let interrupted = false;
            const effectiveApplicationWidth = Math.max(1, safeWidth);
            const appliedAreaHa = inside && Number.isFinite(distance) && distance > 0
                ? ((distance * effectiveApplicationWidth) / 10000)
                : 0;
            const consumptionScale = fuelState && Number.isFinite(fuelState.consumptionScale) && fuelState.consumptionScale > 0
                ? fuelState.consumptionScale
                : 1;
            const requiredFuelForSegment = inside && Number.isFinite(safeFlow) && safeFlow > 0
                ? safeFlow * appliedAreaHa * consumptionScale
                : 0;

            if (inside && fuelState && Number.isFinite(safeFlow) && safeFlow > 0) {
                if (!Number.isFinite(fuelState.level) || fuelState.level <= 0) {
                    return {
                        currentTime: time,
                        currentPoint: previousPoint,
                        completed: false,
                        interrupted: true,
                        remainingLine: sampledLine.slice(Math.max(0, i - 1))
                    };
                }

                if (requiredFuelForSegment > fuelState.level && Number.isFinite(distance) && distance > 0) {
                    const ratio = Math.max(0, Math.min(1, fuelState.level / requiredFuelForSegment));
                    targetPoint = {
                        lat: previousPoint.lat + ((point.lat - previousPoint.lat) * ratio),
                        lng: previousPoint.lng + ((point.lng - previousPoint.lng) * ratio)
                    };
                    targetDistance = distance * ratio;
                    targetDuration = duration * ratio;
                    fuelState.level = 0;
                    interrupted = true;
                    canSpray = true;
                } else {
                    fuelState.level = Math.max(0, fuelState.level - requiredFuelForSegment);
                }
            }

            time += targetDuration;

            this.addPlanningReplay3DPoint(timeline, targetPoint, Object.assign({
                tSec: time,
                spray: canSpray,
                alt: altitude,
                width: width,
                speed: safeSpeed,
                flow: canSpray ? safeFlow : null,
                name: canSpray ? (name || this.props.res.APLICACAO) : this.props.res.SEM_CARGA,
                applicationType: canSpray ? 'app' : null,
                telemetryType: canSpray ? 'spray' : 'transit',
                spraySource: canSpray ? 'explicit_track' : 'none',
                planningStripKey: canSpray ? planningStripKey : null,
                planningStripName: canSpray ? planningStripName : null
            }, this.getPlanningReplay3DFuelStateOptions(fuelState)));

            lastPoint = targetPoint;

            if (interrupted) {
                const remainingLine = [targetPoint].concat(sampledLine.slice(i));
                return {
                    currentTime: time,
                    currentPoint: targetPoint,
                    completed: false,
                    interrupted: true,
                    remainingLine: remainingLine
                };
            }

            previousPoint = point;
        }

        return {
            currentTime: time,
            currentPoint: lastPoint,
            completed: true,
            interrupted: false,
            remainingLine: null
        };
    };

    appendPlanningReplay3DApplicationLine = (timeline, line, currentTime, speedKmH, altitude, width, name) => {
        if (!Array.isArray(line) || line.length === 0) return currentTime;

        const safeSpeed = Number.isFinite(speedKmH) && speedKmH > 0 ? speedKmH : 110;
        const stateFlow = this.getPlanningReplay3DCanonicalFlow(this.state.fluxo);
        const safeFlow = Number.isFinite(stateFlow) && stateFlow > 0 ? stateFlow : null;
        const applicationLine = this.trimPlanningReplay3DApplicationLine(line, width);
        const outputLine = [];

        for (let i = 0; i < applicationLine.length; i++) {
            if (applicationLine[i]) outputLine.push(applicationLine[i]);
        }

        if (!outputLine.length) return currentTime;

        const densified = [outputLine[0]];
        const sampleSpacingMeters = Math.max(10, Math.min(26, (Number.isFinite(width) && width > 0 ? width * 0.32 : 16)));

        for (let i = 1; i < outputLine.length; i++) {
            const previous = outputLine[i - 1];
            const current = outputLine[i];
            const distance = this.distancePlanningReplay3DMeters(previous, current);
            const steps = Math.max(1, Math.ceil(distance / sampleSpacingMeters));

            for (let step = 1; step <= steps; step++) {
                const factor = step / steps;
                densified.push({
                    lat: previous.lat + ((current.lat - previous.lat) * factor),
                    lng: previous.lng + ((current.lng - previous.lng) * factor)
                });
            }
        }

        let previousPoint = timeline.length > 0 ? { lat: timeline[timeline.length - 1].lat, lng: timeline[timeline.length - 1].lng } : densified[0];
        let time = currentTime;

        for (let i = 0; i < densified.length; i++) {
            const point = densified[i];
            if (!point) continue;

            const distance = this.distancePlanningReplay3DMeters(previousPoint, point);
            const duration = distance > 0 ? Math.max(0.4, distance / (safeSpeed / 3.6)) : 0.4;
            time += duration;

            this.addPlanningReplay3DPoint(timeline, point, {
                tSec: time,
                spray: true,
                alt: altitude,
                width: width,
                speed: safeSpeed,
                flow: safeFlow,
                name: name || this.props.res.APLICACAO,
                applicationType: 'app',
                telemetryType: 'spray',
                spraySource: 'explicit_track'
            });

            previousPoint = point;
        }

        return time;
    };

    appendPlanningReplay3DTransitBalloon = (timeline, fromPoint, toPoint, currentDirection, nextDirection, currentTime, speedKmH, altitude, width, name) => {
        if (!fromPoint || !toPoint) return currentTime;

        const safeSpeed = Number.isFinite(speedKmH) && speedKmH > 0 ? speedKmH : 110;
        const loopWidth = this.getPlanningReplay3DCanonicalLength(this.state.size_loop);
        const loopLength = this.getPlanningReplay3DCanonicalLength(this.state.size_h_loop);
        const safeWidth = Number.isFinite(width) && width > 0 ? width : 30;
        const safeLoopWidth = Number.isFinite(loopWidth) && loopWidth > 0
            ? loopWidth
            : Math.max(120, safeWidth * 4.5);
        const safeLoopLength = Number.isFinite(loopLength) && loopLength > 0
            ? loopLength
            : Math.max(220, safeWidth * 9);
        const projection = this.getPlanningReplay3DProjection(fromPoint);
        const dirA = this.normalizePlanningReplay3DVector(currentDirection || { x: 1, y: 0 });
        const nextDir = this.normalizePlanningReplay3DVector(nextDirection || { x: -dirA.x, y: -dirA.y });
        const normalA = { x: -dirA.y, y: dirA.x };
        const startXY = projection.toXY(fromPoint);
        const endXY = projection.toXY(toPoint);
        const delta = {
            x: endXY.x - startXY.x,
            y: endXY.y - startXY.y
        };
        const forwardDelta = (delta.x * dirA.x) + (delta.y * dirA.y);
        const lateralDelta = (delta.x * normalA.x) + (delta.y * normalA.y);
        const lateralGap = Math.abs(lateralDelta);
        const turnCross = (dirA.x * nextDir.y) - (dirA.y * nextDir.x);
        const naturalSideSign = lateralDelta >= 0 ? 1 : -1;
        const turnSideSign = Math.abs(turnCross) > 0.02 ? (turnCross >= 0 ? 1 : -1) : naturalSideSign;
        const sideSign = lateralGap < safeLoopWidth * 0.35 ? turnSideSign : naturalSideSign;

        const balloonWidth = Math.max(safeLoopWidth, lateralGap + (safeWidth * 1.35), safeWidth * 4);
        const balloonLength = Math.max(safeLoopLength, Math.abs(forwardDelta) + (safeWidth * 5), safeWidth * 9);
        const balloonY = sideSign * balloonWidth;
        const endLocal = { x: forwardDelta, y: lateralDelta };

        const radiusY = balloonWidth / 2;
        const radiusX = Math.max(safeWidth * 3.4, Math.min(balloonLength * 0.42, balloonWidth * 0.88));
        const finalLead = Math.max(140, Math.min(balloonLength * 0.46, balloonWidth * 0.82, safeWidth * 11));
        const centerX = Math.max(
            balloonLength - (radiusX * 0.82),
            endLocal.x + finalLead + (safeWidth * 2),
            radiusX + (safeWidth * 3.6)
        );
        const topJoinX = endLocal.x + finalLead;
        const reachX = centerX + radiusX;

        const toWorldXY = (localPoint) => ({
            x: startXY.x + (dirA.x * localPoint.x) + (normalA.x * localPoint.y),
            y: startXY.y + (dirA.y * localPoint.x) + (normalA.y * localPoint.y)
        });

        const toLatLngLocal = (localPoint) => projection.toLatLng(toWorldXY(localPoint));

        const bezierPoint = (p0, p1, p2, p3, t) => {
            const inv = 1 - t;
            const inv2 = inv * inv;
            const inv3 = inv2 * inv;
            const t2 = t * t;
            const t3 = t2 * t;

            return {
                x: (inv3 * p0.x) + (3 * inv2 * t * p1.x) + (3 * inv * t2 * p2.x) + (t3 * p3.x),
                y: (inv3 * p0.y) + (3 * inv2 * t * p1.y) + (3 * inv * t2 * p2.y) + (t3 * p3.y)
            };
        };

        const addLine = (pointsLocal, p0, p1, spacingMeters) => {
            const distance = Math.hypot(p1.x - p0.x, p1.y - p0.y);
            const steps = Math.max(1, Math.ceil(distance / Math.max(8, spacingMeters)));
            for (let i = 1; i <= steps; i++) {
                const t = i / steps;
                pointsLocal.push({
                    x: p0.x + ((p1.x - p0.x) * t),
                    y: p0.y + ((p1.y - p0.y) * t)
                });
            }
        };

        const addBezier = (pointsLocal, p0, p1, p2, p3, steps) => {
            const safeSteps = Math.max(16, steps);
            for (let i = 1; i <= safeSteps; i++) {
                pointsLocal.push(bezierPoint(p0, p1, p2, p3, i / safeSteps));
            }
        };

        const curvePointsLocal = [];
        const bottomArcPoint = { x: centerX, y: 0 };
        const topArcPoint = { x: centerX, y: balloonY };
        const topJoinPoint = { x: topJoinX, y: balloonY };
        const nextDirLocal = this.normalizePlanningReplay3DVector({
            x: (nextDir.x * dirA.x) + (nextDir.y * dirA.y),
            y: (nextDir.x * normalA.x) + (nextDir.y * normalA.y)
        }) || { x: -1, y: 0 };
        const preferDirectArcExit = Math.abs(nextDirLocal.y) > 0.58 && Math.abs(nextDirLocal.x) < 0.72;

        addLine(curvePointsLocal, { x: 0, y: 0 }, bottomArcPoint, 14);

        const centerY = balloonY / 2;
        const arcSteps = Math.max(64, Math.min(150, Math.ceil((Math.PI * Math.max(radiusX, radiusY)) / 7)));
        const startAngle = sideSign >= 0 ? (-Math.PI / 2) : (Math.PI / 2);
        const endAngle = sideSign >= 0 ? (Math.PI / 2) : (-Math.PI / 2);
        for (let i = 1; i <= arcSteps; i++) {
            const angle = startAngle + (((endAngle - startAngle) * i) / arcSteps);
            curvePointsLocal.push({
                x: centerX + (radiusX * Math.cos(angle)),
                y: centerY + (radiusY * Math.sin(angle))
            });
        }

        if (!preferDirectArcExit && centerX > topJoinX) {
            addLine(curvePointsLocal, topArcPoint, topJoinPoint, 14);
        }

        const exitStartPoint = preferDirectArcExit ? topArcPoint : topJoinPoint;
        const finalDistance = Math.hypot(exitStartPoint.x - endLocal.x, exitStartPoint.y - endLocal.y);
        const finalHandleX = Math.max(70, Math.min(finalLead * 0.56, finalDistance * 0.50));
        const endTangentDistance = Math.max(90, Math.min(finalDistance * 0.72, finalLead * 1.20, balloonWidth * 0.72, safeWidth * 12));
        addBezier(
            curvePointsLocal,
            exitStartPoint,
            {
                x: exitStartPoint.x - finalHandleX,
                y: preferDirectArcExit
                    ? exitStartPoint.y - (sideSign * Math.min(balloonWidth * 0.10, finalDistance * 0.10))
                    : exitStartPoint.y
            },
            {
                x: endLocal.x - (nextDirLocal.x * endTangentDistance),
                y: endLocal.y - (nextDirLocal.y * endTangentDistance)
            },
            endLocal,
            Math.max(24, Math.ceil(finalDistance / 7))
        );

        const curvePoints = [];
        for (let i = 0; i < curvePointsLocal.length; i++) {
            curvePoints.push(toLatLngLocal(curvePointsLocal[i]));
        }

        if (!curvePoints.length) {
            return currentTime;
        }

        let totalDistance = this.distancePlanningReplay3DMeters(fromPoint, curvePoints[0]);
        for (let i = 1; i < curvePoints.length; i++) {
            totalDistance += this.distancePlanningReplay3DMeters(curvePoints[i - 1], curvePoints[i]);
        }

        const duration = Math.max(12, totalDistance / (safeSpeed / 3.6));
        const startTime = currentTime;
        const balloonMeasureLengthMax = safeLoopLength;
        const balloonMeasureWidthMax = safeLoopWidth;
        let consumedDistance = this.distancePlanningReplay3DMeters(fromPoint, curvePoints[0]);

        for (let i = 0; i < curvePoints.length; i++) {
            const point = curvePoints[i];

            if (i > 0) {
                consumedDistance += this.distancePlanningReplay3DMeters(curvePoints[i - 1], point);
            }

            this.addPlanningReplay3DPoint(timeline, point, {
                tSec: startTime + (duration * (consumedDistance / totalDistance)),
                spray: false,
                alt: altitude,
                width: width,
                speed: safeSpeed,
                name: name || this.props.res.TRANSLADO || this.props.res.RETORNO_ABASTECIMENTO,
                telemetryType: 'transit',
                applicationType: null,
                spraySource: 'none',
                balloonMeasureWidthMeters: safeLoopWidth,
                balloonMeasureLengthMeters: safeLoopLength,
                balloonMeasureWidthMaxMeters: safeLoopWidth,
                balloonMeasureLengthMaxMeters: safeLoopLength
            });
        }

        return startTime + duration;
    };

    appendPlanningReplay3DSoftTransitBalloon = (timeline, fromPoint, toPoint, currentDirection, nextDirection, currentTime, speedKmH, altitude, width, name) => {
        if (!fromPoint || !toPoint) return currentTime;

        const safeSpeed = Number.isFinite(speedKmH) && speedKmH > 0 ? speedKmH : 110;
        const safeWidth = Number.isFinite(width) && width > 0 ? width : 30;
        const projection = this.getPlanningReplay3DProjection(fromPoint);
        const dirA = this.normalizePlanningReplay3DVector(currentDirection || { x: 1, y: 0 });
        const nextDir = this.normalizePlanningReplay3DVector(nextDirection || { x: -dirA.x, y: -dirA.y });
        const normalA = { x: -dirA.y, y: dirA.x };
        const startXY = projection.toXY(fromPoint);
        const endXY = projection.toXY(toPoint);
        const delta = {
            x: endXY.x - startXY.x,
            y: endXY.y - startXY.y
        };
        const forwardDelta = (delta.x * dirA.x) + (delta.y * dirA.y);
        const lateralDelta = (delta.x * normalA.x) + (delta.y * normalA.y);
        const lateralGap = Math.abs(lateralDelta);
        const turnCross = (dirA.x * nextDir.y) - (dirA.y * nextDir.x);
        const naturalSideSign = lateralDelta >= 0 ? 1 : -1;
        const turnSideSign = Math.abs(turnCross) > 0.02 ? (turnCross >= 0 ? 1 : -1) : naturalSideSign;
        const sideSign = Math.abs(turnCross) > 0.02 ? (-turnSideSign) : naturalSideSign;

        const balloonWidth = Math.max(safeWidth * 10.5, lateralGap + (safeWidth * 6.2), 280);
        const balloonLength = Math.max(safeWidth * 8.0, Math.abs(forwardDelta) + (safeWidth * 4.0), 240);
        const balloonY = sideSign * balloonWidth;
        const endLocal = { x: forwardDelta, y: lateralDelta };

        const radiusY = balloonWidth / 2;
        const radiusX = Math.max(safeWidth * 2.8, Math.min(balloonLength * 0.24, balloonWidth * 0.48));
        const finalLead = Math.max(safeWidth * 3.6, Math.min(balloonLength * 0.34, balloonWidth * 0.42, 95));
        const centerX = Math.max(
            balloonLength - (radiusX * 0.85),
            endLocal.x + finalLead + (safeWidth * 0.9),
            radiusX + (safeWidth * 1.4)
        );
        const topJoinX = endLocal.x + finalLead;
        const reachX = centerX + radiusX;

        const toWorldXY = (localPoint) => ({
            x: startXY.x + (dirA.x * localPoint.x) + (normalA.x * localPoint.y),
            y: startXY.y + (dirA.y * localPoint.x) + (normalA.y * localPoint.y)
        });

        const toLatLngLocal = (localPoint) => projection.toLatLng(toWorldXY(localPoint));

        const bezierPoint = (p0, p1, p2, p3, t) => {
            const inv = 1 - t;
            const inv2 = inv * inv;
            const inv3 = inv2 * inv;
            const t2 = t * t;
            const t3 = t2 * t;

            return {
                x: (inv3 * p0.x) + (3 * inv2 * t * p1.x) + (3 * inv * t2 * p2.x) + (t3 * p3.x),
                y: (inv3 * p0.y) + (3 * inv2 * t * p1.y) + (3 * inv * t2 * p2.y) + (t3 * p3.y)
            };
        };

        const addLine = (pointsLocal, p0, p1, spacingMeters) => {
            const distance = Math.hypot(p1.x - p0.x, p1.y - p0.y);
            const steps = Math.max(1, Math.ceil(distance / Math.max(8, spacingMeters)));
            for (let i = 1; i <= steps; i++) {
                const t = i / steps;
                pointsLocal.push({
                    x: p0.x + ((p1.x - p0.x) * t),
                    y: p0.y + ((p1.y - p0.y) * t)
                });
            }
        };

        const addBezier = (pointsLocal, p0, p1, p2, p3, steps) => {
            const safeSteps = Math.max(16, steps);
            for (let i = 1; i <= safeSteps; i++) {
                pointsLocal.push(bezierPoint(p0, p1, p2, p3, i / safeSteps));
            }
        };

        const curvePointsLocal = [];
        const bottomArcPoint = { x: centerX, y: 0 };
        const topArcPoint = { x: centerX, y: balloonY };
        const topJoinPoint = { x: topJoinX, y: balloonY };
        const nextDirLocal = this.normalizePlanningReplay3DVector({
            x: (nextDir.x * dirA.x) + (nextDir.y * dirA.y),
            y: (nextDir.x * normalA.x) + (nextDir.y * normalA.y)
        }) || { x: -1, y: 0 };
        const preferDirectArcExit = Math.abs(nextDirLocal.y) > 0.58 && Math.abs(nextDirLocal.x) < 0.72;

        addLine(curvePointsLocal, { x: 0, y: 0 }, bottomArcPoint, 12);

        const centerY = balloonY / 2;
        const arcSteps = Math.max(42, Math.min(120, Math.ceil((Math.PI * Math.max(radiusX, radiusY)) / 7)));
        const startAngle = sideSign >= 0 ? (-Math.PI / 2) : (Math.PI / 2);
        const endAngle = sideSign >= 0 ? (Math.PI / 2) : (-Math.PI / 2);
        for (let i = 1; i <= arcSteps; i++) {
            const angle = startAngle + (((endAngle - startAngle) * i) / arcSteps);
            curvePointsLocal.push({
                x: centerX + (radiusX * Math.cos(angle)),
                y: centerY + (radiusY * Math.sin(angle))
            });
        }

        if (!preferDirectArcExit && centerX > topJoinX) {
            addLine(curvePointsLocal, topArcPoint, topJoinPoint, 12);
        }

        const exitStartPoint = preferDirectArcExit ? topArcPoint : topJoinPoint;
        const finalDistance = Math.hypot(exitStartPoint.x - endLocal.x, exitStartPoint.y - endLocal.y);
        const finalHandleX = Math.max(42, Math.min(finalLead * 0.42, finalDistance * 0.38));
        const endTangentDistance = Math.max(56, Math.min(finalDistance * 0.46, finalLead * 0.72, balloonWidth * 0.34, safeWidth * 6.4));
        addBezier(
            curvePointsLocal,
            exitStartPoint,
            {
                x: exitStartPoint.x - finalHandleX,
                y: preferDirectArcExit
                    ? exitStartPoint.y - (sideSign * Math.min(balloonWidth * 0.10, finalDistance * 0.10))
                    : exitStartPoint.y
            },
            {
                x: endLocal.x - (nextDirLocal.x * endTangentDistance),
                y: endLocal.y - (nextDirLocal.y * endTangentDistance)
            },
            endLocal,
            Math.max(22, Math.ceil(finalDistance / 7))
        );

        const curvePoints = [];
        for (let i = 0; i < curvePointsLocal.length; i++) {
            curvePoints.push(toLatLngLocal(curvePointsLocal[i]));
        }

        if (!curvePoints.length) {
            return currentTime;
        }

        let totalDistance = this.distancePlanningReplay3DMeters(fromPoint, curvePoints[0]);
        for (let i = 1; i < curvePoints.length; i++) {
            totalDistance += this.distancePlanningReplay3DMeters(curvePoints[i - 1], curvePoints[i]);
        }

        const duration = Math.max(8, totalDistance / (safeSpeed / 3.6));
        const startTime = currentTime;
        let consumedDistance = this.distancePlanningReplay3DMeters(fromPoint, curvePoints[0]);

        for (let i = 0; i < curvePoints.length; i++) {
            const point = curvePoints[i];

            if (i > 0) {
                consumedDistance += this.distancePlanningReplay3DMeters(curvePoints[i - 1], point);
            }

            this.addPlanningReplay3DPoint(timeline, point, {
                tSec: startTime + (duration * (consumedDistance / totalDistance)),
                spray: false,
                alt: altitude,
                width: width,
                speed: safeSpeed,
                name: name || this.props.res.RETORNO_ABASTECIMENTO,
                telemetryType: 'transit',
                applicationType: null,
                spraySource: 'none',
                balloonMeasureWidthMeters: balloonWidth,
                balloonMeasureLengthMeters: reachX
            });
        }

        return startTime + duration;
    };

    appendPlanningReplay3DBalloon = (timeline, fromPoint, toPoint, currentDirection, nextDirection, currentTime, speedKmH, altitude, width, name) => {
        if (!fromPoint || !toPoint) return currentTime;

        const safeSpeed = Number.isFinite(speedKmH) && speedKmH > 0 ? speedKmH : 110;
        const loopWidth = this.getPlanningReplay3DCanonicalLength(this.state.size_loop);
        const loopLength = this.getPlanningReplay3DCanonicalLength(this.state.size_h_loop);
        const safeLoopWidth = Number.isFinite(loopWidth) && loopWidth > 0 ? loopWidth : 400;
        const safeLoopLength = Number.isFinite(loopLength) && loopLength > 0 ? loopLength : 600;
        const safeWidth = Number.isFinite(width) && width > 0 ? width : 30;
        const projection = this.getPlanningReplay3DProjection(fromPoint);
        const dirA = this.normalizePlanningReplay3DVector(currentDirection || { x: 1, y: 0 });
        const nextDir = this.normalizePlanningReplay3DVector(nextDirection || { x: -dirA.x, y: -dirA.y });
        const normalA = { x: -dirA.y, y: dirA.x };
        const startXY = projection.toXY(fromPoint);
        const endXY = projection.toXY(toPoint);
        const delta = {
            x: endXY.x - startXY.x,
            y: endXY.y - startXY.y
        };
        const forwardDelta = (delta.x * dirA.x) + (delta.y * dirA.y);
        const lateralDelta = (delta.x * normalA.x) + (delta.y * normalA.y);
        const lateralGap = Math.abs(lateralDelta);
        const turnCross = (dirA.x * nextDir.y) - (dirA.y * nextDir.x);
        const naturalSideSign = lateralDelta >= 0 ? 1 : -1;
        const turnSideSign = Math.abs(turnCross) > 0.02 ? (turnCross >= 0 ? 1 : -1) : naturalSideSign;
        const sideSign = lateralGap < safeLoopWidth * 0.35 ? turnSideSign : naturalSideSign;

        const balloonWidth = Math.max(safeLoopWidth, lateralGap + (safeWidth * 0.75), safeWidth * 4);
        const balloonLength = Math.max(safeLoopLength, Math.abs(forwardDelta) + (safeWidth * 4.1), safeWidth * 9);
        const balloonY = sideSign * balloonWidth;
        const endLocal = { x: forwardDelta, y: lateralDelta };

        const radiusY = balloonWidth / 2;
        const radiusX = Math.max(safeWidth * 3, Math.min(balloonLength * 0.33, balloonWidth * 0.68));
        const finalLead = Math.max(125, Math.min(balloonLength * 0.44, balloonWidth * 0.80, safeWidth * 10.5));
        const centerX = Math.max(
            balloonLength - radiusX,
            endLocal.x + finalLead + (safeWidth * 1.4),
            radiusX + (safeWidth * 3.2)
        );
        const topJoinX = endLocal.x + finalLead;
        const reachX = centerX + radiusX;

        const toWorldXY = (localPoint) => ({
            x: startXY.x + (dirA.x * localPoint.x) + (normalA.x * localPoint.y),
            y: startXY.y + (dirA.y * localPoint.x) + (normalA.y * localPoint.y)
        });

        const toLatLngLocal = (localPoint) => projection.toLatLng(toWorldXY(localPoint));

        const bezierPoint = (p0, p1, p2, p3, t) => {
            const inv = 1 - t;
            const inv2 = inv * inv;
            const inv3 = inv2 * inv;
            const t2 = t * t;
            const t3 = t2 * t;

            return {
                x: (inv3 * p0.x) + (3 * inv2 * t * p1.x) + (3 * inv * t2 * p2.x) + (t3 * p3.x),
                y: (inv3 * p0.y) + (3 * inv2 * t * p1.y) + (3 * inv * t2 * p2.y) + (t3 * p3.y)
            };
        };

        const addLine = (pointsLocal, p0, p1, spacingMeters) => {
            const distance = Math.hypot(p1.x - p0.x, p1.y - p0.y);
            const steps = Math.max(1, Math.ceil(distance / Math.max(8, spacingMeters)));
            for (let i = 1; i <= steps; i++) {
                const t = i / steps;
                pointsLocal.push({
                    x: p0.x + ((p1.x - p0.x) * t),
                    y: p0.y + ((p1.y - p0.y) * t)
                });
            }
        };

        const addBezier = (pointsLocal, p0, p1, p2, p3, steps) => {
            const safeSteps = Math.max(16, steps);
            for (let i = 1; i <= safeSteps; i++) {
                pointsLocal.push(bezierPoint(p0, p1, p2, p3, i / safeSteps));
            }
        };

        const curvePointsLocal = [];
        const bottomArcPoint = { x: centerX, y: 0 };
        const topArcPoint = { x: centerX, y: balloonY };
        const topJoinPoint = { x: topJoinX, y: balloonY };
        const nextDirLocal = this.normalizePlanningReplay3DVector({
            x: (nextDir.x * dirA.x) + (nextDir.y * dirA.y),
            y: (nextDir.x * normalA.x) + (nextDir.y * normalA.y)
        }) || { x: -1, y: 0 };
        const preferDirectArcExit = Math.abs(nextDirLocal.y) > 0.58 && Math.abs(nextDirLocal.x) < 0.72;

        addLine(curvePointsLocal, { x: 0, y: 0 }, bottomArcPoint, 14);

        const centerY = balloonY / 2;
        const arcSteps = Math.max(64, Math.min(150, Math.ceil((Math.PI * Math.max(radiusX, radiusY)) / 7)));
        const startAngle = sideSign >= 0 ? (-Math.PI / 2) : (Math.PI / 2);
        const endAngle = sideSign >= 0 ? (Math.PI / 2) : (-Math.PI / 2);
        for (let i = 1; i <= arcSteps; i++) {
            const angle = startAngle + (((endAngle - startAngle) * i) / arcSteps);
            curvePointsLocal.push({
                x: centerX + (radiusX * Math.cos(angle)),
                y: centerY + (radiusY * Math.sin(angle))
            });
        }

        if (!preferDirectArcExit && centerX > topJoinX) {
            addLine(curvePointsLocal, topArcPoint, topJoinPoint, 14);
        }

        const exitStartPoint = preferDirectArcExit ? topArcPoint : topJoinPoint;
        const finalDistance = Math.hypot(exitStartPoint.x - endLocal.x, exitStartPoint.y - endLocal.y);
        const finalHandleX = Math.max(80, Math.min(finalLead * 0.62, finalDistance * 0.55));
        const endTangentDistance = Math.max(95, Math.min(finalDistance * 0.74, finalLead * 1.22, balloonWidth * 0.74, safeWidth * 12));
        addBezier(
            curvePointsLocal,
            exitStartPoint,
            {
                x: exitStartPoint.x - finalHandleX,
                y: preferDirectArcExit
                    ? exitStartPoint.y - (sideSign * Math.min(balloonWidth * 0.10, finalDistance * 0.10))
                    : exitStartPoint.y
            },
            {
                x: endLocal.x - (nextDirLocal.x * endTangentDistance),
                y: endLocal.y - (nextDirLocal.y * endTangentDistance)
            },
            endLocal,
            Math.max(24, Math.ceil(finalDistance / 7))
        );

        const curvePoints = [];
        for (let i = 0; i < curvePointsLocal.length; i++) {
            curvePoints.push(toLatLngLocal(curvePointsLocal[i]));
        }

        if (!curvePoints.length) {
            return currentTime;
        }

        let totalDistance = this.distancePlanningReplay3DMeters(fromPoint, curvePoints[0]);
        for (let i = 1; i < curvePoints.length; i++) {
            totalDistance += this.distancePlanningReplay3DMeters(curvePoints[i - 1], curvePoints[i]);
        }

        const duration = Math.max(12, totalDistance / (safeSpeed / 3.6));
        const startTime = currentTime;
        const balloonMeasureLengthMax = Math.max(safeLoopLength, reachX);
        const balloonMeasureWidthMax = Math.max(safeLoopWidth, balloonWidth);
        let consumedDistance = this.distancePlanningReplay3DMeters(fromPoint, curvePoints[0]);

        for (let i = 0; i < curvePoints.length; i++) {
            const point = curvePoints[i];

            if (i > 0) {
                consumedDistance += this.distancePlanningReplay3DMeters(curvePoints[i - 1], point);
            }

            this.addPlanningReplay3DPoint(timeline, point, {
                tSec: startTime + (duration * (consumedDistance / totalDistance)),
                spray: false,
                alt: altitude,
                width: width,
                speed: safeSpeed,
                name: i === 0 ? (name || this.props.res.SAIDA_BALAO) : (name || this.props.res.CURVA_BALAO),
                telemetryType: 'balloon',
                applicationType: null,
                spraySource: 'none',
                balloonMeasureWidthMeters: balloonWidth,
                balloonMeasureLengthMeters: balloonMeasureLengthMax,
                balloonMeasureWidthMaxMeters: balloonMeasureWidthMax,
                balloonMeasureLengthMaxMeters: balloonMeasureLengthMax
            });
        }

        return startTime + duration;
    };

    getPlanningReplay3DMinimumBalloonAngleDeg = () => {
        return 90;
    };

    getPlanningReplay3DEstimatedBalloonAngleDeg = (lineSpanCount, widthMeters) => {
        const loopWidth = this.getPlanningReplay3DCanonicalLength(this.state.size_loop);
        const loopLength = this.getPlanningReplay3DCanonicalLength(this.state.size_h_loop);
        const safeWidth = Number.isFinite(widthMeters) && widthMeters > 0
            ? widthMeters
            : (Number.isFinite(this.getPlanningReplay3DCanonicalLength(this.state.faixa)) ? this.getPlanningReplay3DCanonicalLength(this.state.faixa) : 30);
        const safeLoopWidth = Number.isFinite(loopWidth) && loopWidth > 0 ? loopWidth : 400;
        const safeLoopLength = Number.isFinite(loopLength) && loopLength > 0 ? loopLength : 600;
        const safeSpanCount = Number.isFinite(lineSpanCount) && lineSpanCount > 0 ? lineSpanCount : 1;

        const forwardReach = Math.max(
            55,
            Math.min(safeLoopLength * 0.18, safeLoopWidth * 0.32, 110)
        );
        const lateralSpan = Math.max(safeWidth * safeSpanCount, safeWidth);

        return (2 * Math.atan2(lateralSpan, Math.max(1, forwardReach))) * (180 / Math.PI);
    };

    getPlanningReplay3DSkipLineCount = (lines, widthMeters) => {
        if (!Array.isArray(lines) || lines.length < 4) return 0;

        const safeWidth = Number.isFinite(widthMeters) && widthMeters > 0
            ? widthMeters
            : (Number.isFinite(this.getPlanningReplay3DCanonicalLength(this.state.faixa)) ? this.getPlanningReplay3DCanonicalLength(this.state.faixa) : 30);

        if (!Number.isFinite(safeWidth) || safeWidth <= 0) {
            return 0;
        }

        const maxPractical = Math.max(1, Math.floor((lines.length - 1) / 2));
        const minimumAngleDeg = this.getPlanningReplay3DMinimumBalloonAngleDeg();

        for (let skipCount = 0; skipCount <= maxPractical; skipCount++) {
            const lineSpanCount = skipCount + 1;
            const estimatedAngleDeg = this.getPlanningReplay3DEstimatedBalloonAngleDeg(lineSpanCount, safeWidth);

            if (estimatedAngleDeg >= minimumAngleDeg) {
                return skipCount;
            }
        }

        return maxPractical;
    };

    isPlanningReplay3DIrregularLineSet = (lines) => {
        if (!Array.isArray(lines) || lines.length < 6) return false;

        const lengths = [];
        const centers = [];

        for (let i = 0; i < lines.length; i++) {
            const line = lines[i];
            if (!Array.isArray(line) || line.length < 2) continue;

            const length = this.getPlanningReplay3DLineLengthMeters(line);
            if (Number.isFinite(length) && length > 0) {
                lengths.push(length);
            }

            const first = line[0];
            const last = line[line.length - 1];
            if (first && last) {
                centers.push({
                    lat: (first.lat + last.lat) / 2,
                    lng: (first.lng + last.lng) / 2
                });
            }
        }

        if (lengths.length < 6 || centers.length < 6) return false;

        const sum = lengths.reduce((acc, value) => acc + value, 0);
        const avg = sum / lengths.length;
        const min = Math.min.apply(null, lengths);
        const max = Math.max.apply(null, lengths);

        if (!Number.isFinite(avg) || avg <= 0) return false;

        const variance = lengths.reduce((acc, value) => {
            const diff = value - avg;
            return acc + (diff * diff);
        }, 0) / lengths.length;
        const cv = Math.sqrt(variance) / avg;

        const centerDistances = [];
        for (let i = 1; i < centers.length; i++) {
            centerDistances.push(this.distancePlanningReplay3DMeters(centers[i - 1], centers[i]));
        }

        const validCenterDistances = centerDistances.filter(value => Number.isFinite(value) && value > 0);
        const avgCenterDistance = validCenterDistances.length
            ? validCenterDistances.reduce((acc, value) => acc + value, 0) / validCenterDistances.length
            : 0;
        const maxCenterDistance = validCenterDistances.length ? Math.max.apply(null, validCenterDistances) : 0;
        if (cv > 0.12) return true;
        if (min < (avg * 0.78)) return true;
        if (max > (avg * 1.22)) return true;
        if (avgCenterDistance > 0 && maxCenterDistance > (avgCenterDistance * 1.45)) return true;

        return false;
    };

    getPlanningReplay3DExecutionLines = (lines, referencePoint, widthMeters) => {
        if (!Array.isArray(lines) || lines.length <= 2) return Array.isArray(lines) ? lines : [];

        if (this.isPlanningReplay3DIrregularLineSet(lines)) {
            return lines;
        }

        const skipLineCount = this.getPlanningReplay3DSkipLineCount(lines, widthMeters);
        if (!skipLineCount) return lines;

        const candidates = [];
        for (let i = 0; i < lines.length; i++) {
            if (!Array.isArray(lines[i]) || lines[i].length < 2) continue;
            candidates.push({
                index: i,
                line: lines[i]
            });
        }

        if (candidates.length <= 2) {
            return candidates.map(item => item.line);
        }

        const count = candidates.length;
        const stride = Math.max(2, Math.min(count - 1, skipLineCount + 1));
        let startIndex = 0;

        if (referencePoint) {
            let bestDistance = Number.POSITIVE_INFINITY;

            for (let i = 0; i < candidates.length; i++) {
                const line = candidates[i].line;
                const distance = Math.min(
                    this.distancePlanningReplay3DMeters(referencePoint, line[0]),
                    this.distancePlanningReplay3DMeters(referencePoint, line[line.length - 1])
                );

                if (distance < bestDistance) {
                    bestDistance = distance;
                    startIndex = i;
                }
            }
        }

        const rotatedCandidates = [];
        for (let i = 0; i < count; i++) {
            rotatedCandidates.push(candidates[(startIndex + i) % count]);
        }

        const sequence = [];
        for (let offset = 0; offset < stride; offset++) {
            for (let i = offset; i < count; i += stride) {
                if (rotatedCandidates[i] && rotatedCandidates[i].line) {
                    sequence.push(rotatedCandidates[i].line);
                }
            }
        }

        return sequence.length ? sequence : candidates.map(item => item.line);
    };



    getPlanningReplay3DABPoints = (polygon) => {
        if (!polygon) return null;

        let ab = polygon.ABs;
        if ((!Array.isArray(ab) || ab.length < 2) && typeof this.selectedAB === 'function') {
            try {
                ab = this.selectedAB(polygon);
            } catch (error) {
                ab = null;
            }
        }

        if (!Array.isArray(ab) || ab.length < 2) return null;

        const pointA = this.normalizePlanningReplay3DCoord(ab[0]);
        const pointB = this.normalizePlanningReplay3DCoord(ab[1]);

        if (!pointA || !pointB) return null;

        return {
            a: pointA,
            b: pointB
        };
    };

    orientPlanningReplay3DLineByAB = (polygon, line) => {
        if (!polygon || !Array.isArray(line) || line.length < 2) return line;

        const abPoints = this.getPlanningReplay3DABPoints(polygon);
        if (!abPoints) return line;

        const projection = this.getPlanningReplay3DProjection(abPoints.a);
        const aXY = projection.toXY(abPoints.a);
        const bXY = projection.toXY(abPoints.b);
        const abVector = this.normalizePlanningReplay3DVector({
            x: bXY.x - aXY.x,
            y: bXY.y - aXY.y
        });

        const lineDirection = this.getPlanningReplay3DLineDirection(line);
        if (!lineDirection) return line;

        const dot = (lineDirection.x * abVector.x) + (lineDirection.y * abVector.y);
        return dot < 0 ? this.reversePlanningReplay3DLine(line) : line;
    };

    ensurePlanningReplay3DFirstLineByAB = (polygon, lines) => {
        if (!polygon || !Array.isArray(lines) || lines.length < 2) return lines;

        const abPoints = this.getPlanningReplay3DABPoints(polygon);
        if (!abPoints) return lines;

        let bestIndex = -1;
        let bestDistance = Number.POSITIVE_INFINITY;

        for (let i = 0; i < lines.length; i++) {
            let line = lines[i];
            if (!Array.isArray(line) || line.length < 2) continue;

            line = this.orientPlanningReplay3DLineByAB(polygon, line);
            const distance = this.distancePlanningReplay3DMeters(abPoints.a, line[0]);

            if (Number.isFinite(distance) && distance < bestDistance) {
                bestDistance = distance;
                bestIndex = i;
            }
        }

        if (bestIndex <= 0) {
            const copy = lines.slice();
            if (copy[0]) copy[0] = this.orientPlanningReplay3DLineByAB(polygon, copy[0]);
            return copy;
        }

        const ordered = [];
        ordered.push(this.orientPlanningReplay3DLineByAB(polygon, lines[bestIndex]));

        for (let i = 0; i < lines.length; i++) {
            if (i === bestIndex) continue;
            ordered.push(lines[i]);
        }

        return ordered;
    };


    getPlanningReplay3DOrderedPolygons = () => {
        return Array.isArray(this.state.polygons)
            ? this.state.polygons.filter(item => this.isPlanningReplay3DOperationalPolygon(item))
            : [];
    };


    buildPlanningReplay3DOfficialStripFromLine = (line, widthMeters, key, name, stripKey) => {
        if (!Array.isArray(line) || line.length < 2) return null;

        const safeWidth = Number.isFinite(widthMeters) && widthMeters > 0 ? widthMeters : 30;
        const geometrySpacingMeters = Math.max(6, Math.min(12, safeWidth * 0.20));
        const geometryLine = this.densifyPlanningReplay3DLine(line, geometrySpacingMeters);
        const safeGeometryLine = Array.isArray(geometryLine) && geometryLine.length >= 2
            ? geometryLine
            : line;
        const direction = this.getPlanningReplay3DLineDirection(safeGeometryLine);
        if (!direction) return null;

        const normal = { x: -direction.y, y: direction.x };
        const projection = this.getPlanningReplay3DProjection(safeGeometryLine[0]);
        const leftPoints = [];
        const rightPoints = [];
        const halfWidth = safeWidth / 2;

        for (let i = 0; i < safeGeometryLine.length; i++) {
            const point = safeGeometryLine[i];
            if (!point) continue;

            const xy = projection.toXY(point);
            const left = projection.toLatLng({
                x: xy.x + (normal.x * halfWidth),
                y: xy.y + (normal.y * halfWidth)
            });
            const right = projection.toLatLng({
                x: xy.x - (normal.x * halfWidth),
                y: xy.y - (normal.y * halfWidth)
            });

            leftPoints.push({ lat: left.lat, lng: left.lng });
            rightPoints.push({ lat: right.lat, lng: right.lng });
        }

        if (leftPoints.length < 2 || rightPoints.length < 2) return null;

        return {
            name: name || key || this.props.res.APLICACAO_PLANEJADA,
            key: key || null,
            planningStripKey: stripKey !== undefined && stripKey !== null ? stripKey : null,
            areaKey: null,
            areaName: name || null,
            left: { points: leftPoints },
            right: { points: rightPoints }
        };
    };

    buildPlanningReplay3DOfficialApplicationItems = (polygonPlans) => {
        const appItems = [];
        if (!Array.isArray(polygonPlans)) return appItems;

        for (let i = 0; i < polygonPlans.length; i++) {
            const plan = polygonPlans[i];
            if (!plan || !plan.polygon || !Array.isArray(plan.pathLines)) continue;

            const polygon = plan.polygon;
            const width = this.getPlanningReplay3DCanonicalLength(polygon.faixa || this.state.faixa);
            const safeWidth = Number.isFinite(width) && width > 0 ? width : 30;

            const officialLines = Array.isArray(plan.officialPathLines) && plan.officialPathLines.length
                ? plan.officialPathLines
                : plan.pathLines;

            for (let j = 0; j < officialLines.length; j++) {
                const line = officialLines[j];
                if (!Array.isArray(line) || line.length < 2) continue;

                let clippedSegments = this.clipPlanningReplay3DLineToPolygonSegments(line, polygon, safeWidth);

                if (!Array.isArray(clippedSegments) || clippedSegments.length === 0) {
                    const fallbackLine = this.clipPlanningReplay3DLineToPolygon(line, polygon, safeWidth);
                    clippedSegments = Array.isArray(fallbackLine) && fallbackLine.length >= 2 ? [fallbackLine] : [];
                }

                for (let segmentIndex = 0; segmentIndex < clippedSegments.length; segmentIndex++) {
                    const clippedLine = clippedSegments[segmentIndex];
                    if (!Array.isArray(clippedLine) || clippedLine.length < 2) continue;

                    const stripKey = line && line.planningStripKey !== undefined && line.planningStripKey !== null ? line.planningStripKey : null;
                    const stripName = stripKey !== null && stripKey !== undefined ? this.props.res.FAIXA_APP + ' ' + stripKey : (plan.areaName || ('Área ' + (i + 1)));
                    const officialStrip = this.buildPlanningReplay3DOfficialStripFromLine(
                        clippedLine,
                        safeWidth,
                        'planning-app-' + i + '-' + j + '-' + segmentIndex,
                        stripName,
                        stripKey
                    );

                    if (officialStrip) {
                        const stripLengthMeters = this.getPlanningReplay3DLineLengthMeters(clippedLine);
                        const stripAreaM2 = Number.isFinite(stripLengthMeters) && stripLengthMeters > 0
                            ? stripLengthMeters * safeWidth
                            : null;

                        officialStrip.areaKey = plan.areaKey || ('planning-polygon-' + i);
                        officialStrip.areaName = plan.areaName || ('Área ' + (i + 1));
                        officialStrip.polygonIndex = i;
                        officialStrip.lineIndex = j;
                        officialStrip.segmentIndex = segmentIndex;
                        officialStrip.areaM2 = Number.isFinite(stripAreaM2) && stripAreaM2 > 0 ? stripAreaM2 : null;
                        officialStrip.areaHa = Number.isFinite(stripAreaM2) && stripAreaM2 > 0 ? stripAreaM2 / 10000 : null;
                        officialStrip.polygonAreaM2 = Number.isFinite(plan.areaM2) && plan.areaM2 > 0 ? plan.areaM2 : null;
                        officialStrip.polygonAreaHa = Number.isFinite(plan.areaHa) && plan.areaHa > 0 ? plan.areaHa : null;
                        appItems.push(officialStrip);
                    }
                }
            }
        }

        return appItems;
    };


    buildPlanningReplay3DOfficialApplicationItemsFromTimeline = (timeline) => {
        const appItems = [];
        if (!Array.isArray(timeline) || timeline.length < 2) return appItems;

        let currentRun = [];
        let currentName = '';
        let currentWidth = null;

        const flushRun = () => {
            if (!currentRun || currentRun.length < 2) {
                currentRun = [];
                currentName = '';
                currentWidth = null;
                return;
            }

            const safeWidth = Number.isFinite(currentWidth) && currentWidth > 0
                ? currentWidth
                : (Number.isFinite(this.getPlanningReplay3DCanonicalLength(this.state.faixa)) ? this.getPlanningReplay3DCanonicalLength(this.state.faixa) : 30);

            const officialStrip = this.buildPlanningReplay3DOfficialStripFromLine(
                currentRun,
                safeWidth,
                'planning-app-timeline-' + appItems.length,
                currentName || ('Área ' + (appItems.length + 1))
            );

            if (officialStrip) appItems.push(officialStrip);

            currentRun = [];
            currentName = '';
            currentWidth = null;
        };

        for (let i = 0; i < timeline.length; i++) {
            const item = timeline[i];

            if (!item || !item.spray) {
                flushRun();
                continue;
            }

            const itemName = item.name || '';
            const itemWidth = this.normalizePlanningReplay3DNumber(item.width);

            if (
                currentRun.length > 0 &&
                currentName &&
                itemName &&
                currentName !== itemName
            ) {
                flushRun();
            }

            currentRun.push({ lat: item.lat, lng: item.lng });
            currentName = currentName || itemName;
            currentWidth = Number.isFinite(itemWidth) && itemWidth > 0 ? itemWidth : currentWidth;
        }

        flushRun();
        return appItems;
    };


    isPlanningReplay3DSameCorridorForwardLine = (currentLine, candidateLine, widthMeters) => {
        if (!Array.isArray(currentLine) || currentLine.length < 2 || !Array.isArray(candidateLine) || candidateLine.length < 2) {
            return false;
        }

        const safeWidth = Number.isFinite(widthMeters) && widthMeters > 0 ? widthMeters : 30;
        const currentDirection = this.getPlanningReplay3DLineDirection(currentLine);
        const candidateDirection = this.getPlanningReplay3DLineDirection(candidateLine);
        if (!currentDirection || !candidateDirection) return false;

        const dot = (currentDirection.x * candidateDirection.x) + (currentDirection.y * candidateDirection.y);
        if (dot < 0.94) return false;

        const projection = this.getPlanningReplay3DProjection(currentLine[0]);
        const origin = projection.toXY(currentLine[0]);
        const currentEnd = projection.toXY(currentLine[currentLine.length - 1]);
        const candidateStart = projection.toXY(candidateLine[0]);
        const candidateEnd = projection.toXY(candidateLine[candidateLine.length - 1]);

        const normal = {
            x: -currentDirection.y,
            y: currentDirection.x
        };

        const toAxis = (xy) => {
            const delta = {
                x: xy.x - origin.x,
                y: xy.y - origin.y
            };

            return {
                forward: (delta.x * currentDirection.x) + (delta.y * currentDirection.y),
                lateral: (delta.x * normal.x) + (delta.y * normal.y)
            };
        };

        const currentEndAxis = toAxis(currentEnd);
        const candidateStartAxis = toAxis(candidateStart);
        const candidateEndAxis = toAxis(candidateEnd);

        const lateralStart = Math.abs(candidateStartAxis.lateral);
        const lateralEnd = Math.abs(candidateEndAxis.lateral);
        const lateralLimit = Math.max(safeWidth * 1.15, 32);

        if (lateralStart > lateralLimit || lateralEnd > lateralLimit) return false;

        const candidateForwardMin = Math.min(candidateStartAxis.forward, candidateEndAxis.forward);
        const candidateForwardMax = Math.max(candidateStartAxis.forward, candidateEndAxis.forward);
        const forwardGap = candidateForwardMin - currentEndAxis.forward;

        if (candidateForwardMax <= currentEndAxis.forward + Math.max(5, safeWidth * 0.20)) return false;
        if (forwardGap < -(safeWidth * 1.20)) return false;
        if (forwardGap > Math.max(safeWidth * 18, 850)) return false;

        return true;
    };

    orientPlanningReplay3DLineForSameCorridor = (currentLine, candidateLine, widthMeters) => {
        if (!Array.isArray(candidateLine) || candidateLine.length < 2) return candidateLine;
        if (this.isPlanningReplay3DSameCorridorForwardLine(currentLine, candidateLine, widthMeters)) return candidateLine;

        const reversed = this.reversePlanningReplay3DLine(candidateLine);
        if (this.isPlanningReplay3DSameCorridorForwardLine(currentLine, reversed, widthMeters)) return reversed;

        return candidateLine;
    };

    findPlanningReplay3DNextSameCorridorLine = (polygonPlans, currentPlanIndex, currentLineIndex, currentLine, widthMeters, consumedLineMap) => {
        if (!Array.isArray(polygonPlans) || !Array.isArray(currentLine) || currentLine.length < 2) return null;

        let best = null;
        for (let planIndex = 0; planIndex < polygonPlans.length; planIndex++) {
            const plan = polygonPlans[planIndex];
            if (!plan || !Array.isArray(plan.pathLines)) continue;

            for (let lineIndex = 0; lineIndex < plan.pathLines.length; lineIndex++) {
                const key = planIndex + '_' + lineIndex;
                if (consumedLineMap && consumedLineMap[key]) continue;

                const polygon = plan.polygon;
                const widthNumber = this.getPlanningReplay3DCanonicalLength((polygon && polygon.faixa) || this.state.faixa);
                const safeWidth = Number.isFinite(widthNumber) && widthNumber > 0 ? widthNumber : widthMeters;
                let rawLine = plan.pathLines[lineIndex];
                if (!Array.isArray(rawLine) || rawLine.length < 2) continue;

                let applicationSegments = this.clipPlanningReplay3DLineToPolygonSegments(rawLine, polygon, safeWidth);
                if (!Array.isArray(applicationSegments) || applicationSegments.length === 0) {
                    const fallbackLine = this.clipPlanningReplay3DLineToPolygon(rawLine, polygon, safeWidth);
                    applicationSegments = Array.isArray(fallbackLine) && fallbackLine.length >= 2 ? [fallbackLine] : [];
                }

                if (!applicationSegments.length) continue;

                const firstSegment = applicationSegments[0];
                const lastSegment = applicationSegments[applicationSegments.length - 1];
                let applicationLine = [
                    firstSegment[0],
                    lastSegment[lastSegment.length - 1]
                ];

                applicationLine = this.orientPlanningReplay3DLineForSameCorridor(
                    currentLine,
                    applicationLine,
                    Math.min(widthMeters, safeWidth)
                );

                if (!this.isPlanningReplay3DSameCorridorForwardLine(currentLine, applicationLine, Math.min(widthMeters, safeWidth))) {
                    continue;
                }

                const distance = this.distancePlanningReplay3DMeters(currentLine[currentLine.length - 1], applicationLine[0]);

                if (!best || distance < best.distance) {
                    best = {
                        key: key,
                        planIndex: planIndex,
                        lineIndex: lineIndex,
                        line: applicationLine,
                        polygon: polygon,
                        safeWidth: safeWidth,
                        areaName: plan.areaName,
                        distance: distance
                    };
                }
            }
        }

        return best;
    };


    buildPlanningReplay3DContinuousPasses = (pathLines, polygon, widthMeters) => {
        const passes = [];
        if (!Array.isArray(pathLines) || !pathLines.length) return passes;

        const safeWidth = Number.isFinite(widthMeters) && widthMeters > 0 ? widthMeters : 30;
        const sourceItems = [];

        for (let i = 0; i < pathLines.length; i++) {
            const rawLine = pathLines[i];
            if (!Array.isArray(rawLine) || rawLine.length < 2) continue;

            let segments = this.clipPlanningReplay3DLineToPolygonSegments(rawLine, polygon, safeWidth);
            if (!Array.isArray(segments) || !segments.length) {
                const fallback = this.clipPlanningReplay3DLineToPolygon(rawLine, polygon, safeWidth);
                segments = Array.isArray(fallback) && fallback.length >= 2 ? [fallback] : [];
            }

            if (!segments.length) continue;

            const firstSegment = segments[0];
            const lastSegment = segments[segments.length - 1];
            const passLine = [
                firstSegment[0],
                lastSegment[lastSegment.length - 1]
            ];

            const direction = this.getPlanningReplay3DLineDirection(passLine);
            if (!direction) continue;

            const center = this.getPlanningReplay3DLineCenter(passLine);
            if (!center) continue;

            sourceItems.push({
                index: i,
                rawLine: rawLine,
                passLine: passLine,
                center: center,
                direction: direction
            });
        }

        if (!sourceItems.length) return passes;

        let baseItem = sourceItems[0];
        let baseLength = this.getPlanningReplay3DLineLengthMeters(baseItem.passLine);
        for (let i = 1; i < sourceItems.length; i++) {
            const length = this.getPlanningReplay3DLineLengthMeters(sourceItems[i].passLine);
            if (length > baseLength) {
                baseLength = length;
                baseItem = sourceItems[i];
            }
        }

        const mainDirection = this.getPlanningReplay3DLineDirection(baseItem.passLine);
        if (!mainDirection) {
            return sourceItems.map(item => ({
                line: item.passLine,
                rawLines: [item.rawLine]
            }));
        }

        const projection = this.getPlanningReplay3DProjection(baseItem.center);
        const origin = projection.toXY(baseItem.center);
        const normal = { x: -mainDirection.y, y: mainDirection.x };

        const axisOf = (point) => {
            const xy = projection.toXY(point);
            const delta = {
                x: xy.x - origin.x,
                y: xy.y - origin.y
            };

            return {
                forward: (delta.x * mainDirection.x) + (delta.y * mainDirection.y),
                lateral: (delta.x * normal.x) + (delta.y * normal.y)
            };
        };

        for (let i = 0; i < sourceItems.length; i++) {
            const item = sourceItems[i];
            const oriented = this.orientPlanningReplay3DLineByDirection(item.passLine, mainDirection);
            const startAxis = axisOf(oriented[0]);
            const endAxis = axisOf(oriented[oriented.length - 1]);
            const centerAxis = axisOf(item.center);

            item.passLine = oriented;
            item.lateral = centerAxis.lateral;
            item.forwardMin = Math.min(startAxis.forward, endAxis.forward);
            item.forwardMax = Math.max(startAxis.forward, endAxis.forward);
        }

        sourceItems.sort((a, b) => {
            if (a.lateral === b.lateral) return a.forwardMin - b.forwardMin;
            return a.lateral - b.lateral;
        });
        const corridorTolerance = Math.max(safeWidth * 0.38, 10);
        const groups = [];

        for (let i = 0; i < sourceItems.length; i++) {
            const item = sourceItems[i];
            let group = null;

            for (let j = 0; j < groups.length; j++) {
                if (Math.abs(groups[j].lateral - item.lateral) <= corridorTolerance) {
                    group = groups[j];
                    break;
                }
            }

            if (!group) {
                group = {
                    lateral: item.lateral,
                    items: []
                };
                groups.push(group);
            }

            group.items.push(item);

            const lateralWeight = group.items.reduce((acc, groupItem) => {
                const itemLength = Math.max(1, groupItem.forwardMax - groupItem.forwardMin);
                return acc + itemLength;
            }, 0);
            const weightedLateral = group.items.reduce((acc, groupItem) => {
                const itemLength = Math.max(1, groupItem.forwardMax - groupItem.forwardMin);
                return acc + (groupItem.lateral * itemLength);
            }, 0);

            group.lateral = lateralWeight > 0 ? weightedLateral / lateralWeight : item.lateral;
        }

        groups.sort((a, b) => a.lateral - b.lateral);

        for (let groupIndex = 0; groupIndex < groups.length; groupIndex++) {
            const group = groups[groupIndex];

            group.items.sort((a, b) => a.forwardMin - b.forwardMin);

            const firstItem = group.items[0];
            const lastItem = group.items[group.items.length - 1];

            const startForward = firstItem.forwardMin;
            const endForward = lastItem.forwardMax;
            const lateral = group.lateral;

            const startPoint = projection.toLatLng({
                x: origin.x + (mainDirection.x * startForward) + (normal.x * lateral),
                y: origin.y + (mainDirection.y * startForward) + (normal.y * lateral)
            });
            const endPoint = projection.toLatLng({
                x: origin.x + (mainDirection.x * endForward) + (normal.x * lateral),
                y: origin.y + (mainDirection.y * endForward) + (normal.y * lateral)
            });

            let line = [startPoint, endPoint];

            if (groupIndex % 2 === 1) {
                line = this.reversePlanningReplay3DLine(line);
            }

            passes.push({
                line: line,
                rawLines: group.items.map(item => item.rawLine)
            });
        }

        return passes;
    };

    getPlanningReplay3DAngleBetweenDirectionsDeg = (directionA, directionB) => {
        if (!directionA || !directionB) return 0;

        const dirA = this.normalizePlanningReplay3DVector(directionA);
        const dirB = this.normalizePlanningReplay3DVector(directionB);
        const dot = Math.max(-1, Math.min(1, (dirA.x * dirB.x) + (dirA.y * dirB.y)));

        return Math.acos(dot) * (180 / Math.PI);
    };

    getPlanningReplay3DDirectionBetweenPoints = (fromPoint, toPoint) => {
        if (!fromPoint || !toPoint) return null;

        const projection = this.getPlanningReplay3DProjection(fromPoint);
        const fromXY = projection.toXY(fromPoint);
        const toXY = projection.toXY(toPoint);

        return this.normalizePlanningReplay3DVector({
            x: toXY.x - fromXY.x,
            y: toXY.y - fromXY.y
        });
    };

    cleanPlanningReplay3DSharpTransitCorners = (timeline) => {
        if (!Array.isArray(timeline) || timeline.length < 4) return timeline;

        const cloneTransitPoint = (source, latLng, tSec) => {
            return Object.assign({}, source, {
                lat: latLng.lat,
                lng: latLng.lng,
                tSec: Number.isFinite(tSec) ? tSec : source.tSec,
                spray: false,
                telemetryType: source.telemetryType || 'transit',
                applicationType: source.applicationType === 'refuel' ? 'refuel' : null,
                spraySource: 'none'
            });
        };

        const interpolateTime = (pointA, pointB, factor) => {
            const timeA = pointA && Number.isFinite(pointA.tSec) ? pointA.tSec : null;
            const timeB = pointB && Number.isFinite(pointB.tSec) ? pointB.tSec : null;

            if (timeA !== null && timeB !== null) {
                return timeA + ((timeB - timeA) * factor);
            }

            if (timeA !== null) return timeA;
            if (timeB !== null) return timeB;
            return null;
        };

        const cleaned = [];

        for (let i = 0; i < timeline.length; i++) {
            const previous = cleaned.length ? cleaned[cleaned.length - 1] : null;
            const current = timeline[i];
            const next = i < timeline.length - 1 ? timeline[i + 1] : null;

            if (
                previous &&
                current &&
                next &&
                !previous.spray &&
                !current.spray &&
                (next.spray || !next.spray)
            ) {
                const distanceA = this.distancePlanningReplay3DMeters(previous, current);
                const distanceB = this.distancePlanningReplay3DMeters(current, next);
                const dirA = this.getPlanningReplay3DDirectionBetweenPoints(previous, current);
                const dirB = this.getPlanningReplay3DDirectionBetweenPoints(current, next);
                const angleDeg = this.getPlanningReplay3DAngleBetweenDirectionsDeg(dirA, dirB);
                const safeWidth = Number.isFinite(current.width) && current.width > 0
                    ? current.width
                    : (Number.isFinite(previous.width) && previous.width > 0 ? previous.width : 30);

                if (
                    Number.isFinite(distanceA) &&
                    Number.isFinite(distanceB) &&
                    distanceA > 14 &&
                    distanceB > 14 &&
                    angleDeg > 24
                ) {
                    const projection = this.getPlanningReplay3DProjection(current);
                    const previousXY = projection.toXY(previous);
                    const currentXY = projection.toXY(current);
                    const nextXY = projection.toXY(next);
                    const isEntryToSpray = !!next.spray;
                    const maxCornerRadius = Math.max(110, Math.min(560, safeWidth * 16));
                    const cornerRadius = Math.max(
                        38,
                        Math.min(
                            distanceA * 0.62,
                            distanceB * (isEntryToSpray ? 0.28 : 0.62),
                            maxCornerRadius
                        )
                    );
                    const entryRatio = Math.max(0, Math.min(1, (distanceA - cornerRadius) / distanceA));
                    const exitRatio = Math.max(0, Math.min(1, cornerRadius / distanceB));
                    const entryXY = {
                        x: previousXY.x + ((currentXY.x - previousXY.x) * entryRatio),
                        y: previousXY.y + ((currentXY.y - previousXY.y) * entryRatio)
                    };
                    const exitXY = {
                        x: currentXY.x + ((nextXY.x - currentXY.x) * exitRatio),
                        y: currentXY.y + ((nextXY.y - currentXY.y) * exitRatio)
                    };
                    const entryPoint = projection.toLatLng(entryXY);
                    const exitPoint = projection.toLatLng(exitXY);
                    const totalRoundedDistance = Math.max(1, cornerRadius * 2);
                    const steps = Math.max(14, Math.min(54, Math.ceil(totalRoundedDistance / Math.max(7, safeWidth * 0.34))));
                    const currentTime = Number.isFinite(current.tSec) ? current.tSec : interpolateTime(previous, next, 0.5);
                    const entryTime = interpolateTime(previous, current, entryRatio);
                    const exitTime = interpolateTime(current, next, exitRatio);

                    if (this.distancePlanningReplay3DMeters(previous, entryPoint) > 1.5) {
                        cleaned.push(cloneTransitPoint(current, entryPoint, entryTime));
                    }

                    for (let step = 1; step < steps; step++) {
                        const t = step / steps;
                        const inv = 1 - t;
                        const xy = {
                            x: (inv * inv * entryXY.x) + (2 * inv * t * currentXY.x) + (t * t * exitXY.x),
                            y: (inv * inv * entryXY.y) + (2 * inv * t * currentXY.y) + (t * t * exitXY.y)
                        };
                        const curveTime = entryTime !== null && exitTime !== null
                            ? entryTime + ((exitTime - entryTime) * t)
                            : currentTime;

                        cleaned.push(cloneTransitPoint(current, projection.toLatLng(xy), curveTime));
                    }

                    if (this.distancePlanningReplay3DMeters(exitPoint, next) > 1.5) {
                        cleaned.push(cloneTransitPoint(current, exitPoint, exitTime));
                    }

                    continue;
                }
            }

            cleaned.push(current);
        }

        return cleaned;
    };


    appendPlanningReplay3DMissingBackToBackLines = (selectedLines, allLines, widthMeters) => {
        if (!Array.isArray(selectedLines) || !selectedLines.length || !Array.isArray(allLines) || !allLines.length) {
            return selectedLines;
        }

        const safeWidth = Number.isFinite(widthMeters) && widthMeters > 0 ? widthMeters : 30;
        const referenceLine = selectedLines[0];
        const referenceDirection = this.getPlanningReplay3DLineDirection(referenceLine);
        if (!referenceDirection) return selectedLines;

        const referenceNormal = { x: -referenceDirection.y, y: referenceDirection.x };
        const referenceProjection = this.getPlanningReplay3DProjection(referenceLine[0]);
        const projectLineCenter = (line) => {
            const center = this.getPlanningReplay3DLineCenter(line);
            if (!center) return null;
            const xy = referenceProjection.toXY(center);
            return {
                line: line,
                center: center,
                offset: (xy.x * referenceNormal.x) + (xy.y * referenceNormal.y)
            };
        };

        const selectedCenters = selectedLines
            .map(projectLineCenter)
            .filter(Boolean);

        if (!selectedCenters.length) return selectedLines;

        let minOffset = selectedCenters[0].offset;
        let maxOffset = selectedCenters[0].offset;
        for (let i = 1; i < selectedCenters.length; i++) {
            minOffset = Math.min(minOffset, selectedCenters[i].offset);
            maxOffset = Math.max(maxOffset, selectedCenters[i].offset);
        }

        const duplicateDistance = Math.max(18, safeWidth * 0.72);
        const outsideTolerance = Math.max(12, safeWidth * 0.42);
        const candidates = [];

        for (let i = 0; i < allLines.length; i++) {
            const candidate = allLines[i];
            if (!Array.isArray(candidate) || candidate.length < 2) continue;

            const candidateCenter = projectLineCenter(candidate);
            if (!candidateCenter) continue;

            const alreadyExists = selectedCenters.some((item) => {
                return this.distancePlanningReplay3DMeters(item.center, candidateCenter.center) <= duplicateDistance;
            });

            if (alreadyExists) continue;

            const isEdgeMissing = candidateCenter.offset < (minOffset - outsideTolerance) ||
                candidateCenter.offset > (maxOffset + outsideTolerance);

            if (!isEdgeMissing) continue;

            candidates.push(candidateCenter);
        }

        if (!candidates.length) return selectedLines;

        candidates.sort((a, b) => Math.abs(a.offset - maxOffset) - Math.abs(b.offset - maxOffset));

        const output = selectedLines.slice();
        for (let i = 0; i < candidates.length; i++) {
            output.push(candidates[i].line);
        }

        return output;
    };


    buildPlanningReplay3DData = () => {
        const configuredBasePoint = this.getPlanningReplay3DInitialBasePoint();
        const applicationSpeed = this.getPlanningReplay3DCanonicalSpeed(this.state.speed_apl || this.state.speed);
        const travelSpeed = this.getPlanningReplay3DCanonicalSpeed(this.state.speed_travel || this.state.speed);
        const loopSpeed = this.getPlanningReplay3DCanonicalSpeed(this.state.speed_loop || this.state.speed || this.state.speed_apl);
        const altitude = this.getPlanningReplay3DCanonicalLength(this.state.altura);
        const safeAltitude = Number.isFinite(altitude) && altitude > 0 ? altitude : 6;
        const baseAltitude = Math.max(safeAltitude + 45, 60);
        const timeline = [];
        const orderedPolygons = this.getPlanningReplay3DOrderedPolygons();
        const polygonPlans = [];
        const consumedLineMap = {};

        for (let i = 0; i < orderedPolygons.length; i++) {
            const polygon = orderedPolygons[i];
            const out = this.getPlanningReplay3DSelectedOut(polygon);
            if (!out) continue;

            const outStart = this.normalizePlanningReplay3DCoord(out.startPath);
            const lineWidth = this.getPlanningReplay3DCanonicalLength(polygon.faixa || this.state.faixa);
            let pathLines = this.getPlanningReplay3DStrategyPathLines(polygon, out);
            let usesStrategyOrder = pathLines && pathLines.length > 0;

            const rawPathLines = this.getPlanningReplay3DLinesFromPolygon(polygon, out);
            const preparedLines = this.preparePlanningReplay3DOperationalLines(rawPathLines, configuredBasePoint || outStart, lineWidth);
            const executionLines = this.getPlanningReplay3DExecutionLines(preparedLines, configuredBasePoint || outStart, lineWidth);

            if (!usesStrategyOrder) {
                pathLines = executionLines;
                pathLines = this.ensurePlanningReplay3DFirstLineByAB(polygon, pathLines);
            } else {
                pathLines = this.appendPlanningReplay3DMissingBackToBackLines(pathLines, executionLines, lineWidth);
            }

            if (!pathLines || pathLines.length === 0) continue;

            const polygonAreaM2 = this.normalizePlanningReplay3DNumber(polygon.area);
            const polygonAreaKey = 'planning-polygon-' + polygonPlans.length;

            polygonPlans.push({
                polygon: polygon,
                out: out,
                pathLines: pathLines,
                officialPathLines: Array.isArray(pathLines) ? pathLines.slice() : [],
                usesStrategyOrder: usesStrategyOrder,
                areaName: polygon.name || ('Área ' + (polygonPlans.length + 1)),
                areaKey: polygonAreaKey,
                areaM2: Number.isFinite(polygonAreaM2) && polygonAreaM2 > 0 ? polygonAreaM2 : null,
                areaHa: Number.isFinite(polygonAreaM2) && polygonAreaM2 > 0 ? polygonAreaM2 / 10000 : null
            });
        }

        if (polygonPlans.length === 0) return null;

        const planningTotalAreaM2 = polygonPlans.reduce((total, item) => {
            const area = this.normalizePlanningReplay3DNumber(item && item.polygon && item.polygon.area);
            return total + (Number.isFinite(area) && area > 0 ? area : 0);
        }, 0);

        const firstReferenceLines = polygonPlans[0].pathLines;
        const firstRawLine = firstReferenceLines && firstReferenceLines.length ? firstReferenceLines[0] : null;
        if (!firstRawLine || firstRawLine.length < 2) return null;

        let firstLine = firstRawLine;
        const firstOutStart = this.normalizePlanningReplay3DCoord(polygonPlans[0].out.startPath);
        if (polygonPlans[0].usesStrategyOrder) {
            firstLine = this.orientPlanningReplay3DLineByAB(polygonPlans[0].polygon, firstLine);
        } else {
            if (configuredBasePoint) {
                firstLine = this.orientPlanningReplay3DLineByReference(firstLine, configuredBasePoint);
            } else if (firstOutStart) {
                firstLine = this.orientPlanningReplay3DLineByReference(firstLine, firstOutStart);
            }
        }

        const firstDirection = this.getPlanningReplay3DLineDirection(firstLine);
        const firstLineStart = firstLine[0];
        const operationLeadMeters = this.getPlanningReplay3DOperationLeadMeters();
        const syntheticStartPoint = this.offsetPlanningReplay3DPoint(firstLineStart, { x: -firstDirection.x, y: -firstDirection.y }, operationLeadMeters);
        const initialPoint = configuredBasePoint || syntheticStartPoint;
        let currentPoint = initialPoint;
        let currentDirection = null;
        let currentTime = 0;
        const fuelCapacity = this.getPlanningReplay3DFuelCapacity();
        const officialRefuelCountValue = this.normalizePlanningReplay3DNumber(
            this.state && this.state.time ? this.state.time.flxMedApl : null
        );
        const officialRefuelCount = Number.isFinite(officialRefuelCountValue)
            ? Math.max(0, Math.round(officialRefuelCountValue))
            : null;
        const planningTime = this.state && this.state.time ? this.state.time : {};
        const officialTotalTimeSec = this.normalizePlanningReplay3DNumber(planningTime.tTotal);
        const officialFlightTimeSec = this.normalizePlanningReplay3DNumber(planningTime.tVoo);
        const officialRefuelTotalSec = Number.isFinite(officialTotalTimeSec) &&
            Number.isFinite(officialFlightTimeSec) &&
            officialTotalTimeSec >= officialFlightTimeSec
            ? officialTotalTimeSec - officialFlightTimeSec
            : (officialRefuelCount !== null
                ? officialRefuelCount * this.getPlanningReplay3DRefuelMinutes() * 60
                : null);
        const officialRefuelDurationSec = officialRefuelCount &&
            Number.isFinite(officialRefuelTotalSec) &&
            officialRefuelTotalSec >= 0
            ? officialRefuelTotalSec / officialRefuelCount
            : null;
        const estimatedTotalConsumption = polygonPlans.reduce((total, plan) => {
            const planLines = Array.isArray(plan && plan.pathLines) ? plan.pathLines : [];
            const planPolygon = plan ? plan.polygon : null;
            const planWidth = this.getPlanningReplay3DCanonicalLength(planPolygon && planPolygon.faixa);
            const defaultWidth = this.getPlanningReplay3DCanonicalLength(this.state && this.state.faixa);
            const effectiveWidth = Number.isFinite(planWidth) && planWidth > 0
                ? planWidth
                : (Number.isFinite(defaultWidth) && defaultWidth > 0 ? defaultWidth : 30);

            return total + planLines.reduce((lineTotal, rawLine) => {
                const applicationLine = this.trimPlanningReplay3DApplicationLine(rawLine, effectiveWidth);
                return lineTotal + this.estimatePlanningReplay3DApplicationConsumption(
                    applicationLine,
                    planPolygon,
                    applicationSpeed,
                    effectiveWidth
                );
            }, 0);
        }, 0);
        let fuelConsumptionScale = 1;

        if (
            fuelCapacity &&
            officialRefuelCount !== null &&
            Number.isFinite(estimatedTotalConsumption) &&
            estimatedTotalConsumption > 0
        ) {
            const targetTotalConsumption = officialRefuelCount > 0
                ? fuelCapacity * (officialRefuelCount + 0.5)
                : Math.min(estimatedTotalConsumption, fuelCapacity * 0.95);
            fuelConsumptionScale = targetTotalConsumption / estimatedTotalConsumption;
        }

        const defaultRefuelPoint = configuredBasePoint || this.getPlanningReplay3DInitialFuelPoint(firstLineStart) || initialPoint;
        const fuelState = fuelCapacity
            ? {
                capacity: fuelCapacity,
                level: fuelCapacity,
                refuelCount: 0,
                refuelIndex: 0,
                officialRefuelCount: officialRefuelCount,
                refuelTotalSec: officialRefuelTotalSec,
                refuelDurationSec: officialRefuelDurationSec,
                consumptionScale: fuelConsumptionScale
            }
            : null;

        this.addPlanningReplay3DPoint(timeline, initialPoint, {
            tSec: currentTime,
            spray: false,
            alt: configuredBasePoint ? baseAltitude : safeAltitude,
            width: this.getPlanningReplay3DCanonicalLength(this.state.faixa),
            speed: configuredBasePoint ? travelSpeed : applicationSpeed,
            name: configuredBasePoint ? this.props.res.BASE : this.props.res.APROXIMACAO_INICIAL,
            fuelLevel: fuelState ? fuelState.level : null,
            fuelCapacity: fuelState ? fuelState.capacity : null,
            fuelPercent: fuelState ? 100 : null,
            refuelIndex: 0,
            refuelCount: 0
        });

        for (let i = 0; i < polygonPlans.length; i++) {
            const plan = polygonPlans[i];
            const polygon = plan.polygon;
            const out = plan.out;
            const pathLines = plan.pathLines;
            const width = this.getPlanningReplay3DCanonicalLength(polygon.faixa || this.state.faixa);
            const safeWidth = Number.isFinite(width) && width > 0 ? width : 30;
            const areaName = plan.areaName;

            for (let j = 0; j < pathLines.length; j++) {
                const currentKey = i + '_' + j;
                if (consumedLineMap[currentKey]) continue;

                let line = pathLines[j];
                if (!Array.isArray(line) || line.length < 2) continue;

                let passLine = line;
                if (plan.usesStrategyOrder) {
                    if (j === 0) {
                        passLine = this.orientPlanningReplay3DLineByAB(polygon, passLine);
                    } else {
                        passLine = this.orientPlanningReplay3DLineByReference(passLine, currentPoint);
                    }
                } else {
                    line = this.orientPlanningReplay3DLineByReference(line, currentPoint);
                    passLine = line;
                    if (j === 0) {
                        passLine = this.orientPlanningReplay3DLineByAB(polygon, passLine);
                    } else {
                        passLine = this.orientPlanningReplay3DLineByReference(passLine, currentPoint);
                    }
                }

                const currentPlanningStripKey = passLine && passLine.planningStripKey !== undefined && passLine.planningStripKey !== null
                    ? passLine.planningStripKey
                    : (line && line.planningStripKey !== undefined && line.planningStripKey !== null ? line.planningStripKey : null);
                const currentPlanningStripName = currentPlanningStripKey !== null && currentPlanningStripKey !== undefined
                    ? this.props.res.FAIXA_APP + ' ' + currentPlanningStripKey
                    : null;

                consumedLineMap[currentKey] = true;

                const lineStart = passLine[0];
                const lineEnd = passLine[passLine.length - 1];
                const nextDirection = this.getPlanningReplay3DLineDirection(passLine);
                const estimatedConsumption = this.estimatePlanningReplay3DApplicationConsumption(passLine, polygon, applicationSpeed, safeWidth);
                const polygonFuelPoint = out && out.fuelPoint && out.fuelPoint.length > 0
                    ? this.getPlanningReplay3DFuelPoint(out.fuelPoint[0])
                    : null;
                const refuelPoint = defaultRefuelPoint || polygonFuelPoint;
                let alreadyPositionedAfterRefuel = false;

                if (
                    !(i === 0 && j === 0) &&
                    fuelState &&
                    refuelPoint &&
                    Number.isFinite(fuelState.level) &&
                    fuelState.level <= 0
                ) {
                    const refuelResult = this.appendPlanningReplay3DRefuelCycle(
                        timeline,
                        currentPoint,
                        lineStart,
                        currentDirection,
                        nextDirection,
                        currentTime,
                        travelSpeed,
                        safeAltitude,
                        safeWidth,
                        fuelState,
                        refuelPoint,
                        areaName
                    );

                    currentTime = refuelResult.currentTime;
                    currentPoint = refuelResult.currentPoint;
                    currentDirection = refuelResult.currentDirection;
                    alreadyPositionedAfterRefuel = true;
                }

                if (!alreadyPositionedAfterRefuel && i === 0 && j === 0) {
                    const configuredLoopLength = this.getPlanningReplay3DConfiguredLoopLength(safeWidth);
                    const approachDistance = configuredBasePoint
                        ? Math.max(operationLeadMeters, configuredLoopLength)
                        : operationLeadMeters;
                    const approachPoint = this.offsetPlanningReplay3DPoint(
                        lineStart,
                        { x: -nextDirection.x, y: -nextDirection.y },
                        approachDistance
                    );

                    if (configuredBasePoint) {
                        const rawApproachDirection = this.getPlanningReplay3DPointDirection(
                            currentPoint,
                            lineStart,
                            nextDirection
                        );
                        const approachDirection = this.normalizePlanningReplay3DVector(rawApproachDirection || nextDirection) || nextDirection;

                        currentTime = this.appendPlanningReplay3DSmoothTransitWithAltitude(
                            timeline,
                            currentPoint,
                            lineStart,
                            approachDirection,
                            nextDirection,
                            currentTime,
                            travelSpeed,
                            baseAltitude,
                            safeAltitude,
                            safeWidth,
                            this.props.res.ENTRADA_PRIMEIRA_FAIXA
                        );
                    } else {
                        currentPoint = approachPoint;

                        currentTime = this.appendPlanningReplay3DSmoothTransit(
                            timeline,
                            currentPoint,
                            lineStart,
                            nextDirection,
                            nextDirection,
                            currentTime,
                            applicationSpeed,
                            safeAltitude,
                            safeWidth,
                            this.props.res.ENTRADA_PRIMEIRA_FAIXA
                        );
                    }

                    currentPoint = lineStart;
                } else if (i > 0 && j === 0) {
                    const configuredLoopLength = this.getPlanningReplay3DConfiguredLoopLength(safeWidth);
                    const areaApproachPoint = this.offsetPlanningReplay3DPoint(lineStart, { x: -nextDirection.x, y: -nextDirection.y }, configuredLoopLength);

                    currentTime = this.appendPlanningReplay3DInterAreaBalloon(
                        timeline,
                        currentPoint,
                        areaApproachPoint,
                        currentDirection,
                        nextDirection,
                        currentTime,
                        travelSpeed,
                        safeAltitude,
                        safeWidth,
                        this.props.res.BALAO_PARA + ' ' + areaName
                    );
                    currentPoint = areaApproachPoint;

                    currentTime = this.appendPlanningReplay3DSmoothTransit(
                        timeline,
                        currentPoint,
                        lineStart,
                        nextDirection,
                        nextDirection,
                        currentTime,
                        applicationSpeed,
                        safeAltitude,
                        safeWidth,
                        this.props.res.ENTRADA_PRIMEIRA_FAIXA_DE + ' ' + areaName
                    );
                } else if (this.isPlanningReplay3DContinuationLine(currentPoint, currentDirection, lineStart, nextDirection, safeWidth)) {
                    currentTime = this.appendPlanningReplay3DSmoothTransit(
                        timeline,
                        currentPoint,
                        lineStart,
                        currentDirection,
                        nextDirection,
                        currentTime,
                        applicationSpeed,
                        safeAltitude,
                        safeWidth,
                        this.props.res.CONTINUACAO_FAIXA
                    );
                } else {
                    const configuredLoopLength = this.getPlanningReplay3DConfiguredLoopLength(safeWidth);
                    const lineApproachPoint = this.offsetPlanningReplay3DPoint(
                        lineStart,
                        { x: -nextDirection.x, y: -nextDirection.y },
                        configuredLoopLength
                    );

                    currentTime = this.appendPlanningReplay3DBalloon(
                        timeline,
                        currentPoint,
                        lineApproachPoint,
                        currentDirection,
                        nextDirection,
                        currentTime,
                        loopSpeed || applicationSpeed,
                        safeAltitude,
                        safeWidth,
                        this.props.res.BALAO_PROXIMA_FAIXA
                    );

                    currentPoint = lineApproachPoint;

                    currentTime = this.appendPlanningReplay3DSmoothTransit(
                        timeline,
                        currentPoint,
                        lineStart,
                        nextDirection,
                        nextDirection,
                        currentTime,
                        applicationSpeed,
                        safeAltitude,
                        safeWidth,
                        this.props.res.ENTRADA_PROXIMA_FAIXA || this.props.res.ENTRADA_PRIMEIRA_FAIXA
                    );
                }

                let remainingApplicationLine = passLine;
                let applicationLoopGuard = 0;

                while (Array.isArray(remainingApplicationLine) && remainingApplicationLine.length >= 2 && applicationLoopGuard < 12) {
                    applicationLoopGuard++;
                    const applicationResult = this.appendPlanningReplay3DSegmentedApplicationLine(
                        timeline,
                        remainingApplicationLine,
                        polygon,
                        currentTime,
                        applicationSpeed,
                        safeAltitude,
                        safeWidth,
                        areaName,
                        fuelState,
                        currentPlanningStripKey,
                        currentPlanningStripName
                    );

                    currentTime = applicationResult.currentTime;
                    currentPoint = applicationResult.currentPoint || currentPoint;
                    currentDirection = nextDirection;

                    if (!applicationResult.interrupted || !refuelPoint || !fuelState) {
                        remainingApplicationLine = null;
                        break;
                    }

                    const refuelResult = this.appendPlanningReplay3DRefuelCycle(
                        timeline,
                        currentPoint,
                        currentPoint,
                        currentDirection,
                        nextDirection,
                        currentTime,
                        travelSpeed,
                        safeAltitude,
                        safeWidth,
                        fuelState,
                        refuelPoint,
                        areaName
                    );

                    currentTime = refuelResult.currentTime;
                    currentPoint = refuelResult.currentPoint;
                    currentDirection = refuelResult.currentDirection;
                    remainingApplicationLine = applicationResult.remainingLine;
                }

                currentPoint = currentPoint || lineEnd;
                currentDirection = nextDirection;

            }

            if (i < polygonPlans.length - 1 && out.fuelPoint && out.fuelPoint.length > 0) {
                const fuelPoint = this.getPlanningReplay3DFuelPoint(out.fuelPoint[0]);
                if (fuelPoint) {
                    currentTime = this.appendPlanningReplay3DTransit(
                        timeline,
                        currentPoint,
                        fuelPoint,
                        currentTime,
                        travelSpeed,
                        baseAltitude,
                        safeWidth,
                        this.props.res.ABASTECIMENTO
                    );
                    currentPoint = fuelPoint;
                    currentDirection = null;
                }
            }
        }

        if (currentPoint && currentDirection) {
            const finalExitWidth = this.getPlanningReplay3DCanonicalLength(this.state.faixa);
            const safeFinalExitWidth = Number.isFinite(finalExitWidth) && finalExitWidth > 0 ? finalExitWidth : 30;
            const finalExitDistance = Math.max(
                240,
                Math.min(
                    Math.max(operationLeadMeters * 2.15, safeFinalExitWidth * 8.5, 285),
                    380
                )
            );
            const finalExitPoint = this.offsetPlanningReplay3DPoint(currentPoint, currentDirection, finalExitDistance);

            currentTime = this.appendPlanningReplay3DTransit(
                timeline,
                currentPoint,
                finalExitPoint,
                currentTime,
                applicationSpeed,
                safeAltitude,
                safeFinalExitWidth,
                'Saída final da última faixa'
            );
        }

        const cleanedTimeline = this.cleanPlanningReplay3DSharpTransitCorners(timeline);
        timeline.length = 0;
        for (let i = 0; i < cleanedTimeline.length; i++) {
            timeline.push(cleanedTimeline[i]);
        }

        if (timeline.length < 2) return null;

        this.propagatePlanningReplay3DFuelState(timeline, fuelState);

        const officialApplicationItems = this.buildPlanningReplay3DOfficialApplicationItems(polygonPlans);
        const baseSec = Date.now() / 1000;
        const path = [];
        const pontos = [];
        let planningReplay3DShotCounter = 0;
        let planningReplay3DWasSpraying = false;
        const timelineTotalTimeSec = timeline.length > 1
            ? Math.max(0, (Number(timeline[timeline.length - 1].tSec) || 0) - (Number(timeline[0].tSec) || 0))
            : currentTime;
        const normalizePlanningOfficialTimeSec = (value) => {
            const numberValue = this.normalizePlanningReplay3DNumber(value);
            return Number.isFinite(numberValue) && numberValue >= 0 ? numberValue : null;
        };
        const statePlanningTime = this.state && this.state.time ? this.state.time : {};
        const instancePlanningTime = this.time || {};
        const getOfficialPlanningTimeSec = (key) => {
            const stateValue = normalizePlanningOfficialTimeSec(statePlanningTime[key]);
            if (stateValue !== null) return stateValue;

            const instanceValue = normalizePlanningOfficialTimeSec(instancePlanningTime[key]);
            if (instanceValue !== null) return instanceValue;

            return null;
        };
        const officialPlanningSpraySec = getOfficialPlanningTimeSec('tApl');
        const officialPlanningBalloonSec = getOfficialPlanningTimeSec('tLoop');
        const officialPlanningTransitSec = getOfficialPlanningTimeSec('tTras');
        const officialPlanningFlightSec = getOfficialPlanningTimeSec('tVoo');
        const officialPlanningTotalSec = getOfficialPlanningTimeSec('tTotal');
        let officialPlanningRefuelSec = null;

        if (
            officialPlanningTotalSec !== null &&
            officialPlanningFlightSec !== null &&
            officialPlanningTotalSec >= officialPlanningFlightSec
        ) {
            officialPlanningRefuelSec = officialPlanningTotalSec - officialPlanningFlightSec;
        } else if (
            officialPlanningTotalSec !== null &&
            officialPlanningSpraySec !== null &&
            officialPlanningBalloonSec !== null &&
            officialPlanningTransitSec !== null
        ) {
            officialPlanningRefuelSec = Math.max(
                0,
                officialPlanningTotalSec - officialPlanningSpraySec - officialPlanningBalloonSec - officialPlanningTransitSec
            );
        }

        const planningReplay3DTotalTimeSec = officialPlanningTotalSec !== null
            ? officialPlanningTotalSec
            : timelineTotalTimeSec;

        for (let i = 0; i < timeline.length; i++) {
            const item = timeline[i];
            const tSec = baseSec + item.tSec;
            const pointSpraying = !!item.spray;
            if (pointSpraying && !planningReplay3DWasSpraying) {
                planningReplay3DShotCounter++;
            }
            const currentShotNumber = pointSpraying ? planningReplay3DShotCounter : null;
            planningReplay3DWasSpraying = pointSpraying;
            path.push({ lat: item.lat, lng: item.lng, alt: item.alt });
            pontos.push({
                tempo: tSec,
                iLatlng: { lat: item.lat, lng: item.lng, alt: item.alt },
                iApp: item.spray,
                iSobre: false,
                iFora: false,
                iAltura: item.alt,
                iVelocidade: item.speed,
                iFluxo: item.spray && Number.isFinite(item.flow) ? item.flow : null,
                setFluxo: item.spray && Number.isFinite(item.flow) ? item.flow : this.getPlanningReplay3DCanonicalFlow(this.state.fluxo),
                fluxo: item.spray && Number.isFinite(item.flow) ? item.flow : null,
                flow: item.spray && Number.isFinite(item.flow) ? item.flow : null,
                fuelLevel: Number.isFinite(item.fuelLevel) ? item.fuelLevel : null,
                fuelCapacity: Number.isFinite(item.fuelCapacity) ? item.fuelCapacity : null,
                fuelPercent: Number.isFinite(item.fuelPercent) ? item.fuelPercent : null,
                refuelIndex: Number.isFinite(item.refuelIndex) ? item.refuelIndex : null,
                refuelCount: Number.isFinite(item.refuelCount) ? item.refuelCount : null,
                setLargura: item.width,
                setAltura: safeAltitude,
                setVelocidade: applicationSpeed,
                tiroName: item.name,
                shotNumber: currentShotNumber,
                tiroNumber: currentShotNumber,
                planningStripKey: pointSpraying && item.planningStripKey !== undefined && item.planningStripKey !== null ? item.planningStripKey : null,
                planningStripName: pointSpraying && item.planningStripName ? item.planningStripName : null,
                faixaKey: pointSpraying && item.planningStripKey !== undefined && item.planningStripKey !== null ? item.planningStripKey : null,
                applicationType: item.applicationType || (item.spray ? 'app' : null),
                telemetryType: item.telemetryType || (item.spray ? 'spray' : null),
                spraySource: item.spraySource || (item.spray ? 'explicit_track' : 'none')
            });
        }

        return {
            planningReplay3D: true,
            title: this.state.title_est,
            path: path,
            pontos: pontos,
            larguraSet: Number.isFinite(this.getPlanningReplay3DCanonicalLength(this.state.faixa)) ? this.getPlanningReplay3DCanonicalLength(this.state.faixa) : 30,
            alturaSet: safeAltitude,
            velocidadeSet: applicationSpeed,
            fluxoSet: this.getPlanningReplay3DCanonicalFlow(this.state.fluxo),
            planningTotalAreaM2: planningTotalAreaM2,
            planningTotalAreaHa: planningTotalAreaM2 > 0 ? planningTotalAreaM2 / 10000 : null,
            planningTotalTimeSec: planningReplay3DTotalTimeSec,
            totalTimeSec: planningReplay3DTotalTimeSec,
            planningTimeSpraySec: officialPlanningSpraySec,
            planningTimeBalloonSec: officialPlanningBalloonSec,
            planningTimeTransitSec: officialPlanningTransitSec,
            planningTimeRefuelSec: officialPlanningRefuelSec,
            planningTimeFlightSec: officialPlanningFlightSec,
            fuelCapacity: fuelState ? fuelState.capacity : null,
            refuelCount: officialRefuelCount !== null
                ? officialRefuelCount
                : (fuelState ? fuelState.refuelCount : 0),
            app: officialApplicationItems
        };
    };

    getPlanningReplay3DFuelPoint = (value) => {
        if (!value) return null;

        const directPoint = this.normalizePlanningReplay3DCoord(value);
        if (directPoint) {
            return directPoint;
        }

        if (Array.isArray(this.fuel)) {
            for (let i = 0; i < this.fuel.length; i++) {
                if (this.fuel[i] && this.fuel[i].guid === value) {
                    return this.normalizePlanningReplay3DCoord(this.fuel[i]);
                }
            }
        }

        const markers = Array.isArray(this.state.markers) ? this.state.markers : [];
        for (let i = 0; i < markers.length; i++) {
            if (markers[i] && markers[i].guid === value) {
                return this.normalizePlanningReplay3DCoord(markers[i]);
            }
        }

        return null;
    };

    mergePlanningReplay3DSelectedPlaneDetail = (plane) => {
        if (!plane) return plane;

        const detail = this.planningReplay3DSelectedPlaneDetail;

        if (
            detail &&
            detail.id !== undefined &&
            detail.id !== null &&
            plane.id !== undefined &&
            plane.id !== null &&
            String(detail.id) === String(plane.id)
        ) {
            return Object.assign({}, plane, detail);
        }

        return plane;
    };

    fetchPlanningReplay3DSelectedPlaneDetail = async () => {
        const selectedPlane = this.getPlanningReplay3DSelectedPlane();

        if (!selectedPlane || selectedPlane.id === undefined || selectedPlane.id === null) {
            this.planningReplay3DSelectedPlaneDetail = null;
            return null;
        }

        if (
            this.planningReplay3DSelectedPlaneDetail &&
            String(this.planningReplay3DSelectedPlaneDetail.id) === String(selectedPlane.id) &&
            this.planningReplay3DSelectedPlaneDetail.model3D !== undefined
        ) {
            return this.planningReplay3DSelectedPlaneDetail;
        }

        try {
            const apiUrl = Config.server + '/plane/' + selectedPlane.id;
            const options = {
                method: 'GET',
                headers: {
                    'Authorization': localStorage.getItem('access-token-jwt')
                }
            };

            const response = await fetch(apiUrl, options);

            if (response.status !== 200) {
                throw response;
            }

            const result = await response.json();
            const detail = Array.isArray(result) && result.length ? result[0] : null;

            if (detail) {
                this.planningReplay3DSelectedPlaneDetail = Object.assign({}, selectedPlane, detail);

                return this.planningReplay3DSelectedPlaneDetail;
            }
        } catch (error) {
        }

        this.planningReplay3DSelectedPlaneDetail = selectedPlane;
        return selectedPlane;
    };

    getPlanningReplay3DSelectedPlane = () => {
        const ids = this.state.plane_est_ids && this.state.plane_est_ids.length ? this.state.plane_est_ids : [];
        const planes = this.state.planes || [];

        const findPlaneById = (value) => {
            if (value === null || value === undefined || value === '') return null;

            const selectedId = String(value);
            for (let i = 0; i < planes.length; i++) {
                if (planes[i] && String(planes[i].id) === selectedId) {
                    return planes[i];
                }
            }

            return null;
        };

        const findPlaneByName = (value) => {
            const planeNames = String(value || '').split(',').map(item => item.trim()).filter(Boolean);

            if (!planeNames.length) return null;

            for (let i = 0; i < planes.length; i++) {
                const planeName = String(planes[i] && planes[i].name ? planes[i].name : '').trim();
                const originalName = String(planes[i] && planes[i].original_name ? planes[i].original_name : '').trim();

                if (planeNames.indexOf(planeName) >= 0 || planeNames.indexOf(originalName) >= 0) {
                    return planes[i];
                }
            }

            return null;
        };

        if (ids.length) {
            const selectedPlane = findPlaneById(ids[0]);

            if (selectedPlane) {
                return this.mergePlanningReplay3DSelectedPlaneDetail(selectedPlane);
            }
        }

        if (this.state.plane_est_id) {
            const selectedPlane = findPlaneById(this.state.plane_est_id);

            if (selectedPlane) {
                return this.mergePlanningReplay3DSelectedPlaneDetail(selectedPlane);
            }
        }

        if (this.state.plane_est) {
            const selectedPlane = findPlaneByName(this.state.plane_est);

            if (selectedPlane) {
                return this.mergePlanningReplay3DSelectedPlaneDetail(selectedPlane);
            }
        }

        return null;
    };

    normalizePlanningReplay3DModelId = (value) => {
        const model = String(value || '').trim();
        const models = [
            'air-tractor-at-502b',
            'air-tractor-at-802',
            'cessna-188',
            'emb200',
            'emb-203',
            'thrush-510'
        ];

        return models.includes(model) ? model : '';
    };

    getPlanningReplay3DModelType = () => {
        const selectedPlane = this.getPlanningReplay3DSelectedPlane() || {};
        const configuredModel3D = this.normalizePlanningReplay3DModelId(selectedPlane.model3D);

        if (configuredModel3D) return configuredModel3D;

        const brand = String(selectedPlane.aircraftbrand || '').trim();
        const model = String(selectedPlane.aircraftmodel || '').trim();

        if (brand === 'Thrush') return 'thrush-510';
        if (brand === 'Embraer' && model === 'EMB-203') return 'emb-203';
        if (brand === 'Cessna') return 'cessna-188';
        if (brand === 'Air Tractor') {
            return model === 'AT-802' || model === 'AT-802A'
                ? 'air-tractor-at-802'
                : 'air-tractor-at-502b';
        }

        return 'emb200';
    };

    getPlanningReplay3DQualityConfig = () => {
        return {
            alturaSet: this.state.altura,
            fluxoSet: this.state.fluxo,
            velocidadeSet: this.state.speed_apl,
            larguraSet: this.state.faixa
        };
    };

    openPlanningReplay3D = async () => {
        if (!this.getPlanningReplay3DPointLatLng(this.base) && !this.hangarsLoaded && this.hangarsPromise) {
            await this.hangarsPromise;
        }

        await this.fetchPlanningReplay3DSelectedPlaneDetail();

        const planningReplay3DData = this.buildPlanningReplay3DData();

        if (!planningReplay3DData) {
            notification.open({
                message: this.props.res.ERRO,
                description: this.props.res.NAO_MONTOU_REPLAY3D,
                icon: <MaterialIcon icon="error" className="text-danger" />
            });
            return;
        }

        this.setState({
            planningReplay3DData: planningReplay3DData,
            showPlanningReplay3D: true
        });
    };

    render() {
        const { res, link, classes, profile } = this.props;

        const disabledButton = {
            color: 'lightgray'
        }

        const indexOfLastItem = this.state.currentPage * this.state.itemsPerPage;
        const indexOfFirstItem = indexOfLastItem - this.state.itemsPerPage;
        const currentItems = this.state.filteredProducts.slice(indexOfFirstItem, indexOfLastItem);
        const currentStep = this.tabItens.find(item => item.value === this.state.tab) || this.tabItens[0];

        return (
            <div className="rowMapCO maxVHMap">
                <Backd id="divPro" style={{ zIndex: 1002, color: '#fff' }} open={this.state.progress}>
                    <CircularProgress color="inherit" disableShrink />
                </Backd>
                {this.state.showImport && (
                    <ListFilter res={res} link={link} open={this.state.showImport} index={1003} listFilter={this.listDrawPoly} />
                )}

                <Dialog
                    open={this.state.openAreaList}
                    onClose={this.cancelAreaList}
                    maxWidth="sm"
                    fullWidth
                >
                    <DialogTitle style={{ padding: 0 }}>
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                backgroundColor: '#2D3238',
                                padding: '0.5rem 0'
                            }}
                        >
                            <div style={{ width: '16%', textAlign: 'left' }} />

                            <div style={{ textAlign: 'center' }}>
                                <p style={{ color: 'white', margin: 0 }}>
                                    {res.GERENCIAR_AREAS}
                                </p>
                            </div>

                            <div style={{ width: '16%', textAlign: 'right' }}>
                                <Button
                                    size="small"
                                    className="popUpButton"
                                    onClick={this.cancelAreaList}
                                >
                                    <CloseIcon style={{ color: 'white' }} />
                                </Button>
                            </div>
                        </div>
                    </DialogTitle>

                    <DialogContent style={{ background: 'white' }}>
                        <div style={{ minWidth: '280px' }}>
                            {(() => {
                                const polygons = Array.isArray(this.state.polygons) ? this.state.polygons : [];
                                const list = Array.isArray(this.state.areaFilterSelection) ? this.state.areaFilterSelection : [];

                                const allGuids = polygons
                                    .map((p) => p && p.guid)
                                    .filter((g) => !!g);

                                const selectedSet = {};
                                for (let i = 0; i < list.length; i++) selectedSet[list[i]] = true;

                                let selectedCount = 0;
                                for (let i = 0; i < allGuids.length; i++) {
                                    if (selectedSet[allGuids[i]]) selectedCount++;
                                }

                                const allSelected = allGuids.length > 0 && selectedCount === allGuids.length;
                                const indeterminate = selectedCount > 0 && selectedCount < allGuids.length;

                                const labelAll = allSelected
                                    ? (res.REMOVER_SELECIONADO)
                                    : (res.SELECIONAR_AREAS);

                                return (
                                    <div
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            padding: '0.25rem 0',
                                            borderBottom: '1px solid #eee',
                                            marginBottom: '0.25rem'
                                        }}
                                    >
                                        <Checkbox
                                            checked={allSelected}
                                            indeterminate={indeterminate}
                                            onChange={this.toggleAllAreaFilters}
                                            color="primary"
                                            size="small"
                                        />
                                        <span style={{ marginLeft: '0.5rem', fontWeight: 600 }}>
                                            {labelAll}
                                        </span>
                                    </div>
                                );
                            })()}

                            {(this.state.polygons || []).map((poly, index) => {
                                const guid = poly.guid;
                                const name = poly.name || ('Área ' + (index + 1));
                                const list = this.state.areaFilterSelection || [];
                                const checked = list.indexOf(guid) >= 0;

                                return (
                                    <div
                                        key={guid}
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            padding: '0.25rem 0'
                                        }}
                                    >
                                        <Checkbox
                                            checked={checked}
                                            onChange={() => this.toggleAreaFilter(guid)}
                                            color="primary"
                                            size="small"
                                        />
                                        <span style={{ marginLeft: '0.5rem' }}>
                                            {name}
                                        </span>
                                    </div>
                                );
                            })}
                        </div>
                    </DialogContent>

                    <DialogActions style={{ background: 'white' }}>
                        <Button onClick={this.cancelAreaList} color="primary">
                            {res.CANCELAR}
                        </Button>
                        <Button
                            onClick={this.saveAreaList}
                            color="primary"
                            variant="contained"
                        >
                            {res.CONFIRMAR}
                        </Button>
                    </DialogActions>
                </Dialog>

                <Dialog
                    open={this.state.clear}
                    onClose={() => this.setState({ clear: false })}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        {res.NOVO_ORCAMENTO_CONFIRM}
                    </DialogTitle>
                    <DialogActions>
                        <Button onClick={() => this.clear()} color="primary">
                            {res.SIM}
                        </Button>
                        <Button onClick={() => { this.setState({ clear: false }); }} color="primary" autoFocus>
                            {res.NAO}
                        </Button>
                    </DialogActions>
                </Dialog>

                <Dialog
                    open={this.state.openSendPlaneDialog === true}
                    onClose={this.closeSendPlaneDialog}
                    maxWidth="sm"
                    fullWidth
                    disableBackdropClick={this.state.sendingPlaneNow === true}
                    disableEscapeKeyDown={this.state.sendingPlaneNow === true}
                    BackdropProps={{ style: { backgroundColor: 'rgba(0,0,0,0.5)' } }}
                    PaperProps={{ style: { background: 'white' } }}
                >
                    <DialogTitle style={{ padding: 0 }}>
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                backgroundColor: '#2D3238',
                                padding: '0.5rem 0'
                            }}
                        >
                            <div style={{ width: '16%', textAlign: 'left' }} />

                            <div style={{ textAlign: 'center' }}>
                                <p style={{ color: 'white', margin: 0 }}>
                                    {this.props.res.ENVIAR_PLANEJAMENTO}
                                </p>
                            </div>

                            <div style={{ width: '16%', textAlign: 'right' }}>
                                <Button
                                    size="small"
                                    className="popUpButton"
                                    onClick={this.closeSendPlaneDialog}
                                >
                                    <CloseIcon style={{ color: 'white' }} />
                                </Button>
                            </div>
                        </div>
                    </DialogTitle>

                    <DialogContent style={{ background: 'white' }}>
                        <div style={{ minWidth: '280px' }}>
                            <div style={{ fontSize: 14 }}>
                                {(this.props.res.DESEJA_ENVIAR_PLANEJAMENTO)}
                            </div>
                        </div>
                    </DialogContent>

                    <DialogActions style={{ background: 'white' }}>
                        <Button onClick={this.closeSendPlaneDialog} color="primary" disabled={this.state.sendingPlaneNow === true}>
                            {this.props.res.NAO}
                        </Button>

                        <Button
                            onClick={this.confirmSendPlane}
                            color="primary"
                            variant="contained"
                            disabled={this.state.sendingPlaneNow === true || !(this.state.sendPlaneIds && this.state.sendPlaneIds.length)}
                        >
                            {this.state.sendingPlaneNow ? (this.props.res.ENVIANDO_PLANEJAMENTO) : (this.props.res.SIM)}
                        </Button>
                    </DialogActions>
                </Dialog>

                <div className="title-grid">
                    <div className="divContent padding-title">
                        <div>
                            <div><h1 className='title-align'>{res.PLANEJAMENTO}</h1></div>
                            <div className='zoomButton'>
                                {this.state.serviceOrderID ? (
                                    <Button variant="contained" color="primary" style={{ marginRight: '.4rem' }} className="popUpButton"
                                        onClick={this.handleBackToServiceOrder}
                                        title={res.ORDEM_SERVICO}
                                    >
                                        <DescriptionIcon className="iconArrow" style={{ color: 'white', width: '2rem', height: '2rem' }} />
                                    </Button>
                                ) : null}

                                <Button variant="contained" color="primary" style={{ marginRight: '.4rem' }} className="popUpButton"
                                    onClick={event => this.setState({ clear: true, treatmentDetails: false })} title={res.NOVO_ORCAMENTO}>
                                    {/* <Button variant="contained" color="primary" style={{ marginRight: '.4rem' }} className="popUpButton" onClick={event => this.setState({ clear: true })} title={res.NOVO_ORCAMENTO}> */}
                                    <SvgIcon viewBox="-2 0 26 26" className="iconArrow"
                                        style={{ color: 'white', width: '2rem', height: '2rem' }}>
                                        <rect fill="none" height="24" width="24" />
                                        <path d="M17,19.22H5V7h7V5H5C3.9,5,3,5.9,3,7v12c0,1.1,0.9,2,2,2h12c1.1,0,2-0.9,2-2v-7h-2V19.22z" />
                                        <path d="M19,2h-2v3h-3c0.01,0.01,0,2,0,2h3v2.99c0.01,0.01,2,0,2,0V7h3V5h-3V2z" />
                                        <rect height="2" width="8" x="7" y="9" />
                                        <polygon points="7,12 7,14 15,14 15,12 12,12" />
                                        <rect height="2" width="8" x="7" y="15" />
                                    </SvgIcon>
                                </Button>
                                <Button variant="contained" color="primary" style={{ marginRight: '.4rem', paddingTop: '.7rem', paddingBottom: '.5rem' }}
                                    disabled={this.state.time.tVoo <= 0 || this.state.groupPolygons !== 'all' || this.state.progress || this.state.openType === 'view' || !this.state.save}
                                    className="popUpButton" title={res.SAVE_JOB}
                                    onClick={() => { this.validationService() }}>
                                    <SaveIcon className="iconMapS" />
                                </Button>
                                <Button variant="contained" color="primary" style={{ marginRight: '.4rem' }} disabled={this.state.download_id < 0 || this.state.time.tVoo <= 0 || this.state.groupPolygons !== 'all' || this.state.progress} className="popUpButton"
                                    onClick={event => this.downloadJob()} title={res.DOWNLOAD_JOB}>
                                    <SvgIcon viewBox="0 0 1000 1000" className="iconArrow"
                                        style={{ color: 'white', transform: 'rotate(180deg)', width: '2rem', height: '2rem' }}>
                                        <path id="polygon" d="M122.513 646.499c3.66376,13.0115 11.813,21.1608 24.4821,24.3451l273.344 0 36.1582 0.47937 25.5093 0 -0.513611 13.662 0 107.002c4.17737,9.51892 9.69012,14.8605 16.504,16.1959 6.84814,1.16418 14.5181,3.97192 23.0098,8.14929 8.14929,-4.17737 15.4768,-6.98511 22.1537,-8.14929 6.67694,-1.33539 12.3267,-6.84814 16.8464,-16.6752l0 -106.523 0 -13.662 25.5093 0 35.6446 -0.47937 273.344 0c12.3267,-3.18439 20.5102,-11.3337 24.4821,-24.3451l-0.47937 -88.8204 -365.828 0 -6.84814 -69.3374 0.992981 10.1695 3.01318 -106.009 16.1616 0 4.34857 145.66 4.31433 -145.66 16.1616 0 4.34857 145.66 4.00616 -145.66 15.9904 0 4.48553 145.66 4.34857 -145.66 10.3407 0c0.992981,-0.513611 1.81476,-0.992981 2.67078,-1.33539 0.821777,-0.342407 1.64355,-0.650574 2.63653,-0.992981l4.34857 147.988 4.48553 -156.822c0.684814,-0.992981 1.19842,-2.67078 1.849,-5.34155l-1.33539 -6.33453 3.83496 -143.16 -18.0106 0 2.84198 102.174 -0.513611 -1.50659 -11.6418 0 3.32135 -100.668 -18.49 0 2.97894 100.668 -12.3267 0 3.01318 -100.668 -18.0106 0 2.84198 100.668 -12.1555 0 2.97894 -100.668 -18.1476 0 2.49957 100.668 -12.1897 0 2.84198 -100.668 -18.0106 0 2.84198 100.668 -1.81476 0c-4.00616,-1.67779 -7.36175,-4.17737 -10.3407,-7.32751l2.97894 -93.3402 -18.1476 0 2.49957 92.8266c-3.01318,3.32135 -6.50574,5.82092 -10.8543,7.84112l-0.821777 0 2.32837 -100.668 -17.9764 0 2.80774 100.668 -12.1555 0 3.01318 -100.668 -18.1818 0 3.01318 100.668 -12.6691 0 2.80774 -100.668 -17.9764 0 2.97894 100.668 -12.3267 0 3.01318 -100.668 -18.1818 0 3.01318 100.668 -12.1555 0 -2.49957 8.8341 1.98596 -7.32751 2.84198 -102.174 -18.0106 0 4.34857 143.16 -1.849 6.33453c-0.342407,-1.33539 0.342407,0.513611 1.849,5.34155l4.99914 156.822 4.31433 -147.988c0,0 1.67779,0.821777 4.82794,2.32837l10.8543 0 4.31433 145.66 4.51977 -145.66 15.9904 0 4.48553 145.66 3.83496 -145.66 16.6752 0 3.83496 145.66 4.34857 -145.66 16.1616 0 2.97894 100.668 -6.33453 64.5095 -365.828 0 -0.47937 88.8204zm19.6542 -419.997l9.17651 311.659 8.8341 -311.659 -18.0106 0zm24.8245 0l8.8341 311.659 9.17651 -311.659 -18.0106 0zm24.3451 0l9.31347 311.659 8.8341 -311.659 -18.1476 0zm24.9957 0l8.8341 311.659 9.17651 -311.659 -18.0106 0zm24.3451 0l9.31347 311.659 8.8341 -311.659 -18.1476 0zm24.9957 0l8.8341 311.659 9.14227 -311.659 -17.9764 0zm24.3109 0l9.34771 311.659 8.8341 -311.659 -18.1818 0zm24.5163 0l9.17651 311.659 9.31347 -311.659 -18.49 0zm24.8245 0l8.8341 311.659 9.34771 -311.659 -18.1818 0zm24.5163 0l9.14227 311.659 9.34771 -311.659 -18.49 0zm135.148 228.488l1.50659 -62.4893 4.34857 0 -5.85516 62.4893zm37.6648 -62.4893l4.86218 0 1.98596 72.3164 -6.84814 -72.3164zm110.837 -9.65588c0,-0.342407 0.171204,-0.513611 0.513611,-0.513611l-0.513611 0.513611zm12.1897 -156.343l9.31347 311.659 8.6629 -311.659 -17.9764 0zm24.8245 0l8.8341 311.659 9.31347 -311.659 -18.1476 0zm24.4821 0l9.34771 311.659 9.17651 -311.659 -18.5242 0zm24.8588 0l9.31347 311.659 8.8341 -311.659 -18.1476 0zm24.4821 0l9.17651 311.659 9.31347 -311.659 -18.49 0zm24.8245 0l9.34771 311.659 8.8341 -311.659 -18.1818 0zm24.0027 0l9.17651 311.659 8.8341 -311.659 -18.0106 0zm24.8588 0l9.31347 311.659 8.8341 -311.659 -18.1476 0zm24.4821 0l9.17651 311.659 9.31347 -311.659 -18.49 0zm24.8245 0l8.8341 311.659 9.34771 -311.659 -18.1818 0z" />
                                    </SvgIcon>
                                </Button>
                                <Button variant="contained" color="primary" style={{ marginRight: '.4rem' }} disabled={this.state.time.tVoo <= 0 || this.state.groupPolygons !== 'all' || this.state.progress} className="popUpButton"
                                    onClick={event => { this.type_rel = 'MR'; this.setRef('keep', this.downloadRel); }} title={res.MELHORES_RUMOS}>
                                    <SvgIcon viewBox="-2 0 26 26" className="iconArrow"
                                        style={{ color: 'white', transform: 'rotate(180deg)', width: '2rem', height: '2rem' }}>
                                        <path d="M0 0h24v24H0V0z" fill="none" /><path d="M4 15h16v-2H4v2zm0 4h16v-2H4v2zm0-8h16V9H4v2zm0-6v2h16V5H4z" />
                                    </SvgIcon>
                                </Button>
                                <Button variant="contained" color="primary" style={{ marginRight: '.4rem' }} disabled={this.state.time.tVoo <= 0 || this.state.groupPolygons !== 'all' || this.state.progress} className="popUpButton"
                                    onClick={event => { this.type_rel = 'total'; this.setRef('keep', this.downloadRel); }} title={res.DOWNLOAD_ORCAMENTO}>
                                    <SvgIcon viewBox="0 0 1000 1000" className="iconArrow"
                                        style={{ color: 'white', transform: 'rotate(180deg)', width: '2rem', height: '2rem' }}>
                                        <path id="polygon" d="M326.156 867.15l462.329 0c20.0054,0 29.8386,-9.83318 29.8386,-29.8047l0 -633.189c0,-20.0054 -9.83318,-29.8386 -29.8386,-29.8386l-462.329 0c-19.8359,0 -29.8386,9.83318 -29.8386,29.8386l0 633.189c0,19.9715 10.0027,29.8047 29.8386,29.8047zm166.52 -540.486l195.307 0 0 -32.6529 -195.307 0 0 32.6529zm-63.5087 0l46.8263 0 0 -32.6529 -46.8263 0 0 32.6529zm0 63.0001l46.8263 0 0 -32.6529 -46.8263 0 0 32.6529zm63.5087 0l195.307 0 0 -32.6529 -195.307 0 0 32.6529zm-63.5087 66.3231l46.8263 0 0 -32.6529 -46.8263 0 0 32.6529zm63.5087 0l195.307 0 0 -32.6529 -195.307 0 0 32.6529zm68.8322 165.503l98.1622 55.8457c9.83318,-17.3267 14.648,-35.8402 14.648,-55.8457 0,-31.161 -10.986,-57.8123 -32.992,-79.6487 -22.006,-22.006 -48.4877,-32.992 -79.8183,-32.992 -31.161,0 -57.8462,10.986 -79.8522,32.992 -22.006,21.8364 -32.992,48.4877 -32.992,79.6487 0,31.0254 10.986,57.5071 32.992,79.6826 22.006,22.1755 48.6912,33.1615 79.8522,33.1615l0 -112.844zm20.9887 31.3305l9.83318 112.336c34.5178,-3.32294 61.8473,-18.8187 81.9883,-46.8263l-91.8215 -65.5093zm-237.319 163.163l0 -587.99 426.828 0 0 587.99 -426.828 0zm-96.6703 4.84877l47.8096 0 0 -44.0119 -31.161 0 0 -504.306 31.161 0 0 -46.0125 -47.8096 0c-16.852,0 -25.3289,8.68032 -25.3289,26.0071l0 542.825c0,16.9877 8.47688,25.4984 25.3289,25.4984z" />
                                    </SvgIcon>
                                </Button>
                                <Button variant="contained" color="primary" disabled={this.state.time.tVoo <= 0 || this.state.groupPolygons !== 'all' || this.state.progress} className="popUpButton"
                                    onClick={event => this.downloadRel('send')} title={res.DOWNLOAD_ORCAMENTO_CLIENTE}>
                                    <SvgIcon viewBox="0 0 1000 1000" className="iconArrow"
                                        style={{ color: 'white', transform: 'rotate(180deg)', width: '2rem', height: '2rem' }}>
                                        <path id="polygon" d="M213.672 179.994l0 62.1718c0,18.4944 15.4844,38.3265 46.654,59.4963 31.0023,21.1699 58.9947,31.6712 83.6761,31.3367l24.9824 0 60.4996 -74.0109 12.6752 0 64.6801 65.0145 14.6483 0 14.1801 0 64.6801 -65.0145 12.6417 0 60.4996 75.0142 25.5175 0c24.3136,0.334437 52.0049,-10.1669 83.0073,-31.504 30.8351,-21.3371 46.654,-41.3364 47.3228,-59.998l0 -62.5063 -307.348 0 -308.317 0zm43.6775 523.16c0.167218,11.8391 11.4712,16.8556 33.6444,14.849 13.344,0.334437 28.8285,-3.34437 46.5202,-11.1702 17.8255,-7.82583 28.3268,-6.98973 31.4705,2.34106 5.68543,9.49801 9.53145,18.1599 11.5046,26.153 3.00993,28.9957 7.85927,53.1755 14.3473,72.1715 5.48477,12.6752 16.9894,24.347 34.1795,35.1828 17.3238,10.9695 33.4771,17.3238 48.4934,19.3305l43.4768 0 43.1758 0c14.6818,-2.00662 30.6679,-8.36092 47.8245,-18.996 17.3573,-10.8358 29.0291,-22.3404 34.8483,-34.6811 6.48808,-19.4977 11.003,-43.343 13.6785,-71.3354 2.30762,-8.32748 6.32086,-16.9894 11.9728,-25.8185 2.84271,-9.33079 13.1768,-10.1669 31.0023,-2.34106 17.6917,7.65861 33.3434,11.5046 47.0218,11.1702 21.8387,1.00331 33.1427,-4.5149 33.6444,-16.5212 0.668874,-14.3139 -9.33079,-23.3103 -30.1662,-27.1563 -20.8354,-4.01324 -39.497,-6.6553 -56.152,-8.32748l-30.8351 -0.501655 2.00662 -63.5096c7.15695,-1.67218 16.655,-9.33079 28.3268,-23.0093 3.84603,-5.8192 6.6553,-15.6517 8.32748,-29.1629 1.67218,-13.4778 -2.00662,-26.153 -10.8358,-37.8248l-120.498 -137.821c-12.6752,-10.5013 -30.6679,-16.1867 -53.8444,-17.1901 -23.8119,1.00331 -41.6374,6.68874 -53.4765,17.1901l-120.33 137.821c-8.82914,11.6719 -12.5079,24.347 -11.003,37.8248 1.33775,13.5113 4.31424,23.3437 8.4947,29.1629 10.6685,13.6785 19.9993,21.3371 27.8252,23.0093l2.50828 63.5096 -30.8351 0.501655c-16.655,1.67218 -35.35,4.31424 -56.3192,8.16026 -21.0026,3.84603 -31.0023,12.8424 -29.999,26.9891zm132.136 -133.307c-9.33079,-0.334437 -14.4811,-6.01987 -15.4844,-17.3573 -1.00331,-11.1702 1.8394,-20.8354 8.32748,-28.6612l59.8308 -64.9811c4.84934,12.1401 11.8391,25.4841 21.1699,39.9987 9.16357,14.4811 19.6649,22.1397 31.3367,23.143l26.3202 0 25.3503 0c11.3374,-1.00331 21.8387,-8.66192 31.3367,-23.143 9.66523,-14.5146 16.8222,-27.8586 21.6715,-39.9987l59.8308 64.9811c5.8192,7.82583 8.4947,17.4911 7.65861,28.6612 -0.836092,11.3374 -5.98642,17.0228 -15.3172,17.3573l-20.501 0c0.300993,31.9722 -4.84934,61.3357 -15.5179,88.1576l-95.0135 0 -94.4784 0c-11.3374,-27.4907 -16.6884,-56.8543 -16.0195,-88.1576l-20.501 0zm-3.47814 -217.852l33.6444 43.0086 64.3457 -64.1785 -46.1523 -46.8212 -51.8377 67.991zm77.9907 81.1679c14.6818,-22.1732 33.5106,-32.8417 56.4864,-32.1728 24.0126,-0.668874 43.1758,9.99967 57.5232,32.1728 -0.334437,4.18046 -3.17715,11.6719 -8.32748,22.5076 -5.18377,10.8358 -11.1702,16.3205 -18.0262,16.3205l-30.6679 0 -30.1662 0c-7.15695,0 -13.3106,-5.48477 -18.8288,-16.3205 -5.31755,-10.8358 -7.99304,-18.3271 -7.99304,-22.5076zm98.3245 -102.17l64.3457 64.5129 33.845 -43.0086 -51.8377 -68.4927 -46.353 46.9884z" />
                                    </SvgIcon>
                                </Button>
                            </div>
                        </div>
                    </div>

                    <div id="divFloat" className="div-list_p divContentList list-p estimate-panel">
                        <div className="estimate-step-navigation">
                            <Tab value={this.state.tab} handleChange={this.handleChangeTab} name="tab" itens={this.tabItens} />
                            {/*<div className="estimate-step-guide" role="status" aria-live="polite">
                                <span className="estimate-step-guide__title">
                                    {res.PLANEJAMENTO_ETAPA} {currentStep.step}/4 · {currentStep.label}
                                </span>
                                <span className="estimate-step-guide__description">
                                    {currentStep.description}
                                </span>
                            </div>*/}
                        </div>
                        {this.state.tab === '2' &&
                            <div className="div-list_h">
                                <div style={{ paddingLeft: '.5rem' }} className="div-list_box">
                                    <div className="div-list_itens">
                                        <div className="notTooBig">
                                            <TextField
                                                id="title"
                                                label={res.TITULO}
                                                value={this.state.title_est}
                                                onChange={this.handleChangeEst('title_est')}
                                                disabled={this.state.openType === 'view'}
                                                fullWidth
                                                onInput={(e) => {
                                                    e.target.value = e.target.value.toString().slice(0, 45)
                                                }}
                                                onFocus={(e) => {
                                                    if (e.currentTarget === e.target) {
                                                        if (this.state.title_est === this.dName) {
                                                            this.setState({ title_est: '' });
                                                        }
                                                    }
                                                }}
                                                onBlur={(e) => {
                                                    if (e.currentTarget === e.target) {
                                                        if (this.state.title_est === '') {
                                                            this.setState({ title_est: this.dName });
                                                            this.keepData('title_est', this.dName);
                                                        }
                                                    }
                                                }}
                                                size="small"
                                                margin="dense"
                                            />
                                            <div>
                                                <TextField
                                                    id="datetime-local1"
                                                    label={res.DATA_DO_TRABALHO}
                                                    type="datetime-local"
                                                    value={this.state.dateTimeTrabalho}
                                                    onChange={this.handleChange('dateTimeTrabalho')}
                                                    style={{ marginTop: '1rem' }}
                                                    fullWidth
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                />
                                            </div>
                                            <FormControl fullWidth margin="dense">
                                                <InputLabel shrink={!!this.state.plane_est || ((this.state.plane_est_ids || []).length > 0)}>{res.AERONAVE}</InputLabel>
                                                <Select
                                                    multiple
                                                    displayEmpty
                                                    id="plane_est"
                                                    value={this.state.plane_est_ids || []}
                                                    onChange={(e) => {
                                                        const ids = e.target.value || [];
                                                        const selectedPlanes = (this.state.planes || []).filter((item) => ids.map(String).indexOf(String(item.id)) >= 0);
                                                        const names = selectedPlanes.map((item) => String(item.name || '').trim());
                                                        const idCompanies = selectedPlanes.map((item) => item.id_company);

                                                        this.setState({
                                                            plane_est: names.join(', '),
                                                            plane_est_id: ids.length ? ids[0] : null,
                                                            plane_est_ids: ids,
                                                            plane_est_id_company: idCompanies.length ? idCompanies[0] : null,
                                                            plane_est_id_companies: idCompanies
                                                        }, () => {
                                                            if (selectedPlanes.length > 0) {
                                                                this.applyPlaneParameters(selectedPlanes[0]);
                                                                this.listEquipment(selectedPlanes[0].original_name ? selectedPlanes[0].original_name : selectedPlanes[0].name);
                                                            }
                                                        });
                                                    }}
                                                    disabled={this.state.openType === 'view'}
                                                    renderValue={(selected) => {
                                                        const names = (this.state.planes || [])
                                                            .filter((item) => selected.map(String).indexOf(String(item.id)) >= 0)
                                                            .map((item) => String(item.name || '').trim());

                                                        return names.length ? names.join(', ') : this.state.plane_est;
                                                    }}
                                                    endAdornment={
                                                        this.state.plane_est ? (
                                                            <IconButton
                                                                size="small"
                                                                style={{ marginRight: 24 }}
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    this.setState({
                                                                        plane_est: '',
                                                                        plane_est_id: null,
                                                                        plane_est_ids: [],
                                                                        plane_est_id_company: null,
                                                                        plane_est_id_companies: []
                                                                    });
                                                                }}
                                                            >
                                                                <CloseIcon fontSize="small" />
                                                            </IconButton>
                                                        ) : null
                                                    }
                                                    MenuProps={{
                                                        anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
                                                        transformOrigin: { vertical: 'top', horizontal: 'left' },
                                                        getContentAnchorEl: null,
                                                    }}
                                                >
                                                    {(this.state.planes || []).map((item) => (
                                                        <MenuItem key={item.id} value={item.id}>
                                                            <Checkbox checked={(this.state.plane_est_ids || []).map(String).indexOf(String(item.id)) >= 0} />
                                                            <ListItemText primary={this.limitChar(String(item.name || '').trim(), 202)} />
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                            <div style={{ position: 'relative' }}>
                                                <TextField
                                                    autoComplete="off"
                                                    id="client_est"
                                                    label={res.CLIENTE}
                                                    value={this.state.client_est}
                                                    onChange={this.handleChangeEst('client_est')}
                                                    disabled={this.state.openType === 'view'}
                                                    fullWidth
                                                    onInput={(e) => {
                                                        e.target.value = e.target.value.toString().slice(0, 45)
                                                    }}
                                                    size="small"
                                                    margin="dense"
                                                    onKeyDown={e => {
                                                        if (e.keyCode === 13) {
                                                            let item = this.state.clients.filter((item) => { return item.name && item.name.includes(this.state.client_est) });
                                                            if (item.length > 0) {
                                                                this.setState({ client_est: item[0].name });
                                                            }
                                                        }
                                                    }}
                                                    onFocus={this.showAutoComplete("client_div")}
                                                    onBlur={this.showAutoComplete("client_div")}
                                                />
                                                <div id="client_div" className="sr-only">
                                                    {this.state.clients
                                                        .filter((item) => { return item.name.includes(this.state.client_est) })
                                                        .map((item, index) => {
                                                            return <ListItem key={index} button
                                                                onMouseDown={event => this.setState({ client_est: item.name })}>
                                                                <ListItemText id={index} primary={this.limitChar(item.name, 202)} />
                                                            </ListItem>
                                                        })}
                                                </div>
                                            </div>
                                            <FormControl fullWidth margin="dense">
                                                <InputLabel shrink={!!this.state.pilot_est || ((this.state.pilot_est_ids || []).length > 0)}>{res.PILOTO}</InputLabel>
                                                <Select
                                                    multiple
                                                    displayEmpty
                                                    id="pilot_est"
                                                    value={this.state.pilot_est_ids || []}
                                                    onChange={(e) => {
                                                        const ids = e.target.value || [];
                                                        const selectedPilots = (this.state.pilots || []).filter((item) => ids.indexOf(item.id) >= 0);
                                                        const names = selectedPilots.map((item) => item.name);
                                                        const idCompanies = selectedPilots.map((item) => item.id_company);

                                                        this.setState({
                                                            pilot_est: names.join(', '),
                                                            pilot_est_id: ids.length ? ids[0] : null,
                                                            pilot_est_ids: ids,
                                                            pilot_est_id_company: idCompanies.length ? idCompanies[0] : null,
                                                            pilot_est_id_companies: idCompanies
                                                        });
                                                    }}
                                                    disabled={this.state.openType === 'view'}
                                                    renderValue={(selected) => {
                                                        const names = (this.state.pilots || [])
                                                            .filter((item) => selected.map(String).indexOf(String(item.id)) >= 0)
                                                            .map((item) => String(item.name || '').trim());

                                                        return names.length ? names.join(', ') : this.state.pilot_est;
                                                    }}
                                                    endAdornment={
                                                        this.state.pilot_est ? (
                                                            <IconButton
                                                                size="small"
                                                                style={{ marginRight: 24 }}
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    this.setState({
                                                                        pilot_est: '',
                                                                        pilot_est_id: null,
                                                                        pilot_est_ids: [],
                                                                        pilot_est_id_company: null,
                                                                        pilot_est_id_companies: []
                                                                    });
                                                                }}
                                                            >
                                                                <CloseIcon fontSize="small" />
                                                            </IconButton>
                                                        ) : null
                                                    }
                                                    MenuProps={{
                                                        anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
                                                        transformOrigin: { vertical: 'top', horizontal: 'left' },
                                                        getContentAnchorEl: null,
                                                    }}
                                                >
                                                    {(this.state.pilots || []).map((item) => (
                                                        <MenuItem key={item.id} value={item.id}>
                                                            <Checkbox checked={(this.state.pilot_est_ids || []).indexOf(item.id) >= 0} />
                                                            <ListItemText primary={this.limitChar(String(item.name || '').trim(), 202)} />
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                            <div>
                                                <FormControl fullWidth margin="dense">
                                                    <InputLabel id="typeApp-label" style={{ fontSize: '1rem' }}>{res.TIPO_APLICACAO}</InputLabel>
                                                    <NativeSelect
                                                        labelId="typeApp-label"
                                                        id="typeApp-select"
                                                        value={this.state.aplicacao === 'S' ? 'Sólido' : 'Líquido'}
                                                        onChange={this.handleChangeApplicationData}
                                                        label={res.TIPO_APLICACAO}
                                                        IconComponent="null"
                                                    >
                                                        <option aria-label="None" value="" disabled>{res.PRODUTO_TIPO}</option>
                                                        <option value="Líquido">{res.PRODUTO_LIQUIDO}</option>
                                                        <option value="Sólido">{res.PRODUTO_SOLIDO}</option>
                                                    </NativeSelect>
                                                </FormControl>
                                            </div>
                                            <div>
                                                <TextField
                                                    id="altura"
                                                    label={tools.replaceString(res._ALTURA_VOO, Units.getLengthUnit(res))}
                                                    value={this.state.altura}
                                                    onChange={this.handleChangeEst('altura')}
                                                    disabled={this.state.openType === 'view'}
                                                    type="number"
                                                    className="mb-4 notTooClose"
                                                    size="small"
                                                    margin="dense"
                                                />
                                                <TextField
                                                    id="carga"
                                                    label={tools.replaceString(res._CARGO_HOPPER, Units.getVolumeUnit(res, this.state.aplicacao === 'S' ? 'kg' : 'L'))}
                                                    value={this.state.carga}
                                                    onChange={this.handleChangeEstReset('carga')}
                                                    disabled={this.state.openType === 'view'}
                                                    type="number"
                                                    className="mb-4 notTooClose"
                                                    size="small"
                                                    margin="dense"
                                                />
                                            </div>
                                            <div>
                                                <TextField
                                                    id="speed"
                                                    label={tools.replaceString(res._VELOCIDADE_TITLE, Units.getSpeedUnit(res))}
                                                    value={this.state.speed}
                                                    onChange={this.handleChangeSpeed('speed')}
                                                    disabled={this.state.openType === 'view'}
                                                    size="small"
                                                    margin="dense"
                                                    type="number"
                                                    style={{ width: '20rem' }}
                                                    onInput={(e) => {
                                                        e.target.value = e.target.value.toString().slice(0, 10)
                                                    }}
                                                />
                                                <div style={{ display: 'inline-block', marginTop: '1.7rem', marginLeft: '0.5rem' }}>
                                                    <Button className={this.state.edit_speed ? "buttonS buttonMenuHL" : "buttonS buttonMenu"} disabled={this.state.openType === 'view'} onClick={event => this.showAdd(0)} title={res.DETALHE}>
                                                        <MaterialIcon icon="settings" className="iconMap" />
                                                    </Button>
                                                </div>
                                            </div>

                                            <TextField
                                                id="size_loop"
                                                label={tools.replaceString(res._TAMANHO_BALAO, Units.getLengthUnit(res))}
                                                value={this.state.size_loop}
                                                onChange={this.handleChangeEstReset('size_loop')}
                                                disabled={this.state.openType === 'view'}
                                                type="number"
                                                className="mb-4 notTooClose"
                                                size="small"
                                                margin="dense"
                                                fullWidth
                                                onInput={(e) => {
                                                    e.target.value = e.target.value.toString().slice(0, 10)
                                                }}
                                            />
                                            <TextField
                                                id="size_h_loop"
                                                label={tools.replaceString(res._DISTANCIA_BALAO, Units.getLengthUnit(res))}
                                                value={this.state.size_h_loop}
                                                onChange={this.handleChangeEstReset('size_h_loop')}
                                                disabled={this.state.openType === 'view'}
                                                type="number"
                                                className="mb-4 notTooClose"
                                                size="small"
                                                margin="dense"
                                                fullWidth
                                                onInput={(e) => {
                                                    e.target.value = e.target.value.toString().slice(0, 10)
                                                }}
                                            />

                                            <TextField
                                                id="r_time"
                                                label={res.TEMPO_REABASTECIMENTO}
                                                value={this.state.r_time}
                                                onChange={this.handleChangeEst('r_time')}
                                                disabled={this.state.openType === 'view'}
                                                type="number"
                                                fullWidth
                                                size="small"
                                                margin="dense"
                                                onInput={(e) => {
                                                    e.target.value = e.target.value.toString().slice(0, 10)
                                                }}
                                            />

                                            <div style={{ display: 'flex' }}>
                                                <TextField
                                                    id="horas_dia"
                                                    label={res.PERIODO_DIARIO}
                                                    value={this.state.horas_dia}
                                                    onChange={this.handleChangeEstReset('horas_dia')}
                                                    disabled={this.state.openType === 'view'}
                                                    type="number"
                                                    className="mb-4 notTooClose"
                                                    size="small"
                                                    margin="dense"
                                                    style={{ width: '10rem' }}
                                                    onInput={(e) => {
                                                        e.target.value = e.target.value.toString().slice(0, 3)
                                                    }}
                                                />
                                                <div style={{ paddingTop: '1rem' }}>
                                                    <Checkbox
                                                        disabled={this.state.openType === 'view'}
                                                        checked={this.state.horas_base}
                                                        onChange={this.handleCheck('horas_base', true)}
                                                    />
                                                    <span onClick={this.handleCheck('horas_base', true)} className="MuiFormLabel-root" style={{ fontSize: '12px', cursor: 'pointer' }}>
                                                        {res.RETORNO_PERIODO}
                                                    </span>
                                                </div>
                                            </div>
                                            <div style={{ display: 'flex' }}>
                                                <div style={{ width: '10.5rem' }}></div>
                                                <div style={{ paddingTop: '1rem' }}>
                                                    <Checkbox
                                                        disabled={this.state.openType === 'view'}
                                                        checked={this.state.aproveitamento}
                                                        onChange={this.handleCheck('aproveitamento', true)}
                                                    />
                                                    <span onClick={this.handleCheck('aproveitamento', true)} className="MuiFormLabel-root" style={{ fontSize: '12px', cursor: 'pointer' }}>
                                                        {res.APROVEITAMENTO_TANQUE//res
                                                        }
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                        {this.state.tab === '0' &&
                            <div className="div-list_h">
                                <div className="div-list_box">
                                    <div className="div-list_itens_list">
                                        {this.state.polygons.map((item, index) => {
                                            return (
                                                <div key={index} style={{ padding: '.5rem', display: 'flex', borderBottom: 'solid 2px #e8e8e8', paddingBottom: '0.6rem' }}>
                                                    <div className="notTooBig">
                                                        <div style={{ display: 'grid', gridTemplateColumns: '1.5rem auto' }}>
                                                            <div style={{ position: 'relative' }}>
                                                                <div style={{ position: 'absolute', width: '1rem', top: '1rem', left: '.3rem', fontSize: '12px', textAlign: 'center' }}>{index + 1}</div>
                                                                <div style={{ height: '1.5rem', width: '1.5rem', overflow: 'hidden' }}>
                                                                    <Button style={{ marginLeft: '-1.2rem', marginTop: '-.4rem', opacity: index === 0 ? .2 : 1 }} disabled={index === 0}
                                                                        onClick={event => this.movePoly(item.guid, 'up')}>
                                                                        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#5f6368"><path d="m280-400 200-200 200 200H280Z" /></svg>
                                                                    </Button>
                                                                </div>
                                                                <div style={{ height: '1.5rem', width: '1.5rem', transform: 'rotate(180deg)', overflow: 'hidden' }}>
                                                                    <Button style={{ marginLeft: '-1.3rem', marginTop: '-.5rem', opacity: this.state.polygons.length - 1 === index ? .2 : 1 }} disabled={this.state.polygons.length - 1 === index}
                                                                        onClick={event => this.movePoly(item.guid, 'down')}>
                                                                        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#5f6368"><path d="m280-400 200-200 200 200H280Z" /></svg>
                                                                    </Button>
                                                                </div>
                                                            </div>
                                                            <div
                                                                key={`${item.guid}-${item.blink ? 'blink' : 'normal'}`}
                                                                style={{
                                                                    borderRadius: '4px',
                                                                    animation: item.blink ? 'blinkOnce .3s linear forwards' : 'none'
                                                                }}
                                                            >
                                                                <ListItem
                                                                    button
                                                                    onClick={event => this.handleListItemClick(item.guid)}
                                                                    title={item.name}
                                                                    style={{
                                                                        borderLeft: (this.state.sel_poly && this.state.sel_poly.guid === item.guid) ? '6px solid #E67E22' : '6px solid transparent',
                                                                        backgroundColor: (this.state.sel_poly && this.state.sel_poly.guid === item.guid) ? 'rgba(230, 126, 34, 0.18)' : '#f5f5f5',
                                                                        borderRadius: '4px',
                                                                        borderBottom: '2px black',
                                                                        fontWeight: (this.state.sel_poly && this.state.sel_poly.guid === item.guid) ? 700 : 400,
                                                                        transition: 'all 0.15s ease',
                                                                        cursor: 'pointer'
                                                                    }}
                                                                >
                                                                    <ListItemText
                                                                        id={index}
                                                                        primary={this.limitChar(item.name, 202)}
                                                                    />

                                                                    {
                                                                        item.type === 'X' || item.type === 'R'
                                                                            ? <div title={item.type === 'R' ? res.POLY_R : res.POLY_X} style={{ height: '1rem', width: '.5rem', backgroundColor: item.type === 'R' ? this.color_r : this.color_x }}></div>
                                                                            : item.type === 'F'
                                                                                ? <>{Units.formatValue(Units.convertArea(item.area, 'm2', res), res) + ' ' + Units.getAreaUnit(res)} <div style={{ marginLeft: '.5rem', height: '1rem', width: '.5rem', backgroundColor: this.getFlowPolygonColor(item) }}></div></>
                                                                                : Units.formatValue(Units.convertArea(item.area, 'm2', res), res) + ' ' + Units.getAreaUnit(res) + (item.text ? ' ' + item.text + ' ' + res.FAIXAS : '')
                                                                    }
                                                                </ListItem>
                                                            </div>
                                                        </div>
                                                        {item.type !== 'X' && item.type !== 'T' && item.type !== 'R' &&
                                                            <div>
                                                                {item.type !== 'F' ?
                                                                    <TextField
                                                                        id="faixa"
                                                                        label={tools.replaceString(res._LARGURA_FAIXA, Units.getLengthUnit(res))}
                                                                        value={item.faixa}
                                                                        onChange={this.polyData('faixa', item.guid, 'reset')}
                                                                        disabled={this.state.openType === 'view'}
                                                                        onBlur={(e) => this.polyDataBlur('faixa', item.guid)}
                                                                        className="mb-4 notTooClose"
                                                                        size="small"
                                                                        margin="dense"
                                                                        onInput={(e) => {
                                                                            e.target.value = isNaN(e.target.value.slice(-1)) ? e.target.value.slice(0, -1) : e.target.value
                                                                        }}
                                                                    />
                                                                    : <div style={{ width: '11rem', display: 'inline-flex' }}></div>
                                                                }
                                                                <TextField
                                                                    id="fluxo"
                                                                    label={this.state.aplicacao === 'L' ?
                                                                        (tools.replaceString(res._FLUXO_APLICACAO, Units.getFlowUnit(res, 'L'))) :
                                                                        this.state.aplicacao === 'S' ?
                                                                            (tools.replaceString(res._FLUXO_APLICACAO, Units.getFlowUnit(res, 'kg'))) :
                                                                            res.FLUXO_APLICACAO}
                                                                    value={item.fluxo}
                                                                    onChange={this.polyData('fluxo', item.guid, '')}
                                                                    disabled={this.state.openType === 'view'}
                                                                    onBlur={(e) => this.polyDataBlur('fluxo', item.guid)}
                                                                    className="mb-4 notTooClose"
                                                                    size="small"
                                                                    margin="dense"
                                                                    type="number"
                                                                />
                                                                <div style={{ width: '100%', marginTop: '1rem' }}>
                                                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                                        <Tooltip
                                                                            title={
                                                                                <div>
                                                                                    <h3 style={{ color: 'white' }}>{res.TIPO_APLICACAO}: {this.state.aplicacao === 'S' ? 'Sólido' : 'Líquido'}</h3>
                                                                                    <h3 style={{ color: 'white' }}>{res.EQUIPAMENTO}: {this.state.polygons[index]?.detalhes?.equipment ? this.state.polygons[index]?.detalhes?.equipment : 'Sem cadastro'}</h3>
                                                                                    <h3 style={{ color: 'white' }}>{res.CULTURA}: {this.state.polygons[index].detalhes?.agriculturelCulture ? this.state.polygons[index]?.detalhes?.agriculturelCulture : 'Sem cadastro'}</h3>
                                                                                </div>
                                                                            }
                                                                            key={index}
                                                                        >
                                                                            <Button
                                                                                style={{ fontSize: '12px' }}
                                                                                variant="outlined"
                                                                                color="primary"
                                                                                onClick={() => this.handleClickOpenDetails(index)}
                                                                                disabled={!this.state.treatmentDetails || this.state.isCalculating}
                                                                            >
                                                                                {res.DETALHES_TRATAMENTO}
                                                                            </Button>
                                                                        </Tooltip>
                                                                        <Dialog
                                                                            open={this.state.openDialogDetail}
                                                                            onClose={this.handleClose}
                                                                        >
                                                                            <DialogTitle id="responsive-dialog-title" style={{ padding: '0' }}>
                                                                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: ' 0.5rem 0', backgroundColor: '#2D3238' }} >
                                                                                    <div className="leftDivHeader"></div>
                                                                                    <div className="centerDivHeader">
                                                                                        <h3 style={{ margin: '0', color: 'white', whiteSpace: 'nowrap', }}>{res.DETALHES_TRATAMENTO}</h3>
                                                                                    </div>
                                                                                    <div className="rightDivHeader">
                                                                                        <CloseIcon
                                                                                            onClick={this.handleClose}
                                                                                            style={{ cursor: 'pointer', width: '2rem', height: '2rem', color: 'white', marginRight: '0.5rem' }}
                                                                                            autoFocus
                                                                                        />
                                                                                    </div>
                                                                                </div>
                                                                                <Button
                                                                                    variant="outlined"
                                                                                    color="primary"
                                                                                    title='Copiar dados de outra área'
                                                                                    onClick={this.handleOpenCloneDialog()}
                                                                                    style={{ padding: '0.5rem', margin: '0.5rem' }}
                                                                                >
                                                                                    <FileCopyIcon />
                                                                                </Button>
                                                                            </DialogTitle>
                                                                            <DialogContent style={{ padding: '0', height: '44rem', width: '37rem' }}>
                                                                                <DialogContentText>
                                                                                    <div>
                                                                                        <div className="tabs">
                                                                                            <div style={{ display: 'flex' }}>
                                                                                                <button
                                                                                                    className={this.state.selectedTab === 0 ? 'active' : ''}
                                                                                                    onClick={() => this.handleTabChange(0)}
                                                                                                >
                                                                                                    {res.EQUIPAMENTO}
                                                                                                </button>
                                                                                                <button
                                                                                                    className={this.state.selectedTab === 1 ? 'active' : ''}
                                                                                                    onClick={() => this.handleTabChange(1)}
                                                                                                >
                                                                                                    {res.CULTURA}
                                                                                                </button>
                                                                                                <button
                                                                                                    className={this.state.selectedTab === 2 ? 'active' : ''}
                                                                                                    onClick={() => this.handleTabChange(2)}
                                                                                                >
                                                                                                    {res.PRODUTO}
                                                                                                </button>
                                                                                                <button
                                                                                                    className={this.state.selectedTab === 3 ? 'active' : ''}
                                                                                                    onClick={() => this.handleTabChange(3)}
                                                                                                >
                                                                                                    {res.INFORMAÇÕES_COMPLEMENTARES}
                                                                                                </button>
                                                                                            </div>
                                                                                        </div>

                                                                                        {this.state.selectedTab === 0 &&
                                                                                            <div style={{ padding: '1rem' }}>
                                                                                                <div style={{ display: 'flex', justifyContent: 'center' }}>
                                                                                                    <FormControlLabel
                                                                                                        control={
                                                                                                            <Checkbox
                                                                                                                color="primary"
                                                                                                                onChange={(event) => this.handleUseReport(event, 'useEquipmentReport')}
                                                                                                                checked={this.state.polygons[this.state.openedDialogDetail]?.detalhes?.useEquipmentReport || false}
                                                                                                            />
                                                                                                        }
                                                                                                        label="Adicionar equipamento ao relatório"
                                                                                                    />
                                                                                                </div>
                                                                                                <FormControl style={{ width: '100%', marginBottom: '1rem' }}>
                                                                                                    <InputLabel htmlFor="type-service">{res.TIPO_SERVICO}</InputLabel>
                                                                                                    <Select
                                                                                                        value={this.state.polygons[this.state.openedDialogDetail]?.detalhes?.selectedService}
                                                                                                        onChange={this.handleServiceChange}
                                                                                                        style={{ width: '100%' }}
                                                                                                        inputProps={{
                                                                                                            name: 'typeService',
                                                                                                            id: 'type-service',
                                                                                                        }}
                                                                                                    >
                                                                                                        <MenuItem value="">{res.SELECIONE_TIPO_SERVICO}</MenuItem>
                                                                                                        <MenuItem value="AplicacaoAgrotoxico">{res.APLICACAO_AGROTOXICO}</MenuItem>
                                                                                                        <MenuItem value="AplicacaoBioinsumo">{res.APLICACAO_BIOINSUMO}</MenuItem>
                                                                                                        <MenuItem value="AplicacaoFertilizante">{res.APLICACAO_FERTILIZANTE}</MenuItem>
                                                                                                        <MenuItem value="Semeadura">{res.SEMEADURA}</MenuItem>
                                                                                                        <MenuItem value="Maturador">{res.MATURADOR}</MenuItem>
                                                                                                        <MenuItem value="AplicacaoAdjuvante">{res.APLICACAO_ADJUVANTE}</MenuItem>
                                                                                                    </Select>
                                                                                                </FormControl>
                                                                                                <div style={{ display: 'grid', gridTemplateColumns: '16rem', marginTop: '1rem' }}>
                                                                                                    <span className="MuiFormLabel-root" style={{ fontSize: '16px' }}>
                                                                                                        {res.CLASSE_AGROTOXICO}
                                                                                                    </span>
                                                                                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>
                                                                                                        <Checkbox
                                                                                                            checked={
                                                                                                                this.state.openedDialogDetail != null &&
                                                                                                                this.state.polygons[this.state.openedDialogDetail]?.detalhes?.typeService?.insecticide
                                                                                                            }
                                                                                                            onClick={this.handleCheckType('typeService', 'insecticide')}
                                                                                                            style={{ padding: '0.5rem 0.5rem 0.5rem 0' }}
                                                                                                        />
                                                                                                        <span className="MuiFormLabel-root" style={{ fontSize: '1rem', cursor: 'pointer' }}>
                                                                                                            {res.INSETICIDA}
                                                                                                        </span>
                                                                                                    </div>
                                                                                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>
                                                                                                        <Checkbox
                                                                                                            checked={
                                                                                                                this.state.openedDialogDetail != null &&
                                                                                                                this.state.polygons[this.state.openedDialogDetail]?.detalhes?.typeService?.herbicide
                                                                                                            }
                                                                                                            onClick={this.handleCheckType('typeService', 'herbicide')}
                                                                                                            style={{ padding: '0.5rem 0.5rem 0.5rem 0' }}
                                                                                                        />
                                                                                                        <span className="MuiFormLabel-root" style={{ fontSize: '1rem', cursor: 'pointer' }}>
                                                                                                            {res.HERBICIDA}
                                                                                                        </span>
                                                                                                    </div>
                                                                                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>
                                                                                                        <Checkbox
                                                                                                            checked={
                                                                                                                this.state.openedDialogDetail != null &&
                                                                                                                this.state.polygons[this.state.openedDialogDetail]?.detalhes?.typeService?.fungicide
                                                                                                            }
                                                                                                            onClick={this.handleCheckType('typeService', 'fungicide')}
                                                                                                            style={{ padding: '0.5rem 0.5rem 0.5rem 0' }}
                                                                                                        />
                                                                                                        <span onClick={this.handleCheckType('typeService', 'fungicide')} className="MuiFormLabel-root" style={{ fontSize: '1rem', cursor: 'pointer' }}>
                                                                                                            {res.FUNGICIDA}
                                                                                                        </span>
                                                                                                    </div>
                                                                                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>
                                                                                                        <Checkbox
                                                                                                            checked={
                                                                                                                this.state.openedDialogDetail != null &&
                                                                                                                this.state.polygons[this.state.openedDialogDetail]?.detalhes?.typeService?.seeding
                                                                                                            }
                                                                                                            onClick={this.handleCheckType('typeService', 'seeding')}
                                                                                                            style={{ padding: '0.5rem 0.5rem 0.5rem 0' }}
                                                                                                        />
                                                                                                        <span className="MuiFormLabel-root" style={{ fontSize: '1rem', cursor: 'pointer' }}>
                                                                                                            {res.SEMEADURA}
                                                                                                        </span>
                                                                                                    </div>
                                                                                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>
                                                                                                        <Checkbox
                                                                                                            checked={
                                                                                                                this.state.openedDialogDetail != null &&
                                                                                                                this.state.polygons[this.state.openedDialogDetail]?.detalhes?.typeService?.fertilizing
                                                                                                            }
                                                                                                            onClick={this.handleCheckType('typeService', 'fertilizing')}
                                                                                                            style={{ padding: '0.5rem 0.5rem 0.5rem 0' }}
                                                                                                        />
                                                                                                        <span className="MuiFormLabel-root" style={{ fontSize: '1rem', cursor: 'pointer' }}>
                                                                                                            {res.ADUBACAO}
                                                                                                        </span>
                                                                                                    </div>
                                                                                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>
                                                                                                        <Checkbox
                                                                                                            checked={
                                                                                                                this.state.openedDialogDetail != null &&
                                                                                                                this.state.polygons[this.state.openedDialogDetail]?.detalhes?.typeService?.maturator
                                                                                                            }
                                                                                                            onClick={this.handleCheckType('typeService', 'maturator')}
                                                                                                            style={{ padding: '0.5rem 0.5rem 0.5rem 0' }}
                                                                                                        />
                                                                                                        <span className="MuiFormLabel-root" style={{ fontSize: '1rem', cursor: 'pointer' }}>
                                                                                                            {res.MATURADOR}
                                                                                                        </span>
                                                                                                    </div>
                                                                                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>
                                                                                                        <Checkbox
                                                                                                            checked={
                                                                                                                this.state.openedDialogDetail != null &&
                                                                                                                this.state.polygons[this.state.openedDialogDetail]?.detalhes?.typeService?.others
                                                                                                            }
                                                                                                            onClick={this.handleCheckType('typeService', 'others')}
                                                                                                            style={{ padding: '0.5rem 0.5rem 0.5rem 0' }}
                                                                                                        />
                                                                                                        <span className="MuiFormLabel-root" style={{ fontSize: '1rem', cursor: 'pointer' }}>
                                                                                                            {res.OUTROSTXT}
                                                                                                        </span>
                                                                                                        <div style={{ display: 'inline-block', height: '2rem', marginLeft: '0.5rem' }}>
                                                                                                            <div style={{ marginTop: '-1rem' }}>
                                                                                                                <TextField
                                                                                                                    id="otherService"
                                                                                                                    disabled={!this.state.polygons[this.state.openedDialogDetail]?.detalhes?.typeService?.others}
                                                                                                                    value={this.state.polygons[this.state.openedDialogDetail]?.detalhes?.otherService || ''}
                                                                                                                    onChange={this.handleChangeDetails('otherService')}
                                                                                                                    margin="normal"
                                                                                                                    onInput={(e) => {
                                                                                                                        e.target.value = e.target.value.toString().slice(0, 45);
                                                                                                                    }}
                                                                                                                    style={{ width: '8rem' }}
                                                                                                                />
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </div>
                                                                                                <FormControl style={{ width: '100%' }}>
                                                                                                    <InputLabel htmlFor="equipment" style={{ paddingTop: '1rem' }}>{res.EQUIPAMENTO}</InputLabel>
                                                                                                    <Select
                                                                                                        onChange={this.handleChangeEquipment}
                                                                                                        value={this.state.polygons[this.state.openedDialogDetail]?.detalhes?.equipment || ''}
                                                                                                        style={{ width: '100%', marginTop: '2rem' }}
                                                                                                    >
                                                                                                        <MenuItem disabled value="">Selecione o equipamento</MenuItem>
                                                                                                        {this.state.equipmentData.map((item, key) => {
                                                                                                            const hasCalibration = this.state.calibrationData.some(tc => tc.id_equipment === item.id);
                                                                                                            const hasConfiguration = this.state.configurationData.some(tc => tc.id_equipment === item.id);
                                                                                                            const selectedPlaneId = this.state.planes.filter(plane => plane.name === this.state.selectedPlane).map(plane => plane.id)[0];
                                                                                                            const isEquipmentOfSelectedPlane = item.id_plane === selectedPlaneId;

                                                                                                            const isDisabled = !hasCalibration || !hasConfiguration || !isEquipmentOfSelectedPlane;
                                                                                                            return (
                                                                                                                <MenuItem
                                                                                                                    key={key}
                                                                                                                    value={`${item.equipment} (${item.name})`}
                                                                                                                    disabled={isDisabled}
                                                                                                                    onMouseDown={() => {
                                                                                                                        if (!isDisabled) {
                                                                                                                            this.listEquipmentCalibration(item.id);
                                                                                                                            this.listEquipmentConfiguration(item.id);
                                                                                                                        }
                                                                                                                    }}
                                                                                                                >
                                                                                                                    <Tooltip
                                                                                                                        key={key}
                                                                                                                        title={
                                                                                                                            item.equipmentType === 'Bico Hidráulico'
                                                                                                                                ?
                                                                                                                                <div>
                                                                                                                                    <ul style={{ listStyle: 'none', padding: '0' }}>
                                                                                                                                        <li style={{ fontSize: '1rem', margin: '0 0.5rem', padding: '0.5rem 0' }}>Equipamento: {item.equipment}</li>
                                                                                                                                        <li style={{ fontSize: '1rem', margin: '0 0.5rem', padding: '0.5rem 0' }}>Nome: {item.name}</li>
                                                                                                                                        <li style={{ fontSize: '1rem', margin: '0 0.5rem', padding: '0.5rem 0' }}>Farbicante: {item.manufacturerEquipment}</li>
                                                                                                                                        <li style={{ fontSize: '1rem', margin: '0 0.5rem', padding: '0.5rem 0' }}>Tipo de jato: {item.jetType}</li>
                                                                                                                                        <li style={{ fontSize: '1rem', margin: '0 0.5rem', padding: '0.5rem 0' }}>Ponta de pulverização: {item.sprayTip}</li>
                                                                                                                                        <li style={{ fontSize: '1rem', margin: '0 0.5rem', padding: '0.5rem 0' }}>Ângulo de deflexão: {item.deflectionAngle}</li>
                                                                                                                                        <li style={{ fontSize: '1rem', margin: '0 0.5rem', padding: '0.5rem 0' }}>Quantidade de bicos: {item.quantityNozzle}</li>
                                                                                                                                    </ul>
                                                                                                                                </div>
                                                                                                                                :
                                                                                                                                <div>
                                                                                                                                    <ul style={{ listStyle: 'none', padding: '0' }}>
                                                                                                                                        <li style={{ fontSize: '1rem', margin: '0 0.5rem', padding: '0.5rem 0' }}>Equipamento: {item.equipment}</li>
                                                                                                                                        <li style={{ fontSize: '1rem', margin: '0 0.5rem', padding: '0.5rem 0' }}>Nome: {item.name}</li>
                                                                                                                                        <li style={{ fontSize: '1rem', margin: '0 0.5rem', padding: '0.5rem 0' }}>Farbicante: {item.manufacturerEquipment}</li>
                                                                                                                                        <li style={{ fontSize: '1rem', margin: '0 0.5rem', padding: '0.5rem 0' }}>Tela: {item.screen}</li>
                                                                                                                                        <li style={{ fontSize: '1rem', margin: '0 0.5rem', padding: '0.5rem 0' }}>Regulador de vazão: {item.flowRegulator}</li>
                                                                                                                                        <li style={{ fontSize: '1rem', margin: '0 0.5rem', padding: '0.5rem 0' }}>Ângulo de pás: {item.angleBlades}</li>
                                                                                                                                        <li style={{ fontSize: '1rem', margin: '0 0.5rem', padding: '0.5rem 0' }}>Quantidade de atomizadores: {item.quantityAtomizer}</li>
                                                                                                                                    </ul>
                                                                                                                                </div>
                                                                                                                        }
                                                                                                                        placement="top"
                                                                                                                    >
                                                                                                                        <span>{isDisabled ?
                                                                                                                            <div>
                                                                                                                                <span>{`${item.equipment} (${item.name}) `}</span>
                                                                                                                                <span style={{ color: 'red', fontWeight: '600' }}>Cadastro incompleto</span>
                                                                                                                            </div>
                                                                                                                            : `${item.equipment} (${item.name})`}</span>
                                                                                                                    </Tooltip>
                                                                                                                </MenuItem>
                                                                                                            );
                                                                                                        })}
                                                                                                    </Select>
                                                                                                </FormControl>
                                                                                            </div>}
                                                                                        {this.state.selectedTab === 1 &&
                                                                                            <div style={{ padding: '1rem' }}>
                                                                                                <div style={{ display: 'flex', justifyContent: 'center' }}>
                                                                                                    <FormControlLabel
                                                                                                        control={
                                                                                                            <Checkbox
                                                                                                                color="primary"
                                                                                                                onChange={(event) => this.handleUseReport(event, 'useCultureReport')}
                                                                                                                checked={this.state.polygons[this.state.openedDialogDetail]?.detalhes?.useCultureReport || false}
                                                                                                            />
                                                                                                        }
                                                                                                        label={res.ADD_DADOS_CULTURA_RELATORIO}
                                                                                                    />
                                                                                                </div>
                                                                                                <FormControl style={{ width: '100%' }}>
                                                                                                    <InputLabel htmlFor="agriculturelCulture" style={{ paddingTop: '1rem' }}>{res.CULTURA}</InputLabel>
                                                                                                    <Select
                                                                                                        onChange={this.handleChangeCulture}
                                                                                                        value={this.state.polygons[this.state.openedDialogDetail]?.detalhes?.agriculturelCulture}
                                                                                                        style={{ width: '100%', marginTop: '2rem' }}
                                                                                                    >
                                                                                                        <MenuItem disabled value="">Selecione uma cultura</MenuItem>
                                                                                                        {this.state.cultureData.map((item) => {
                                                                                                            return (
                                                                                                                <MenuItem key={item} value={item.name}>{item.name}</MenuItem>
                                                                                                            )
                                                                                                        })}
                                                                                                    </Select>
                                                                                                </FormControl>
                                                                                                <FormControl style={{ width: '100%', padding: '0.5rem 0' }}>
                                                                                                    <TextField
                                                                                                        id="cultureVariety"
                                                                                                        onChange={this.handleChangeDetails('cultureVariety')}
                                                                                                        value={this.state.polygons[this.state.openedDialogDetail]?.detalhes?.cultureVariety}
                                                                                                        label={res.VARIEDADE}
                                                                                                    />
                                                                                                </FormControl>
                                                                                                <FormControl style={{ width: '100%', padding: '0.5rem 0' }}>
                                                                                                    <TextField
                                                                                                        id="target"
                                                                                                        onChange={this.handleChangeDetails('target')}
                                                                                                        value={this.state.polygons[this.state.openedDialogDetail]?.detalhes?.target}
                                                                                                        label={res.ALVO}
                                                                                                    />
                                                                                                </FormControl>
                                                                                                <div style={{ width: '100%', padding: '0.5rem 0' }}>
                                                                                                    <span>
                                                                                                        {res.CICLO}
                                                                                                    </span>
                                                                                                    <div style={{ display: 'grid', gridTemplateColumns: '10rem 10rem 10rem' }}>
                                                                                                        <div onClick={this.handleChangeCultureData('cultureCycle', 'Curto')} style={{ fontSize: '1rem', cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
                                                                                                            <Checkbox
                                                                                                                checked={this.state.polygons[this.state.openedDialogDetail]?.detalhes?.cultureCycle === 'Curto'}
                                                                                                                style={{ padding: '0.5rem 0.5rem 0.5rem 0' }}
                                                                                                            />
                                                                                                            <span
                                                                                                                className="MuiFormLabel-root"
                                                                                                            >
                                                                                                                {res.CURTO}
                                                                                                            </span>
                                                                                                        </div>
                                                                                                        <div onClick={this.handleChangeCultureData('cultureCycle', 'Médio')} style={{ fontSize: '1rem', cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
                                                                                                            <Checkbox
                                                                                                                checked={this.state.polygons[this.state.openedDialogDetail]?.detalhes?.cultureCycle === 'Médio'}
                                                                                                                style={{ padding: '0.5rem 0.5rem 0.5rem 0' }}
                                                                                                            />
                                                                                                            <span
                                                                                                                className="MuiFormLabel-root"
                                                                                                            >
                                                                                                                {res.MEDIO_}
                                                                                                            </span>
                                                                                                        </div>
                                                                                                        <div onClick={this.handleChangeCultureData('cultureCycle', 'Tardio')} style={{ fontSize: '1rem', cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
                                                                                                            <Checkbox
                                                                                                                checked={this.state.polygons[this.state.openedDialogDetail]?.detalhes?.cultureCycle === 'Tardio'}
                                                                                                                style={{ padding: '0.5rem 0.5rem 0.5rem 0' }}
                                                                                                            />
                                                                                                            <span
                                                                                                                className="MuiFormLabel-root"
                                                                                                            >
                                                                                                                {res.TARDIO}
                                                                                                            </span>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </div>
                                                                                                <div style={{ width: '100%', padding: '0.5rem 0' }}>
                                                                                                    <span>
                                                                                                        {res.ALTURA}
                                                                                                    </span>
                                                                                                    <div style={{ display: 'grid', gridTemplateColumns: '10rem 10rem 10rem' }}>
                                                                                                        <div onClick={this.handleChangeCultureData('cultureHeight', 'Baixo')} style={{ fontSize: '1rem', cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
                                                                                                            <Checkbox
                                                                                                                checked={this.state.polygons[this.state.openedDialogDetail]?.detalhes?.cultureHeight === 'Baixo'}
                                                                                                                style={{ padding: '0.5rem 0.5rem 0.5rem 0' }}
                                                                                                            />
                                                                                                            <span
                                                                                                                className="MuiFormLabel-root"
                                                                                                            >
                                                                                                                {res.BAIXO}
                                                                                                            </span>
                                                                                                        </div>
                                                                                                        <div onClick={this.handleChangeCultureData('cultureHeight', 'Médio')} style={{ fontSize: '1rem', cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
                                                                                                            <Checkbox
                                                                                                                checked={this.state.polygons[this.state.openedDialogDetail]?.detalhes?.cultureHeight === 'Médio'}
                                                                                                                style={{ padding: '0.5rem 0.5rem 0.5rem 0' }}
                                                                                                            />
                                                                                                            <span
                                                                                                                className="MuiFormLabel-root"
                                                                                                            >
                                                                                                                {res.MEDIO_}
                                                                                                            </span>
                                                                                                        </div>
                                                                                                        <div onClick={this.handleChangeCultureData('cultureHeight', 'Alto')} style={{ fontSize: '1rem', cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
                                                                                                            <Checkbox
                                                                                                                checked={this.state.polygons[this.state.openedDialogDetail]?.detalhes?.cultureHeight === 'Alto'}
                                                                                                                style={{ padding: '0.5rem 0.5rem 0.5rem 0' }}
                                                                                                            />
                                                                                                            <span
                                                                                                                className="MuiFormLabel-root"
                                                                                                            >
                                                                                                                {res.ALTO}
                                                                                                            </span>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </div>
                                                                                                <div style={{ width: '100%', padding: '0.5rem 0' }}>
                                                                                                    <span>
                                                                                                        {res.DENSIDADE_POPULACIONAL}
                                                                                                    </span>
                                                                                                    <div style={{ display: 'grid', gridTemplateColumns: '10rem 10rem 10rem' }}>
                                                                                                        <div onClick={this.handleChangeCultureData('culturePopulationDensity', 'Baixa')} style={{ fontSize: '1rem', cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
                                                                                                            <Checkbox
                                                                                                                checked={this.state.polygons[this.state.openedDialogDetail]?.detalhes?.culturePopulationDensity === 'Baixa'}
                                                                                                                style={{ padding: '0.5rem 0.5rem 0.5rem 0' }}
                                                                                                            />
                                                                                                            <span
                                                                                                                className="MuiFormLabel-root"
                                                                                                            >
                                                                                                                {res.BAIXA}
                                                                                                            </span>
                                                                                                        </div>
                                                                                                        <div onClick={this.handleChangeCultureData('culturePopulationDensity', 'Padrão')} style={{ fontSize: '1rem', cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
                                                                                                            <Checkbox
                                                                                                                checked={this.state.polygons[this.state.openedDialogDetail]?.detalhes?.culturePopulationDensity === 'Padrão'}
                                                                                                                style={{ padding: '0.5rem 0.5rem 0.5rem 0' }}
                                                                                                            />
                                                                                                            <span
                                                                                                                className="MuiFormLabel-root"
                                                                                                            >
                                                                                                                {res.PADRAO}
                                                                                                            </span>
                                                                                                        </div>
                                                                                                        <div onClick={this.handleChangeCultureData('culturePopulationDensity', 'Alta')} style={{ fontSize: '1rem', cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
                                                                                                            <Checkbox
                                                                                                                checked={this.state.polygons[this.state.openedDialogDetail]?.detalhes?.culturePopulationDensity === 'Alta'}
                                                                                                                style={{ padding: '0.5rem 0.5rem 0.5rem 0' }}
                                                                                                            />
                                                                                                            <span
                                                                                                                className="MuiFormLabel-root"
                                                                                                            >
                                                                                                                {res.ALTA}
                                                                                                            </span>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </div>
                                                                                                <div style={{ width: '100%', padding: '0.5rem 0' }}>
                                                                                                    <span>
                                                                                                        {res.EPOCA_PLANTIO}
                                                                                                    </span>
                                                                                                    <div style={{ display: 'grid', gridTemplateColumns: '10rem 10rem' }}>
                                                                                                        <div
                                                                                                            onClick={this.handleChangeCultureData('culturePlantingTime', 'Safra')}
                                                                                                            style={{ fontSize: '1rem', cursor: 'pointer', display: 'flex', alignItems: 'center', whiteSpace: 'nowrap' }}
                                                                                                        >
                                                                                                            <Checkbox
                                                                                                                checked={this.state.polygons[this.state.openedDialogDetail]?.detalhes?.culturePlantingTime === 'Safra'}
                                                                                                                style={{ padding: '0.5rem 0.5rem 0.5rem 0' }}
                                                                                                            />
                                                                                                            <span
                                                                                                                className="MuiFormLabel-root"
                                                                                                            >
                                                                                                                {res.SAFRA_VERAO}
                                                                                                            </span>
                                                                                                        </div>
                                                                                                        <div
                                                                                                            onClick={this.handleChangeCultureData('culturePlantingTime', 'Safrinha')}
                                                                                                            style={{ fontSize: '1rem', cursor: 'pointer', display: 'flex', alignItems: 'center', whiteSpace: 'nowrap' }}
                                                                                                        >
                                                                                                            <Checkbox
                                                                                                                checked={this.state.polygons[this.state.openedDialogDetail]?.detalhes?.culturePlantingTime === 'Safrinha'}
                                                                                                                style={{ padding: '0.5rem 0.5rem 0.5rem 0' }}
                                                                                                            />
                                                                                                            <span
                                                                                                                className="MuiFormLabel-root"
                                                                                                            >
                                                                                                                {res.SAFRINHA_INVERNO}
                                                                                                            </span>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </div>
                                                                                                <div style={{ width: '100%', padding: '0.5rem 0' }}>
                                                                                                    <span>
                                                                                                        {res.LEVANTAMENTO_PRAGA}
                                                                                                    </span>
                                                                                                    <div style={{ display: 'grid', gridTemplateColumns: '10rem 10rem 10rem' }}>
                                                                                                        <div onClick={this.handleChangeCultureData('culturePestSurvey', 'Baixo')} style={{ fontSize: '1rem', cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
                                                                                                            <Checkbox
                                                                                                                checked={this.state.polygons[this.state.openedDialogDetail]?.detalhes?.culturePestSurvey === 'Baixo'}
                                                                                                                style={{ padding: '0.5rem 0.5rem 0.5rem 0' }}
                                                                                                            />
                                                                                                            <span
                                                                                                                className="MuiFormLabel-root"
                                                                                                            >
                                                                                                                {res.BAIXO}
                                                                                                            </span>
                                                                                                        </div>
                                                                                                        <div onClick={this.handleChangeCultureData('culturePestSurvey', 'Médio')} style={{ fontSize: '1rem', cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
                                                                                                            <Checkbox
                                                                                                                checked={this.state.polygons[this.state.openedDialogDetail]?.detalhes?.culturePestSurvey === 'Médio'}
                                                                                                                style={{ padding: '0.5rem 0.5rem 0.5rem 0' }}
                                                                                                            />
                                                                                                            <span
                                                                                                                className="MuiFormLabel-root"
                                                                                                            >
                                                                                                                {res.MEDIO_}
                                                                                                            </span>
                                                                                                        </div>
                                                                                                        <div onClick={this.handleChangeCultureData('culturePestSurvey', 'Alto')} style={{ fontSize: '1rem', cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
                                                                                                            <Checkbox
                                                                                                                checked={this.state.polygons[this.state.openedDialogDetail]?.detalhes?.culturePestSurvey === 'Alto'}
                                                                                                                style={{ padding: '0.5rem 0.5rem 0.5rem 0' }}
                                                                                                            />
                                                                                                            <span
                                                                                                                className="MuiFormLabel-root"
                                                                                                            >
                                                                                                                {res.ALTO}
                                                                                                            </span>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </div>
                                                                                                <FormControl style={{ width: '100%', padding: '0.5rem 0' }}>
                                                                                                    <TextField
                                                                                                        onChange={this.handleChangeDetails('cultureQuantityApplications')}
                                                                                                        id="cultureQuantityApplications"
                                                                                                        type="number"
                                                                                                        label={res.NUMERO_APLICACOES}
                                                                                                        value={this.state.polygons[this.state.openedDialogDetail]?.detalhes?.cultureQuantityApplications}
                                                                                                        InputProps={{
                                                                                                            inputProps: {
                                                                                                                min: 0
                                                                                                            }
                                                                                                        }}
                                                                                                    />
                                                                                                </FormControl>
                                                                                            </div>}
                                                                                        {this.state.selectedTab === 2 &&
                                                                                            <div style={{ padding: '1rem' }}>
                                                                                                <FormControlLabel
                                                                                                    control={
                                                                                                        <Checkbox
                                                                                                            color="primary"
                                                                                                            onChange={(event) => this.handleUseReport(event, 'useProductReport')}
                                                                                                            checked={this.state.polygons[this.state.openedDialogDetail]?.detalhes?.useProductReport || false}
                                                                                                            disabled={!this.productsValidation()}
                                                                                                        />
                                                                                                    }
                                                                                                    label="Adicionar dados de produto ao relatório"
                                                                                                />
                                                                                                {this.state.aplicacao === 'L'
                                                                                                    ?
                                                                                                    <div>
                                                                                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', margin: '1rem 0' }}>
                                                                                                            <span>{res.LISTA_PRODUTOS}</span>
                                                                                                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                                                                                <input
                                                                                                                    type="text"
                                                                                                                    placeholder="Filtrar produtos"
                                                                                                                    value={this.state.filter}
                                                                                                                    onChange={this.handleFilterChange}
                                                                                                                    style={{ border: 'none', borderBottom: '1px solid black', outline: 'none', fontSize: '0.75rem', width: '6rem' }}
                                                                                                                />
                                                                                                                <SearchIcon style={{ borderBottom: '1px solid black', marginTop: '-3px' }} />
                                                                                                            </div>
                                                                                                        </div>
                                                                                                        <div>
                                                                                                            <div style={{ overflowY: 'auto' }}>
                                                                                                                {currentItems.map((product) => {
                                                                                                                    const isSelected =
                                                                                                                        this.state.openedDialogDetail != null &&
                                                                                                                        this.state.polygons[this.state.openedDialogDetail]?.detalhes?.selectedProducts?.some(
                                                                                                                            (p) => p.id === product.id
                                                                                                                        );

                                                                                                                    return (
                                                                                                                        <div
                                                                                                                            key={product.id}
                                                                                                                            style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}
                                                                                                                        >
                                                                                                                            <Checkbox
                                                                                                                                checked={!!isSelected}
                                                                                                                                onChange={() => this.handleProductSelect(product)}
                                                                                                                                style={{ padding: '0.25rem 0.5rem 0.25rem 0' }}
                                                                                                                            />
                                                                                                                            <span
                                                                                                                                className="MuiFormLabel-root"
                                                                                                                                style={{ fontSize: '0.9rem', cursor: 'pointer' }}
                                                                                                                                onClick={() => this.handleProductSelect(product)}
                                                                                                                            >
                                                                                                                                {product.name}
                                                                                                                            </span>
                                                                                                                        </div>
                                                                                                                    );
                                                                                                                })}
                                                                                                            </div>
                                                                                                            {this.renderPaginationControls()}
                                                                                                        </div>
                                                                                                        {this.renderDosageInputs()}
                                                                                                        {!this.productsValidation() && (
                                                                                                            <p style={{ color: 'red', textAlign: 'center' }}>{res.VALIDANDO_PRODUTO}</p>
                                                                                                        )}
                                                                                                    </div>
                                                                                                    :
                                                                                                    this.state.aplicacao === 'S'
                                                                                                        ?
                                                                                                        <div>
                                                                                                            <Button variant="contained" color="primary" onClick={this.handleAddProduct}>
                                                                                                                {res.ADICIONAR_PRODUTO}
                                                                                                            </Button>
                                                                                                            {this.renderProductInputs()}
                                                                                                            {!this.productsValidation() && (
                                                                                                                <p style={{ color: 'red', textAlign: 'center' }}>{res.VALIDANDO_PRODUTO}</p>
                                                                                                            )}
                                                                                                        </div>
                                                                                                        :
                                                                                                        <span style={{ display: 'block', marginBottom: '1rem' }}>{res.SELECIONAR_TIPO_APLICACAO}</span>
                                                                                                }
                                                                                                <FormControl style={{ width: '100%', padding: '0.5rem 0' }}>
                                                                                                    <TextField
                                                                                                        id="tailVolume"
                                                                                                        onChange={this.handleChangeDetails('tailVolume')}
                                                                                                        value={this.state.polygons[this.state.openedDialogDetail]?.detalhes?.tailVolume}
                                                                                                        label={res.VOLUME_CALDA}
                                                                                                    />
                                                                                                </FormControl>
                                                                                                <FormControl style={{ width: '100%', padding: '0.5rem 0' }}>
                                                                                                    <TextField
                                                                                                        id="mixingRecommendation"
                                                                                                        onChange={this.handleChangeDetails('mixingRecommendation')}
                                                                                                        value={this.state.polygons[this.state.openedDialogDetail]?.detalhes?.mixingRecommendation}
                                                                                                        label={res.RECOMENDACAO_MISTURA}
                                                                                                    />
                                                                                                </FormControl>
                                                                                            </div>}
                                                                                        {this.state.selectedTab === 3 &&
                                                                                            <div style={{ padding: '1rem' }}>
                                                                                                <div style={{ display: 'flex', justifyContent: 'center' }}>
                                                                                                    <FormControlLabel
                                                                                                        control={
                                                                                                            <Checkbox
                                                                                                                color="primary"
                                                                                                                onChange={(event) => this.handleUseReport(event, 'useInfoReport')}
                                                                                                                checked={this.state.polygons[this.state.openedDialogDetail]?.detalhes?.useInfoReport || false}
                                                                                                            />
                                                                                                        }
                                                                                                        label="Adicionar dados de informações complementares ao relatório"
                                                                                                    />
                                                                                                </div>
                                                                                                <div style={{ display: 'flex' }}>
                                                                                                    <FormControl style={{ width: '100%', padding: '0.5rem' }}>
                                                                                                        <TextField
                                                                                                            id="tempMin"
                                                                                                            onChange={this.handleChangeDetails('tempMin')}
                                                                                                            value={this.state.polygons[this.state.openedDialogDetail]?.detalhes?.tempMin}
                                                                                                            label={res.TEMPERATURA_MINIMA}
                                                                                                            type='number'
                                                                                                            InputProps={{
                                                                                                                endAdornment: <InputAdornment position="end">°C</InputAdornment>,
                                                                                                            }}
                                                                                                        />
                                                                                                    </FormControl>
                                                                                                    <FormControl style={{ width: '100%', padding: '0.5rem' }}>
                                                                                                        <TextField
                                                                                                            id="tempMax"
                                                                                                            onChange={this.handleChangeDetails('tempMax')}
                                                                                                            value={this.state.polygons[this.state.openedDialogDetail]?.detalhes?.tempMax}
                                                                                                            label={res.TEMPERATURA_MAXIMA}
                                                                                                            type='number'
                                                                                                            InputProps={{
                                                                                                                endAdornment: <InputAdornment position="end">°C</InputAdornment>,
                                                                                                            }}
                                                                                                        />
                                                                                                    </FormControl>
                                                                                                </div>
                                                                                                <div style={{ display: 'flex' }}>
                                                                                                    <FormControl style={{ width: '100%', padding: '0.5rem' }}>
                                                                                                        <TextField
                                                                                                            id="humidityMin"
                                                                                                            onChange={this.handleChangeDetails('humidityMin')}
                                                                                                            value={this.state.polygons[this.state.openedDialogDetail]?.detalhes?.humidityMin}
                                                                                                            label={res.UMIDADE_MINIMA}
                                                                                                            type='number'
                                                                                                            InputProps={{
                                                                                                                endAdornment: <InputAdornment position="end">%</InputAdornment>,
                                                                                                            }}
                                                                                                        />
                                                                                                    </FormControl>
                                                                                                    <FormControl style={{ width: '100%', padding: '0.5rem' }}>
                                                                                                        <TextField
                                                                                                            id="humidityMax"
                                                                                                            onChange={this.handleChangeDetails('humidityMax')}
                                                                                                            value={this.state.polygons[this.state.openedDialogDetail]?.detalhes?.humidityMax}
                                                                                                            label={res.UMIDADE_MAXIMA}
                                                                                                            type='number'
                                                                                                            InputProps={{
                                                                                                                endAdornment: <InputAdornment position="end">%</InputAdornment>,
                                                                                                            }}
                                                                                                        />
                                                                                                    </FormControl>
                                                                                                </div>
                                                                                                <div style={{ display: 'flex' }}>
                                                                                                    <FormControl style={{ width: '100%', padding: '0.5rem' }}>
                                                                                                        <TextField
                                                                                                            id="windSpeed"
                                                                                                            onChange={(event) => {
                                                                                                                const value = event.target.value;
                                                                                                                this.handleChangeDetails('windSpeed')({
                                                                                                                    target: { value: value === '' ? '' : Units.toCanonicalSpeed(value, res) }
                                                                                                                });
                                                                                                            }}
                                                                                                            value={this.state.polygons[this.state.openedDialogDetail]?.detalhes?.windSpeed === '' || this.state.polygons[this.state.openedDialogDetail]?.detalhes?.windSpeed == null ? '' : Units.convertSpeed(this.state.polygons[this.state.openedDialogDetail]?.detalhes?.windSpeed, 'km/h', res)}
                                                                                                            label={res.VENTO_VELOCIDADE}
                                                                                                            type='number'
                                                                                                            InputProps={{
                                                                                                                endAdornment: <InputAdornment position="end">{Units.getSpeedUnit(res)}</InputAdornment>,
                                                                                                            }}
                                                                                                        />
                                                                                                    </FormControl>
                                                                                                </div>

                                                                                                <div style={{ display: 'flex', padding: '0.5rem', flexDirection: 'column', alignItems: 'center', marginTop: '1rem', position: 'relative' }}>
                                                                                                    <FormLabel component="legend">{res.DIRECAO_VENTO}</FormLabel>

                                                                                                    <div style={{ position: 'relative', width: '250px', height: '250px', marginBottom: '40px' }}>
                                                                                                        <img
                                                                                                            src={RosaDosVentos}
                                                                                                            alt="Rosa dos Ventos"
                                                                                                            style={{ width: '100%', height: '100%' }}
                                                                                                        />

                                                                                                        <div
                                                                                                            style={{
                                                                                                                position: 'absolute',
                                                                                                                top: '50%',
                                                                                                                left: '50%',
                                                                                                                transform: `translate(-50%, -50%) rotate(${this.getArrowRotation(this.state.polygons[this.state.openedDialogDetail]?.detalhes?.windDirection)}deg)`,
                                                                                                                color: '#FA7D34',
                                                                                                            }}
                                                                                                        >
                                                                                                            <NavigationIcon style={{ fontSize: 80 }} />
                                                                                                        </div>

                                                                                                        <RadioGroup
                                                                                                            value={this.state.polygons[this.state.openedDialogDetail]?.detalhes?.windDirection}
                                                                                                            onChange={this.handleChangeDetails('windDirection')}
                                                                                                            style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
                                                                                                        >
                                                                                                            <FormControlLabel
                                                                                                                value="N"
                                                                                                                control={<Radio color="primary" />}
                                                                                                                label="N"
                                                                                                                style={{ position: 'absolute', top: '-25px', left: '50%', transform: 'translateX(-50%)' }}
                                                                                                            />
                                                                                                            <FormControlLabel
                                                                                                                value="NE"
                                                                                                                control={<Radio color="primary" />}
                                                                                                                label="NE"
                                                                                                                style={{ position: 'absolute', top: '8%', left: '72%' }}
                                                                                                            />
                                                                                                            <FormControlLabel
                                                                                                                value="L"
                                                                                                                control={<Radio color="primary" />}
                                                                                                                label="L"
                                                                                                                style={{ position: 'absolute', top: '50%', left: '100%', transform: 'translateY(-50%)' }}
                                                                                                            />
                                                                                                            <FormControlLabel
                                                                                                                value="SE"
                                                                                                                control={<Radio color="primary" />}
                                                                                                                label="SE"
                                                                                                                style={{ position: 'absolute', bottom: '8%', left: '80%' }}
                                                                                                            />
                                                                                                            <FormControlLabel
                                                                                                                value="S"
                                                                                                                control={<Radio color="primary" />}
                                                                                                                label="S"
                                                                                                                style={{ position: 'absolute', bottom: '-25px', left: '50%', transform: 'translateX(-50%)' }}
                                                                                                            />
                                                                                                            <FormControlLabel
                                                                                                                value="SO"
                                                                                                                control={<Radio color="primary" />}
                                                                                                                label="SO"
                                                                                                                style={{ position: 'absolute', bottom: '8%', left: '8%' }}
                                                                                                            />
                                                                                                            <FormControlLabel
                                                                                                                value="O"
                                                                                                                control={<Radio color="primary" />}
                                                                                                                label="O"
                                                                                                                style={{ position: 'absolute', top: '50%', left: '-44px', transform: 'translateY(-50%)' }}
                                                                                                            />
                                                                                                            <FormControlLabel
                                                                                                                value="NO"
                                                                                                                control={<Radio color="primary" />}
                                                                                                                label="NO"
                                                                                                                style={{ position: 'absolute', top: '8%', left: '12%' }}
                                                                                                            />
                                                                                                        </RadioGroup>
                                                                                                    </div>
                                                                                                </div>

                                                                                                <div style={{ display: 'flex' }}>
                                                                                                    <FormControl style={{ display: 'flex', flexDirection: 'row', marginTop: '1rem' }} disabled={this.state.editData === false}>
                                                                                                        <FormLabel style={{ display: 'flex', alignItems: 'center', marginRight: '1rem' }}>{res.PERIODO_APLICACAO}:</FormLabel>
                                                                                                        <RadioGroup style={{ display: 'flex', flexDirection: 'row' }} value={this.state.polygons[this.state.openedDialogDetail]?.detalhes?.application_period} onChange={this.handleChangeDetails('application_period')}>
                                                                                                            <FormControlLabel style={{ marginRight: '2rem' }} value="preEmergente" control={<Radio color="primary" />} label={res.PRE_EMERGENTE} />
                                                                                                            <FormControlLabel style={{ marginRight: '2rem' }} value="posEmergente" control={<Radio color="primary" />} label={res.POS_EMERGENTE} />
                                                                                                        </RadioGroup>
                                                                                                    </FormControl>
                                                                                                </div>
                                                                                                <FormControl style={{ width: '100%', padding: '0.5rem 0' }}>
                                                                                                    <TextField
                                                                                                        id="deltaT"
                                                                                                        onChange={this.handleChangeDetails('deltaT')}
                                                                                                        value={this.state.polygons[this.state.openedDialogDetail]?.detalhes?.deltaT}
                                                                                                        label={res.DELTA_T}
                                                                                                        type='number'
                                                                                                    />
                                                                                                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                                                                                                        <img style={{ marginTop: '1rem', height: '18rem', width: '24rem' }} src={deltaTChart} alt="Gráfico de delta-t" />
                                                                                                    </div>
                                                                                                </FormControl>
                                                                                                <div style={{ width: '100%', padding: '0.5rem 0' }}>
                                                                                                    <span className="MuiFormLabel-root" style={{ fontSize: '16px' }}>
                                                                                                        {res.AREA_RISCO}
                                                                                                    </span>
                                                                                                    <div style={{ display: 'grid', gridTemplateColumns: '10rem 10rem' }}>
                                                                                                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>
                                                                                                            <Checkbox
                                                                                                                checked={
                                                                                                                    this.state.openedDialogDetail != null &&
                                                                                                                    this.state.polygons[this.state.openedDialogDetail]?.detalhes?.areaRisk?.app
                                                                                                                }
                                                                                                                onClick={this.handleCheckType('areaRisk', 'app')}
                                                                                                                style={{ padding: '0.5rem 0.5rem 0.5rem 0' }}
                                                                                                            />
                                                                                                            <span className="MuiFormLabel-root" style={{ fontSize: '1rem', cursor: 'pointer' }}>
                                                                                                                {res.APP}
                                                                                                            </span>
                                                                                                        </div>
                                                                                                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>
                                                                                                            <Checkbox
                                                                                                                checked={
                                                                                                                    this.state.openedDialogDetail != null &&
                                                                                                                    this.state.polygons[this.state.openedDialogDetail]?.detalhes?.areaRisk?.abelhas
                                                                                                                }
                                                                                                                onClick={this.handleCheckType('areaRisk', 'abelhas')}
                                                                                                                style={{ padding: '0.5rem 0.5rem 0.5rem 0' }}
                                                                                                            />
                                                                                                            <span className="MuiFormLabel-root" style={{ fontSize: '1rem', cursor: 'pointer' }}>
                                                                                                                {res.ABELHAS}
                                                                                                            </span>
                                                                                                        </div>
                                                                                                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>
                                                                                                            <Checkbox
                                                                                                                checked={
                                                                                                                    this.state.openedDialogDetail != null &&
                                                                                                                    this.state.polygons[this.state.openedDialogDetail]?.detalhes?.areaRisk?.others
                                                                                                                }
                                                                                                                onClick={this.handleCheckType('areaRisk', 'others')}
                                                                                                                style={{ padding: '0.5rem 0.5rem 0.5rem 0' }}
                                                                                                            />
                                                                                                            <span onClick={this.handleCheckType('areaRisk', 'others')} className="MuiFormLabel-root" style={{ fontSize: '1rem', cursor: 'pointer' }}>
                                                                                                                {res.OUTROSTXT}
                                                                                                            </span>
                                                                                                            <div style={{ display: 'inline-block', height: '2rem', marginLeft: '0.5rem' }}>
                                                                                                                <div style={{ marginTop: '-1rem' }}>
                                                                                                                    <TextField
                                                                                                                        id="otherService"
                                                                                                                        disabled={!this.state.polygons[this.state.openedDialogDetail]?.detalhes?.areaRisk?.others}
                                                                                                                        value={this.state.polygons[this.state.openedDialogDetail]?.detalhes?.areaRiskOthers || ''}
                                                                                                                        onChange={this.handleChangeDetails('areaRiskOthers')}
                                                                                                                        margin="normal"
                                                                                                                        onInput={(e) => {
                                                                                                                            e.target.value = e.target.value.toString().slice(0, 45);
                                                                                                                        }}
                                                                                                                        style={{ width: '8rem' }}
                                                                                                                    />
                                                                                                                </div>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>}
                                                                                    </div>
                                                                                </DialogContentText>
                                                                            </DialogContent>
                                                                        </Dialog>
                                                                        <Dialog open={this.state.openCloneDialog} onClose={() => this.setState({ openCloneDialog: false })}>
                                                                            <DialogTitle id="responsive-dialog-title" style={{ padding: '0' }}>
                                                                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: ' 0.5rem 0', backgroundColor: '#2D3238' }} >
                                                                                    <div className="leftDivHeader"></div>
                                                                                    <div className="centerDivHeader">
                                                                                        <h3 style={{ margin: '0', color: 'white', whiteSpace: 'nowrap', }}>{res.COPIAR_AREA}</h3>
                                                                                    </div>
                                                                                    <div className="rightDivHeader">
                                                                                        <CloseIcon
                                                                                            onClick={() => this.setState({ openCloneDialog: false })}
                                                                                            style={{ cursor: 'pointer', width: '2rem', height: '2rem', color: 'white', marginRight: '0.5rem' }}
                                                                                            autoFocus
                                                                                        />
                                                                                    </div>
                                                                                </div>
                                                                            </DialogTitle>
                                                                            <DialogContent>
                                                                                <DialogContentText>{res.DESEJA_COPIAR}</DialogContentText>
                                                                                <Select
                                                                                    onChange={(e) => {
                                                                                        const sourceIndex = parseInt(e.target.value, 10);
                                                                                        if (sourceIndex !== this.state.openedDialogDetail) {
                                                                                            this.cloneData(sourceIndex);
                                                                                        }
                                                                                    }}
                                                                                    style={{ width: '100%', marginBottom: '1rem' }}
                                                                                >
                                                                                    <MenuItem disabled value="">{res.SELECIONAR_AREA_COPIAR}</MenuItem>
                                                                                    {this.state.polygons.map((item, index) => (
                                                                                        index !== this.state.openedDialogDetail &&
                                                                                        <MenuItem key={index} value={index}>{item.name}</MenuItem>
                                                                                    ))}
                                                                                </Select>
                                                                            </DialogContent>
                                                                        </Dialog>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        }
                                                    </div>
                                                </div>
                                            )
                                        })}
                                    </div>
                                </div>
                            </div>
                        }
                        {this.state.tab === '1' &&
                            <div className="div-list_h">
                                <div style={{ padding: '.5rem', paddingTop: '.2rem' }} className="div-list_box">
                                    <div className="div-list_itens">
                                        <div className="notTooBig">
                                            <FormControl className="notTooBig">
                                                <InputLabel htmlFor="age-simple">{res.AREAS}</InputLabel>
                                                <Select
                                                    value={this.state.groupPolygons}
                                                    onChange={this.changeGPolygons}
                                                    inputProps={{ id: 'type' }}
                                                >
                                                    <MenuItem key="0" value="all">{res.TODAS_AREAS}</MenuItem>
                                                    {this.state.polygons
                                                        .filter(item => {
                                                            return (item.type === 'N' && item.lines.length > 0);
                                                        })
                                                        .map((n, key) => {
                                                            return (
                                                                <MenuItem key={key + 1} value={n.guid}>{n.name}</MenuItem>
                                                            );
                                                        })
                                                    }
                                                </Select>
                                            </FormControl>
                                            <div style={{ fontSize: '12px', fontWeight: 'bold', color: 'black', textAlign: 'center', backgroundColor: this.state.groupPolygons !== 'all' ? '#fff899' : 'white' }}>{this.state.groupPolygons !== 'all' ? res.MSG_SEL_AREA : <span>&nbsp;</span>}</div>
                                            <FormControl style={{ marginTop: '1rem' }} className="notTooBig">
                                                <InputLabel htmlFor="age-simple">{res.ESTRATEGIA}</InputLabel>
                                                <Select
                                                    disabled={this.state.groupPolygons === 'all' || this.state.openType === 'view'}
                                                    value={this.state.groupPolygons === 'all' ? ' ' : this.state.estrategia}
                                                    onChange={this.handleChangeSelectEstra}
                                                    inputProps={{
                                                        id: 'type',
                                                    }}

                                                >
                                                    {this.state.groupPolygons === 'all' && <MenuItem key="0" value=" "></MenuItem>}
                                                    {this.strategy.map((n, key) => {
                                                        return (
                                                            <MenuItem key={key + 1} value={n.value}><span>{n.text}</span>
                                                                <span style={{ position: 'absolute', right: '20px' }}>{tools.fancyTimeFormat(n.time)}</span></MenuItem>
                                                        )
                                                    })}
                                                </Select>
                                            </FormControl>
                                            <div>
                                                <TextField
                                                    id="tTotal"
                                                    label={res.TEMPO_TOTAL}
                                                    value={tools.fancyTimeFormat(this.state.time.tTotal) + (Math.ceil(this.state.time.tTotal / 60 / 60 / this.state.horas_dia) > 1 ? ' (' + Math.ceil(this.state.time.tTotal / 60 / 60 / this.state.horas_dia) + ' ' + res.DIAS + ')' : '')}
                                                    size="small"
                                                    margin="dense"
                                                    className="mb-4 notTooClose"
                                                    InputProps={{
                                                        readOnly: true,
                                                    }}
                                                />
                                                <TextField
                                                    id="tVoo"
                                                    label={res.TEMPO_VOO + (this.state.time.tVoo > 0 ? ' (' + (this.state.time.tVoo * 100 / this.state.time.tTotal).toFixed(1) + '%)' : '')}
                                                    value={tools.fancyTimeFormat(this.state.time.tVoo)}
                                                    size="small"
                                                    margin="dense"
                                                    className="mb-4 notTooClose"
                                                    InputProps={{
                                                        readOnly: true,
                                                    }}
                                                />
                                            </div>
                                            <div>
                                                <TextField
                                                    id="tLoop"
                                                    label={res.TEMPO_BALAO + (this.state.time.tLoop > 0 ? ' (' + (this.state.time.tLoop * 100 / this.state.time.tTotal).toFixed(1) + '%)' : '')}
                                                    value={tools.fancyTimeFormat(this.state.time.tLoop)}
                                                    size="small"
                                                    margin="dense"
                                                    className="mb-4 notTooClose"
                                                    InputProps={{
                                                        readOnly: true,
                                                    }}
                                                />
                                                <TextField
                                                    id="tTras"
                                                    label={res.TEMPO_TRANSLADO + (this.state.time.tTras > 0 ? ' (' + (this.state.time.tTras * 100 / this.state.time.tTotal).toFixed(1) + '%)' : '')}
                                                    value={tools.fancyTimeFormat(this.state.time.tTras)}
                                                    size="small"
                                                    margin="dense"
                                                    className="mb-4 notTooClose"
                                                    InputProps={{
                                                        readOnly: true,
                                                    }}
                                                />
                                            </div>
                                            <div>
                                                <TextField
                                                    id="tApl"
                                                    label={res.TEMPO_APLICACAO + (this.state.time.tApl > 0 ? ' (' + (this.state.time.tApl * 100 / this.state.time.tTotal).toFixed(1) + '%)' : '')}
                                                    value={tools.fancyTimeFormat(this.state.time.tApl)}
                                                    size="small"
                                                    margin="dense"
                                                    className="mb-4 notTooClose"
                                                    InputProps={{
                                                        readOnly: true,
                                                    }}
                                                />
                                                <TextField
                                                    id="flxMedApl"
                                                    label={res.REABASTECIMENTO + (this.state.r_time * this.state.time.flxMedApl * 60 > 0 ? ' (' + (this.state.r_time * this.state.time.flxMedApl * 60 * 100 / this.state.time.tTotal).toFixed(1) + '%)' : '')}
                                                    value={tools.fancyTimeFormat(this.state.r_time * this.state.time.flxMedApl * 60) + " (" + this.state.time.flxMedApl + ")"}
                                                    size="small"
                                                    margin="dense"
                                                    className="mb-4 notTooClose"
                                                    InputProps={{
                                                        readOnly: true,
                                                    }}
                                                />
                                            </div>

                                            <TextField
                                                id="comTl"
                                                label={tools.replaceString(res._COMSUMO_TOTAL, Units.getVolumeUnit(res, this.state.aplicacao === 'S' ? 'kg' : 'L'))}
                                                value={Units.formatValue(Units.convertVolume(this.state.time.comTl, this.state.aplicacao === 'S' ? 'kg' : 'L', res), res)}
                                                size="small"
                                                margin="dense"
                                                className="mb-4 notTooClose"
                                                fullWidth
                                                InputProps={{
                                                    readOnly: true,
                                                }}
                                            />
                                            <TextField
                                                id="aTlPul"
                                                label={res.AREA_APLICADA}
                                                value={this.state.time.aTlPul.toLocaleString('pt-BR')}
                                                size="small"
                                                margin="dense"
                                                className="mb-4 notTooClose"
                                                fullWidth
                                                InputProps={{
                                                    readOnly: true,
                                                }}
                                            />
                                            <TextField
                                                id="pRen"
                                                label={tools.replaceString(res._RENDIMENTO, Units.getAreaRateUnit(res))}
                                                value={this.state.time.tTotal === 0 ? 0 : (this.state.time.aTlPul / (this.state.time.tTotal / 3600)).toFixed(2)}
                                                size="small"
                                                margin="dense"
                                                className="mb-4 notTooClose"
                                                fullWidth
                                                InputProps={{
                                                    readOnly: true,
                                                }}
                                            />
                                            {this.state.sel_poly &&
                                                <div>
                                                    <span style={{ margin: '0 6rem', fontWeight: 'bolder', fontSize: '15px' }}>{this.state.label_text}</span>
                                                </div>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                        {this.state.tab === '3' &&
                            <div className="div-list_h">
                                <div style={{ padding: '.5rem', paddingTop: '.2rem' }} className="div-list_box">
                                    <div className="div-list_itens">
                                        <div className="notTooBig">
                                            <span>
                                                <TextField
                                                    id="cost"
                                                    label={res.VALOR_HORA}
                                                    value={this.state.cost}
                                                    onChange={this.handleChangeEst('cost')}
                                                    disabled={this.state.openType === 'view'}
                                                    type="number"
                                                    className="mb-4 notTooClose"
                                                    size="small"
                                                    margin="dense"
                                                    fullWidth
                                                    onInput={(e) => {
                                                        e.target.value = e.target.value ? ((e.target.value - 0) === 0 || e.target.value.slice(-1) === '0' ? e.target.value : e.target.value - 0).toString().slice(0, 10) : 0
                                                    }}
                                                />
                                                <div>
                                                    <TextField
                                                        id="cost"
                                                        label={res.VALOR}
                                                        value={this.state.cVoo.toFixed(2)}
                                                        type="number"
                                                        className="mb-4 notTooClose"
                                                        size="small"
                                                        margin="dense"
                                                        InputProps={{
                                                            readOnly: true,
                                                        }}
                                                    />
                                                    <TextField
                                                        id="cVoo"
                                                        label={res.MOEDA_LUCRO_HORA}
                                                        value={this.state.cLucroHora.toFixed(2)}
                                                        size="small"
                                                        margin="dense"
                                                        type="number"
                                                        className="mb-4 notTooClose"
                                                        InputProps={{
                                                            readOnly: true,
                                                        }}
                                                    />

                                                </div>
                                                <div>
                                                    <TextField
                                                        id="cLucro"
                                                        label={res.VALOR_LUCRO}
                                                        value={Math.round(this.state.cLucro * 100) / 100}
                                                        onChange={this.handleChangeVlr('cLucro')}
                                                        disabled={this.state.openType === 'view'}
                                                        size="small"
                                                        margin="dense"
                                                        type="number"
                                                        className="mb-4 notTooClose"
                                                        onInput={(e) => {
                                                            e.target.value = e.target.value ? ((e.target.value - 0) === 0 || e.target.value.slice(-1) === '0' ? e.target.value : e.target.value - 0).toString().slice(0, 10) : 0
                                                        }}
                                                    />
                                                    <CssTextField
                                                        id="vLucro"
                                                        value={this.state.vLucro.toFixed(2)}
                                                        label={res.MOEDA_LUCRO}
                                                        size="small"
                                                        margin="dense"
                                                        type="number"
                                                        className="mb-4 notTooClose"
                                                        InputProps={{
                                                            readOnly: true,
                                                        }}
                                                    />
                                                </div>
                                                <div>
                                                    <TextField
                                                        id="cImp"
                                                        label={res.IMPOSTOP}
                                                        value={this.state.cImp}
                                                        onChange={this.handleChangeVlr('cImp')}
                                                        disabled={this.state.openType === 'view'}
                                                        size="small"
                                                        margin="dense"
                                                        type="number"
                                                        className="mb-4 notTooClose"
                                                        onInput={(e) => {
                                                            e.target.value = e.target.value ? ((e.target.value - 0) === 0 || e.target.value.slice(-1) === '0' ? e.target.value : e.target.value - 0).toString().slice(0, 10) : 0
                                                        }}
                                                    />
                                                    <CssTextField
                                                        id="cImp"
                                                        label={res.IMPOSTOV}
                                                        value={this.state.vImp.toFixed(2)}
                                                        size="small"
                                                        margin="dense"
                                                        type="number"
                                                        className="mb-4 notTooClose"
                                                        InputProps={{
                                                            readOnly: true,
                                                        }}
                                                    />
                                                </div>
                                                <CssTextField
                                                    id="vVoo"
                                                    label={res.VALOR_SUGERIDO}
                                                    value={this.state.vVoo}
                                                    onChange={this.handleChangeFinal('vVoo')}
                                                    onBlur={(e) => {
                                                        this.setState({ vVoo: Number(this.state.vVoo).toFixed(2) });
                                                    }}
                                                    disabled={this.state.openType === 'view'}
                                                    size="small"
                                                    margin="dense"
                                                    type="number"
                                                    className="mb-4 notTooClose"
                                                    fullWidth
                                                    onInput={(e) => {
                                                        e.target.value = e.target.value ? ((e.target.value - 0) === 0 || e.target.value.slice(-1) === '0' ? e.target.value : e.target.value - 0).toString().slice(0, 10) : 0
                                                    }}
                                                />
                                                <CssTextField
                                                    id="vVooHA"
                                                    label={res.VALOR_SUGERIDO_HA}
                                                    value={this.state.vVooHA}
                                                    onChange={this.handleChangeFinal('vVooHA')}
                                                    onBlur={(e) => {
                                                        this.setState({ vVooHA: Number(this.state.vVooHA).toFixed(2) });
                                                    }}
                                                    disabled={this.state.openType === 'view'}
                                                    size="small"
                                                    margin="dense"
                                                    type="number"
                                                    className="mb-4 notTooClose"
                                                    fullWidth
                                                    onInput={(e) => {
                                                        e.target.value = e.target.value ? ((e.target.value - 0) === 0 || e.target.value.slice(-1) === '0' ? e.target.value : e.target.value - 0).toString().slice(0, 10) : 0
                                                    }}
                                                />
                                                <div style={{ marginTop: '1.7rem', marginLeft: '0.5rem', marginRight: '0.5rem' }}>
                                                    <Slider res={res} handleChange={this.handleChangeS} value={this.state.dificuldade} />
                                                </div>
                                            </span >
                                        </div >
                                    </div >
                                </div >
                            </div >
                        }
                    </div>
                </div >
                <div className="divContent divRelative map-p">
                    <div className="containerTop">
                        <div className="leftTop">
                            {this.state.play ?
                                <div style={{ display: 'flex' }}>
                                    <Button className="buttonS buttonMenu" onClick={event => this.moveLine('L')} title={res.CRIAR_ROTA}>
                                        <MaterialIcon icon="navigate_before" className="iconMap" />
                                    </Button>
                                    <FormControl variant="outlined" style={{ marginLeft: '5px', marginRight: '5px' }}>
                                        <Select
                                            native
                                            value={this.state.sel_faixa}
                                            onChange={event => {
                                                this.setState({ sel_faixa: event.target.value });
                                                this.moveLine('T', event.target.value);
                                            }}
                                            style={{ height: '2.3rem', overflow: 'hidden' }}
                                            label="Age"
                                            inputProps={{
                                                name: 'age',
                                                id: 'outlined-age-native-simple',
                                            }}
                                        >
                                            {this.state.itens_faixa.map((item, key) => {
                                                return <option value={key}>{res.FAIXA_APP} {item.key}&nbsp;</option>;
                                            })}
                                        </Select>
                                    </FormControl>
                                    <Button className="buttonS buttonMenu" onClick={event => this.moveLine('R')} title={res.CRIAR_ROTA}>
                                        <MaterialIcon icon="navigate_next" className="iconMap" />
                                    </Button>
                                </div>
                                :
                                <div>
                                    <Button className="buttonS buttonMenu buttonMenuSmall" onClick={event => this.showMenu()}>
                                        <MaterialIcon icon="menu" className="iconMapF" />
                                    </Button>

                                    {(!this.state.sel_polygons || this.state.sel_polygons.length <= 1) &&
                                        <>
                                            <Button
                                                className={this.state.polyCreate ? "buttonS buttonMenuHL" : "buttonS buttonMenu"}
                                                disabled={this.state.disable || this.state.split}
                                                onClick={event => this.criaPoly()}
                                                title={res.CRIAR_POLY}
                                            >
                                                <SvgIcon viewBox="79 18 21 26" className="iconMapP" >
                                                    <path id="polygon" d="M 100 23.4 L 97 36.9 L 83 39.6 L 76 27 L 86 18 Z" />
                                                </SvgIcon>
                                            </Button>
                                            <Button className="buttonS buttonMenu" onClick={event => this.deletePoly()} disabled={this.state.openType === 'view'} title={res.DELETAR_POLY}>
                                                <MaterialIcon icon="delete" className="iconMap" />
                                            </Button>
                                            <Button
                                                className={this.state.polyEdit ? "buttonS buttonMenuHL" : "buttonS buttonMenu"}
                                                disabled={
                                                    !this.state.sel_poly ||
                                                    !this.state.sel_poly.id ||
                                                    this.state.disable ||
                                                    this.state.split
                                                }
                                                onClick={event => this.editPoly()}
                                                title={res.EDITAR_POLY}
                                            >
                                                <MaterialIcon icon="edit" className="iconMap" />
                                            </Button>
                                            {this.getChangePatternButton()}
                                            <Button
                                                className="buttonS buttonMenu"
                                                disabled={
                                                    !this.state.sel_poly ||
                                                    !this.state.sel_poly.id ||
                                                    this.state.disable ||
                                                    this.state.split
                                                }
                                                onClick={event => this.showItem()}
                                                title={res.EDITAR_NOME}
                                            >
                                                <MaterialIcon icon="format_shapes" className="iconMap" />
                                            </Button>
                                        </>
                                    }

                                    {this.state.sPoly ? (
                                        <Button
                                            className={this.state.selector ? "buttonS buttonMenuHL" : "buttonS buttonMenu"}
                                            disabled={this.state.disable || this.state.split}
                                            onClick={(event) => this.selectorEstimateRet()}
                                            title={this.props.res ? this.props.res.SELECAO_RET : 'Seleção Retângulo'}
                                        >
                                            <SvgIcon viewBox="79 18 21 26" className="iconMapP">
                                                <path d="M 99 19 L 99 39 L 78 39 L 78 19 z M 97 34 L 99 34 L 99 30 L 97 30 L 97 28 L 99 28 L 99 24 L 97 24 L 97 21 L 94 21 L 94 19 L 90 19 L 90 21 L 87 21 L 87 19 L 83 19 L 83 21 L 80 21 L 80 24 L 78 24 L 78 28 L 80 28 L 80 30 L 78 30 L 78 34 L 80 34 L 80 37 L 83 37 L 83 39 L 87 39 L 87 37 L 90 37 L 90 39 L 94 39 L 94 37 L 97 37 z" />
                                            </SvgIcon>
                                        </Button>
                                    ) : (
                                        <Button
                                            className={this.state.selector ? "buttonS buttonMenuHL" : "buttonS buttonMenu"}
                                            disabled={this.state.disable || this.state.split}
                                            onClick={(event) => this.selectorEstimate()}
                                            title={this.props.res ? this.props.res.SELECAO_LIVRE : 'Seleção Livre'}
                                        >
                                            <SvgIcon viewBox="79 18 21 26" className="iconMapP">
                                                <path d="M 100.003 22.997 L 97 36.9 L 83 40 L 76 27 L 86 18 z M 96.109 31.635 L 98.032 32.276 L 99.037 27.914 L 97.244 27.441 L 98.012 24.052 L 93.677 22.653 L 94.387 21.017 L 89.851 19.328 L 89.103 20.931 L 86.352 19.81 L 84 22 L 82.872 20.815 L 79.821 23.569 L 80.914 24.761 L 78.146 27.234 L 80.103 31.055 L 78.578 31.723 L 80.773 35.814 L 81.876 35.026 L 83.672 38.046 L 85.935 37.489 L 86.25 39.282 L 91.621 38.046 L 91.033 36.229 L 95.53 35.204 z" />
                                            </SvgIcon>
                                        </Button>
                                    )}

                                    <Button
                                        className={"buttonS buttonMenu buttonMenuPS"}
                                        disabled={this.state.disable || this.state.split}
                                        onClick={this.setAnchor('select')}
                                    >
                                        <MaterialIcon icon="arrow_drop_down" className="iconMap" />
                                    </Button>
                                    {this.state.sel_poly && this.state.origemPolygons.find(a => a.guid_link === this.state.sel_poly.guid) &&
                                        <Button className="buttonS buttonMenu" onClick={this.desfazerMerge} title={res.DESFAZER}>
                                            <MaterialIcon icon="undo" className="iconMap" />
                                        </Button>
                                    }
                                    <MenuList
                                        id="app-header-menu"
                                        className="popup-list"
                                        anchorEl={this.state.anchorMN}
                                        open={Boolean(this.state.anchorMN)}
                                        onClose={() => this.setAnchor()()}
                                        style={{ marginRight: '2rem' }}
                                    >
                                        {this.state.typeTool === 'select' ? (
                                            <div>
                                                <MenuItem
                                                    className="popup-item"
                                                    onClick={() => {
                                                        this.setAnchor()();
                                                        this.setState({ sPoly: true }, () => this.selectorEstimateRet(true));
                                                    }}
                                                >
                                                    <div style={{ paddingRight: '.7rem' }}>
                                                        <SvgIcon viewBox="80 9 16 42" className="iconMap" style={{ verticalAlign: 'middle' }}>
                                                            <path d="M 99 19 L 99 39 L 78 39 L 78 19 z M 97 34 L 99 34 L 99 30 L 97 30 L 97 28 L 99 28 L 99 24 L 97 24 L 97 21 L 94 21 L 94 19 L 90 19 L 90 21 L 87 21 L 87 19 L 83 19 L 83 21 L 80 21 L 80 24 L 78 24 L 78 28 L 80 28 L 80 30 L 78 30 L 78 34 L 80 34 L 80 37 L 83 37 L 83 39 L 87 39 L 87 37 L 90 37 L 90 39 L 94 39 L 94 37 L 97 37 z" />
                                                        </SvgIcon>
                                                        {this.props.res ? this.props.res.SELECAO_RET : 'Seleção Retângulo'}
                                                    </div>
                                                </MenuItem>

                                                <MenuItem
                                                    className="popup-item"
                                                    onClick={() => {
                                                        this.setAnchor()();
                                                        this.setState({ sPoly: false }, () => this.selectorEstimate(true));
                                                    }}
                                                >
                                                    <div style={{ paddingRight: '.7rem' }}>
                                                        <SvgIcon viewBox="80 9 16 42" className="iconMap" style={{ verticalAlign: 'middle' }}>
                                                            <path d="M 100.003 22.997 L 97 36.9 L 83 40 L 76 27 L 86 18 z M 96.109 31.635 L 98.032 32.276 L 99.037 27.914 L 97.244 27.441 L 98.012 24.052 L 93.677 22.653 L 94.387 21.017 L 89.851 19.328 L 89.103 20.931 L 86.352 19.81 L 84 22 L 82.872 20.815 L 79.821 23.569 L 80.914 24.761 L 78.146 27.234 L 80.103 31.055 L 78.578 31.723 L 80.773 35.814 L 81.876 35.026 L 83.672 38.046 L 85.935 37.489 L 86.25 39.282 L 91.621 38.046 L 91.033 36.229 L 95.53 35.204 z" />
                                                        </SvgIcon>
                                                        {this.props.res ? this.props.res.SELECAO_LIVRE : 'Seleção Livre'}
                                                    </div>
                                                </MenuItem>
                                            </div>
                                        ) : (this.state.typeTool === 'tools' ?
                                            <div>
                                                <MenuItem
                                                    className="popup-item"
                                                    onClick={() => {
                                                        this.setAnchor()();
                                                        this.mountStrategy();
                                                    }}
                                                >
                                                    <div style={{ paddingRight: '.7rem' }}>
                                                        <MaterialIcon icon="crop_free" className="iconMap" />
                                                        {'Otimizador (Beta)'}
                                                    </div>
                                                </MenuItem>
                                            </div>
                                            : null)}
                                        {this.state.typeTool === 'type' && <div>
                                            {[
                                                ['N', 'check', 'SET_N'], ['X', 'close', 'SET_X'],
                                                ['T', 'indeterminate_check_box', 'SET_T'], ['R', 'block', 'POLY_R']
                                            ].map(([type, icon, label]) => <MenuItem key={type} className="popup-item" onClick={() => { this.changeType(type); this.setAnchor()(); }}>
                                                <div style={{ paddingRight: '.7rem' }}>
                                                    <MaterialIcon icon={icon} className="iconMap" />
                                                    {res[label]}
                                                </div>
                                            </MenuItem>)}
                                        </div>}
                                    </MenuList>

                                    {this.state.sel_polygons && this.state.sel_polygons.length > 1 &&
                                        <Button
                                            className="buttonS buttonMenu"
                                            disabled={!(this.state.sel_polygons.length > 1)}
                                            onClick={event => this.setState({ merge: true })}
                                            title={res.AGRUPAR}
                                        >
                                            <MaterialIcon icon="view_compact" className="iconMap" />
                                        </Button>
                                    }

                                    <Button className={this.state.base ? "buttonS buttonMenuHL" : "buttonS buttonMenu"} disabled={this.state.openType === 'view'} onClick={event => this.criaMark(this.img_base['T'])} title={res.HANGAR}>
                                        <MaterialIcon icon="add_location_alt" className="iconMap" />
                                    </Button>

                                    <Button className={this.state.fuel ? "buttonS buttonMenuHL" : "buttonS buttonMenu"} disabled={this.state.openType === 'view'} onClick={event => this.criaMark(this.img_fuel['Y'])} title={res.PISTA_REABASTECIMENTO}>
                                        <MaterialIcon icon="add_road" className="iconMap" />
                                    </Button>

                                    {/* <Button className="buttonS buttonMenu" disabled={(this.state.lat_base === '' && this.state.lat_fuel === '')} onClick={event => this.editMark()} title={res.EDITAR}>
                                            <MaterialIcon icon="crop_free" className="iconMap" />
                                        </Button> */}
                                    <Button className="buttonS buttonMenu" disabled={this.state.polygons.length === 0 || (this.state.sel_poly && this.state.sel_poly.type !== 'N') || this.state.delete || this.state.openType === 'view'} onClick={event => this.handleClickB(!this.state.sel_poly ? 'all' : null)} title={res.CRIAR_ROTA}>
                                        <SvgIcon viewBox="-3.5 0 24 20" className="iconMap"
                                            style={{ color: (this.state.polygons.length === 0 || (this.state.sel_poly && this.state.sel_poly.type !== 'N') || this.state.delete) ? '#b9b9b9' : 'black', width: '2rem', height: '2rem' }}>
                                            <path d="M 13.657 3.08 L 7.7 11 L 9.8 11 L 14.651 4.49 c -0.133 -0.69 -0.511 -1.23 -0.994 -1.41 z M 8.316 3 L 2.1 11 L 4.2 11 L 10.297 3 h -1.981 z M 3.5 3 c -0.77 0 -1.4 0.9 -1.4 2 v 2 l 2.8 -4 H 3.5 z m 11.2 8 z V 9.29 L 13.3 11 z M 11.2 15 L 11.2 14 L 14 16 L 11.2 18 L 11.2 17 L 2.8 17 L 2.8 15 z" />
                                        </SvgIcon>
                                    </Button>
                                    {profile && profile.includes(1) &&
                                        <Button
                                            className={"buttonS buttonMenu buttonMenuPS"}
                                            disabled={this.state.disable || this.state.split}
                                            onClick={this.setAnchor('tools')}
                                        >
                                            <MaterialIcon icon="arrow_drop_down" className="iconMap" />
                                        </Button>}
                                    {/* <Button
                                                className={this.state.ruler_a && this.ruler_p?.type === 'ab' ? "buttonS buttonMenuHL" : "buttonS buttonMenu"}
                                                disabled={this.state.ruler_a?.type === 'r' || this.state.sel_poly === null || this.state.type_poly === 'X' || this.state.type_poly === 'T' || this.state.type_poly === 'R' || this.state.delete || this.state.openType === 'view'}
                                                onClick={event => this.regua(null, 'ab')}>
                                                <MaterialIcon icon="edit" className="iconMap" />
                                            </Button> */}
                                    <Button className="buttonS buttonMenu" disabled={this.state.sel_poly === null || !this.state.line_poly || this.state.type_poly === 'X' || this.state.type_poly === 'T' || this.state.type_poly === 'R' || this.state.delete || this.state.openType === 'view'} onClick={event => this.handleClickA()} title={res.ROTA_ANGULO}>
                                        <MaterialIcon icon="explore" className="iconMap" />
                                    </Button>
                                    <Button
                                        className="buttonS buttonMenu"
                                        disabled={
                                            this.state.sel_poly === null ||
                                            !this.state.sel_poly ||
                                            !this.state.sel_poly.lines ||
                                            this.state.sel_poly.lines.length === 0 ||
                                            this.state.delete ||
                                            this.state.openType === 'view'
                                        }
                                        onClick={event => this.updatePolyData('', '', 'reset')}
                                        title={res.REMOVER_RUMO}
                                    >
                                        <MaterialIcon icon="highlight_alt" className="iconMap" />
                                    </Button>
                                    <Button className="buttonS buttonMenu" disabled={this.state.sel_poly === null || !this.state.line_poly || this.state.delete || this.state.openType === 'view'} onClick={event => this.handleClickPR()} title={res.ROTA_PROXIMO}>
                                        <MaterialIcon icon="autorenew" className="iconMap" />
                                    </Button>
                                    <Button className="buttonS buttonMenu" disabled={this.state.sel_poly === null || !this.state.line_poly || this.state.delete || this.state.openType === 'view'} onClick={event => this.handleClickIAB()} title={res.INVERTER_AB}>
                                        <MaterialIcon icon="compare_arrows" className="iconMap" />
                                    </Button>
                                    <Button className="buttonS buttonMenu" disabled={this.state.sel_poly === null || !this.state.line_poly || this.state.delete || this.state.openType === 'view'} onClick={event => this.handleClickIABS()} title={res.ESPELHAR_AB}>
                                        <MaterialIcon icon="swap_vert" className="iconMap" />
                                    </Button>
                                    <Button className={((this.state.setBase) && this.state.dEstimative && this.state.uEstimative) ? "buttonS buttonMenuAL" : "buttonS buttonMenu"} disabled={(!this.state.setBase) || !this.state.dEstimative || (this.state.lat_base === '' && this.state.lat_fuel === '') || this.state.delete || this.state.openType === 'view'} onClick={event => this.clickEstimative()} title={res.CALCULAR_ESTRATEGIA}>
                                        <MaterialIcon icon="calculate" className="iconMap" />
                                    </Button>
                                    <Button className="buttonS buttonMenu" disabled={(!this.state.setBase) || !this.state.dEstimative || (this.state.lat_base === '' && this.state.lat_fuel === '') || this.state.delete || this.state.openType === 'view'} onClick={event => this.setRef('', this.updateSetRef)} title={res.MELHOR_ESTRATEGIA}>
                                        <MaterialIcon icon="stars" className="iconMap" />
                                    </Button>
                                </div>
                            }
                        </div>
                        <div className="centerTop"></div>
                        <div className="rightTop">
                            <Button className="buttonS buttonMenu" onClick={event => this.openAreaList()} disabled={this.state.polygons.length === 0 || this.state.openType === 'view'} title={res.GERENCIAR_AREAS}>
                                <MaterialIcon icon="ballot" className="iconMap" />
                            </Button>
                            <Button className="buttonS buttonMenu" onClick={event => this.showArea()} disabled={this.state.openType === 'view'} title={res.SELECIONAR_AREAS}>
                                <MaterialIcon icon="select_all" className="iconMap" />
                            </Button>
                            <Button
                                className="buttonS buttonMenu"
                                disabled={
                                    (
                                        !this.state.sel_poly ||
                                        !this.state.sel_poly.lines ||
                                        this.state.sel_poly.lines.length === 0 ||
                                        this.state.delete
                                    ) && !this.state.play
                                }
                                onClick={event => this.startLine(!this.state.play)}
                                title={res.SIMULACAO_ESTRATEGIA}
                            >
                                <MaterialIcon icon="history" className="iconMap" />
                            </Button>
                            <Button
                                className="buttonS buttonMenu"
                                disabled={!((this.state.sel_polygons && this.state.sel_polygons.length) || (this.state.sel_poly && this.state.sel_poly.guid))}
                                onClick={this.downloadSelectedPolygons}
                                title={res.BAIXAR_SELECIONADOS}
                                aria-label={res.BAIXAR_SELECIONADOS}
                            >
                                <MaterialIcon icon="download" className="iconMap" />
                            </Button>
                            <Button className={this.state.ruler_a && this.ruler_p?.type === 'r' ? "buttonS buttonMenuHL" : "buttonS buttonMenu"} disabled={(this.state.delete) || this.state.openType === 'view'} onClick={event => this.regua(null, 'r')} title={res.REGUA}>
                                <MaterialIcon icon="settings_ethernet" className="iconMap highlightSVG" />
                            </Button>
                            <Button className="buttonS buttonMenu" onClick={event => this.showGoto()} title={res.IR_PARA}>
                                <MaterialIcon icon="search" className="iconMap" />
                            </Button>
                        </div>
                    </div>

                    <div className={this.state.polyEdit ? "divContent floatDiv floatDivItens" : "sr-only"}>
                        <label className="textDiv">
                            {res.CLICK_DESFAZER}
                        </label>
                        <Button
                            size="small"
                            className="popUpButton"
                            onClick={event => this.savePolyEdit()}
                        >
                            {res.SALVAR}
                        </Button>
                        <Button
                            size="small"
                            className="popUpButton"
                            onClick={event => this.cancelPolyEdit()}
                        >
                            {res.CANCELAR}
                        </Button>
                    </div>

                    <div
                        className={
                            this.state.polyNameEditing ||
                                this.state.create_circle ||
                                this.state.mergeNameEditing
                                ? "divContent floatDiv floatDivItens popUpF"
                                : "sr-only"
                        }
                    >
                        <div style={{ overflowY: 'auto' }}>
                            {this.state.mergeNameEditing &&
                                this.state.mergeNames.map((item, index) => (
                                    <TextField
                                        key={item.guid}
                                        id={'name_' + index}
                                        label={res.NOME}
                                        margin="none"
                                        className="textI"
                                        size="small"
                                        fullWidth
                                        onChange={this.handleChangeMergeName(item.guid)}
                                        value={item.name}
                                        error={!item.valid}
                                        onInput={(e) => {
                                            e.target.value = e.target.value.toString().slice(0, 45);
                                        }}
                                    />
                                ))
                            }

                            {!this.state.mergeNameEditing &&
                                (this.state.polyNameEditing || this.state.create_circle) && (
                                    <TextField
                                        id="name"
                                        label={res.NOME}
                                        margin="none"
                                        className="textI"
                                        size="small"
                                        fullWidth
                                        onChange={this.handleChange('nameP')}
                                        value={this.state.nameP}
                                        error={!this.state.valid_nameP}
                                        onKeyDown={e => {
                                            if (e.keyCode === 13) { this.savePolyName(); }
                                        }}
                                        onInput={(e) => {
                                            e.target.value = e.target.value.toString().slice(0, 45);
                                        }}
                                    />
                                )
                            }
                        </div>

                        <div className="divForm">
                            {!this.state.create_circle && (
                                <Button
                                    size="small"
                                    className="popUpButton"
                                    disabled={
                                        this.state.mergeNameEditing
                                            ? this.state.mergeNames.some(item => !item.valid)
                                            : !this.state.valid_nameP
                                    }
                                    onClick={event =>
                                        this.state.mergeNameEditing
                                            ? this.saveMergeNames()
                                            : this.savePolyName()
                                    }
                                >
                                    {res.SALVAR}
                                </Button>
                            )}

                            {this.state.polyCreate && !this.state.mergeNameEditing && (
                                <Button
                                    size="small"
                                    className="popUpButton"
                                    onClick={event => this.cancelCreate()}
                                >
                                    {res.DESFAZER}
                                </Button>
                            )}

                            <Button
                                size="small"
                                className="popUpButton"
                                onClick={event =>
                                    this.state.mergeNameEditing
                                        ? this.cancelMergeNames()
                                        : this.cancelCreate()
                                }
                            >
                                {res.CANCELAR}
                            </Button>
                        </div>
                    </div>

                    <div className="wrapperMap">
                        <div id="mapid"></div>
                        <Button
                            className="buttonS buttonMenu replay3d-open-button"
                            onClick={this.openPlanningReplay3D}
                            title="Simulação 3D do planejamento"
                            style={{
                                position: 'absolute',
                                top: '1rem',
                                right: '1rem',
                                zIndex: 1101
                            }}
                        >
                            <MaterialIcon icon="public" className="iconMap" />
                        </Button>
                        {this.state.showPlanningReplay3D ?
                            <Replay3D
                                data={this.state.planningReplay3DData}
                                polygons={this.state.polygons}
                                p={null}
                                res={res}
                                key={'planning-' + this.getPlanningReplay3DModelType()}
                                defaultModelType={this.getPlanningReplay3DModelType()}
                                selectedAircraft={this.getPlanningReplay3DSelectedPlane()}
                                qualityConfig={this.getPlanningReplay3DQualityConfig()}
                                onClose={() => this.setState({ showPlanningReplay3D: false, planningReplay3DData: null })}
                            />
                            : null}
                        <div className="tool-tip-H" style={{
                            position: 'absolute',
                            right: '1rem',
                            bottom: '1.8rem',
                            zIndex: 1100,
                            textAlign: 'right',
                            color: '#edb83b'
                        }}>
                            <div>{res.LAT}: {this.state.lat ? this.formatCoordText(this.state.lat.value, 'latitude') : ''}</div>
                            <div>{res.LNG}: {this.state.lng ? this.formatCoordText(this.state.lng.value, 'longitude') : ''}</div>
                        </div>
                        <div style={{ zIndex: 999 }} className={this.state.edit_add || this.state.edit_speed || this.state.calibracao ? "divContent floatDiv floatDivItens popUpF" : "sr-only"}>
                            {this.state.edit_add ?
                                <div style={{ overflowY: 'auto' }}>
                                    {res.VALOR_ADD}
                                    <div>
                                        <TextField
                                            id="list_name"
                                            label={res.DESCRICAO}
                                            margin="none"
                                            className="textI"
                                            size="small"
                                            style={{ width: '12rem' }}
                                            value={this.state.list_name}
                                            onChange={this.handleChange("list_name")}
                                            onKeyDown={e => {
                                                if (e.keyCode === 13) { this.add_list() }
                                            }}
                                            onInput={(e) => {
                                                e.target.value = e.target.value.toString().slice(0, 20)
                                            }}
                                        />
                                        <div style={{ display: 'inline-block', marginTop: '0.7rem', marginLeft: '0.5rem' }}>
                                            <Button className="buttonS buttonMenu" disabled={this.state.list_name.length < 3} onClick={event => this.add_list()} title={res.ROTA_ANGULO}>
                                                <MaterialIcon icon="add" className="iconMap" />
                                            </Button>
                                        </div>
                                    </div>
                                    {this.state.add_list
                                        .map((item, index) => {
                                            return (
                                                <TextField
                                                    key={index}
                                                    id="namePoly"
                                                    label={item.name}
                                                    margin="none"
                                                    className="textI"
                                                    size="small"
                                                    style={{ marginTop: '1rem' }}
                                                    fullWidth
                                                    type="number"
                                                    onChange={this.handleChangeNameList(item.guid)}
                                                    value={item.value}
                                                    onInput={(e) => {
                                                        e.target.value = e.target.value ? ((e.target.value - 0) === 0 || e.target.value.slice(-1) === '0' ? e.target.value : e.target.value - 0).toString().slice(0, 10) : 0
                                                    }}
                                                />
                                            )
                                        })}
                                </div>
                                :
                                <div style={{ height: '100%' }}>
                                    {this.state.calibracao ?
                                        <div style={{ overflowY: 'auto', height: '100%', display: 'flex', flexFlow: 'column' }}>
                                            <TextField
                                                id="nPulverizador"
                                                label={'nº de Pulverizadores'}
                                                value={this.state.tempPoly ? this.state.tempPoly.nPulverizador ? this.state.tempPoly.nPulverizador : 40 : 40}
                                                onChange={this.polyData('nPulverizador', this.state.tempPoly ? this.state.tempPoly.guid : '', '')}
                                                onBlur={(e) => this.polyDataBlur('nPulverizador', this.state.tempPoly ? this.state.tempPoly.guid : '')}
                                                type="number"
                                                className="mb-4 notTooClose"
                                                size="small"
                                                margin="dense"
                                                ref={(node) => { if (node) node.style.setProperty("margin-right", "0px", "important"); }}
                                                style={{ marginBottom: '1rem' }}
                                                fullWidth
                                                onInput={(e) => {
                                                    e.target.value = e.target.value ? ((e.target.value - 0) === 0 || e.target.value.slice(-1) === '0' ? e.target.value : e.target.value - 0).toString().slice(0, 10) : 0
                                                }}
                                            />
                                            <FormControl style={{ width: '100%' }}>
                                                <InputLabel htmlFor="age-simple">{'DSC'}</InputLabel>
                                                <Select
                                                    value={this.state.dsc}
                                                    onChange={this.handleChange('dsc')}
                                                    inputProps={{
                                                        id: 'dsc',
                                                    }}
                                                >
                                                    <MenuItem key={99} value={99}>{'TODOS'}</MenuItem>
                                                    {this.dsc_label.map((item, key) => (
                                                        <MenuItem key={key} value={key}>{item}</MenuItem>
                                                    ))};
                                                </Select>
                                            </FormControl>

                                            <FormControl style={{ width: '100%', marginTop: '1rem' }}>
                                                <InputLabel htmlFor="age-simple">{'Tipo de Bico'}</InputLabel>
                                                <Select
                                                    value={this.state.tbico}
                                                    onChange={this.handleChange('tbico')}
                                                    inputProps={{
                                                        id: 'tbico',
                                                    }}
                                                >
                                                    <MenuItem key={99} value={99}>{'TODOS'}</MenuItem>
                                                    {this.bico_label.map((item, key) => (
                                                        <MenuItem key={key} value={key}>{item}</MenuItem>
                                                    ))};
                                                </Select>
                                            </FormControl>
                                            <FormControl style={{ width: '100%', marginTop: '1rem' }}>
                                                <InputLabel htmlFor="age-simple">{'Fabricante'}</InputLabel>
                                                <Select
                                                    value={this.state.fabricante}
                                                    onChange={this.handleChange('fabricante')}
                                                    inputProps={{
                                                        id: 'fabricante',
                                                    }}
                                                >
                                                    <MenuItem key={99} value={99}>{'TODOS'}</MenuItem>
                                                    {this.fabricante_label.map((item, key) => (
                                                        <MenuItem key={key} value={key}>{item}</MenuItem>
                                                    ))};
                                                </Select>
                                            </FormControl>
                                            <div style={{ paddingTop: '1rem', textAlign: 'left' }}>
                                                <Checkbox
                                                    checked={this.state.equip_plan}
                                                    onChange={this.handleCheck('equip_plan')}
                                                />
                                                <span onClick={this.handleCheck('equip_plan')} className="MuiFormLabel-root" style={{ fontSize: '12px', cursor: 'pointer' }}>
                                                    Exibir no Relatório de Planejamento
                                                </span>
                                            </div>
                                            <div style={{ paddingTop: '1rem', textAlign: 'left' }}>
                                                <Checkbox
                                                    checked={this.state.equip_orc}
                                                    onChange={this.handleCheck('equip_orc')}
                                                />
                                                <span onClick={this.handleCheck('equip_orc')} className="MuiFormLabel-root" style={{ fontSize: '12px', cursor: 'pointer' }}>
                                                    Exibir no Relatório de Orçamento
                                                </span>
                                            </div>
                                        </div>
                                        :
                                        <div style={{ overflowY: 'auto' }}>
                                            <TextField
                                                id="speed_apl"
                                                label={tools.replaceString(res._VELOCIDADE_APLICACAO, Units.getSpeedUnit(res))}
                                                value={this.state.speed_apl}
                                                onChange={this.handleChangeEstReset('speed_apl')}
                                                margin="normal"
                                                type="number"
                                                fullWidth
                                                onInput={(e) => {
                                                    e.target.value = e.target.value.toString().slice(0, 10)
                                                }}
                                            />
                                            <TextField
                                                id="speed_travel"
                                                label={tools.replaceString(res._VELOCIDADE_TRANSLADO, Units.getSpeedUnit(res))}
                                                value={this.state.speed_travel}
                                                onChange={this.handleChangeEstReset('speed_travel')}
                                                margin="normal"
                                                type="number"
                                                fullWidth
                                                onInput={(e) => {
                                                    e.target.value = e.target.value.toString().slice(0, 10)
                                                }}
                                            />
                                            <TextField
                                                id="speed_loop"
                                                label={tools.replaceString(res._VELOCIDADE_MEDIA_BALAO, Units.getSpeedUnit(res))}
                                                value={this.state.speed_loop}
                                                onChange={this.handleChangeEstReset('speed_loop')}
                                                margin="normal"
                                                type="number"
                                                fullWidth
                                                onInput={(e) => {
                                                    e.target.value = e.target.value.toString().slice(0, 10)
                                                }}
                                            />
                                        </div>
                                    }
                                </div>
                            }
                            <div className="divForm">
                                {(!this.state.calibracao && !this.state.create_circle) &&
                                    <Button size="small" className="popUpButton" onClick={event => this.state.edit_add ? this.showAdd(1) : this.showAdd(0)}>
                                        OK
                                    </Button>
                                }
                            </div>
                        </div>

                        <div className={this.state.calibracao ? "divContent" : "sr-only"} style={{ position: 'absolute', top: '1rem', marginLeft: '23rem', zIndex: '999', height: 'calc(100% - 2rem)', width: 'calc(100% - 24rem)' }}>
                            <div style={{ height: '100%', marginRight: '-0.5rem' }}>
                                <div style={{ overflowY: 'auto', height: '100%', display: 'flex', flexFlow: 'column' }}>
                                    {this.state.list_local.map((item) => toolsCali.montaItens(item, this.updateEquipamento))}
                                    {this.state.list_data1.map((item) => toolsCali.montaItensEx(item, this.updateEquipamento))}
                                </div>
                            </div>
                        </div>

                        <div className="zoomB">
                            <Button className="buttonS buttonMenu" onClick={event => this.zoomInL()}>
                                <MaterialIcon icon="add" className="iconMap" />
                            </Button>
                            <Button className="buttonS buttonMenu" onClick={event => this.zoomOutL()}>
                                <MaterialIcon icon="remove" className="iconMap" />
                            </Button>
                        </div>

                        <div className={this.state.edit || this.state.delete ? "divContent floatDiv floatDivItens" : "sr-only"}>
                            <label className="textDiv">
                                {res.CLICK_DESFAZER}
                            </label>
                            <Button size="small" className="popUpButton" onClick={event => this.state.edit ? this.saveEdit() : this.saveDelete()}>
                                {res.SALVAR}
                            </Button>
                            <Button size="small" className="popUpButton" onClick={event => this.state.edit ? this.cancelEdit() : this.cancelDelete()}>
                                {res.CANCELAR}
                            </Button>
                        </div>

                        {this.state.merge &&
                            <div className="divContent floatW divIA">
                                <div>
                                    <FormControl className="notTooBig notTooClose">
                                        <InputLabel htmlFor="age-simple">{res.AGRUPAR}</InputLabel>
                                        <Select
                                            value={this.state.type}
                                            onChange={event => { this.setState({ type: event.target.value }); }}
                                            inputProps={{ id: 'type' }}
                                        >
                                            <MenuItem key="2" value="2">{res.LIGAR_AREA}</MenuItem>
                                            <MenuItem key="7" value="7">{res.ANEXAR_AREA}</MenuItem>
                                        </Select>
                                    </FormControl>
                                </div>

                                {(['3', '5', '7'].includes(this.state.type)) &&
                                    <div className="">
                                        <TextField
                                            id="name"
                                            label={res.TAMANHO}
                                            margin="normal"
                                            className="textI"
                                            inputProps={{ style: { textAlign: 'right' } }}
                                            onChange={this.handleChange('gap_size')}
                                            value={this.state.gap_size}
                                        />
                                        <span style={{ position: 'relative', bottom: '-1.3rem' }}>  {res.METROS}</span>
                                    </div>}

                                <div style={{ padding: '1rem' }}></div>

                                <Button
                                    size="small"
                                    className="popUpButton"
                                    disabled={!(this.state.sel_polygons && this.state.sel_polygons.length > 1)}
                                    onClick={event => { this.junta(); }}
                                >
                                    {res.SALVAR}
                                </Button>

                                <Button
                                    size="small"
                                    className="popUpButton"
                                    onClick={event => { this.setState({ merge: false }); }}
                                >
                                    {res.CANCELAR}
                                </Button>
                            </div>
                        }

                        {this.state.angle &&
                            <div style={{ width: '16rem' }} className="divContent floatW divI">
                                <form onSubmit={this.hSubmitPoly}>
                                    <div>
                                        <TextField
                                            id="angulo"
                                            label={res.ANGULO}
                                            value={tools.round(this.state.angulo, 2)}
                                            onChange={this.handleChange('angulo')}
                                            type="number"
                                            style={{ width: '8rem' }}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            margin="normal"
                                            onKeyDown={e => {
                                                if (e.keyCode === 13) { this.handleClickAA() }
                                            }}
                                        />
                                        <Button
                                            style={{ marginTop: '1.8rem', marginLeft: '.4rem' }}
                                            className={this.state.ruler_a && this.ruler_p?.type === 'ab' ? "buttonS buttonMenuHL" : "buttonS buttonMenu"}
                                            disabled={this.state.ruler_a?.type === 'r'}
                                            onClick={event => this.regua(null, 'ab')}>
                                            <MaterialIcon icon="edit" className="iconMap" />
                                        </Button>
                                    </div>
                                    <div>
                                        <TextField
                                            id="space"
                                            label={tools.replaceString(res._DISTANCIA_BORDA_, Units.getLengthUnit(res))}
                                            value={this.state.space}
                                            onChange={this.handleChange('space')}
                                            type="number"
                                            style={{ width: '11rem' }}
                                            inputProps={{
                                                min: -Units.convertLengthTo(
                                                    Math.max(0, Units.toCanonicalLength(this.state.sel_poly?.faixa ?? this.state.faixa, res) / 2),
                                                    'm',
                                                    Units.getLengthUnit(res)
                                                ),
                                                max: Units.convertLengthTo(
                                                    Math.max(0, Units.toCanonicalLength(this.state.sel_poly?.faixa ?? this.state.faixa, res) / 2),
                                                    'm',
                                                    Units.getLengthUnit(res)
                                                )
                                            }}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            margin="normal"
                                            onKeyDown={e => {
                                                if (e.keyCode === 13) { this.handleClickAA() }
                                            }}
                                            onInput={(e) => {
                                                const faixa = Number(this.state.sel_poly?.faixa ?? this.state.faixa);
                                                const value = Number(e.target.value);
                                                if (Number.isFinite(faixa) && Number.isFinite(value)) {
                                                    const limit = Units.convertLengthTo(
                                                        Math.max(0, Units.toCanonicalLength(faixa, res) / 2),
                                                        'm',
                                                        Units.getLengthUnit(res)
                                                    );
                                                    e.target.value = Math.min(Math.max(value, -limit), limit);
                                                }
                                            }}
                                        />
                                    </div>
                                    <div style={{ padding: '1rem' }}></div>
                                    <Button size="small" className="popUpButton" onClick={event => this.handleClickAA()}>
                                        {res.CRIAR}
                                    </Button>
                                    <Button size="small" className="popUpButton" onClick={event => this.cancelAA()}>
                                        {res.CANCELAR}
                                    </Button>
                                </form>
                            </div>
                        }
                        {this.state.goto &&
                            <div className="divContent floatW divS" style={{ width: '15rem' }}>
                                <div>
                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                        <span>{res.IRPARA}</span>

                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <Button
                                                size="small"
                                                className="popUpButton blButton"
                                                disabled={!this.state.sel_poly}
                                                onClick={event => this.goto("sel_poly")}
                                                title={res.SELECIONADO}
                                            >
                                                <SvgIcon viewBox="79 18 21 26" className="iconMapP" style={!this.state.sel_poly ? disabledButton : {}} >
                                                    <path id="polygon" d="M 100 23.4 L 97 36.9 L 88 40 L 88 27 L 76 27 L 86 18 z M 76 29 L 86 29 L 86 40 L 83 40 Z" />
                                                </SvgIcon>
                                            </Button>

                                            <Button
                                                size="small"
                                                className="popUpButton blButton"
                                                disabled={this.state.polygons.length <= 0}
                                                onClick={event => this.goto("poly")}
                                                title={res.POLIGONO}
                                            >
                                                <SvgIcon viewBox="79 18 21 26" className="iconMapP" style={this.state.polygons.length <= 0 ? disabledButton : {}} >
                                                    <path id="polygon" d="M 100 23.4 L 97 36.9 L 83 39.6 L 76 27 L 86 18 Z" />
                                                </SvgIcon>
                                            </Button>

                                            <Button
                                                size="small"
                                                className="popUpButton blButton"
                                                disabled={this.state.home === Config.place}
                                                onClick={event => this.goto("home")}
                                                title={res.REFERENCIA}
                                            >
                                                <MaterialIcon icon="home" className="iconMap" />
                                            </Button>
                                        </div>
                                    </div>

                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                                        <Button
                                            size="small"
                                            className="popUpButton blButton"
                                            onClick={this.toggleCoordMode}
                                            title={(this.state.coordMode === 'dms') ? res.COORDENADA_DMS : res.COORDENADA_DD}
                                        >
                                            <MaterialIcon icon="swap_horiz" className="iconMap" />
                                        </Button>

                                        <Button
                                            size="small"
                                            className="popUpButton blButton"
                                            disabled={!this.waypointMarker}
                                            onClick={this.gotoWaypoint}
                                            title="Ir para o Pin"
                                        >
                                            <RoomIcon className="iconMap" />
                                        </Button>
                                    </div>
                                </div>

                                <TextField
                                    id="lat"
                                    label="LAT"
                                    margin="normal"
                                    size='small'
                                    error={this.state.lat.error}
                                    onChange={this.handleChangeCoordinates('lat')}
                                    value={this.state.lat.input}
                                    placeholder={this.formatCoordText(this.state.lat.value, 'latitude')}
                                    onKeyDown={e => {
                                        if (e.keyCode === 13) { this.goto() }
                                    }}
                                />
                                <TextField
                                    id="lng"
                                    label="LNG"
                                    margin="normal"
                                    error={this.state.lng.error}
                                    onChange={this.handleChangeCoordinates('lng')}
                                    value={this.state.lng.input}
                                    placeholder={this.formatCoordText(this.state.lng.value, 'longitude')}
                                    onKeyDown={e => {
                                        if (e.keyCode === 13) { this.goto() }
                                    }}
                                />
                                <div className="divForm">
                                    <Button size="small" className="popUpButton" onClick={event => this.goto()}>
                                        {res.IR}
                                    </Button>
                                    <Button size="small" className="popUpButton" onClick={event => this.setState({ goto: false })}>
                                        {res.CANCELAR}
                                    </Button>
                                </div>
                            </div>}
                        {this.state.label_text !== '' &&
                            <div className='tool-tip-H'
                                style={{
                                    right: '1rem',
                                    position: 'absolute',
                                    bottom: '0.3rem',
                                    zIndex: 1099,
                                    textAlign: 'right',
                                    color: '#edb83b'
                                }}>
                                {this.state.label_text}
                            </div>}
                    </div>
                </div >
            </div >
        );
    };
}

Edit.propTypes = {
    classes: PropTypes.object.isRequired,
};

const TextFields1 = withStyles(styles)(Edit);

const Box = (props) => {
    const { link, res, profile } = props;
    let { guid, type } = useParams();
    return (
        <div className="rowPMap maxHMap">
            <TextFields1 link={link} guid={guid} type={type} res={res} profile={profile} />
        </div>)
}

export default Box;
